export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AccountPrivacySettings = {
  __typename?: 'AccountPrivacySettings';
  fieldName?: Maybe<Scalars['String']>;
  fieldVisibility?: Maybe<FieldVisibility>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  businessKey?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Ach = {
  __typename?: 'Ach';
  ach?: Maybe<AchDetails>;
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  type: PaymentMethodTypeV2 | PaymentMethodType;
};

export type AchDetails = {
  __typename?: 'AchDetails';
  id?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/**
 * Add-ons are child entitlements to parent entitlements.
 *
 * Examples: Team Members for Statuspage
 */
export type AddOn = {
  __typename?: 'AddOn';
  billingStatus?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  dateLastBilled?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextBillDate?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

export type AddOnConnection = Connection & {
  __typename?: 'AddOnConnection';
  edges?: Maybe<Array<Maybe<AddOnEdge>>>;
  nodes?: Maybe<Array<Maybe<AddOn>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AddOnEdge = Edge & {
  __typename?: 'AddOnEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<AddOn>;
};

export type AdditionalNotes = {
  __typename?: 'AdditionalNotes';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type AddnCcpEntitlementDetails = {
  __typename?: 'AddnCCPEntitlementDetails';
  billedUsers?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<SubscriptionBillingDetails>;
  trial?: Maybe<Scalars['Boolean']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type Adjustments = {
  __typename?: 'Adjustments';
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  promotionId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AggregatedProduct = {
  __typename?: 'AggregatedProduct';
  billedProductCount?: Maybe<Scalars['Int']>;
  evaluationProductCount?: Maybe<Scalars['Int']>;
  freeProductCount?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  unlimitedUserProductCount?: Maybe<Scalars['Int']>;
  userCount?: Maybe<Scalars['Int']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  description?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  isUnseen?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<AnnouncementMeta>;
  previewThumbnail?: Maybe<PreviewThumbnail>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AnnouncementConnection = Connection & {
  __typename?: 'AnnouncementConnection';
  edges?: Maybe<Array<Maybe<AnnouncementEdge>>>;
  nodes?: Maybe<Array<Maybe<Announcement>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AnnouncementEdge = Edge & {
  __typename?: 'AnnouncementEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Announcement>;
};

export type AnnouncementMeta = {
  __typename?: 'AnnouncementMeta';
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Properties that drive the CASSI application experience (non-entity related) */
export type Application = {
  __typename?: 'Application';
  announcements?: Maybe<AnnouncementConnection>;
  /** Populates the app switcher menu in the navigation */
  appSwitcherNavigation?: Maybe<Array<Maybe<NavigationItem>>>;
  banner?: Maybe<Banner>;
  featureFlag?: Maybe<FeatureFlag>;
  /** Populates the help menu in the navigation */
  helpNavigation?: Maybe<Array<Maybe<NavigationItem>>>;
  /** Custom icon url that will be displayed in the header */
  iconUrl?: Maybe<Scalars['String']>;
  /** Application slug that will identify the application */
  id?: Maybe<Scalars['String']>;
  /** Application name that will be displayed in navigation */
  name?: Maybe<Scalars['String']>;
  portalApp?: Maybe<PortalApp>;
};

/** Properties that drive the CASSI application experience (non-entity related) */
export type ApplicationFeatureFlagArgs = {
  flagKey: Scalars['String'];
  targetingProperties?: Maybe<Scalars['JSON']>;
};

/** Properties that drive the CASSI application experience (non-entity related) */
export type ApplicationPortalAppArgs = {
  id: Scalars['String'];
};

export type AtlassianAccess = {
  __typename?: 'AtlassianAccess';
  billingStatus?: Maybe<BillingStatus>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
};

export type AtlassianAccountDetails = {
  __typename?: 'AtlassianAccountDetails';
  active?: Maybe<Scalars['Boolean']>;
  atlassianAccessStatus?: Maybe<BillingStatus>;
  created?: Maybe<Scalars['String']>;
  hasVerifiedEmail?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

/** Transactional billing emails sent to customers. */
export type Attachment = {
  __typename?: 'Attachment';
  checksum?: Maybe<Scalars['String']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  self?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

export type AuditEdge = {
  __typename?: 'AuditEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AuditNote>;
};

/**
 * A record of a single update made to an entity, such as updating a payment
 * method or changing a site name.
 */
export type AuditNote = {
  __typename?: 'AuditNote';
  /** User or system who triggered the update */
  author?: Maybe<Scalars['String']>;
  /** Description of the update */
  body?: Maybe<Scalars['String']>;
  /** Contact email address */
  contactKey?: Maybe<Scalars['String']>;
  /** Date the update happened */
  created?: Maybe<Scalars['String']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  /** Id or Unique identifier of the audit note */
  id: Scalars['String'];
  metadata?: Maybe<Array<Maybe<AuditNoteMetadata>>>;
};

export type AuditNoteConnection = Connection & {
  __typename?: 'AuditNoteConnection';
  edges: Array<Maybe<AuditEdge>>;
  nodes: Array<Maybe<AuditNote>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AuditNoteMetadata = {
  __typename?: 'AuditNoteMetadata';
  fieldName?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
};

export type AuditNoteResult = {
  __typename?: 'AuditNoteResult';
  results?: Maybe<Array<Maybe<AuditNote>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export enum ContactType {
  BUSINESS_CONTACT = 'BUSINESS_CONTACT',
  CUSTOMER_CONTACT = 'CUSTOMER_CONTACT',
  OAUTH_API_CONTACT = 'OAUTH_API_CONTACT',
  QUOTE_CONTACT = 'QUOTE_CONTACT',
}

export type ContactInfo = {
  __typename?: 'ContactInfo';
  accountId?: Maybe<Scalars['String']>;
  contactType?: Maybe<ContactType>;
  email?: Maybe<Scalars['String']>;
  identifierId?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  principalAri?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AuthorProfile = {
  __typename?: 'AuthorProfile';
  account_id?: Maybe<Scalars['String']>;
  account_status?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

/** Application banner to share information such as an announcement, warning, or outage with users */
export type Banner = {
  __typename?: 'Banner';
  bannerAppearance: Scalars['String'];
  dismissalExpiration?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  endDate?: Maybe<Scalars['String']>;
  incidentTicketUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['JSON']>;
  startDate?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Benefit = {
  __typename?: 'Benefit';
  benefitType?: Maybe<Scalars['String']>;
  customisable?: Maybe<BenefitCustomisableObj>;
  duration?: Maybe<Scalars['String']>;
  iterations?: Maybe<Scalars['Int']>;
  scale?: Maybe<Scalars['String']>;
  subBenefitType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  values?: Maybe<Array<Maybe<BenefitsValueObj>>>;
};

export type BenefitCustomisableObj = {
  __typename?: 'BenefitCustomisableObj';
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  iterations?: Maybe<BenefitCustomisableValue>;
  value?: Maybe<BenefitCustomisableValue>;
};

export type BenefitCustomisableValue = {
  __typename?: 'BenefitCustomisableValue';
  lowerBound?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  upperBound?: Maybe<Scalars['Int']>;
};

export type BenefitState = {
  __typename?: 'BenefitState';
  amountOff?: Maybe<Scalars['Int']>;
  benefitEnd?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  percentageOff?: Maybe<Scalars['Int']>;
};

export enum BenefitType {
  TRIAL = 'TRIAL',
}

export type BenefitsValueObj = {
  __typename?: 'BenefitsValueObj';
  appliedOn?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type BillEstimate = {
  __typename?: 'BillEstimate';
  currency?: Maybe<Scalars['String']>;
  currentBillingPeriod?: Maybe<BillingPeriod>;
  lines?: Maybe<Array<Maybe<Lines>>>;
  totalAmountWithTax?: Maybe<Scalars['Float']>;
  upcomingCurrencyExtras?: Maybe<UpcomingCurrencyExtras>;
};

export type BillTo = {
  __typename?: 'BillTo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

/** Derive specific payment method information based on the type (Credit Card, Payment on Terms, etc). */
export type Billing = {
  __typename?: 'Billing';
  billingContacts: BillingContacts;
  billingInformation: BillTo;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
};

export type BillingAdmin = {
  __typename?: 'BillingAdmin';
  atlassianAccountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  relationshipType?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type BillingAdminConnection = Connection & {
  __typename?: 'BillingAdminConnection';
  edges?: Maybe<Array<Maybe<BillingAdminEdge>>>;
  nodes?: Maybe<Array<Maybe<BillingAdmin>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BillingAdminEdge = Edge & {
  __typename?: 'BillingAdminEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingAdmin;
};

export type BillingAdminEmailSearchParams = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

export type BillingContact = {
  __typename?: 'BillingContact';
  atlassianAccountId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
};

export type BillingContactAddress = {
  __typename?: 'BillingContactAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type BillingContacts = {
  __typename?: 'BillingContacts';
  contacts: Array<Maybe<BillingContact>>;
  totalHits: Scalars['Int'];
};

/** The countries that can be billed for form validation */
export type BillingCountry = {
  __typename?: 'BillingCountry';
  isoCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BillingCountryConnection = Connection & {
  __typename?: 'BillingCountryConnection';
  edges: Array<Maybe<BillingCountryEdge>>;
  nodes: Array<Maybe<BillingCountry>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BillingCountryEdge = Edge & {
  __typename?: 'BillingCountryEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingCountry;
};

/** The states or regions that can be billed for form validation */
export type BillingCountryState = {
  __typename?: 'BillingCountryState';
  isoCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BillingCountryStateConnection = Connection & {
  __typename?: 'BillingCountryStateConnection';
  edges: Array<Maybe<BillingCountryStateEdge>>;
  nodes: Array<Maybe<BillingCountryState>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BillingCountryStateEdge = Edge & {
  __typename?: 'BillingCountryStateEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingCountryState;
};

export enum BillingFrequency {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  OTHER = 'OTHER',
}

export type BillingPeriod = {
  __typename?: 'BillingPeriod';
  endDate?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};

export type BillingProfile = {
  __typename?: 'BillingProfile';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  numberOfCloudsites?: Maybe<Scalars['Int']>;
  numberOfSubscriptions?: Maybe<Scalars['Int']>;
  shipTo?: Maybe<ShipTo>;
};

export type BillingProfileEdge = {
  __typename?: 'BillingProfileEdge';
  node?: Maybe<BillingProfile>;
};

export type BillingProfiles = {
  __typename?: 'BillingProfiles';
  billingProfiles?: Maybe<Array<Maybe<BillingProfile>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Status of the entitlement, includes CCP and HAMS statuses */
export enum BillingStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export type BlendedComputation = {
  __typename?: 'BlendedComputation';
  blendedMargin?: Maybe<Scalars['Int']>;
  newGlp?: Maybe<Scalars['Int']>;
  previousGlp?: Maybe<Scalars['Int']>;
  renewPercentage?: Maybe<Scalars['String']>;
  renewalMargin?: Maybe<Scalars['Int']>;
  renewalValue?: Maybe<Scalars['Int']>;
  upsellMargin?: Maybe<Scalars['Int']>;
  upsellPercentage?: Maybe<Scalars['String']>;
  upsellValue?: Maybe<Scalars['Int']>;
};

export type BusinessContact = {
  __typename?: 'BusinessContact';
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type CcpInvoice = {
  __typename?: 'CcpInvoice';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceGroup?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CcpQuote = {
  __typename?: 'CcpQuote';
  createdAt?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type ChargeQuantities = {
  __typename?: 'ChargeQuantities';
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type ChargeQuantity = {
  __typename?: 'ChargeQuantity';
  chargeElement?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  usersUpdate?: Maybe<ChargeQuantityUsersUpdate>;
};

export type ChargeQuantityUsersUpdate = {
  __typename?: 'ChargeQuantityUsersUpdate';
  changeBy: Scalars['Int'];
  isAdded: Scalars['Boolean'];
  isCreated: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
};

export type ChargingDetails = {
  __typename?: 'ChargingDetails';
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantities>>>;
  pricingPlanId?: Maybe<Scalars['String']>;
};

export type ChildEntitlementsResults = {
  __typename?: 'ChildEntitlementsResults';
  results?: Maybe<Array<Maybe<CloudLicenseResults>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type CloudLicenseConnection = {
  __typename?: 'CloudLicenseConnection';
  nodes?: Maybe<Array<Maybe<CloudLicenseResults>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CloudLicenseResults = {
  __typename?: 'CloudLicenseResults';
  /** TODO :: Add proper types */
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountOwnerEmail?: Maybe<Scalars['String']>;
  aliases?: Maybe<Array<Maybe<Scalars['String']>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  childEntitlements?: Maybe<ChildEntitlementsResults>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  hoursFromSupendedDate?: Maybe<Scalars['Int']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  jobStatuses?: Maybe<JobStatus>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  renewalAction?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
  sourceSystem?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type CloudMigrationMetadata = {
  __typename?: 'CloudMigrationMetadata';
  applicationReason?: Maybe<Scalars['String']>;
  trialEndTimestamp?: Maybe<Scalars['String']>;
  trialStartTimestamp?: Maybe<Scalars['String']>;
};

export type CloudMigrationTrial = {
  __typename?: 'CloudMigrationTrial';
  metadata?: Maybe<CloudMigrationMetadata>;
  optedUsageOptions?: Maybe<OptedUsageOptions>;
  promotions?: Maybe<Array<Maybe<Promotions>>>;
};

export type CloudProduct = {
  __typename?: 'CloudProduct';
  billingStatus?: Maybe<BillingStatus>;
  cloudSiteId?: Maybe<Scalars['ID']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type CloudProductConnection = Connection & {
  __typename?: 'CloudProductConnection';
  edges?: Maybe<Array<Maybe<CloudProductEdge>>>;
  nodes?: Maybe<Array<Maybe<CloudProduct>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CloudProductEdge = Edge & {
  __typename?: 'CloudProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CloudProduct>;
};

export type CloudSite = {
  __typename?: 'CloudSite';
  baseProduct?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  bitbucketUserProfileType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSource?: Maybe<EntitlementDataSource>;
  edition?: Maybe<Scalars['String']>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  entitlementPeriods?: Maybe<Array<Maybe<EntitlementPeriod>>>;
  featureVariables?: Maybe<Scalars['JSON']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  licensedTo?: Maybe<Scalars['String']>;
  migrationEvaluationId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  prioritySupport?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningOverrideId?: Maybe<Scalars['Float']>;
  rangeEndDate?: Maybe<Scalars['JSON']>;
  renewalAction?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
};

export type CloudSiteAccess = {
  __typename?: 'CloudSiteAccess';
  results?: Maybe<Array<Maybe<SiteAccess>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type CloudSiteConnection = Connection & {
  __typename?: 'CloudSiteConnection';
  edges?: Maybe<Array<Maybe<CloudSiteEdge>>>;
  nodes?: Maybe<Array<Maybe<CloudSite>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CloudSiteData = {
  __typename?: 'CloudSiteData';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
};

export type CloudSiteDataConnection = Connection & {
  __typename?: 'CloudSiteDataConnection';
  nodes?: Maybe<Array<Maybe<CloudSiteData>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CloudSiteDetail = {
  __typename?: 'CloudSiteDetail';
  cloudSiteHostname: Scalars['String'];
  cloudSiteId: Scalars['String'];
  parentEntitlementId?: Maybe<Scalars['String']>;
  provisionedResourceType?: Maybe<ProvisionedResourceType>;
  subscriptionCount?: Maybe<Scalars['Int']>;
};

export type CloudSiteEdge = Edge & {
  __typename?: 'CloudSiteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CloudSite>;
};

export type CloudSiteJiraTrialProduct = {
  __typename?: 'CloudSiteJiraTrialProduct';
  entitlementId?: Maybe<Scalars['String']>;
  trialEndTimestamp?: Maybe<Scalars['Float']>;
};

export type CloudSiteProduct = {
  __typename?: 'CloudSiteProduct';
  accountId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billToParty?: Maybe<CommerceAddress>;
  billedUsers?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  ccpEntitlementId?: Maybe<Scalars['String']>;
  chargeElement?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  deletedProductDetails?: Maybe<DeletedProductDetails>;
  edition?: Maybe<Scalars['String']>;
  editionKey?: Maybe<Scalars['String']>;
  endBehaviour?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  extendedCloudTrial?: Maybe<ExtendedCloudTrial>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  futureEditionKey?: Maybe<Scalars['String']>;
  hasUncollectibleInvoices?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  invoiceGroup?: Maybe<InvoiceGroup>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isExternallyBilled?: Scalars['Boolean'];
  isCloud?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  optedQuantitySource?: Maybe<Scalars['String']>;
  overriddenEdition?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerDiscountTier?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<Relationship>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  sen?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
  sourceSystem?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountName?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Boolean']>;
  trialEndDate?: Maybe<Scalars['String']>;
  trialStartDate?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userTier?: Maybe<Scalars['Int']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
};

export type CloudSiteProductEdge = Edge & {
  __typename?: 'CloudSiteProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CloudSiteProduct>;
};

export type CloudSiteProductsConnection = Connection & {
  __typename?: 'CloudSiteProductsConnection';
  edges?: Maybe<Array<Maybe<CloudSiteProductEdge>>>;
  nodes?: Maybe<Array<Maybe<CloudSiteProduct>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CloudSiteProductsSearchOptions = {
  cursor?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<CloudSiteProductsSortFields>>>;
};

export type CloudSiteProductsSortFields = {
  atlassianAccess?: Maybe<SortDirection>;
  cloudSiteAndBitbucketProductName?: Maybe<SortDirection>;
  cloudSiteUrl?: Maybe<SortDirection>;
  id?: Maybe<SortDirection>;
  latestPeriodEndDate?: Maybe<SortDirection>;
  productName?: Maybe<SortDirection>;
  status?: Maybe<SortDirection>;
};

export type CloudSiteResult = {
  __typename?: 'CloudSiteResult';
  results?: Maybe<Array<Maybe<SiteAccess>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type CloudSiteSearchParams = {
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
};

export type CloudSubscription = {
  __typename?: 'CloudSubscription';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountOwnerEmail?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  bitbucketAccountType?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  childEntitlements?: Maybe<CloudSubscriptionConnection>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  edition?: Maybe<Scalars['String']>;
  editionKey?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  pageName?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  sen?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
  sourceSystem?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  subscription?: Maybe<Array<Maybe<SubscriptionDetails>>>;
  subscriptionId?: Maybe<Scalars['String']>;
  transactionDetail?: Maybe<TransactionDetailObj>;
  trial?: Maybe<Scalars['Boolean']>;
  trialEndDate?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userTier?: Maybe<Scalars['Int']>;
};

export type CloudSubscriptionConnection = {
  __typename?: 'CloudSubscriptionConnection';
  results?: Maybe<Array<Maybe<CloudSubscription>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type CloudSubscriptionSearchOptions = {
  cursor?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<SortOptions>>>;
};

export type CloudSubscriptionSearchParams = {
  email?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type CommerceAddress = {
  __typename?: 'CommerceAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  /** this a duplicate key for shipToPriceEligibility key only created to support ship to party details from CCP Search API */
  priceEligibility?: Maybe<Scalars['String']>;
  /** Pricing plan type that orders should be allowed for. ([CCP Reference](https://hello.atlassian.net/wiki/spaces/tintin/pages/927987612/Elements+of+CCP+Architecture)) */
  shipToPriceEligibility?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  taxLabels?: Maybe<Array<Maybe<TaasTaxLabel>>>;
  isActive?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type CommerceAddressConnection = Connection & {
  __typename?: 'CommerceAddressConnection';
  edges?: Maybe<Array<Maybe<CommerceAddressEdge>>>;
  nodes?: Maybe<Array<Maybe<CommerceAddress>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CommerceAddressEdge = Edge & {
  __typename?: 'CommerceAddressEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: CommerceAddress;
};

export type CommerceNoteSearchParams = {
  and?: Maybe<Array<Maybe<CommerceNoteSearchParams>>>;
  author?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  contactKey?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  createdIsGte?: Maybe<Scalars['String']>;
  createdIsLte?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  idText?: Maybe<Scalars['String']>;
  invoiceKey?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isNotNull?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<CommerceNoteSearchParams>>>;
  quoteKey?: Maybe<Scalars['String']>;
  refundKey?: Maybe<Scalars['String']>;
  transactionAccountKey?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
};

export type CommunityUser = {
  __typename?: 'CommunityUser';
  aaid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  topicsQuery?: Maybe<Scalars['String']>;
  viewProfileUrl?: Maybe<Scalars['String']>;
};

export type ComputedDetails = {
  __typename?: 'ComputedDetails';
  offeringId?: Maybe<Scalars['String']>;
};

/**
 * The connection model provides a standard mechanism for slicing and paginating the result set.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm)
 */
export type Connection = {
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Common parameters when searching for a connection and paginating (either by cursor or offset). Uses Hydra terminology by default. */
export type ConnectionSearchOptions = {
  after?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<SortType>;
};

export type Contact = {
  __typename?: 'Contact';
  accountPrivacySettings?: Maybe<Array<Maybe<AccountPrivacySettings>>>;
  address?: Maybe<Address>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  atlassianAccount?: Maybe<AtlassianAccountDetails>;
  atlassianAccountId?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cloudSiteAccess?: Maybe<CloudSiteAccess>;
  communityAccount?: Maybe<CommunityUser>;
  companyName?: Maybe<Scalars['String']>;
  countCustomerDomain?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSource?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emails: EmailConnection;
  firstName?: Maybe<Scalars['String']>;
  flaggedUser?: Maybe<FlaggedUser>;
  fullName?: Maybe<Scalars['String']>;
  hasMultipleBillingAddress?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  idType?: Maybe<IdType>;
  invoices: InvoiceConnection;
  isoCountryCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organizations>>>;
  partnerType?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status?: Maybe<ContactStatus>;
  supportIssues: SupportIssuesConnection;
  taxId?: Maybe<Scalars['String']>;
  whitelisted?: Maybe<WhitelistedUser>;
};

export type ContactEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type ContactInvoicesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type ContactSupportIssuesArgs = {
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchOptions?: Maybe<SupportIssueSearchOptions>;
  updatedFrom?: Maybe<Scalars['String']>;
  updatedTo?: Maybe<Scalars['String']>;
};

export type ContactConnection = Connection & {
  __typename?: 'ContactConnection';
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  nodes?: Maybe<Array<Maybe<Contact>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ContactEdge = Edge & {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Contact>;
};

export type ContactSearchResult = {
  __typename?: 'ContactSearchResult';
  results?: Maybe<Array<Maybe<Contact>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export enum ContactStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type ContentMeta = {
  __typename?: 'ContentMeta';
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type Credit = {
  __typename?: 'Credit';
  amountConsumedExTax?: Maybe<Scalars['Float']>;
  amountExTax?: Maybe<Scalars['Float']>;
  amountIncTax?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  creditAppliedOrderId?: Maybe<Scalars['String']>;
  creditEventDate?: Maybe<Scalars['String']>;
  creditRequesterEmail?: Maybe<Scalars['String']>;
  creditType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencyExchangeRate?: Maybe<Scalars['String']>;
  entitlementExternalId?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supportRequestId?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

export type CreditCard = PaymentMethod & {
  __typename?: 'CreditCard';
  card?: Maybe<CreditCardDetails>;
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  type: PaymentMethodType;
};

export type CreditCardDetails = {
  __typename?: 'CreditCardDetails';
  brand?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
  expirationMonth?: Maybe<Scalars['String']>;
  expirationYear?: Maybe<Scalars['String']>;
  last4Numbers?: Maybe<Scalars['String']>;
};

export enum Currency {
  AUD = 'AUD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  USD = 'USD',
}

export type CustomerBalancesRecord = {
  __typename?: 'CustomerBalancesRecord';
  jpy?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountOwnerEmail?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  bitbucketAccountType?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  edition?: Maybe<Scalars['String']>;
  editionKey?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  licenseLevel?: Maybe<Scalars['String']>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  pageName?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  sen?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
  sourceSystem?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  trial?: Maybe<Scalars['Boolean']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type CustomerSubscriptionConnection = {
  __typename?: 'CustomerSubscriptionConnection';
  results?: Maybe<Array<Maybe<CustomerSubscription>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type CustomerSubscriptionSearchOptions = {
  cursor?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type CustomerSubscriptionSearchParams = {
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
};

export type CustomisedValues = {
  __typename?: 'CustomisedValues';
  applicationReason?: Maybe<PromotionReason>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
};

export enum CycleInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type DataSource = {
  __typename?: 'DataSource';
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

export type DateRange = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type DefaultPricingPlanCycle = {
  __typename?: 'DefaultPricingPlanCycle';
  count?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DefaultPricingPlans = {
  __typename?: 'DefaultPricingPlans';
  currency?: Maybe<Scalars['String']>;
  cycle?: Maybe<DefaultPricingPlanCycle>;
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DeletedProductDetails = {
  __typename?: 'DeletedProductDetails';
  author?: Maybe<Scalars['String']>;
  datePlaced?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['String']>;
  internalComment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supportTicket?: Maybe<Scalars['String']>;
};

/** Health of the graph by basic dependency checks */
export type DependencyHealth = {
  __typename?: 'DependencyHealth';
  key: Scalars['String'];
  label: Scalars['String'];
  successful: Scalars['Boolean'];
};

export type DerivedFromOffering = {
  __typename?: 'DerivedFromOffering';
  originalOfferingKey?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  templateVersion?: Maybe<Scalars['Int']>;
};

export type DirectMatch = {
  __typename?: 'DirectMatch';
  entity?: Maybe<GraphEntity>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  /** for child entities, also return parent type (think Entitlement <-> Add-on relationship) */
  parentEntity?: Maybe<GraphEntity>;
  /** for child entities, also return identifier type (think Entitlement <-> Add-on relationship) */
  parentIdentifier?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
};

export type Domain = {
  __typename?: 'Domain';
  /**
   * The account team that services and supports a  customer. Useful for support teams to know who to talk to when problems arise.
   *
   * Examples: Customer Success Manager, Loyalty Advocate, Enterprise Advocate
   */
  salesforceAccountTeam?: Maybe<Array<Maybe<SalesforceAccountMember>>>;
};

export type Domains = {
  __typename?: 'Domains';
  domain?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  verificationType?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['String']>;
};

export type DueDate = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type Dunning = {
  __typename?: 'Dunning';
  endTimestamp?: Maybe<Scalars['Float']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type DunningStatus = {
  __typename?: 'DunningStatus';
  attemptCount?: Maybe<Scalars['Int']>;
  declineCode?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  nextPaymentAttempDate?: Maybe<Scalars['String']>;
  paymentRetryDate?: Maybe<Scalars['String']>;
};

/**
 * A type that is returned in list form by a connection type’s edges field is considered by this spec to be an Edge Type. Edge types must be an “Object” as defined in the “Type System” section of the GraphQL Specification.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-Edges)
 */
export type Edge = {
  cursor?: Maybe<Scalars['ID']>;
};

export type EffectiveTime = {
  __typename?: 'EffectiveTime';
  endsAt?: Maybe<EndsAt>;
};

export type EligibilityRule = {
  __typename?: 'EligibilityRule';
  currency?: Maybe<Array<Maybe<Scalars['String']>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  partnerTier?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerType?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  saleTransitionType?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Email = {
  __typename?: 'Email';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  bcc?: Maybe<Array<Maybe<EmailAddress>>>;
  cc?: Maybe<Array<Maybe<EmailAddress>>>;
  date?: Maybe<Scalars['String']>;
  from?: Maybe<Array<Maybe<EmailAddress>>>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mailbox?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
  replyTo?: Maybe<Array<Maybe<EmailAddress>>>;
  self?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  to?: Maybe<Array<Maybe<EmailAddress>>>;
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EmailConnection = Connection & {
  __typename?: 'EmailConnection';
  edges?: Maybe<Array<Maybe<EmailEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EmailEdge = Edge & {
  __typename?: 'EmailEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: Email;
};

export type EmailFilterSearchParams = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

export type EmailSearchParams = {
  __typename?: 'EmailSearchParams';
  term?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EndCustomerContact = {
  __typename?: 'EndCustomerContact';
  accountId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  entitlements?: Maybe<EndCustomerContactEntitlements>;
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type EndCustomerContactConnection = Connection & {
  __typename?: 'EndCustomerContactConnection';
  nodes?: Maybe<Array<Maybe<EndCustomerContact>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EndCustomerContactEntitlements = {
  __typename?: 'EndCustomerContactEntitlements';
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  orders?: Maybe<OrderConnection>;
};

export type EndCustomerContactSearchParams = {
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
};

export type EndsAt = {
  __typename?: 'EndsAt';
  billingFrequencyCount?: Maybe<Scalars['Float']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Base type from which all product entitlements extend. This contains the
 * minimal amount fields that should be expected on all entitlements.
 * Any queries that return this Entitlement interface will also return any
 * types extended from Entitlement.
 */
export type Entitlement = {
  /** AKA Invoice Group Id: foreign key to invoice group used to pay for the entitlement's subscriptions. */
  billingGroupId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  offering?: Maybe<Offering>;
  pricingPlan?: Maybe<PricingPlan>;
};

export type EntitlementDataSource = {
  __typename?: 'EntitlementDataSource';
  bitbucketAuthUser?: Maybe<Scalars['String']>;
  hamsAccount?: Maybe<Scalars['String']>;
  hamsLicense?: Maybe<Scalars['String']>;
  hipchatSubscriptions?: Maybe<Scalars['String']>;
  pakoLicense?: Maybe<Scalars['String']>;
  shopSubscriber?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceTable?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  trello?: Maybe<Scalars['String']>;
};

export type EntitlementDetails = Entitlement & {
  __typename?: 'EntitlementDetails';
  activeSubscriptionBillingGroupId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  addOns?: Maybe<AddOnConnection>;
  addnCCPEntitlementDetails?: Maybe<AddnCcpEntitlementDetails>;
  auditNotes?: Maybe<AuditNoteConnection>;
  availableOfferings?: Maybe<Array<Maybe<Offering>>>;
  availablePartnerPromotions?: Maybe<Array<Maybe<Promotion>>>;
  availablePricingPlans?: Maybe<Array<Maybe<PricingPlan>>>;
  availablePromotions?: Maybe<Array<Maybe<Promotion>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billing?: Maybe<Billing>;
  billingClockId?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  chargeElement?: Maybe<Scalars['String']>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  deletedProductDetails?: Maybe<DeletedProductDetails>;
  edition?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailConnection>;
  endBehaviour?: Maybe<Scalars['String']>;
  endCustomerContacts?: Maybe<Array<Maybe<EndCustomerContact>>>;
  endTimestamp?: Maybe<Scalars['Float']>;
  enterpriseInstanceInGraph?: Maybe<LinkedDestinationEntitlement>;
  entitlementNumber?: Maybe<Scalars['String']>;
  familyEntitlements?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  futureDatedStartTimestamp?: Maybe<Scalars['Float']>;
  hasOpenInvoices?: Maybe<Scalars['Boolean']>;
  hasPendingInvoices?: Maybe<Scalars['Boolean']>;
  hasUncollectibleInvoices?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoices: InvoiceConnection;
  isAddOn?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isAppInstalled?: Maybe<Scalars['Boolean']>;
  isFutureDatedSubscription?: Maybe<Scalars['Boolean']>;
  isOptOutAllowed?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  linkedAccessEntitlementNumber?: Maybe<Scalars['String']>;
  linkedEntitlementDetailsBasedOnIds?: Maybe<Array<Maybe<LinkedDestinationEntitlement>>>;
  linkedEntitlementIds?: Maybe<Array<Scalars['String']>>;
  linkedEntitlements?: Maybe<Array<Maybe<LinkedDestinationEntitlement>>>;
  logoId?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['String']>;
  migrationType?: Maybe<Scalars['String']>;
  nextBillEstimate?: Maybe<NextBillEstimate>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  nextBillingTimestampForScheduledUpgrades?: Maybe<Scalars['String']>;
  nextInvoiceTimeAt?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  optedQuantitySource?: Maybe<Scalars['String']>;
  orders?: Maybe<OrderConnection>;
  ordersForRewind?: Maybe<OrderConnection>;
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  organizationDomains?: Maybe<Array<Maybe<OrganizationDomain>>>;
  parentCloudSiteName?: Maybe<Scalars['String']>;
  parentContainerId?: Maybe<Scalars['String']>;
  parentEntitlementDetails?: Maybe<LinkedDestinationEntitlement>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  pauseBilling?: Maybe<PauseBilling>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanHistory: InvoiceConnection;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productStatus?: Maybe<Scalars['String']>;
  productType?: Maybe<LinkedProductTypes>;
  promoCodesApplicable?: Maybe<PromoCodeResponseDto>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  provisionedResourceDetails?: Maybe<ProvisionedResourceDetails>;
  provisionedResourceType?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  renewalAction?: Maybe<Scalars['String']>;
  sandboxEntitlements?: Maybe<Array<Maybe<LinkedDestinationEntitlement>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  showExtendTrial?: Maybe<Scalars['Boolean']>;
  siteAdmins?: Maybe<SiteAdminConnection>;
  sourceSystem?: Maybe<Scalars['String']>;
  subscription?: Maybe<Array<Maybe<SubscriptionDetails>>>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionTimestamps?: Maybe<SubscriptionTimeStamps>;
  subscriptionsEndTimestamp?: Maybe<Scalars['String']>;
  supportIssues?: Maybe<SupportIssues>;
  termDetails?: Maybe<EntitlementTermDetails>;
  totalBilledUsers?: Maybe<Scalars['Int']>;
  transactionAccount?: Maybe<TransactionAccount>;
  transactionAccountId?: Maybe<Scalars['String']>;
  trialDetails?: Maybe<TrialDetails>;
  trialPromotionDetails?: Maybe<TrialPromotionDetails>;
  unitCount?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  updatePaymentMethodLinkPartner?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userHistory?: Maybe<UserHistoryDetails>;
  userTier?: Maybe<Scalars['Int']>;
  users?: Maybe<UserConnection>;
  validOfferings?: Maybe<Array<Maybe<ValidOfferings>>>;
  version?: Maybe<Scalars['String']>;
  isExternallyBilled?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<EntitlementMetadata>;
};

export type EntitlementDetailsActiveUsersArgs = {
  id?: Maybe<Scalars['String']>;
};

export type EntitlementDetailsAddOnsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsAuditNotesArgs = {
  dateFilter?: Maybe<DateRange>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsAvailablePartnerPromotionsArgs = {
  billingFrequency?: Maybe<Scalars['String']>;
  discountTier?: Maybe<Scalars['String']>;
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
};

export type EntitlementDetailsAvailablePricingPlansArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

export type EntitlementDetailsAvailablePromotionsArgs = {
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
};

export type EntitlementDetailsEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsEndCustomerContactsArgs = {
  isRestricted?: Maybe<Scalars['Boolean']>;
};

export type EntitlementDetailsEntitlementPeriodArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsHasOpenInvoicesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  shouldFilterByEntitlementTxA?: Maybe<Scalars['Boolean']>;
};

export type EntitlementDetailsInvoicesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  shouldFilterByEntitlementTxA?: Maybe<Scalars['Boolean']>;
};

export type EntitlementDetailsLinkedEntitlementDetailsBasedOnIdsArgs = {
  linkedEntitlementsParams: Array<Scalars['String']>;
};

export type EntitlementDetailsLinkedEntitlementIdsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type EntitlementDetailsLinkedEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type EntitlementDetailsOrdersArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsParentContainerIdArgs = {
  id?: Maybe<Scalars['String']>;
};

export type EntitlementDetailsPricingPlanHistoryArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsProductNotesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsPromoCodesApplicableArgs = {
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
};

export type EntitlementDetailsSandboxEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type EntitlementDetailsSubscriptionArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsSupportIssuesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParam?: Maybe<SupportIssueEntitlementSearchParams>;
};

export type EntitlementDetailsUsageAggregationArgs = {
  entitlementId: Scalars['String'];
};

export type EntitlementDetailsUsageForCurrentBillingPeriodStartArgs = {
  id?: Maybe<Scalars['String']>;
};

export type EntitlementDetailsUserHistoryArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

export type EntitlementDetailsUsersArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type EntitlementDetailsFilters = {
  status?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type EntitlementIds = {
  __typename?: 'EntitlementIds';
  id?: Maybe<Scalars['String']>;
};

export type EntitlementMetadata = {
  __typename?: 'EntitlementMetadata';
  contractId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  originalOrderItemId?: Maybe<Scalars['String']>;
};

export type EntitlementPeriod = {
  __typename?: 'EntitlementPeriod';
  baseProduct?: Maybe<Scalars['String']>;
  billTo?: Maybe<BillTo>;
  billingFrequency?: Maybe<BillingFrequency>;
  bitbucketUserProfileType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  edition?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  licenseLevel?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  periodEndDate?: Maybe<Scalars['String']>;
  periodStartDate?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  previousEntitlementPeriodId?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  shipTo?: Maybe<BillTo>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type EntitlementPeriodHistory = {
  __typename?: 'EntitlementPeriodHistory';
  amount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  periodEndDate?: Maybe<Scalars['String']>;
  periodStartDate?: Maybe<Scalars['String']>;
  pricingPlanName?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
};

export type EntitlementPeriodHistoryConnection = Connection & {
  __typename?: 'EntitlementPeriodHistoryConnection';
  edges?: Maybe<Array<Maybe<EntitlementPeriodHistoryEdge>>>;
  nodes?: Maybe<Array<Maybe<EntitlementPeriodHistory>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EntitlementPeriodHistoryEdge = Edge & {
  __typename?: 'EntitlementPeriodHistoryEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<EntitlementPeriodHistory>;
};

export type EntitlementTermDetails = {
  __typename?: 'EntitlementTermDetails';
  availableCreditLimit?: Maybe<Scalars['Float']>;
  creditOutstanding?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  pendingInvoiceRequestsTotal?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  totalCreditLimit?: Maybe<Scalars['Float']>;
};

export type EntitlementToOrganizationLinkSearchParams = {
  query: Scalars['String'];
};

export type EntitlementsGroupByBillingDate = {
  __typename?: 'EntitlementsGroupByBillingDate';
  billingDateGroup?: Maybe<Array<Maybe<EntitlementGroup>>>;
  id?: Maybe<Scalars['String']>;
};

export type EntitlementsGroupByCloudSite = {
  __typename?: 'EntitlementsGroupByCloudSite';
  billingFrequency?: Maybe<Scalars['String']>;
  cloudSiteHostname: Scalars['String'];
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementNumber: Scalars['String'];
  logoId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  scheduledChanges?: Maybe<ScheduledChanges>;
  isApp?: Maybe<Scalars['Boolean']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  parentEntitlementId?: Maybe<Scalars['String']>;
  familyContainerId?: Maybe<Scalars['String']>;
  entitlementId?: Scalars['String'];
};

export type EntitlementsGroupByCloudSiteConnection = {
  __typename?: 'EntitlementsGroupByCloudSiteConnection';
  cloudSiteId: Scalars['String'];
  entries?: Maybe<Array<Maybe<EntitlementsGroupByCloudSite>>>;
};

export type EssotEntitlement = {
  __typename?: 'EssotEntitlement';
  accountOwnerEmail?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  ccpBillingContactEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  ccpOfferingId?: Maybe<Scalars['String']>;
  ccpOrderItemId?: Maybe<Scalars['String']>;
  ccpSubscriptionId?: Maybe<Scalars['String']>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  destroyDate?: Maybe<Scalars['String']>;
  destroyGsacTicket?: Maybe<Scalars['String']>;
  destroyNotes?: Maybe<Scalars['String']>;
  destroyRequestBy?: Maybe<Scalars['String']>;
  destroyRequestOn?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  hamsCcpInvoiceGroupId?: Maybe<Scalars['String']>;
  hamsCcpTransactionAccountId?: Maybe<Scalars['String']>;
  hipaaEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  invoiceGroupId?: Maybe<Scalars['String']>;
  lastPeriodEndDate?: Maybe<Scalars['String']>;
  lastPeriodStartDate?: Maybe<Scalars['String']>;
  legacyEntitlementId?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['Boolean']>;
  migrationType?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  organisationId?: Maybe<Scalars['String']>;
  organisationSen?: Maybe<Scalars['String']>;
  pageCode?: Maybe<Scalars['String']>;
  parentEntitlementId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  priceOverrideType?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  prioritySupport?: Maybe<Scalars['Boolean']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  provisioningSystem?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  renewalAction?: Maybe<Scalars['String']>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  serverId?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type EssotEntitlementConnection = Connection & {
  __typename?: 'EssotEntitlementConnection';
  edges?: Maybe<Array<Maybe<EssotEntitlementEdge>>>;
  nodes?: Maybe<Array<Maybe<EssotEntitlement>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EssotEntitlementEdge = Edge & {
  __typename?: 'EssotEntitlementEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: EssotEntitlement;
};

export type EstimateBillingPeriod = {
  __typename?: 'EstimateBillingPeriod';
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type ExistingEnterpriseInstanceDetails = {
  __typename?: 'ExistingEnterpriseInstanceDetails';
  cloudSiteId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
};

export type ExtendedCloudTrial = {
  __typename?: 'ExtendedCloudTrial';
  btfSourceAccountId?: Maybe<Scalars['String']>;
  usageLimit?: Maybe<Scalars['Int']>;
  usageType?: Maybe<Scalars['String']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  flagKey: Scalars['String'];
  isEnabled: Scalars['Boolean'];
};

export enum FieldVisibility {
  collaborator = 'collaborator',
  private = 'private',
  public = 'public',
}

/** Filter option to be sent in filterOptions array when filtering for a connection. */
export type FilterOption = {
  and?: Maybe<Array<Maybe<FilterOption>>>;
  key?: Maybe<Scalars['String']>;
  not?: Maybe<Array<Maybe<FilterOption>>>;
  or?: Maybe<Array<Maybe<FilterOption>>>;
  value?: Maybe<Scalars['String']>;
  /**
   * values to pass as an array in case where filter option supports key value need array
   * Union is another option to update value property to be used but that need a major refactoring of code
   */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FlaggedUser = {
  __typename?: 'FlaggedUser';
  actionTaken?: Maybe<Scalars['String']>;
  aid?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  manual?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  requestor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

/** Graph entity is an enumeration of the different objects that's information is then aggregated within the graph */
export enum GraphEntity {
  ATLASSIAN_ACCESS = 'ATLASSIAN_ACCESS',
  BITBUCKET = 'BITBUCKET',
  CCP_ENTITLEMENT = 'CCP_ENTITLEMENT',
  /** this can be an add-on, marketplace app, or right now Jira / Confluence */
  CHILD_PRODUCT = 'CHILD_PRODUCT',
  CLOUD_SITE = 'CLOUD_SITE',
  CREDITNOTE = 'CREDITNOTE',
  DOMAIN = 'DOMAIN',
  EMAIL = 'EMAIL',
  ENTITLEMENT = 'ENTITLEMENT',
  INVOICE = 'INVOICE',
  INVOICE_GROUP = 'INVOICE_GROUP',
  OPPORTUNITY = 'OPPORTUNITY',
  OPSGENIE = 'OPSGENIE',
  ORDER = 'ORDER',
  ORGANIZATION = 'ORGANIZATION',
  PARTNER_ACCOUNT = 'PARTNER_ACCOUNT',
  PERSON = 'PERSON',
  QUOTE = 'QUOTE',
  REFUND = 'REFUND',
  SERVER_LICENSE = 'SERVER_LICENSE',
  SERVICE_LICENSE = 'SERVICE_LICENSE',
  STATUSPAGE = 'STATUSPAGE',
  SUPPORT_ISSUE = 'SUPPORT_ISSUE',
  TRANSACTION_ACCOUNT = 'TRANSACTION_ACCOUNT',
  TRELLO = 'TRELLO',
}

export type HamsInvoice = {
  __typename?: 'HamsInvoice';
  lastEvaluatedKey?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<Invoice>>>;
};

export enum IdType {
  AAID = 'AAID',
  Email = 'Email',
}

export type Invoice = {
  __typename?: 'Invoice';
  appliedBalance?: Maybe<Scalars['Float']>;
  billTo?: Maybe<InvoiceBillAndShipTo>;
  billingContactName?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingFrequencyInterval?: Maybe<Scalars['Int']>;
  billingGroupId?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  coupledLineItems?: Maybe<ProductAppLineItemData>;
  createdDate?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  creditCard?: Maybe<CreditCardDetails>;
  creditCardMaskedNumber?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  dstLineItems?: Maybe<Array<Maybe<InvoiceLineItems>>>;
  dueDate?: Maybe<Scalars['String']>;
  dunningStatus?: Maybe<Array<Maybe<DunningStatus>>>;
  entitlementId?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Float']>;
  grandTotalPaymentCurrency?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  invoiceContactEmails?: Maybe<Array<Maybe<InvoiceContactEmails>>>;
  invoiceDueDays?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  itemsCount?: Maybe<Scalars['Int']>;
  itemsSubtotal?: Maybe<Scalars['Float']>;
  itemsTotal?: Maybe<Scalars['Float']>;
  itemsTotalPaymentCurrency?: Maybe<Scalars['Float']>;
  lineItems?: Maybe<Array<Maybe<InvoiceLineItems>>>;
  memo?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<AdditionalNotes>>>;
  orderId?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<InvoiceOrderStatus>;
  paidDate?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentCurrency?: Maybe<Scalars['String']>;
  paymentMadeByEmail?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentOnTermsDetails?: Maybe<PaymentOnTerms>;
  paymentTerms?: Maybe<InvoicePaymentTerms>;
  paypalAccountEmail?: Maybe<Scalars['String']>;
  pdfLink?: Maybe<Scalars['String']>;
  prePaymentCreditNotesAmount?: Maybe<Scalars['Float']>;
  previousInvoiceId?: Maybe<Scalars['String']>;
  pricingCurrency?: Maybe<Scalars['String']>;
  promotionCode?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  purchaserEmail?: Maybe<Scalars['String']>;
  refunds?: Maybe<Array<Maybe<Refunds>>>;
  revisionNumber?: Maybe<Scalars['String']>;
  selfServeBACInvoiceLink?: Maybe<Scalars['String']>;
  serviceCreditAmount?: Maybe<Scalars['Float']>;
  shipTo?: Maybe<InvoiceBillAndShipTo>;
  slaCredits?: Maybe<Array<Maybe<SlaCreditApplications>>>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  statusReason?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  taxIdentifier?: Maybe<Scalars['String']>;
  taxIdentifierType?: Maybe<Scalars['String']>;
  taxRate?: Maybe<InvoiceTaxRate>;
  taxes?: Maybe<Scalars['String']>;
  taxesPaymentCurrency?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalDiscount?: Maybe<Scalars['Float']>;
  totalPartnerMargin?: Maybe<Scalars['Float']>;
  transactionAccount?: Maybe<Array<Maybe<TransactionAccount>>>;
  transactionAccountId?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  upgradeCredits?: Maybe<Scalars['String']>;
  userDefinedNotes?: Maybe<Scalars['JSON']>;
};

export type InvoiceCoupledLineItemsArgs = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
};
export type InvoiceCoupledLineItemsV2Args = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
};

export type InvoiceAddress = {
  __typename?: 'InvoiceAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type InvoiceBillAndShipTo = {
  __typename?: 'InvoiceBillAndShipTo';
  address?: Maybe<InvoiceAddress>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  taxLabels?: Maybe<Array<Maybe<TaasTaxLabel>>>;
};

export type InvoiceConnection = Connection & {
  __typename?: 'InvoiceConnection';
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvoiceContactEmails = {
  __typename?: 'InvoiceContactEmails';
  items?: Maybe<Scalars['String']>;
};

export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type InvoiceEdge = Edge & {
  __typename?: 'InvoiceEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Invoice>;
};

export type OrgDetails = {
  __typename?: 'OrgDetails';
  orgId: Maybe<Scalars['String']>;
  orgName: Maybe<Scalars['String']>;
};
export type InvoiceEntitlementItem = {
  __typename?: 'InvoiceEntitlementItem';
  baseProduct?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  offeringId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  sourceSystem?: Maybe<Scalars['String']>;
  orgInfo?: Maybe<OrgDetails>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
};

export type InvoiceEssotEntitlementItem = {
  __typename?: 'InvoiceEssotEntitlementItem';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  sourceSystem?: Maybe<Scalars['String']>;
};

export type InvoiceFilterOption = {
  billingGroupId?: Maybe<Scalars['String']>;
  cloudSiteHostnamePartial?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  containsNameMultiMatch?: Maybe<Scalars['String']>;
  creditNoteNumber?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<InvoiceFilterOption>>>;
  organization?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  shipToId?: Maybe<Scalars['String']>;
  shipToPartyId?: Maybe<Scalars['String']>;
  shipToPartyName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  technicalContactName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroup = {
  __typename?: 'InvoiceGroup';
  availablePaymentMethods?: Maybe<PaymentMethodConnection>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  id?: Maybe<Scalars['ID']>;
  invoiceGroupNumber?: Maybe<Scalars['String']>;
  invoiceToRecipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoices?: Maybe<InvoiceConnection>;
  name?: Maybe<Scalars['String']>;
  numberOfCloudsites?: Maybe<Scalars['Int']>;
  numberOfSubscriptions?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  pendingInvoices?: Maybe<Array<Maybe<Scalars['Float']>>>;
  productAndAppSubscriptions?: Maybe<ProductAppSubscriptionForInvoiceGroupData>;
  productSubscriptions?: Maybe<InvoiceGroupProductConnection>;
  products?: Maybe<InvoiceGroupProductConnection>;
  purchaseOrder?: Maybe<InvoiceGroupPurchaseOrder>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  shipToParty?: Maybe<CommerceAddress>;
  shipToPriceEligibility?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  termPaymentStatus?: Maybe<TermDetailsAccountConnection>;
  transactionAccount?: Maybe<TransactionAccount>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  updatePaymentMethodLinkPartner?: Maybe<Scalars['String']>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroupDefaultPaymentMethodArgs = {
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroupInvoicesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroupProductAndAppSubscriptionsArgs = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroupProductSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type InvoiceGroupProductsArgs = {
  fetchEntitlementProductIDs?: Maybe<Scalars['Boolean']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupBasedOnSearch = {
  __typename?: 'InvoiceGroupBasedOnSearch';
  currency?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
};

export type InvoiceGroupBasedOnSearchDefaultPaymentMethodArgs = {
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
};

export type InvoiceGroupConnection = Connection & {
  __typename?: 'InvoiceGroupConnection';
  edges: Array<Maybe<InvoiceGroupEdge>>;
  nodes: Array<Maybe<InvoiceGroup>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InvoiceGroupEdge = Edge & {
  __typename?: 'InvoiceGroupEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: InvoiceGroup;
};

export type InvoiceGroupFromSearch = {
  __typename?: 'InvoiceGroupFromSearch';
  currency?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pricingEligibility?: Maybe<Scalars['String']>;
};

export type InvoiceGroupProduct = {
  __typename?: 'InvoiceGroupProduct';
  activeSubscriptionBillingGroupId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  baseProduct?: Maybe<Scalars['String']>;
  billedUsers?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isApp?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningStatus?: Maybe<Scalars['String']>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  trial?: Maybe<Scalars['Boolean']>;
  trialEndDate?: Maybe<Scalars['String']>;
  trialStartDate?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userTier?: Maybe<Scalars['Int']>;
};

export type InvoiceGroupProductConnection = Connection & {
  __typename?: 'InvoiceGroupProductConnection';
  edges?: Maybe<Array<Maybe<InvoiceGroupProductEdge>>>;
  nodes?: Maybe<Array<Maybe<InvoiceGroupProduct>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InvoiceGroupProductEdge = Edge & {
  __typename?: 'InvoiceGroupProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: InvoiceGroupProduct;
};

export type InvoiceGroupPurchaseOrder = {
  __typename?: 'InvoiceGroupPurchaseOrder';
  number?: Maybe<Scalars['String']>;
  oneTimeUse?: Maybe<Scalars['Boolean']>;
};

export type InvoiceGroupSearchOptions = {
  defaultInvoiceGroupId?: Maybe<Scalars['String']>;
  searchText: Scalars['String'];
};

export type InvoiceGroupsForInvoiceGroupIds = {
  __typename?: 'InvoiceGroupsForInvoiceGroupIds';
  invoiceGroupId?: Maybe<Scalars['String']>;
  totalEntitlementsCount?: Maybe<Scalars['Int']>;
};

export type InvoiceGroupsForPaymentMethod = {
  __typename?: 'InvoiceGroupsForPaymentMethod';
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceConnection>;
  paymentMethodBillingGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productSubscriptions?: Maybe<InvoiceGroupProductConnection>;
};

export type InvoiceGroupsForPaymentMethodInvoicesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupsForPaymentMethodProductSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupsForShipToPartyId = {
  __typename?: 'InvoiceGroupsForShipToPartyId';
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<InvoiceConnection>;
  productSubscriptions?: Maybe<InvoiceGroupProductConnection>;
  shipToPartyBillingGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InvoiceGroupsForShipToPartyIdInvoicesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupsForShipToPartyIdProductSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupsForShipToPartyIds = {
  __typename?: 'InvoiceGroupsForShipToPartyIds';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoices?: Maybe<InvoiceConnection>;
  shipToPartiesBillingGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InvoiceGroupsForShipToPartyIdsInvoicesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type InvoiceGroupsForShipToPartyNames = {
  __typename?: 'InvoiceGroupsForShipToPartyNames';
  shipToPartyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  shipToPartyName?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvoiceLineItemRequest = {
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  isApp?: Maybe<Scalars['Boolean']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  promotionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InvoiceLineItems = {
  __typename?: 'InvoiceLineItems';
  accountName?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Array<Maybe<AdditionalNotes>>>;
  amount?: Maybe<Scalars['String']>;
  amountPaymentCurrency?: Maybe<Scalars['Float']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  contractModified?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  description?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<InvoiceDiscounts>>>;
  edition?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  entitlement?: Maybe<InvoiceEntitlementItem>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  entitlementPeriodId?: Maybe<Scalars['String']>;
  essotEntitlement?: Maybe<InvoiceEssotEntitlementItem>;
  externalNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  latestInvoiceDetails?: Maybe<LatestInvoiceDetails>;
  listPrice?: Maybe<Scalars['Float']>;
  listPricePaymentCurrency?: Maybe<Scalars['Float']>;
  logoId?: Maybe<Scalars['String']>;
  margins?: Maybe<Array<Maybe<InvoiceMargins>>>;
  metadata?: Maybe<LineItemMetaData>;
  orderLineId?: Maybe<Scalars['String']>;
  originalInvoiceReferral?: Maybe<OriginalInvoiceReferral>;
  parentBaseProduct?: Maybe<Scalars['String']>;
  parentEntitlementKey?: Maybe<Scalars['String']>;
  parentProductKey?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  previousInvoiceItemId?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  promotionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotionItems?: Maybe<Array<Maybe<Promotion>>>;
  proratedPrice?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  renewalListPrice?: Maybe<Scalars['Float']>;
  saleAction?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  taxAmountPaymentCurrency?: Maybe<Scalars['Float']>;
  taxExemptAmountPaymentCurrency?: Maybe<Scalars['Float']>;
  taxItems?: Maybe<Array<Maybe<TaxItems>>>;
  taxRate?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalPaymentCurrency?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['Float']>;
  unitLabel?: Maybe<Scalars['String']>;
  vendorAmount?: Maybe<Scalars['Float']>;
  vendorId?: Maybe<Scalars['String']>;
  vendorPaymentCurrency?: Maybe<Scalars['Float']>;
};

export type InvoiceMargins = {
  __typename?: 'InvoiceMargins';
  amount?: Maybe<Scalars['Float']>;
  blended?: Maybe<Scalars['Boolean']>;
  blendedComputation?: Maybe<BlendedComputation>;
  endDate?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
  promoCode?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type InvoiceOrderStatus = {
  __typename?: 'InvoiceOrderStatus';
  completed?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['String']>;
  orderReference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  successful?: Maybe<Scalars['Boolean']>;
};

export type InvoicePageParams = {
  cursor?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export enum InvoicePaymentMethod {
  DEFERRED = 'DEFERRED',
  NOPAYMENT = 'NOPAYMENT',
  NULL = 'NULL',
  PAID = 'PAID',
  PAIDCC = 'PAIDCC',
  PAIDONACCOUNT = 'PAIDONACCOUNT',
  PAIDPAYPAL = 'PAIDPAYPAL',
  PAID_BANK = 'PAID_BANK',
  PAID_ON_TERMS = 'PAID_ON_TERMS',
  STRIPE_CARD = 'STRIPE_CARD',
}

export enum InvoicePaymentTerms {
  PAY_CC = 'PAY_CC',
  PAY_ON_ACCOUNT = 'PAY_ON_ACCOUNT',
}

export type InvoicePromotionDetail = {
  __typename?: 'InvoicePromotionDetail';
  promotionDefinition?: Maybe<PromotionDefinition>;
  promotionInstanceId?: Maybe<Scalars['String']>;
};

export type InvoiceRelationship = {
  __typename?: 'InvoiceRelationship';
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
};

export type InvoiceSearchOptions = {
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export enum InvoiceStatus {
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  DEFERRED_PAID = 'DEFERRED_PAID',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  INVOICED = 'INVOICED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PAYMENT_DEFERRED = 'PAYMENT_DEFERRED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  REFUNDED = 'REFUNDED',
  RESERVED = 'RESERVED',
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
  VOID = 'VOID',
}

export type InvoiceTaxRate = {
  __typename?: 'InvoiceTaxRate';
  displayName?: Maybe<Scalars['String']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  taxIdLabel?: Maybe<Scalars['String']>;
  taxType?: Maybe<Scalars['String']>;
};

export type InvoiceWhereFilter = {
  and?: Maybe<Array<Maybe<InvoiceWhereFilter>>>;
  cloudSiteId?: Maybe<Scalars['String']>;
  creditCardExpiryMonth?: Maybe<Scalars['String']>;
  creditCardExpiryYear?: Maybe<Scalars['String']>;
  creditCardHolderName?: Maybe<Scalars['String']>;
  creditExternalId?: Maybe<Scalars['String']>;
  creditLastFour?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  dueDate?: Maybe<DueDate>;
  endDate?: Maybe<Scalars['String']>;
  endDateIsGte?: Maybe<Scalars['String']>;
  endDateIsLte?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includeItems?: Maybe<Scalars['Boolean']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceNumberIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxTotal?: Maybe<Scalars['Float']>;
  minTotal?: Maybe<Scalars['Float']>;
  not?: Maybe<Array<Maybe<InvoiceWhereFilter>>>;
  or?: Maybe<Array<Maybe<InvoiceWhereFilter>>>;
  paymentMethod?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  showCCPData?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type InvoicesFilterOptions = {
  and?: Maybe<Array<Maybe<InvoiceFilterOption>>>;
  not?: Maybe<Array<Maybe<InvoiceFilterOption>>>;
  or?: Maybe<Array<Maybe<InvoiceFilterOption>>>;
};

export type InvoicesSearchResult = {
  __typename?: 'InvoicesSearchResult';
  results?: Maybe<Array<Maybe<Invoice>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type JobStatus = {
  __typename?: 'JobStatus';
  deactivateInProgress?: Maybe<Scalars['Boolean']>;
  deleteInProgress?: Maybe<Scalars['Boolean']>;
  reactivateInProgress?: Maybe<Scalars['Boolean']>;
  renameInProgress?: Maybe<Scalars['Boolean']>;
};

export type LastInvoiceDetails = {
  __typename?: 'LastInvoiceDetails';
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type LevelDetails = {
  __typename?: 'LevelDetails';
  discountTier?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  setAs?: Maybe<Scalars['Float']>;
};

export type LicenseSortFields = {
  latestPeriodEndDate?: Maybe<LicenseSortTypes>;
  maintenanceActive?: Maybe<LicenseSortTypes>;
  productName?: Maybe<LicenseSortTypes>;
  status?: Maybe<LicenseSortTypes>;
};

export enum LicenseSortTypes {
  asc = 'asc',
  desc = 'desc',
}

export type LineItemEnrichmentDetail = {
  __typename?: 'LineItemEnrichmentDetail';
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  latestInvoiceDetails?: Maybe<LatestInvoiceDetails>;
  logoId?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  promotionItems?: Maybe<Array<Maybe<Promotion>>>;
  provisionedResourceDetails?: Maybe<ProvisionedResourceDetails>;
  sourceSystem?: Maybe<Scalars['String']>;
};

export type LineItemEntitlementTrial = {
  __typename?: 'LineItemEntitlementTrial';
  endTimestamp?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
};

export type LineItemMetaData = {
  __typename?: 'LineItemMetaData';
  parentItemId?: Maybe<Scalars['String']>;
  type?: Maybe<MetadataType>;
};

export type Lines = {
  __typename?: 'Lines';
  entitlementId?: Maybe<Scalars['String']>;
  usage?: Maybe<Array<Maybe<Usage>>>;
};

export type LinkEntitlementToProvisionedResource = {
  __typename?: 'LinkEntitlementToProvisionedResource';
  entitlementId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisionedResourceId?: Maybe<Scalars['String']>;
  provisionedResourceMetadataObject?: Maybe<ProvisionedResourceMetadataObject>;
  provisionedResourceName?: Maybe<Scalars['String']>;
  provisionedResourceType?: Maybe<Scalars['String']>;
};

export type LinkedDestinationEntitlement = {
  __typename?: 'LinkedDestinationEntitlement';
  activeUsers?: Maybe<Scalars['Int']>;
  baseProduct?: Maybe<Scalars['String']>;
  billPeriod?: Maybe<Scalars['String']>;
  billedUsers?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<BillingFrequency>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<BillingStatus>;
  chargeElement?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['String']>;
  endBehaviour?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementId: Scalars['String'];
  entitlementNumber?: Maybe<Scalars['String']>;
  futureDatedStartTimestamp?: Maybe<Scalars['Float']>;
  grandTotal?: Maybe<Scalars['Float']>;
  hasUncollectibleInvoices?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isFutureDatedSubscription?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  lastPeriodStartDate?: Maybe<Scalars['String']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  linkedAddOnsId?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedAppsId?: Maybe<Array<Maybe<Scalars['String']>>>;
  logoId?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['String']>;
  nextBillEstimate?: Maybe<NextBillEstimate>;
  nextBillingTimestamp?: Maybe<Scalars['Float']>;
  nextBillingTimestampForScheduledUpgrades?: Maybe<Scalars['Float']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  optedQuantitySource?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  pauseBilling?: Maybe<PauseBilling>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  provisionedResourceDetails?: Maybe<ProvisionedResourceDetails>;
  provisioningStatus?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  shipToParty?: Maybe<CommerceAddress>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionTimestamps?: Maybe<SubscriptionTimeStamps>;
  transactionAccountId?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Boolean']>;
  trialDetails?: Maybe<TrialDetails>;
  trialEndDate?: Maybe<Scalars['String']>;
  trialStartDate?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['Int']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userTier?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type LinkedEnterprise = {
  __typename?: 'LinkedEnterprise';
  billedUsers?: Maybe<Scalars['String']>;
  endTimeStamp?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Boolean']>;
  trialDetails?: Maybe<LineItemEntitlementTrial>;
  trialEndDate?: Maybe<Scalars['String']>;
};

export enum LinkedEntitlementTypes {
  ENTERPRISE_INSTANCE = 'ENTERPRISE_INSTANCE',
  ENTERPRISE_PARENT = 'ENTERPRISE_PARENT',
  PROD_ENTITLEMENT_ADDON = 'PROD_ENTITLEMENT_ADDON',
  PROD_ENTITLEMENT_APP = 'PROD_ENTITLEMENT_APP',
  PROD_ENTITLEMENT_PRODUCT = 'PROD_ENTITLEMENT_PRODUCT',
  SANDBOX_APP_ENTITLEMENT = 'SANDBOX_APP_ENTITLEMENT',
  SANDBOX_PRODUCT_ENTITLEMENT = 'SANDBOX_PRODUCT_ENTITLEMENT',
  COLLECTION_INSTANCE = 'COLLECTION_INSTANCE',
  COLLECTION_PRODUCT = 'COLLECTION_PRODUCT',
  MULTI_INSTANCE_PRODUCT = 'MULTI_INSTANCE_PRODUCT',
  MULTI_INSTANCE = 'MULTI_INSTANCE',
}

export type LinkedFamilyEntitlementsDetails = {
  __typename?: 'LinkedFamilyEntitlementsDetails';
  id?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
};

export enum LinkedProductTypes {
  CONFLUENCE = 'CONFLUENCE',
  JIRA = 'JIRA',
  OTHER = 'OTHER',
  STATUSPAGE = 'STATUSPAGE',
}

export enum MetadataType {
  ADMIN_FEE = 'ADMIN_FEE',
}

export enum Method {
  ACCOUNT = 'ACCOUNT',
  BANK = 'BANK',
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL',
}

export type NavigationGroup = {
  __typename?: 'NavigationGroup';
  links?: Maybe<Array<Maybe<NavigationLink>>>;
  name?: Maybe<Scalars['String']>;
};

export type NavigationItem = NavigationGroup | NavigationLink;

export type NavigationLink = {
  __typename?: 'NavigationLink';
  iconUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NextBillEstimate = {
  __typename?: 'NextBillEstimate';
  currency?: Maybe<Scalars['String']>;
  lastBillEstimateItem?: Maybe<LastBillEstimateItem>;
  nextCyclePartnerDiscountOrMargin?: Maybe<NextCyclePartnerDiscountOrMargin>;
  proratedCharge?: Maybe<Scalars['Float']>;
  renewalCharge?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type NextCyclePartnerDiscountOrMargin = {
  __typename?: 'NextCyclePartnerDiscountOrMargin';
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  promotionId?: Maybe<Scalars['String']>;
};

/**
 * A combination of a product and the edition/plan. Examples: _Confluence Free_, _Trello Business Class_.
 *
 * See more: [Tintin CCP Glosary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type Offering = {
  __typename?: 'Offering';
  /** Add ons eligible to be added to this offering */
  availableAddOns?: Maybe<Array<Maybe<AddOn>>>;
  availablePricingPlans?: Maybe<Array<Maybe<PricingPlan>>>;
  /** Synthetic pricing plans eligible to be applied to this offering */
  availableSyntheticPricingPlans?: Maybe<Array<Maybe<SyntheticPricingPlan>>>;
  defaultPricingPlans?: Maybe<Array<Maybe<DefaultPricingPlans>>>;
  derivedFromOffering?: Maybe<DerivedFromOffering>;
  expiryDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  /** offering-level for upgrade or downgrade */
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  offeringId?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  offeringGroup?: Maybe<Scalars['String']>;
  relationshipRequirements?: Maybe<Array<Maybe<RelationshipRequirement>>>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trial?: Maybe<OfferingTrial>;
  type?: Maybe<Scalars['String']>;
};

/**
 * A combination of a product and the edition/plan. Examples: _Confluence Free_, _Trello Business Class_.
 *
 * See more: [Tintin CCP Glosary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type OfferingAvailablePricingPlansArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

export type OfferingChargeElement = {
  __typename?: 'OfferingChargeElement';
  ceiling?: Maybe<Scalars['Int']>;
};

export type OfferingChargeElements = {
  __typename?: 'OfferingChargeElements';
  agent?: Maybe<OfferingChargeElement>;
  unit?: Maybe<OfferingChargeElement>;
  user?: Maybe<OfferingChargeElement>;
};

export type OfferingTrial = {
  __typename?: 'OfferingTrial';
  lengthDays?: Maybe<Scalars['Int']>;
};

export enum OfferingType {
  CHILD = 'CHILD',
  PARENT = 'PARENT',
}

export type Opportunity = {
  __typename?: 'Opportunity';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  billTo?: Maybe<CommerceAddress>;
  closeDate?: Maybe<Scalars['String']>;
  cloudHostSen?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currencyIsoCode?: Maybe<Scalars['String']>;
  customerTechnicalContact?: Maybe<Scalars['String']>;
  customerTechnicalContactUuid?: Maybe<Scalars['String']>;
  dpe?: Maybe<Scalars['String']>;
  ectlSen?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastmodifiedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netOrderAmount?: Maybe<Scalars['String']>;
  opportunityId?: Maybe<Scalars['String']>;
  opportunityLineItems?: Maybe<Array<Maybe<OpportunityLineItem>>>;
  ownerId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerDiscount?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  reasonForPurchase?: Maybe<Scalars['String']>;
  recordtypeName?: Maybe<Scalars['String']>;
  renewalInvoice?: Maybe<Scalars['String']>;
  renewed?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  shipTo?: Maybe<CommerceAddress>;
  sourceSequence: Scalars['String'];
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  stageName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriptionTerm?: Maybe<Scalars['String']>;
};

export type OpportunityConnection = Connection & {
  __typename?: 'OpportunityConnection';
  edges?: Maybe<Array<Maybe<OpportunityEdge>>>;
  nodes?: Maybe<Array<Maybe<Opportunity>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OpportunityEdge = Edge & {
  __typename?: 'OpportunityEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Opportunity>;
};

export type OpportunityLineItem = {
  __typename?: 'OpportunityLineItem';
  createdDate?: Maybe<Scalars['String']>;
  inventoryProductId?: Maybe<Scalars['String']>;
  inventoryProductName?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  netOrderAmount?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  opportunityLineId?: Maybe<Scalars['String']>;
  otherDiscount?: Maybe<Scalars['String']>;
  partnerDiscount?: Maybe<Scalars['String']>;
  priceAdjustment?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  salesPrice?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['String']>;
  upgradeCredit?: Maybe<Scalars['String']>;
};

export type Opsgenie = {
  __typename?: 'Opsgenie';
  baseProduct: Scalars['String'];
  billingFrequency?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
};

export type OptedQuantity = {
  __typename?: 'OptedQuantity';
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
};

export type OptedUsageOptions = {
  __typename?: 'OptedUsageOptions';
  chargingDetails?: Maybe<ChargingDetails>;
  effectiveTime?: Maybe<EffectiveTime>;
  purchaseMetadata?: Maybe<PurchaseMetadata>;
  trial?: Maybe<Trial>;
};

/**
 * An action that results in a subscription change. This can be an amendment, creation, deletion.
 *
 * Transaction Account A. amended their subscription to include a new add-on.
 */
export type Order = {
  __typename?: 'Order';
  authorProfile?: Maybe<AuthorProfile>;
  billTo?: Maybe<OrderBillTo>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingGroup?: Maybe<OrderBillingGroup>;
  /** // TODO: Convert to subject to direct link to contact or system */
  contextSubject?: Maybe<Scalars['String']>;
  contextSubjectId?: Maybe<Scalars['String']>;
  /** Date the order was created, represents the sourceSequence in Hydra (date in epoch) */
  created?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  hasPendingInvoice?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceGroup?: Maybe<InvoiceGroup>;
  metadata?: Maybe<OrderMetadata>;
  metadataObj?: Maybe<OrderMetadataObj>;
  orderContext?: Maybe<OrderContext>;
  orderLineItems?: Maybe<OrderLineItemConnection>;
  /** Human readable identifier */
  orderNumber?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  quote?: Maybe<CcpQuote>;
  shipTo?: Maybe<OrderShipTo>;
  sourceSystem?: Maybe<Scalars['String']>;
};

/**
 * An action that results in a subscription change. This can be an amendment, creation, deletion.
 *
 * Transaction Account A. amended their subscription to include a new add-on.
 */
export type OrderOrderLineItemsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type OrderBillTo = {
  __typename?: 'OrderBillTo';
  billToAccountId?: Maybe<Scalars['String']>;
  billToAddress1?: Maybe<Scalars['String']>;
  billToAddress2?: Maybe<Scalars['String']>;
  billToCity?: Maybe<Scalars['String']>;
  billToCompanyName?: Maybe<Scalars['String']>;
  billToCountry?: Maybe<Scalars['String']>;
  billToPostalCode?: Maybe<Scalars['String']>;
  billToState?: Maybe<Scalars['String']>;
};

export type OrderBillingGroup = {
  __typename?: 'OrderBillingGroup';
  billingGroupId?: Maybe<Scalars['String']>;
};

export type OrderConnection = Connection & {
  __typename?: 'OrderConnection';
  edges: Array<Maybe<OrderEdge>>;
  nodes: Array<Maybe<Order>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The person or system that is responsible for the action taking place */
export type OrderContext = Contact;

export type OrderDetails = {
  __typename?: 'OrderDetails';
  chargeQuantities?: Maybe<ChargeQuantities>;
  type?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type OrderEdge = Edge & {
  __typename?: 'OrderEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Order>;
};

export enum OrderItemRequestType {
  ACCOUNT_MODIFICATION_ORDER = 'ACCOUNT_MODIFICATION_ORDER',
  ACCOUNT_MODIFICATION_ORDER_OF_FAMILY = 'ACCOUNT_MODIFICATION_ORDER_OF_FAMILY',
  AMENDMENT_ORDER = 'AMENDMENT_ORDER',
  AMENDMENT_ORDER_OF_FAMILY = 'AMENDMENT_ORDER_OF_FAMILY',
  CANCELLATION_ORDER = 'CANCELLATION_ORDER',
  CANCELLATION_ORDER_OF_FAMILY = 'CANCELLATION_ORDER_OF_FAMILY',
  CREATION_ORDER = 'CREATION_ORDER',
  CREATION_ORDER_OF_FAMILY = 'CREATION_ORDER_OF_FAMILY',
  PATCH_ENTITLEMENT_DETAILS_ORDER = 'PATCH_ENTITLEMENT_DETAILS_ORDER',
  REACTIVATION_ORDER = 'REACTIVATION_ORDER',
  REBILL_ORDER = 'REBILL_ORDER',
  REVERT_TRIAL_ORDER = 'REVERT_TRIAL_ORDER',
  REWIND_ORDER = 'REWIND_ORDER',
  SYSTEM_AMENDMENT_ORDER = 'SYSTEM_AMENDMENT_ORDER',
  SYSTEM_CANCELLATION_ORDER = 'SYSTEM_CANCELLATION_ORDER',
  TRANSFER_IN_ORDER = 'TRANSFER_IN_ORDER',
  TRANSFER_IN_ORDER_OF_FAMILY = 'TRANSFER_IN_ORDER_OF_FAMILY',
  TRANSFER_OUT_ORDER = 'TRANSFER_OUT_ORDER',
  TRANSFER_OUT_ORDER_OF_FAMILY = 'TRANSFER_OUT_ORDER_OF_FAMILY',
  TRANSITION_ORDER = 'TRANSITION_ORDER',
}

export type OrderLineBillingBehaviour = {
  __typename?: 'OrderLineBillingBehaviour';
  startDate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrderLineEffectiveTimeEndsAtObject = {
  __typename?: 'OrderLineEffectiveTimeEndsAtObject';
  billingFrequencyCount?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrderLineEffectiveTimeObject = {
  __typename?: 'OrderLineEffectiveTimeObject';
  effectiveTimeEndsAtObject?: Maybe<OrderLineEffectiveTimeEndsAtObject>;
};

/** An action that results in a subscription change. This can be an amendment, creation, deletion. */
export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  amount?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  metadata?: Maybe<OrderLineItemMetadata>;
  computedDetails?: Maybe<ComputedDetails>;
  edition?: Maybe<Scalars['String']>;
  entitlementId: Scalars['ID'];
  entitlementNumber?: Maybe<Scalars['String']>;
  familyContainerId?: Maybe<Scalars['String']>;
  invoice?: Maybe<CcpInvoice>;
  isApp?: Maybe<Scalars['Boolean']>;
  isDisplay?: Maybe<Scalars['Boolean']>;
  isExternallyBilled?: Scalars['Boolean'];
  lineItemId: Scalars['ID'];
  nextBillingAnchorTimestamp?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  orderLineBillingBehaviourObject?: Maybe<OrderLineBillingBehaviour>;
  orderLineItemsAccountModification?: Maybe<OrderLineItemsAccountModification>;
  orderLineItemsAdditionalNotes?: Maybe<Scalars['String']>;
  orderLineItemsPurchaseMetadata?: Maybe<Array<Maybe<OrderLineItemsPurchaseMetadataType>>>;
  orderTransitionType?: Maybe<Scalars['String']>;
  parentEntitlementId?: Maybe<Scalars['ID']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promotionCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  quantity?: Maybe<Scalars['String']>;
  quoteLineItemDetailsReference?: Maybe<QuoteLineItemDetailsReference>;
  reasonCode?: Maybe<Scalars['String']>;
  removedPromotions?: Maybe<Array<Maybe<Promotion>>>;
  salesTransitionType?: Maybe<Scalars['String']>;
  skipTrial?: Maybe<Scalars['Boolean']>;
  status?: Maybe<OrderStatus>;
  subscription?: Maybe<Subscription>;
  type?: Maybe<OrderItemRequestType>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
};

export type OrderLineItemConnection = Connection & {
  __typename?: 'OrderLineItemConnection';
  edges: Array<Maybe<OrderLineItemEdge>>;
  nodes: Array<Maybe<OrderLineItem>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrderLineItemEdge = Edge & {
  __typename?: 'OrderLineItemEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<OrderLineItem>;
};

export type OrderLineItemMetadata = {
  __typename?: 'OrderLineItemMetadata';
  legacyInvoiceId?: Maybe<Scalars['String']>;
};

export type OrderLineItemsAccountModification = {
  __typename?: 'OrderLineItemsAccountModification';
  accountModificationInvoiceGroupId?: Maybe<Scalars['String']>;
  accountModificationTransactionAccountId?: Maybe<Scalars['String']>;
};

export type OrderMetadata = {
  __typename?: 'OrderMetadata';
  supportTicketNumber?: Maybe<Scalars['String']>;
};

export type OrderMetadataObj = {
  __typename?: 'OrderMetadataObj';
  cancelContext?: Maybe<Scalars['String']>;
  consentTaken?: Maybe<Scalars['String']>;
  currentBillingAdmin?: Maybe<Scalars['String']>;
  handNote?: Maybe<Scalars['String']>;
  newBillingAdmin?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  supportTicketNumber?: Maybe<Scalars['String']>;
  termsOfTransfer?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
};

export type OrderShipTo = {
  __typename?: 'OrderShipTo';
  shipToAccountId?: Maybe<Scalars['String']>;
  shipToAddress1?: Maybe<Scalars['String']>;
  shipToAddress2?: Maybe<Scalars['String']>;
  shipToCity?: Maybe<Scalars['String']>;
  shipToCompanyName?: Maybe<Scalars['String']>;
  shipToCountry?: Maybe<Scalars['String']>;
  shipToPostalCode?: Maybe<Scalars['String']>;
  shipToState?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  FAIL = 'FAIL',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

export enum OrderTransitionType {
  IMMEDIATE = 'IMMEDIATE',
}

export type Organization = {
  __typename?: 'Organization';
  aggregatedProducts?: Maybe<Array<Maybe<AggregatedProduct>>>;
  atlassianAccess?: Maybe<AtlassianAccess>;
  id: Scalars['ID'];
  name: Scalars['String'];
  products: CloudProductConnection;
};

export type OrganizationProductsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type OrganizationBillingAccount = {
  __typename?: 'OrganizationBillingAccount';
  availableInvoiceGroups?: Maybe<InvoiceGroupConnection>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountName?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
};

export type OrganizationDomain = {
  __typename?: 'OrganizationDomain';
  domain?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  verificationType?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type Organizations = {
  __typename?: 'Organizations';
  domains?: Maybe<Array<Maybe<Domains>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OriginalInvoiceReferral = {
  __typename?: 'OriginalInvoiceReferral';
  invoiceNumber?: Maybe<Scalars['String']>;
};

export type Overage = {
  __typename?: 'Overage';
  lineItems?: Maybe<Array<Maybe<InvoiceLineItems>>>;
  totalAccruedAmount?: Maybe<Scalars['Float']>;
  totalAccruedSubtotal?: Maybe<Scalars['Float']>;
  totalDiscountsApplied?: Maybe<Scalars['Float']>;
  totalMarginsApplied?: Maybe<Scalars['Float']>;
  totalTaxApplied?: Maybe<Scalars['Float']>;
  totalUsersAdded?: Maybe<Scalars['Float']>;
};

/**
 * Information about pagination in a connection
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

export type PaidAchCard = PaymentMethod & {
  __typename?: 'PaidAchCard';
  card?: Maybe<CreditCardDetails>;
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  type: PaymentMethodType;
};

export type PaidInvoiceDetails = {
  __typename?: 'PaidInvoiceDetails';
  createdAt?: Maybe<Scalars['Float']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  offeringKey?: Maybe<Scalars['String']>;
  prevBillingAnchorTimestamp?: Maybe<Scalars['Float']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  promotionDetails?: Maybe<Array<Maybe<InvoicePromotionDetail>>>;
  quantity?: Maybe<Scalars['Int']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** A container that groups together transaction-related entities for a partner */
export type Partner = {
  __typename?: 'Partner';
  emailAddress?: Maybe<Scalars['String']>;
  transactionAccounts?: Maybe<Array<Maybe<TransactionAccount>>>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  contactAccountRole?: Maybe<AccountRole>;
  domains?: Maybe<PartnerDomain>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
};

export type PartnerAccountResult = {
  __typename?: 'PartnerAccountResult';
  results?: Maybe<Array<Maybe<PartnerAccount>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type PartnerDomain = {
  __typename?: 'PartnerDomain';
  alternates?: Maybe<Array<Maybe<Scalars['String']>>>;
  main?: Maybe<Scalars['String']>;
};

export enum PartnerSearchContext {
  ALL = 'ALL',
  COMPANY = 'COMPANY',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  EMAIL = 'EMAIL',
  INVOICE_ID = 'INVOICE_ID',
  PERSON = 'PERSON',
  REFUND_ID = 'REFUND_ID',
  SITE_URL = 'SITE_URL',
  SUBSCRIPTION_ID = 'SUBSCRIPTION_ID',
}

export type PartnerStatusDetails = {
  __typename?: 'PartnerStatusDetails';
  discountTier?: Maybe<Scalars['String']>;
  externalSystemIdentifier?: Maybe<Scalars['String']>;
  programLevel?: Maybe<ProgramLevelDetails>;
  programLevelGlobal?: Maybe<Scalars['String']>;
};

export type PauseBilling = {
  __typename?: 'PauseBilling';
  endTimestamp?: Maybe<Scalars['Float']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type PayPal = PaymentMethod & {
  __typename?: 'PayPal';
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  payPal?: Maybe<PayPalAccountDetails>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  type: PaymentMethodTypeV2;
};

export type PayPalAccountDetails = {
  __typename?: 'PayPalAccountDetails';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * A container that groups together transaction-related entities. It is aimed at
 * helping a purchasing person (a Billing Admin) organize their transactions with
 * Atlassian. See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 */
export type PaymentMethod = {
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  type: PaymentMethodType;
};

export type PaymentMethodConnection = Connection & {
  __typename?: 'PaymentMethodConnection';
  edges?: Maybe<Array<Maybe<PaymentMethodEdge>>>;
  nodes?: Maybe<Array<Maybe<PaymentMethod>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PaymentMethodEdge = Edge & {
  __typename?: 'PaymentMethodEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: PaymentMethod;
};

export enum PaymentMethodType {
  CARD = 'CARD',
  DEFERRED = 'DEFERRED',
}

export enum PaymentMethodTypeV2 {
  CARD = 'CARD',
  DEFERRED = 'DEFERRED',
  PAYPAL = 'PAYPAL',
  ACH = 'ACH',
}

export type PaymentOnTerms = PaymentMethod & {
  __typename?: 'PaymentOnTerms';
  default?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  terms?: Maybe<PaymentOnTermsDetails>;
  totalCreditLimit?: Maybe<Scalars['Float']>;
  type: PaymentMethodType;
};

export type PaymentOnTermsDetails = {
  __typename?: 'PaymentOnTermsDetails';
  invoiceDueDays?: Maybe<Scalars['Int']>;
  payOnStatement?: Maybe<Scalars['Boolean']>;
};

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export enum Permission {
  BITBUCKET_ADMIN = 'BITBUCKET_ADMIN',
  BITBUCKET_CHANGE_PLAN = 'BITBUCKET_CHANGE_PLAN',
  CASSI_ADMIN = 'CASSI_ADMIN',
  CASSI_DISTURBED = 'CASSI_DISTURBED',
  CHANGE_RENEWAL_ACTION = 'CHANGE_RENEWAL_ACTION',
  CLOSE_ACCOUNT = 'CLOSE_ACCOUNT',
  CLOUD_SITE_DEACTIVATION = 'CLOUD_SITE_DEACTIVATION',
  CLOUD_SITE_DELETION = 'CLOUD_SITE_DELETION',
  CLOUD_SITE_PRODUCTS_DEACTIVATION = 'CLOUD_SITE_PRODUCTS_DEACTIVATION',
  CLOUD_SITE_REACTIVATION = 'CLOUD_SITE_REACTIVATION',
  CONTACT_READ = 'CONTACT_READ',
  COUPONS_READ = 'COUPONS_READ',
  COUPONS_WRITE = 'COUPONS_WRITE',
  CREDIT_READ = 'CREDIT_READ',
  CREDIT_WRITE = 'CREDIT_WRITE',
  DEAL_DESK = 'DEAL_DESK',
  EMAIL_READ = 'EMAIL_READ',
  ENTITLEMENT_READ = 'ENTITLEMENT_READ',
  EXPORT_CONTROLS_WRITE = 'EXPORT_CONTROLS_WRITE',
  EXTEND_CLOUD_TRIAL = 'EXTEND_CLOUD_TRIAL',
  FINANCE_USER = 'FINANCE_USER',
  GENERATE_LICENSE_REPORT = 'GENERATE_LICENSE_REPORT',
  IMPERSONATE_SITE_ADMIN = 'IMPERSONATE_SITE_ADMIN',
  INVOICE_READ = 'INVOICE_READ',
  MANAGE_BILLING = 'MANAGE_BILLING',
  MANAGE_EXTENDED_CLOUD_TRIAL = 'MANAGE_EXTENDED_CLOUD_TRIAL',
  OBFUSCATE_ACCOUNT = 'OBFUSCATE_ACCOUNT',
  PARTNER_ACCOUNT_READ = 'PARTNER_ACCOUNT_READ',
  PROCESS_REFUND = 'PROCESS_REFUND',
  QUOTE_READ = 'QUOTE_READ',
  REFUND_READ = 'REFUND_READ',
  RENAME_CLOUD_SITE = 'RENAME_CLOUD_SITE',
  RESEND_IDENTITY_LINKS = 'RESEND_IDENTITY_LINKS',
  STAFFID_LOGIN = 'STAFFID_LOGIN',
  TICKET_READ = 'TICKET_READ',
  UPDATE_ADD_ON_SUBSCRIPTIONS = 'UPDATE_ADD_ON_SUBSCRIPTIONS',
  USER_READ = 'USER_READ',
}

/** A container that groups together transaction-related entities for a contact/person. */
export type Person = {
  __typename?: 'Person';
  emailAddress?: Maybe<Scalars['String']>;
  opportunities: OpportunityConnection;
  quoteHeaders: QuoteConnection;
  transactionAccounts: TransactionAccountConnection;
};

/** A container that groups together transaction-related entities for a contact/person. */
export type PersonOpportunitiesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** A container that groups together transaction-related entities for a contact/person. */
export type PersonQuoteHeadersArgs = {
  searchOptions?: Maybe<QuoteSearchParameters>;
};

/** A container that groups together transaction-related entities for a contact/person. */
export type PersonTransactionAccountsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type PlanObj = {
  __typename?: 'PlanObj';
  hostingType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Applications (micro-frontends) hosted elsewhere consumed by CASSI */
export type PortalApp = {
  __typename?: 'PortalApp';
  appId: Scalars['String'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type PostUncollectibleDunningList = {
  __typename?: 'PostUncollectibleDunningList';
  dunningHistory?: Maybe<Array<Maybe<DunningStatus>>>;
  endDate?: Maybe<Scalars['String']>;
  isEnforceUncollectibleActions?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['String']>;
  uncollectibleDate?: Maybe<Scalars['String']>;
};

export type PreDunning = {
  __typename?: 'PreDunning';
  associatedEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  endTimestamp?: Maybe<Scalars['Float']>;
  orderItemId?: Maybe<Scalars['String']>;
  predunningInvoiceIdentifier?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type PreviewThumbnail = {
  __typename?: 'PreviewThumbnail';
  link?: Maybe<Scalars['String']>;
};

export type PricingPlan = {
  __typename?: 'PricingPlan';
  amount?: Maybe<Scalars['Int']>;
  billingFrequency?: Maybe<BillingFrequency>;
  chargeElement?: Maybe<Scalars['String']>;
  chargeType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  offeringName?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  pricingPlanType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<PricingTiers>>>;
  type: Scalars['String'];
};

export type PricingTiers = {
  __typename?: 'PricingTiers';
  amount?: Maybe<Scalars['Int']>;
  ceiling?: Maybe<Scalars['Int']>;
  flatAmount?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['Int']>;
  policy?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export enum PricingType {
  FREE = 'FREE',
  LIMITED_FREE = 'LIMITED_FREE',
  PAID = 'PAID',
}

export type ProductAppLineItem = {
  __typename?: 'ProductAppLineItem';
  addOns?: Array<Maybe<InvoiceLineItems>>;
  apps: Array<Maybe<InvoiceLineItems>>;
  products: Array<Maybe<InvoiceLineItems>>;
};

export type ProductAppLineItemData = {
  __typename?: 'ProductAppLineItemData';
  confluence: ProductAppLineItem;
  jira: ProductAppLineItem;
  other?: Maybe<ProductAppLineItem>;
  statuspage: ProductAppLineItem;
};

export type ProductAppRefundItem = {
  __typename?: 'ProductAppRefundItem';
  apps: Array<Maybe<RefundItems>>;
  products: Array<Maybe<RefundItems>>;
};

export type ProductAppRefundItemData = {
  __typename?: 'ProductAppRefundItemData';
  confluence: ProductAppRefundItem;
  jira: ProductAppRefundItem;
  other?: Maybe<ProductAppRefundItem>;
  statuspage: ProductAppRefundItem;
};

export type ProductAppSubscription = {
  __typename?: 'ProductAppSubscription';
  apps: Array<Maybe<TransactionAccountProduct>>;
  products: Array<Maybe<TransactionAccountProduct>>;
};

export type ProductAppSubscriptionData = {
  __typename?: 'ProductAppSubscriptionData';
  confluence: ProductAppSubscription;
  jira: ProductAppSubscription;
  other?: Maybe<ProductAppSubscription>;
  statuspage: ProductAppSubscription;
};

export type ProductAppSubscriptionForCloudSite = {
  __typename?: 'ProductAppSubscriptionForCloudSite';
  apps: Array<Maybe<CloudSiteProduct>>;
  products: Array<Maybe<CloudSiteProduct>>;
};

export type ProductAppSubscriptionForCloudSiteData = {
  __typename?: 'ProductAppSubscriptionForCloudSiteData';
  confluence: ProductAppSubscriptionForCloudSite;
  jira: ProductAppSubscriptionForCloudSite;
  other?: Maybe<ProductAppSubscriptionForCloudSite>;
  statuspage: ProductAppSubscriptionForCloudSite;
};

export type ProductAppSubscriptionForInvoiceGroup = {
  __typename?: 'ProductAppSubscriptionForInvoiceGroup';
  apps: Array<Maybe<InvoiceGroupProduct>>;
  products: Array<Maybe<InvoiceGroupProduct>>;
};

export type ProductAppSubscriptionForInvoiceGroupData = {
  __typename?: 'ProductAppSubscriptionForInvoiceGroupData';
  confluence: ProductAppSubscriptionForInvoiceGroup;
  jira: ProductAppSubscriptionForInvoiceGroup;
  other?: Maybe<ProductAppSubscriptionForInvoiceGroup>;
  statuspage: ProductAppSubscriptionForInvoiceGroup;
};

export type ProductEntitlementPageParams = {
  cursor?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

export type ProductEntitlementSearchParams = {
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
  partnerSearchContext: PartnerSearchContext;
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
};

export type ProductNotes = {
  __typename?: 'ProductNotes';
  author?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type ProductNotesFilterSearchParams = {
  query?: Maybe<Scalars['String']>;
};

export type ProductNotesResult = {
  __typename?: 'ProductNotesResult';
  cursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  results?: Maybe<Array<Maybe<ProductNotes>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type ProductSubscriptionsFilterOption = {
  cloudSiteHostname?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  or?: Maybe<Array<Maybe<ProductSubscriptionsFilterOption>>>;
  productName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProductSubscriptionsFilterOptions = {
  and?: Maybe<Array<Maybe<ProductSubscriptionsFilterOption>>>;
};

export type ProgramLevelDetails = {
  __typename?: 'ProgramLevelDetails';
  current?: Maybe<LevelDetails>;
  previous?: Maybe<LevelDetails>;
};

export type PromoCode = {
  code?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
};

export type PromoCodeDetails = {
  __typename?: 'PromoCodeDetails';
  createdAt?: Maybe<Scalars['String']>;
  promotionCode?: Maybe<Scalars['String']>;
  promotionId: Scalars['String'];
  redeemedCount?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PromoCodeResponseDto = {
  __typename?: 'PromoCodeResponseDTO';
  maxRedemptions?: Maybe<Scalars['Int']>;
  notApplicablePromotionCodesWithReason?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotionId?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  redeemedCount?: Maybe<Scalars['Int']>;
};

export type Promotion = {
  __typename?: 'Promotion';
  applicationReason?: Maybe<PromotionReason>;
  benefitStates?: Maybe<Array<Maybe<BenefitState>>>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
  customisableReasons?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  cycleIntervalWithEligibleConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
  eligibilityRules?: Maybe<EligibilityRule>;
  id?: Maybe<Scalars['String']>;
  isPromotionCustomisable?: Maybe<Scalars['Boolean']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  maxRedemptionsCustomer?: Maybe<Scalars['Int']>;
  maxRedemptionsPromotion?: Maybe<Scalars['Int']>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  promotionCode?: Maybe<Scalars['String']>;
  promotionCodeType?: Maybe<Scalars['String']>;
  promotionInstanceId?: Maybe<Scalars['String']>;
  promotionWindow?: Maybe<PromotionWindow>;
  purpose?: Maybe<Purpose>;
  rule?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PromotionDefinition = {
  __typename?: 'PromotionDefinition';
  customisedValues?: Maybe<CustomisedValues>;
  promotionId?: Maybe<Scalars['String']>;
};

export type PromotionInputParams = {
  discountTier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type PromotionReason = {
  __typename?: 'PromotionReason';
  customisable?: Maybe<PromotionReasonCustomisable>;
  id?: Maybe<Scalars['String']>;
  readableName?: Maybe<Scalars['String']>;
};

export type PromotionReasonCustomisable = {
  __typename?: 'PromotionReasonCustomisable';
  id?: Maybe<PromotionReasonListObj>;
};

export type PromotionReasonListObj = {
  __typename?: 'PromotionReasonListObj';
  anyOf?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  type?: Maybe<Scalars['String']>;
};

export type PromotionWindow = {
  __typename?: 'PromotionWindow';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type Promotions = {
  __typename?: 'Promotions';
  promotionDefinition?: Maybe<PromotionDefinition>;
};

export type PromotionsInputParams = {
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProvisionedResourceDetails = {
  __typename?: 'ProvisionedResourceDetails';
  organisationId?: Maybe<Scalars['String']>;
  organisationName?: Maybe<Scalars['String']>;
  provisionedResourceType?: Maybe<ProvisionedResourceType>;
};

export enum ProvisionedResourceType {
  CLOUDSITE = 'CLOUDSITE',
  ORGANISATION = 'ORGANISATION',
}

export enum ProvisioningStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
  SUSPENDED = 'SUSPENDED',
}

export type PurchaseMetadata = {
  __typename?: 'PurchaseMetadata';
  note?: Maybe<Scalars['String']>;
};

export type Purpose = {
  __typename?: 'Purpose';
  invoiceNote?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type Query = {
  __typename?: 'Query';
  accountInvoices?: Maybe<InvoicesSearchResult>;
  application?: Maybe<Application>;
  assigneeSupportIssues?: Maybe<SupportIssuesConnection>;
  auditNotes: AuditNoteConnection;
  /** get all available country information */
  availableCountries: BillingCountryConnection;
  /** get all available states for a given country's iso code */
  availableStatesForCountry: BillingCountryStateConnection;
  availableTaxLabels: Array<Maybe<TaasTaxLabel>>;
  billEstimate?: Maybe<BillEstimate>;
  billingProfilesByPaymentMethodId?: Maybe<BillingProfiles>;
  cloudLicense?: Maybe<CloudLicenseResults>;
  cloudLicenses?: Maybe<CloudLicenseConnection>;
  cloudSite: CloudSite;
  cloudSiteOrders?: Maybe<OrderConnection>;
  cloudSiteProducts?: Maybe<CloudSiteProductsConnection>;
  cloudSiteProductsAppsAndSubscriptions: ProductAppSubscriptionForCloudSiteData;
  cloudSiteProductsAppsAndSubscriptionsForOrganization: ProductAppSubscriptionForCloudSiteData;
  cloudSitesForBillingProfile: Array<Maybe<CloudSiteDetail>>;
  cloudSitesForOrganization: Array<Maybe<CloudSiteDetail>>;
  cloudSitesForTransactionAccount: Array<Maybe<CloudSiteDetail>>;
  cloudSitesForTransactionAccountForQuotingV2: Array<Maybe<CloudSiteDetail>>;
  cloudSubscription?: Maybe<CloudSubscriptionConnection>;
  credits?: Maybe<Array<Maybe<Credit>>>;
  customerSubscriptions?: Maybe<CustomerSubscriptionConnection>;
  /** Provides insight to if a dependency is currently accessible */
  deepcheck: Array<Maybe<DependencyHealth>>;
  domain?: Maybe<Domain>;
  endCustomerContacts?: Maybe<EndCustomerContactConnection>;
  entitlementDetails: EntitlementDetails;
  entitlements?: Maybe<TransactionAccountProductConnection>;
  entitlementsFamily?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
  entitlementsForSxp?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
  entitlementsGroupByBillingDate?: Maybe<EntitlementsGroupByBillingDate>;
  entitlementsGroupByCloudSite?: Maybe<Array<Maybe<EntitlementsGroupByCloudSiteConnection>>>;
  fetchAuditTrails?: Maybe<AuditNoteResult>;
  fetchContact?: Maybe<Contact>;
  fetchEmailDetails?: Maybe<Email>;
  fetchPartnerAccounts?: Maybe<PartnerAccountResult>;
  fetchSearchSupportIssues?: Maybe<SupportIssuesConnection>;
  fetchServerLicensesByEmail?: Maybe<ServerLicenseResults>;
  fetchServiceLicensesByEmail?: Maybe<ServiceLicenseResults>;
  invoice: Invoice;
  invoiceForOrderToCancel: Invoice;
  invoiceGroup?: Maybe<InvoiceGroup>;
  invoiceGroups?: Maybe<InvoiceGroupConnection>;
  invoiceGroupsCountForShipToPartyNames?: Maybe<Array<Maybe<InvoiceGroupsForShipToPartyNames>>>;
  invoiceGroupsForPaymentMethod?: Maybe<InvoiceGroupsForPaymentMethod>;
  invoiceGroupsForShipToPartyId?: Maybe<InvoiceGroupsForShipToPartyId>;
  invoiceGroupsForShipToPartyIds?: Maybe<InvoiceGroupsForShipToPartyIds>;
  invoiceSearch?: Maybe<InvoicesSearchResult>;
  invoices?: Maybe<InvoicesSearchResult>;
  /** The user profile of the currently logged-in user */
  me?: Maybe<UserProfile>;
  opsgenie?: Maybe<Opsgenie>;
  orderDetail?: Maybe<Order>;
  orderDetailV2?: Maybe<OrderConnection>;
  organization?: Maybe<Organization>;
  organizationByDomain?: Maybe<Organization>;
  partnerByEmail?: Maybe<Partner>;
  partnerCloudSites?: Maybe<CloudSiteDataConnection>;
  partnerProductEntitlements?: Maybe<TransactionAccountProductConnection>;
  partnerRefunds?: Maybe<RefundConnection>;
  partnerTransactionAccounts?: Maybe<TransactionAccountConnection>;
  personByEmailAddress?: Maybe<Person>;
  productAndAppSubscriptionsForTxa?: Maybe<ProductAppSubscriptionData>;
  promotion?: Maybe<Promotion>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  refund?: Maybe<Array<Maybe<Refunds>>>;
  refunds?: Maybe<Array<Maybe<Refunds>>>;
  searchCloudSite?: Maybe<CloudSiteResult>;
  searchContact?: Maybe<ContactSearchResult>;
  searchEmailDetails?: Maybe<EmailConnection>;
  searchForDirectMatch?: Maybe<DirectMatch>;
  searchForTransactionAccount: TransactionAccountConnection;
  shipToParty?: Maybe<ShipToPartyConnection>;
  shipToPartyGrouped?: Maybe<ShipToPartyAggregatedConnection>;
  statuspage: Statuspage;
  subscriptionsForTxa?: Maybe<TransactionAccountProductConnection>;
  supportIssue?: Maybe<SupportIssueResult>;
  termPaymentAuditTrails: TermPaymentAuditTrailsConnection;
  transactionAccount: TransactionAccount;
  transactionAccountsByBillToAddress?: Maybe<TransactionAccountConnection>;
  trello: Trello;
  txaPartnerAccount?: Maybe<TxaPartnerAccount>;
  txaPartnerDiscounts?: Maybe<Array<Maybe<TxaPartnerAccountDiscount>>>;
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAccountInvoicesArgs = {
  invoiceWhereFilter?: Maybe<InvoiceWhereFilter>;
  size?: Maybe<Scalars['Int']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAdaNotesArgs = {
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
  searchParams?: Maybe<ProductNotesFilterSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryApplicationArgs = {
  id?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAssigneeSupportIssuesArgs = {
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  email: Scalars['String'];
  searchOptions?: Maybe<SupportIssueSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAuditNotesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParams?: Maybe<CommerceNoteSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailableStatesForCountryArgs = {
  isoCode?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailableTaxLabelsArgs = {
  isoCode?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryBillEstimateArgs = {
  cloudSiteId: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryBillingAccountsForOrganizationArgs = {
  orgId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryBillingProfilesByPaymentMethodIdArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudLicenseArgs = {
  params: SearchCloudLicenseParams;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudLicensesArgs = {
  params: SearchCloudLicensesParams;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudMigrationTrialArgs = {
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteArgs = {
  cloudSiteId: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteJiraTrialProductArgs = {
  cloudSiteId: Scalars['String'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  parentSen: Scalars['String'];
  showCcpData?: Maybe<Scalars['Boolean']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteOrdersArgs = {
  cloudSiteId: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteProductsArgs = {
  callFromACUI?: Maybe<Scalars['Boolean']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  fromCassi?: Maybe<Scalars['Boolean']>;
  parentSen: Scalars['String'];
  searchOptions?: Maybe<CloudSiteProductsSearchOptions>;
  showCcpData?: Maybe<Scalars['Boolean']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteProductsAppsAndSubscriptionsArgs = {
  cloudSiteId?: Maybe<Scalars['String']>;
  parentSen: Scalars['String'];
  showCcpData?: Maybe<Scalars['Boolean']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSiteProductsAppsAndSubscriptionsForOrganizationArgs = {
  cloudSiteId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSitesForBillingProfileArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSitesForOrganizationArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSitesForTransactionAccountArgs = {
  filterOptions?: Maybe<FilterOption>;
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSitesForTransactionAccountForQuotingV2Args = {
  filterOptions?: Maybe<FilterOption>;
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSitesProductsArgs = {
  cloudSiteIdIsIn?: Maybe<Array<Scalars['String']>>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCloudSubscriptionArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<CloudSubscriptionSearchOptions>;
  searchParams: CloudSubscriptionSearchParams;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryContactsByResourceArgs = {
  contactType?: Maybe<Array<Maybe<ContactType>>>;
  resourceAri?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCreditsArgs = {
  cloudSiteId: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCustomerSubscriptionsArgs = {
  searchOptions?: Maybe<CustomerSubscriptionSearchOptions>;
  searchParams?: Maybe<CustomerSubscriptionSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryDomainArgs = {
  url: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEndCustomerContactsArgs = {
  searchParams?: Maybe<EndCustomerContactSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementCountsForInvoiceGroupIdsArgs = {
  invoiceGroupIds: Array<Scalars['String']>;
  transactionAccountId: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementDetailsArgs = {
  filters?: Maybe<EntitlementDetailsFilters>;
  id?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsArgs = {
  filterOptions?: Maybe<FilterOption>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsByContactArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsByIdsArgs = {
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsFamilyArgs = {
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsForOrganizationArgs = {
  searchParams?: Maybe<EntitlementToOrganizationLinkSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsForSxpArgs = {
  searchParams?: Maybe<SxpEntitlementSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsGroupByBillingDateArgs = {
  entitlementId?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  id: Scalars['ID'];
  isBillingCycleChange?: Maybe<Scalars['Boolean']>;
  isTermed?: Maybe<Scalars['Boolean']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryEntitlementsGroupByCloudSiteArgs = {
  invoiceGroupId: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchAuditTrailsArgs = {
  email: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchBusinessContactsArgs = {
  contactType?: Maybe<ContactType>;
  resourceId?: Maybe<Scalars['String']>;
  resourceType?: Maybe<ResourceType>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchCloudSitesForUserArgs = {
  atlassianAccountId: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchContactArgs = {
  email: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchContactV2Args = {
  email: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchEmailDetailsArgs = {
  email: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchOrganisationsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<SearchOptions>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchOrganizationsForUserArgs = {
  atlassianAccountId: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchPartnerAccountsArgs = {
  email?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchSearchSupportIssuesArgs = {
  searchOptions?: Maybe<SearchOptions>;
  searchParam?: Maybe<SupportIssueSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchServerLicensesByEmailArgs = {
  params: SearchServerLicenses;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryFetchServiceLicensesByEmailArgs = {
  params: SearchServiceLicenses;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceArgs = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchCoupledLineItemsV2?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceForEntitlementIdArgs = {
  entitlementId: Scalars['ID'];
  invoiceRequestItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  txaId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceForOrderToCancelArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceGroupArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceGroupsArgs = {
  filterOptions?: Maybe<FilterOption>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceGroupsForPaymentMethodArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceGroupsForShipToPartyIdArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceGroupsForShipToPartyIdsArgs = {
  ids: Array<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceLineItemEnrichmentDetailsArgs = {
  invoiceLineItemRequest: Array<Maybe<InvoiceLineItemRequest>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoiceSearchArgs = {
  searchOptions?: Maybe<InvoiceWhereFilter>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryInvoicesArgs = {
  searchOptions?: Maybe<InvoiceWhereFilter>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryLinkedFamilyEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<Array<Maybe<SearchLinkedEntitlementParams>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOpsgenieArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOrderDetailArgs = {
  id: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOrderDetailV2Args = {
  filterOptions?: Maybe<FilterOption>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOrganizationByDomainArgs = {
  domain: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerByEmailArgs = {
  email?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerCloudSitesArgs = {
  searchParams?: Maybe<CloudSiteSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerProductEntitlementsArgs = {
  pageParams?: Maybe<ProductEntitlementPageParams>;
  searchParams?: Maybe<ProductEntitlementSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerRefundsArgs = {
  searchParams?: Maybe<RefundSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerTransactionAccountsArgs = {
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPersonByEmailAddressArgs = {
  email?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryProductAndAppSubscriptionsForTxaArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryProductsForOrganizationArgs = {
  cloudSiteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationId?: Maybe<Scalars['String']>;
  parentSens?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryProductsForOrganizationPpcArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  organizationId?: Maybe<Scalars['String']>;
  organizationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPromotionArgs = {
  params?: Maybe<PromotionInputParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPromotionsArgs = {
  params?: Maybe<PromotionsInputParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryRefundArgs = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchCoupledRefundItemsV2?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  where?: Maybe<RefundWhereFilter>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryRefundsArgs = {
  where?: Maybe<RefundWhereFilter>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryRelatedEntitlementIdsArgs = {
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryResourcesByContactArgs = {
  contactEmail?: Maybe<Scalars['String']>;
  contactType?: Maybe<Array<Maybe<ContactType>>>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchBillingProfilesForTxaArgs = {
  id: Scalars['ID'];
  searchText?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchCloudSiteArgs = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchContactArgs = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchEmailDetailsArgs = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchForDirectMatchArgs = {
  query?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchForTransactionAccountArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryShipToPartyArgs = {
  pageParams?: Maybe<ShipToPartyPageParams>;
  searchParams?: Maybe<ShipToPartySearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryShipToPartyForPpcArgs = {
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoiceGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageParams?: Maybe<ShipToPartyPageParams>;
  searchParams?: Maybe<ShipToPartySearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryShipToPartyGroupedArgs = {
  pageParams?: Maybe<ShipToPartyPageParams>;
  searchParams?: Maybe<ShipToPartySearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryStatuspageArgs = {
  id?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySubscriptionsForTxaArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySupportIssueArgs = {
  params: SupportIssueParams;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTermPaymentAuditTrailsArgs = {
  searchOptions?: Maybe<TermPaymentAuditTrailsSearchOptions>;
  searchParams?: Maybe<TermPaymentAuditTrailSearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTransactionAccountArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTransactionAccountsByBillToAddressArgs = {
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTrelloArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTxaPartnerAccountArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTxaPartnerAccountDomainsArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTxaPartnerDiscountsArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryUncollectibleInvoicesByEntitlementIdArgs = {
  entitlementId: Scalars['ID'];
};

export type Quote = {
  __typename?: 'Quote';
  atNumber?: Maybe<Scalars['String']>;
  billTo?: Maybe<QuoteBillingContact>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingFrequencyInterval?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Scalars['String']>;
  grandTotal: Scalars['Float'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  itemsCount?: Maybe<Scalars['Int']>;
  itemsSubtotal?: Maybe<Scalars['Int']>;
  itemsTotal?: Maybe<Scalars['Float']>;
  lineItems?: Maybe<Array<Maybe<QuoteLineItem>>>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  pdfLink: Scalars['String'];
  previousQuoteId?: Maybe<Scalars['String']>;
  promotionCode?: Maybe<Scalars['String']>;
  purchaser?: Maybe<QuotePurchaser>;
  quoteHeaderId?: Maybe<Scalars['String']>;
  quoteType?: Maybe<QuoteType>;
  reseller?: Maybe<Scalars['Boolean']>;
  shipTo?: Maybe<QuoteBillingContact>;
  sourceSystem?: Maybe<SourceSystem>;
  status?: Maybe<QuoteStatus>;
  taxes?: Maybe<Scalars['Float']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type QuoteBillingContact = {
  __typename?: 'QuoteBillingContact';
  address?: Maybe<BillingContactAddress>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type QuoteConnection = Connection & {
  __typename?: 'QuoteConnection';
  edges?: Maybe<Array<Maybe<QuoteEdge>>>;
  nodes?: Maybe<Array<Maybe<Quote>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuoteEdge = Edge & {
  __typename?: 'QuoteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Quote>;
};

export type QuoteLineDiscount = {
  __typename?: 'QuoteLineDiscount';
  amount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuoteLineItem = {
  __typename?: 'QuoteLineItem';
  accountName?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  appliedPurchaseCredit?: Maybe<Scalars['Int']>;
  baseProduct?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discountTotal?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Maybe<QuoteLineDiscount>>>;
  endDate?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  listPrice: Scalars['Int'];
  logoId?: Maybe<Scalars['String']>;
  parentEntitlementKey?: Maybe<Scalars['String']>;
  parentQuoteLineItemId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  proratedPrice?: Maybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  quoteHeaderId: Scalars['String'];
  quoteLineItemId: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type QuoteLineItemDetailsReference = {
  __typename?: 'QuoteLineItemDetailsReference';
  quoteId?: Maybe<Scalars['String']>;
  quoteLineItemId?: Maybe<Scalars['String']>;
};

export type QuotePurchaser = {
  __typename?: 'QuotePurchaser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type QuoteResults = {
  __typename?: 'QuoteResults';
  results?: Maybe<Array<Maybe<Quote>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type QuoteSearchParameters = {
  after?: Maybe<Scalars['String']>;
  atNumber?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  excludeDeletedQuotes?: Maybe<Scalars['Boolean']>;
  excludeExpiredQuotes?: Maybe<Scalars['Boolean']>;
  from?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<SortOptions>>>;
};

export enum QuoteStatus {
  DELETED = 'DELETED',
  PROCESSED = 'PROCESSED',
  QUOTED = 'QUOTED',
  REVIEW_REQUIRED = 'REVIEW_REQUIRED',
}

export enum QuoteType {
  CONVERTED_TO_ANNUAL = 'CONVERTED_TO_ANNUAL',
  CONVERTED_TO_MONTHLY = 'CONVERTED_TO_MONTHLY',
  DOWNGRADE = 'DOWNGRADE',
  MIXED = 'MIXED',
  NEW = 'NEW',
  RENEWAL = 'RENEWAL',
  UPGRADE = 'UPGRADE',
}

export type ReasonCustomisableObj = {
  __typename?: 'ReasonCustomisableObj';
  id?: Maybe<Scalars['String']>;
  readableName?: Maybe<Scalars['String']>;
};

export type RefundConnection = {
  __typename?: 'RefundConnection';
  results?: Maybe<Array<Maybe<Refunds>>>;
};

export type RefundDataSource = {
  __typename?: 'RefundDataSource';
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

export type RefundItems = {
  __typename?: 'RefundItems';
  adjustmentDetails?: Maybe<Array<Maybe<Adjustments>>>;
  adjustments?: Maybe<Array<Maybe<Adjustments>>>;
  billingCycle?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  editionWhileRefund?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  marginDetails?: Maybe<Array<Maybe<InvoiceMargins>>>;
  margins?: Maybe<Array<Maybe<InvoiceMargins>>>;
  metadata?: Maybe<LineItemMetaData>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  quantity?: Maybe<Scalars['Float']>;
  refundToCustomerBalance?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxExemptAmount?: Maybe<Scalars['Float']>;
  taxItems?: Maybe<Array<Maybe<TaxItems>>>;
  taxPercent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  taxableAmount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalExTax?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
};

export type RefundLineItems = {
  __typename?: 'RefundLineItems';
  adjustments?: Maybe<Array<Maybe<Adjustments>>>;
  id?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  planObj?: Maybe<Array<Maybe<PlanObj>>>;
  subTotal?: Maybe<Scalars['Float']>;
  subscriptionObj?: Maybe<Array<Maybe<SubscriptionObj>>>;
  tax?: Maybe<Scalars['Float']>;
  taxPercent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type RefundSearchParams = {
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
};

export type RefundWhereFilter = {
  and?: Maybe<Array<Maybe<RefundWhereFilter>>>;
  from?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  not?: Maybe<Array<Maybe<RefundWhereFilter>>>;
  or?: Maybe<Array<Maybe<RefundWhereFilter>>>;
  query?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type Refunds = {
  __typename?: 'Refunds';
  arn?: Maybe<Scalars['String']>;
  billTo?: Maybe<InvoiceBillAndShipTo>;
  chargeId?: Maybe<Scalars['String']>;
  coupledRefundItems?: Maybe<ProductAppRefundItemData>;
  createdDate?: Maybe<Scalars['String']>;
  creationNotes?: Maybe<Scalars['String']>;
  creditCardLastFourDigits?: Maybe<Scalars['String']>;
  creditNoteId?: Maybe<Scalars['String']>;
  creditNoteNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  dstRefundItems?: Maybe<Array<Maybe<RefundItems>>>;
  id: Scalars['String'];
  invoice?: Maybe<Invoice>;
  isPartner?: Maybe<Scalars['Boolean']>;
  memo?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  rechargeInvoiceId?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['String']>;
  refundItems?: Maybe<Array<Maybe<RefundItems>>>;
  refundedDate?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<Scalars['String']>;
  shipTo?: Maybe<InvoiceBillAndShipTo>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  totalExTax?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RefundsCoupledRefundItemsArgs = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
};
export type RefundsCoupledRefundItemsV2Args = {
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
};

/** Below type RelatedEntitlementDetails refers only to linked entitlement details. */
export type RelatedEntitlementDetails = {
  __typename?: 'RelatedEntitlementDetails';
  entitlementId?: Maybe<Scalars['String']>;
  relationshipId?: Maybe<Scalars['String']>;
  relationshipType?: Maybe<RelationshipPathType>;
};

export enum RelatedEntitlementDirection {
  RELATES_FROM_ENTITLEMENTS = 'RELATES_FROM_ENTITLEMENTS',
  RELATES_TO_ENTITLEMENTS = 'RELATES_TO_ENTITLEMENTS',
}

export type Relationship = {
  __typename?: 'Relationship';
  entitlementId?: Maybe<Scalars['String']>;
  relationshipId?: Maybe<Scalars['String']>;
  relationshipType?: Maybe<Scalars['String']>;
};

/** Linked Entitlement types */
export enum RelationshipPathType {
  APP_DEPENDENCE = 'APP_DEPENDENCE',
  FAMILY_CONTAINER = 'FAMILY_CONTAINER',
  SANDBOX_DEPENDENCE = 'SANDBOX_DEPENDENCE',
  SANDBOX_GRANT = 'SANDBOX_GRANT',
}

export type RelationshipRequirement = {
  __typename?: 'RelationshipRequirement';
  level?: Maybe<Scalars['String']>;
  side?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Resource = {
  __typename?: 'Resource';
  contactType?: Maybe<ContactType>;
  customerType?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum ResourceType {
  entitlement = 'entitlement',
  quote = 'quote',
  invoiceGroup = 'invoice-group',
}

export enum Role {
  CASSI_DEVELOPER = 'CASSI_DEVELOPER',
  COMMERCE_DEV = 'COMMERCE_DEV',
  CST_DEVELOPER = 'CST_DEVELOPER',
  CUSTOMER_ADVOCATE = 'CUSTOMER_ADVOCATE',
  ENTERPRISE_ADVOCATE = 'ENTERPRISE_ADVOCATE',
  GOVERNATOR_ADMIN = 'GOVERNATOR_ADMIN',
  LOYALTY_ADVOCATE = 'LOYALTY_ADVOCATE',
  PRODUCT_ADVOCATE = 'PRODUCT_ADVOCATE',
  SALES_OPERATIONS = 'SALES_OPERATIONS',
}

export type RssotContactEntitlement = {
  __typename?: 'RssotContactEntitlement';
  contactIdEmail?: Maybe<Scalars['String']>;
  contactRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  emailDomain?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  relationship?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSystem?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type RssotContactEntitlementConnection = Connection & {
  __typename?: 'RssotContactEntitlementConnection';
  edges?: Maybe<Array<Maybe<RssotContactEntitlementEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RssotContactEntitlementEdge = Edge & {
  __typename?: 'RssotContactEntitlementEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<RssotContactEntitlement>;
};

export enum SalesTransitionType {
  NEW = 'NEW',
  RENEW = 'RENEW',
  UPGRADE = 'UPGRADE',
}

/** The Atlassian employee who provides additional support to a customer account. */
export type SalesforceAccountMember = {
  __typename?: 'SalesforceAccountMember';
  accountId?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
  slackInfo?: Maybe<SlackInfo>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Int']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teamEmail?: Maybe<Scalars['String']>;
  teamFirstName?: Maybe<Scalars['String']>;
  teamLastName?: Maybe<Scalars['String']>;
  teamRole?: Maybe<Scalars['String']>;
};

/** A change to an entitlement scheduled to happen at a later time, often at the end of a billing cycle. */
export type ScheduledChanges = {
  __typename?: 'ScheduledChanges';
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  /** Unix epoch time in milliseconds */
  nextChangeTimestamp?: Maybe<Scalars['Float']>;
  /** Updated offering */
  offering?: Maybe<Offering>;
  pauseBilling?: Maybe<PauseBilling>;
  /** Updated pricing plan */
  pricingPlan?: Maybe<PricingPlan>;
  promotionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  scheduledBillingInvoiceGroupId?: Maybe<Scalars['String']>;
  subscriptionScheduleAction?: Maybe<SubscriptionScheduleAction>;
  /** Updated txa */
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type SearchCloudLicenseParams = {
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type SearchCloudLicensesParams = {
  idIsIn: Array<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type SearchLinkedEntitlementParams = {
  checkForLastParentExistence?: Maybe<Scalars['Boolean']>;
  containerId?: Maybe<Scalars['String']>;
  currentEntitlementType?: Maybe<LinkedEntitlementTypes>;
  destinationEntitlementType?: Maybe<Array<Maybe<LinkedEntitlementTypes>>>;
  entitlementId: Scalars['String'];
  findApps?: Maybe<Scalars['Boolean']>;
  findProducts?: Maybe<Scalars['Boolean']>;
  productType?: Maybe<LinkedProductTypes>;
};

export type SearchOptions = {
  after?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<SortType>;
  startDate?: Maybe<Scalars['String']>;
};

export type SearchOrganisationsConnection = Connection & {
  __typename?: 'SearchOrganisationsConnection';
  nodes?: Maybe<Array<Maybe<ProvisionedResourceMetadataObject>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SearchServerLicenses = {
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  maintenanceStatus?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<LicenseSortFields>>>;
};

export type SearchServiceLicenses = {
  email?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<LicenseSortFields>>>;
};

export type ServerLicense = {
  __typename?: 'ServerLicense';
  accountId?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  maintenancePeriod?: Maybe<Scalars['Int']>;
  planType?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  unitCount?: Maybe<Scalars['Int']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type ServerLicenseResults = {
  __typename?: 'ServerLicenseResults';
  activeMaintenance?: Maybe<Scalars['Int']>;
  expiredMaintenance?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<ServerLicense>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type ServiceLicenseResults = {
  __typename?: 'ServiceLicenseResults';
  results?: Maybe<Array<Maybe<ServerLicense>>>;
  totalHits?: Maybe<Scalars['Int']>;
};

export type ShipTo = {
  __typename?: 'ShipTo';
  address1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ShipToPartyAggregated = {
  __typename?: 'ShipToPartyAggregated';
  data?: Maybe<Array<Maybe<CommerceAddress>>>;
  key?: Maybe<Scalars['String']>;
};

export type ShipToPartyAggregatedConnection = {
  __typename?: 'ShipToPartyAggregatedConnection';
  nodes?: Maybe<Array<Maybe<ShipToPartyAggregated>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ShipToPartyConnection = {
  __typename?: 'ShipToPartyConnection';
  nodes?: Maybe<Array<Maybe<CommerceAddress>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ShipToPartyGroupBy {
  name = 'name',
}

export type ShipToPartyPageParams = {
  cursor?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  groupBy?: Maybe<ShipToPartyGroupBy>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type ShipToPartySearchParams = {
  companyName?: Maybe<Scalars['String']>;
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  query?: Maybe<Scalars['String']>;
  soldToAddressId?: Maybe<Scalars['String']>;
  transactionAccountId: Scalars['String'];
};

export type SiteAccess = {
  __typename?: 'SiteAccess';
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['String']>;
};

export type SiteAdmin = {
  __typename?: 'SiteAdmin';
  atlassianAccount?: Maybe<AtlassianAccountDetails>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastActive?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  status?: Maybe<Scalars['String']>;
};

export type SiteAdminConnection = Connection & {
  __typename?: 'SiteAdminConnection';
  edges?: Maybe<Array<Maybe<SiteAdminEdge>>>;
  nodes?: Maybe<Array<Maybe<SiteAdmin>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SiteAdminEdge = Edge & {
  __typename?: 'SiteAdminEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<SiteAdmin>;
};

export type SlaCreditApplications = {
  __typename?: 'SlaCreditApplications';
  amountExTax?: Maybe<Scalars['Float']>;
  amountIncTax?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  creditExternalId?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currencyExchangeRate?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** Associated Slack account information for an Atlassian. Useful for opening a direct message or sending information to. */
export type SlackInfo = {
  __typename?: 'SlackInfo';
  slackTeamId?: Maybe<Scalars['String']>;
  slackUserId?: Maybe<Scalars['String']>;
};

export type SoldToAddress = {
  __typename?: 'SoldToAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  priceEligibility?: Maybe<Scalars['String']>;
  shipToPriceEligibility?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  taxLabels?: Maybe<Array<Maybe<TaasTaxLabel>>>;
  type?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SoldToAddressConnection = Connection & {
  __typename?: 'SoldToAddressConnection';
  nodes?: Maybe<Array<Maybe<SoldToAddress>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Direction to sort returned connection */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortOptions = {
  createdDate?: Maybe<SortDirection>;
};

/** ElasticSearch Script for finely tuned sorts (used with Hydra) */
export type SortScript = {
  order?: Maybe<Scalars['String']>;
  returnType?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
};

/** Available sort options; defaults to Hydra terminology */
export type SortType = {
  /** Fields to sort, must be equal length to sortFieldsDirections */
  sortFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Direction to sort, must be equal length to sortFields */
  sortFieldsDirections?: Maybe<Array<Maybe<SortDirection>>>;
  sortScript?: Maybe<Array<Maybe<SortScript>>>;
};

export enum SourceSystem {
  CCP = 'CCP',
  HAMS = 'HAMS',
}

export type Statuspage = Entitlement & {
  __typename?: 'Statuspage';
  activeSubscriptionBillingGroupId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  addOns?: Maybe<AddOnConnection>;
  auditNotes?: Maybe<AuditNoteConnection>;
  availableOfferings?: Maybe<Array<Maybe<Offering>>>;
  availablePricingPlans?: Maybe<Array<Maybe<PricingPlan>>>;
  availablePromotions?: Maybe<Array<Maybe<Promotion>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billing?: Maybe<Billing>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  deletedProductDetails?: Maybe<DeletedProductDetails>;
  edition?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailConnection>;
  entitlementNumber?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  hasPendingInvoices?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoices: InvoiceConnection;
  isApp?: Maybe<Scalars['Boolean']>;
  isOptOutAllowed?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  linkedEntitlements?: Maybe<Array<Maybe<LinkedDestinationEntitlement>>>;
  nextBillEstimate?: Maybe<NextBillEstimate>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  nextInvoiceTimeAt?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  orders?: Maybe<OrderConnection>;
  ordersForRewind?: Maybe<OrderConnection>;
  orgId?: Maybe<Scalars['String']>;
  parentCloudSiteName?: Maybe<Scalars['String']>;
  parentContainerId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanHistory: InvoiceConnection;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promoCodesApplicable?: Maybe<PromoCodeResponseDto>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  provisioningStatus?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  renewalAction?: Maybe<Scalars['String']>;
  sandboxEntitlements?: Maybe<Array<Maybe<LinkedDestinationEntitlement>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  siteAdmins?: Maybe<SiteAdminConnection>;
  sourceSystem?: Maybe<Scalars['String']>;
  subscription?: Maybe<Array<Maybe<SubscriptionDetails>>>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionTimestamps?: Maybe<SubscriptionTimeStamps>;
  subscriptionsEndTimestamp?: Maybe<Scalars['String']>;
  supportIssues?: Maybe<SupportIssues>;
  totalBilledUsers?: Maybe<Scalars['Int']>;
  transactionAccount?: Maybe<TransactionAccount>;
  transactionAccountId?: Maybe<Scalars['String']>;
  trialPromotionDetails?: Maybe<TrialPromotionDetails>;
  unitCount?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  userHistory?: Maybe<UserHistoryDetails>;
  users?: Maybe<UserConnection>;
  validOfferings?: Maybe<Array<Maybe<ValidOfferings>>>;
  version?: Maybe<Scalars['String']>;
};

export type StatuspageActiveUsersArgs = {
  id?: Maybe<Scalars['String']>;
};

export type StatuspageAddOnsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageAuditNotesArgs = {
  dateFilter?: Maybe<DateRange>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageAvailablePricingPlansArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

export type StatuspageAvailablePromotionsArgs = {
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
};

export type StatuspageEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageInvoicesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageLinkedEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type StatuspageOrdersArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageParentContainerIdArgs = {
  id?: Maybe<Scalars['String']>;
};

export type StatuspagePricingPlanHistoryArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspagePromoCodesApplicableArgs = {
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
};

export type StatuspageSandboxEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type StatuspageSubscriptionArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type StatuspageSupportIssuesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParam?: Maybe<SupportIssueEntitlementSearchParams>;
};

export type StatuspageUserHistoryArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
};

export type StatuspageUsersArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export enum SubBenefitType {
  PERCENTAGE = 'PERCENTAGE',
  TRIAL = 'TRIAL',
}

export type Subscription = {
  __typename?: 'Subscription';
  subscriptionPeriod?: Maybe<Array<Maybe<SubscriptionPeriod>>>;
};

export type SubscriptionBillingDetails = {
  __typename?: 'SubscriptionBillingDetails';
  endTimestamp?: Maybe<Scalars['Float']>;
  nextBillingTimestamp?: Maybe<Scalars['Float']>;
  nextBillingTimestampForScheduledUpgrades?: Maybe<Scalars['Float']>;
  pauseBilling?: Maybe<PauseBilling>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  id?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  subscriptionPeriod?: Maybe<Array<Maybe<SubscriptionPeriodDetails>>>;
};

export type SubscriptionObj = {
  __typename?: 'SubscriptionObj';
  chargeType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
};

export type SubscriptionPeriod = {
  __typename?: 'SubscriptionPeriod';
  endTimestamp?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trial?: Maybe<TrialDetails>;
};

export type SubscriptionPeriodDetails = {
  __typename?: 'SubscriptionPeriodDetails';
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  endTimestamp?: Maybe<Scalars['String']>;
  offeringKey?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
  trial?: Maybe<TrialTimeStamps>;
};

export enum SubscriptionScheduleAction {
  CANCEL = 'CANCEL',
  TRANSFER = 'TRANSFER',
  UPDATE = 'UPDATE',
  UPDATE_CANCEL = 'UPDATE_CANCEL',
  UPDATE_TRANSFER = 'UPDATE_TRANSFER',
}

export type SubscriptionTimeStamps = {
  __typename?: 'SubscriptionTimeStamps';
  firstStartTimestamp?: Maybe<Scalars['String']>;
  firstTrialStartTimestamp?: Maybe<Scalars['String']>;
  lastEndTimestamp?: Maybe<Scalars['String']>;
  lastTrialEndTimestamp?: Maybe<Scalars['String']>;
};

export type SupportIssue = {
  __typename?: 'SupportIssue';
  createdTimestamp?: Maybe<Scalars['String']>;
  currentStatus?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  issueKey?: Maybe<Scalars['String']>;
  reporterEmailAddress?: Maybe<Scalars['String']>;
  resolutionTimestamp?: Maybe<Scalars['String']>;
  status?: Maybe<SupportIssueStatus>;
  summary?: Maybe<Scalars['String']>;
  supportIssueField?: Maybe<SupportIssueField>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type SupportIssueComment = {
  __typename?: 'SupportIssueComment';
  authorDisplayName?: Maybe<Scalars['String']>;
  authorEmail?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  businessKey: Scalars['String'];
  createdTimestamp: Scalars['String'];
};

export type SupportIssueComponent = {
  __typename?: 'SupportIssueComponent';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SupportIssueEdge = Edge & {
  __typename?: 'SupportIssueEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<SupportIssue>;
};

export type SupportIssueEntitlementSearchParams = {
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedFrom?: Maybe<Scalars['String']>;
  updatedTo?: Maybe<Scalars['String']>;
};

export type SupportIssueField = {
  __typename?: 'SupportIssueField';
  atlassianCloudURL?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  firstResponseDate?: Maybe<Scalars['String']>;
  partnerType?: Maybe<Scalars['String']>;
  quoteNumber?: Maybe<Scalars['String']>;
  senURL?: Maybe<Scalars['String']>;
  supportEntitlementNumber?: Maybe<Scalars['String']>;
  ticketScore?: Maybe<Scalars['String']>;
  ticketSegment?: Maybe<Scalars['String']>;
};

export type SupportIssueParams = {
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  issueKey?: Maybe<Scalars['String']>;
};

export type SupportIssueResult = {
  __typename?: 'SupportIssueResult';
  assigneeDisplayName?: Maybe<Scalars['String']>;
  assigneeEmailAddress?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<Maybe<SupportIssueComment>>>;
  createdTimestamp?: Maybe<Scalars['String']>;
  currentStatus?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enterpriseAccountTier?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  issueKey?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  reporterDisplayName?: Maybe<Scalars['String']>;
  reporterEmailAddress?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  resolution?: Maybe<Scalars['String']>;
  resolutionTimestamp?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  status?: Maybe<SupportIssueStatus>;
  summary?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type SupportIssueSearchOptions = {
  after?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<Maybe<SupportIssueSortFields>>>;
};

export type SupportIssueSearchParams = {
  cloudSiteId?: Maybe<Scalars['String']>;
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  domain?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  issueKey?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedFrom?: Maybe<Scalars['String']>;
  updatedTo?: Maybe<Scalars['String']>;
};

export type SupportIssueSortFields = {
  assigneeEmailAddress?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<SortDirection>;
  issueKey?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<SortDirection>;
};

export type SupportIssueStatus = {
  __typename?: 'SupportIssueStatus';
  categoryId: Scalars['Int'];
  categoryKey?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SupportIssues = {
  __typename?: 'SupportIssues';
  results: Array<Maybe<SupportIssue>>;
  totalHits: Scalars['Int'];
};

export type SupportIssuesConnection = Connection & {
  __typename?: 'SupportIssuesConnection';
  edges?: Maybe<Array<Maybe<SupportIssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SxpEntitlementSearchParams = {
  appEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingFrequency?: Maybe<Scalars['String']>;
  cloudSiteEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  quoteTxaId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

/** Synthetic pricing plans may exist on offerings to provide discounts based on the customer (academic, open source, etc) */
export type SyntheticPricingPlan = {
  __typename?: 'SyntheticPricingPlan';
  discountPercentage: Scalars['Float'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type TxaPartnerAccount = {
  __typename?: 'TXAPartnerAccount';
  domains?: Maybe<TxaPartnerAccountDomains>;
  parentAccountId?: Maybe<Scalars['String']>;
  payOnAccount?: Maybe<Scalars['Boolean']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  specializations?: Maybe<Array<Maybe<Scalars['String']>>>;
  territory?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  verifiedExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TxaPartnerAccountDiscount = {
  __typename?: 'TXAPartnerAccountDiscount';
  label?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
};

export type TxaPartnerAccountDomains = {
  __typename?: 'TXAPartnerAccountDomains';
  alternates?: Maybe<Array<Maybe<Scalars['String']>>>;
  main?: Maybe<Scalars['String']>;
};

export type TxaPartnerAccountDomainsSfdc = {
  __typename?: 'TXAPartnerAccountDomainsSfdc';
  alternates?: Maybe<Array<Maybe<Scalars['String']>>>;
  main?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaasTaxLabel = {
  __typename?: 'TaasTaxLabel';
  region?: Maybe<Scalars['String']>;
  taxIdLabels?: Maybe<Array<Maybe<TasstaxIdLabel>>>;
};

export type TassTaxIdLabelMetadata = {
  __typename?: 'TassTaxIdLabelMetadata';
  labels?: Maybe<Array<Maybe<TassTaxIdLabelMetadataLabel>>>;
  type?: Maybe<Scalars['String']>;
};

export type TassTaxIdLabelMetadataLabel = {
  __typename?: 'TassTaxIdLabelMetadataLabel';
  default?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  vatStatus?: Maybe<Scalars['String']>;
};

export type TasstaxIdLabel = {
  __typename?: 'TasstaxIdLabel';
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  metadata?: Maybe<TassTaxIdLabelMetadata>;
  type?: Maybe<Scalars['String']>;
};

export type TaxId = {
  __typename?: 'TaxId';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<TaxMetadata>;
  taxExempt?: Maybe<Scalars['Boolean']>;
};

export type TaxItems = {
  __typename?: 'TaxItems';
  id?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['String']>;
  taxAmountLabel?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIdLabel?: Maybe<Scalars['String']>;
  taxPercent?: Maybe<Scalars['String']>;
};

/** Address details used for billing information. */
export type TaxMetadata = {
  __typename?: 'TaxMetadata';
  vatStatus?: Maybe<Scalars['String']>;
};

export type TermDetailsAccount = {
  __typename?: 'TermDetailsAccount';
  billingAdmins?: Maybe<Scalars['String']>;
  creditOutstanding?: Maybe<Scalars['Float']>;
  customerName?: Maybe<Scalars['String']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  jiraDetails?: Maybe<Scalars['String']>;
  legalCompanyName?: Maybe<Scalars['String']>;
  pendingInvoiceRequestsTotal?: Maybe<Scalars['Float']>;
  sourceBillingSystem?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
};

export type TermDetailsAccountConnection = {
  __typename?: 'TermDetailsAccountConnection';
  availableCreditLimit?: Maybe<Scalars['Float']>;
  creditOutstanding?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLevel?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<TermDetailsAccount>>>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalCreditLimit?: Maybe<Scalars['Float']>;
};

export type TermPaymentAuditTrail = {
  __typename?: 'TermPaymentAuditTrail';
  comments?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  revisionNumber?: Maybe<Scalars['Int']>;
  revisionType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type TermPaymentAuditTrailSearchParams = {
  netTerm?: Maybe<Scalars['String']>;
  transactionAccountKey?: Maybe<Scalars['String']>;
};

export type TermPaymentAuditTrailsConnection = {
  __typename?: 'TermPaymentAuditTrailsConnection';
  nodes?: Maybe<Array<Maybe<TermPaymentAuditTrail>>>;
  totalCount: Scalars['Int'];
};

export type TermPaymentAuditTrailsSearchOptions = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export enum TermPaymentTypes {
  NET14 = 'NET14',
  NET30 = 'NET30',
}

export type TransactionAccount = {
  __typename?: 'TransactionAccount';
  availableInvoiceGroups?: Maybe<InvoiceGroupConnection>;
  availablePaymentMethods?: Maybe<PaymentMethodConnection>;
  availableShipToParties?: Maybe<CommerceAddressConnection>;
  billToAddress?: Maybe<CommerceAddress>;
  billToParty?: Maybe<CommerceAddress>;
  billToPartyPricingEligibilty?: Maybe<Scalars['String']>;
  billingAccountsList?: Maybe<TermDetailsAccountConnection>;
  billingAdmins?: Maybe<BillingAdminConnection>;
  billingProfiles?: Maybe<InvoiceGroupConnection>;
  createArTicketLink?: Maybe<Scalars['String']>;
  creditRequestAppLink?: Maybe<Scalars['String']>;
  customerBalances?: Maybe<CustomerBalancesRecord>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  displayName?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailConnection>;
  entitlements?: Maybe<EssotEntitlementConnection>;
  hamsInvoices?: Maybe<HamsInvoice>;
  id: Scalars['ID'];
  internalUseBillingProfiles?: Maybe<InvoiceGroupConnection>;
  internalUseSubscriptions?: Maybe<TransactionAccountProductConnection>;
  invoices?: Maybe<InvoiceConnection>;
  isPartner?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<OrderConnection>;
  overdueInvoices?: Maybe<InvoiceConnection>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerDiscountTier?: Maybe<Scalars['String']>;
  partnerInvoices?: Maybe<InvoiceConnection>;
  partnerLevel?: Maybe<Scalars['String']>;
  pendingInvoices?: Maybe<Scalars['Boolean']>;
  productAndAppSubscriptions?: Maybe<ProductAppSubscriptionData>;
  productFamilies?: Maybe<TransactionAccountProductConnection>;
  productSubscriptions?: Maybe<TransactionAccountProductConnection>;
  productSubscriptionsInPPC?: Maybe<TransactionAccountProductConnection>;
  products?: Maybe<TransactionAccountProductConnection>;
  programLevelGlobal?: Maybe<Scalars['String']>;
  refundedInvoices?: Maybe<InvoiceConnection>;
  soldToAddress?: Maybe<SoldToAddressConnection>;
  status?: Maybe<Scalars['String']>;
  transactionAccountBalanceEntity?: Maybe<Array<Maybe<TxaCustomerBalanceDetails>>>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  partnerBillingAdminIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TransactionAccountAvailablePaymentMethodsArgs = {
  viewSubscriptionsLink?: Maybe<Scalars['Boolean']>;
};

export type TransactionAccountAvailableShipToPartiesArgs = {
  viewTaxRelatedInfo?: Maybe<Scalars['Boolean']>;
};

export type TransactionAccountBillingAdminsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountBillingProfilesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountBillingProfilesFromCcpArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParams?: Maybe<BillingAdminEmailSearchParams>;
};

export type TransactionAccountEmailsArgs = {
  partnerAccountId?: Maybe<Scalars['String']>;
  searchParams?: Maybe<BillingAdminEmailSearchParams>;
};

export type TransactionAccountEntitlementsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountHamsInvoicesArgs = {
  filterOptions?: Maybe<InvoicesFilterOptions>;
  page?: Maybe<Scalars['Int']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountInternalUseBillingProfilesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  relatedDomains: Array<Maybe<Scalars['String']>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountInternalUseSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  relatedDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountInvoicesArgs = {
  filterOptions?: Maybe<InvoicesFilterOptions>;
  includeItems?: Maybe<Scalars['Boolean']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountOrderSitesArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountOrdersArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountOverdueInvoicesArgs = {
  filterOptions?: Maybe<FilterOption>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountPartnerInvoicesArgs = {
  pageParams?: Maybe<InvoicePageParams>;
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  queryString?: Maybe<Scalars['String']>;
};

export type TransactionAccountProductAndAppSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountProductFamiliesArgs = {
  filterOptions?: Maybe<ProductSubscriptionsFilterOptions>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountProductSubscriptionsArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountProductSubscriptionsInPpcArgs = {
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountProductsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountRefundedInvoicesArgs = {
  filterOptions?: Maybe<InvoicesFilterOptions>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TransactionAccountSoldToAddressArgs = {
  id: Scalars['ID'];
};

export type TransactionAccountConnection = Connection & {
  __typename?: 'TransactionAccountConnection';
  edges?: Maybe<Array<Maybe<TransactionAccountEdge>>>;
  nodes?: Maybe<Array<Maybe<TransactionAccount>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TransactionAccountDetail = {
  __typename?: 'TransactionAccountDetail';
  transactionAccountName?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
};

export type TransactionAccountEdge = Edge & {
  __typename?: 'TransactionAccountEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: TransactionAccount;
};

export type TransactionAccountProduct = {
  __typename?: 'TransactionAccountProduct';
  activeSubscriptionBillingGroupId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  availableOfferings?: Maybe<Array<Maybe<Offering>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billedUsers?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<SubscriptionBillingDetails>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  endBehaviour?: Maybe<Scalars['String']>;
  endCustomerContacts?: Maybe<Array<EndCustomerContact>>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  isFutureDatedSubscription?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  linkedAppsId?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedAddOnsId?: Maybe<Array<Maybe<Scalars['String']>>>;
  logoId?: Maybe<Scalars['String']>;
  nextBillingTimestamp?: Maybe<Scalars['String']>;
  nextBillingTimestampForScheduledUpgrades?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  pauseBilling?: Maybe<PauseBilling>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  provisioningStatus?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<RelatedEntitlementDetails>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  shipTo?: Maybe<InvoiceBillAndShipTo>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionTimestamps?: Maybe<SubscriptionTimeStamps>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Boolean']>;
  trialDetails?: Maybe<TrialDetails>;
  trialEndDate?: Maybe<Scalars['String']>;
  trialStartDate?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
  userTier?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  isExternallyBilled?: Maybe<Scalars['Boolean']>;
};

export type TransactionAccountProductEndCustomerContactsArgs = {
  isRestricted?: Maybe<Scalars['Boolean']>;
};

export type TransactionAccountProductLinkedEntitlementsArgs = {
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
};

export type TransactionAccountProductConnection = Connection & {
  __typename?: 'TransactionAccountProductConnection';
  edges?: Maybe<Array<Maybe<TransactionAccountProductEdge>>>;
  nodes?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TransactionAccountProductEdge = Edge & {
  __typename?: 'TransactionAccountProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: TransactionAccountProduct;
};

export type TransactionDetailObj = {
  __typename?: 'TransactionDetailObj';
  billToCompany?: Maybe<Scalars['String']>;
  shipToCompany?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type Trello = Entitlement & {
  __typename?: 'Trello';
  baseProduct: Scalars['String'];
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  contacts: ContactConnection;
  emails: EmailConnection;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  supportIssues: SupportIssues;
  trFindLink: Scalars['String'];
};

export type TrelloContactsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TrelloEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type TrelloSupportIssuesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

export type Trial = {
  __typename?: 'Trial';
  endBehaviour?: Maybe<Scalars['String']>;
};

export type TrialDetails = {
  __typename?: 'TrialDetails';
  endTimestamp?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
};

export type TrialPromotionDetails = {
  __typename?: 'TrialPromotionDetails';
  totalTrialCount?: Maybe<Scalars['Int']>;
  totalTrialDays?: Maybe<Scalars['Int']>;
};

export type TrialTimeStamps = {
  __typename?: 'TrialTimeStamps';
  endTimestamp?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
};

export type UpcomingCurrencyExtras = {
  __typename?: 'UpcomingCurrencyExtras';
  currency?: Maybe<Scalars['String']>;
  period?: Maybe<BillingPeriod>;
};

export type UpdatedChargeQuantities = {
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type UpgradeTrialDetails = {
  __typename?: 'UpgradeTrialDetails';
  baseOffering?: Maybe<Offering>;
  baseOfferingName?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  startTimestamp?: Maybe<Scalars['String']>;
};

export type Usage = {
  __typename?: 'Usage';
  currentUnits?: Maybe<Scalars['Int']>;
  unitCode?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  unlimited?: Maybe<Scalars['Boolean']>;
};

export type UsageAggregation = {
  __typename?: 'UsageAggregation';
  highWaterMarkUsage?: Maybe<Scalars['Int']>;
  latestUsage?: Maybe<Scalars['Int']>;
  maxUsage?: Maybe<Scalars['Int']>;
  periodTimestamp?: Maybe<Scalars['String']>;
  usersAdded?: Maybe<Scalars['Int']>;
  usersRemoved?: Maybe<Scalars['Int']>;
};

export type UsageAggregationDetails = {
  __typename?: 'UsageAggregationDetails';
  period?: Maybe<UsageTimePeriod>;
  results?: Maybe<Array<Maybe<UsageAggregation>>>;
};

export type UsageOptions = {
  __typename?: 'UsageOptions';
  chargingDetails?: Maybe<ChargingDetails>;
};

export type UsageTimePeriod = {
  __typename?: 'UsageTimePeriod';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  atlassianAccount?: Maybe<AtlassianAccountDetails>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastActive?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  status?: Maybe<Scalars['String']>;
};

export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<User>;
};

export type UserHistoryDetails = {
  __typename?: 'UserHistoryDetails';
  nextId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<ChargeQuantity>>>;
};

/** security profile of the logged in user */
export type UserProfile = {
  __typename?: 'UserProfile';
  atlassianAccountId: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  featureFlags: Scalars['JSON'];
  hasValidBitbucketLink: Scalars['Boolean'];
  permissions: Array<Maybe<Permission>>;
  roles: Array<Maybe<Role>>;
  userId: Scalars['String'];
  xsrfToken?: Maybe<Scalars['String']>;
};

export enum UserRole {
  SITE_ADMIN = 'SITE_ADMIN',
  USER = 'USER',
}

export type ValidOfferings = {
  __typename?: 'ValidOfferings';
  key?: Maybe<Scalars['String']>;
  offeringKey?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type WhitelistedUser = {
  __typename?: 'WhitelistedUser';
  email?: Maybe<Scalars['String']>;
  whitelists?: Maybe<Array<Maybe<Whitelists>>>;
};

export type EntitlementGroup = {
  __typename?: 'entitlementGroup';
  billingDate?: Maybe<Scalars['String']>;
  entitlements?: Maybe<Array<Maybe<EntitlementDetails>>>;
};

export type LatestInvoiceDetails = {
  __typename?: 'latestInvoiceDetails';
  id?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
};

export type OrderLineItemsPurchaseMetadataType = {
  __typename?: 'orderLineItemsPurchaseMetadataType';
  fieldName?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
};

export type TxaCustomerBalanceDetails = {
  __typename?: 'txaCustomerBalanceDetails';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  creditNote?: Maybe<Scalars['String']>;
  creditNoteNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  endingAmount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Whitelists = {
  __typename?: 'whitelists';
  addedBy?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

export type FetchInternalLicensesForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isRestricted?: Maybe<Scalars['Boolean']>;
  fetchIsExternallyEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInternalLicensesForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      internalUseSubscriptions?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & MakeOptional<
                    Pick<
                      TransactionAccountProduct,
                      | 'id'
                      | 'logoId'
                      | 'activeSubscriptionBillingGroupId'
                      | 'activeUsers'
                      | 'baseProduct'
                      | 'createdDate'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'transactionAccountNumber'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                      | 'cloudSiteId'
                      | 'cloudSiteHostname'
                      | 'billingFrequency'
                      | 'edition'
                      | 'provisioningStatus'
                      | 'billingGroupId'
                      | 'billedUsers'
                      | 'isFutureDatedSubscription'
                      | 'trial'
                      | 'isSandbox'
                      | 'linkedAppsId'
                      | 'linkedAddOnsId'
                      | 'isAddOn'
                      | 'orgId'
                      | 'orgName'
                      | 'endTimestamp'
                      | 'endBehaviour'
                      | 'trialStartDate'
                      | 'trialEndDate'
                      | 'isExternallyBilled'
                      | 'userTier'
                    >,
                    'isExternallyBilled'
                  > & {
                      pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type'>>;
                      relatesFromEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      relatesToEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      endCustomerContacts?: Maybe<
                        Array<
                          { __typename?: 'EndCustomerContact' } & Pick<
                            EndCustomerContact,
                            'accountId' | 'name' | 'picture' | 'email'
                          >
                        >
                      >;
                      chargeQuantities?: Maybe<
                        Array<
                          Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>
                        >
                      >;
                      subscriptionTimestamps?: Maybe<
                        { __typename?: 'SubscriptionTimeStamps' } & Pick<
                          SubscriptionTimeStamps,
                          | 'firstStartTimestamp'
                          | 'lastEndTimestamp'
                          | 'firstTrialStartTimestamp'
                          | 'lastTrialEndTimestamp'
                        >
                      >;
                      upgradeTrial?: Maybe<
                        { __typename?: 'UpgradeTrialDetails' } & Pick<
                          UpgradeTrialDetails,
                          'startTimestamp' | 'endTimestamp'
                        >
                      >;
                      scheduledChanges?: Maybe<
                        { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'> & {
                            offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id'>>;
                            pauseBilling?: Maybe<
                              { __typename?: 'PauseBilling' } & Pick<PauseBilling, 'startTimestamp' | 'endTimestamp'>
                            >;
                          }
                      >;
                      offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType' | 'name'>>;
                      pauseBilling?: Maybe<
                        { __typename?: 'PauseBilling' } & Pick<PauseBilling, 'startTimestamp' | 'endTimestamp'>
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchInvoicesForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type FetchInvoicesForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id' | 'pendingInvoices'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'invoiceDueDays'
                    | 'dueDate'
                    | 'prePaymentCreditNotesAmount'
                    | 'paymentCurrency'
                    | 'pdfLink'
                    | 'transactionAccountId'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      creditCard?: Maybe<
                        { __typename?: 'CreditCardDetails' } & Pick<CreditCardDetails, 'last4Numbers'>
                      >;
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                              | 'creditNoteId'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'DunningStatus' } & Pick<
                              DunningStatus,
                              'errorCode' | 'nextPaymentAttempDate'
                            >
                          >
                        >
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'>)
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'type' | 'paymentIssue' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type FetchProductsForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isRestricted?: Maybe<Scalars['Boolean']>;
  fetchIsExternallyEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchProductsForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'id'
                    | 'logoId'
                    | 'activeSubscriptionBillingGroupId'
                    | 'activeUsers'
                    | 'baseProduct'
                    | 'createdDate'
                    | 'billingStatus'
                    | 'entitlementNumber'
                    | 'transactionAccountNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                    | 'cloudSiteId'
                    | 'cloudSiteHostname'
                    | 'billingFrequency'
                    | 'edition'
                    | 'provisioningStatus'
                    | 'billingGroupId'
                    | 'billedUsers'
                    | 'trial'
                    | 'linkedAppsId'
                    | 'linkedAddOnsId'
                    | 'isSandbox'
                    | 'isExternallyBilled'
                  > & {
                      relatesFromEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      relatesToEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      endCustomerContacts?: Maybe<
                        Array<
                          { __typename?: 'EndCustomerContact' } & Pick<
                            EndCustomerContact,
                            'accountId' | 'name' | 'picture'
                          >
                        >
                      >;
                      chargeQuantities?: Maybe<
                        Array<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>
                      >;
                      subscriptionTimestamps?: Maybe<
                        { __typename?: 'SubscriptionTimeStamps' } & Pick<
                          SubscriptionTimeStamps,
                          | 'firstStartTimestamp'
                          | 'lastEndTimestamp'
                          | 'firstTrialStartTimestamp'
                          | 'lastTrialEndTimestamp'
                        >
                      >;
                      upgradeTrial?: Maybe<
                        { __typename?: 'UpgradeTrialDetails' } & Pick<
                          UpgradeTrialDetails,
                          'startTimestamp' | 'endTimestamp'
                        >
                      >;
                      scheduledChanges?: Maybe<
                        { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'> & {
                            offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id'>>;
                          }
                      >;
                      offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'name'>>;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchEntitlementTotalCountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchEntitlementTotalCountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<TransactionAccountProductConnection, 'totalCount'>
      >;
    };
};
export type CreditDetailsInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type CreditDetailsInvoiceQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'dueDate'
                    | 'prePaymentCreditNotesAmount'
                    | 'paymentCurrency'
                    | 'pdfLink'
                    | 'transactionAccountId'
                    | 'status'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      dunningStatus?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'DunningStatus' } & Pick<
                              DunningStatus,
                              'errorCode' | 'nextPaymentAttempDate'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchTermDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTermDetailsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber'
  > & {
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<
                      CreditCard,
                      'id' | 'paymentIssue' | 'type' | 'default' | 'hasLinkedSubscriptions'
                    > & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'id' | 'paymentIssue' | 'type' | 'default' | 'hasLinkedSubscriptions'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'taxId' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode' | 'state' | 'taxExempt'
        > & {
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'displayName' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'type' | 'displayName' | 'description'
                            > & {
                                metadata?: Maybe<
                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                      labels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                              TassTaxIdLabelMetadataLabel,
                                              'label' | 'vatStatus' | 'default'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<
          TermDetailsAccountConnection,
          | 'totalCount'
          | 'totalCreditLimit'
          | 'creditOutstanding'
          | 'availableCreditLimit'
          | 'paymentMethod'
          | 'currency'
          | 'status'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TermDetailsAccount' } & Pick<
                    TermDetailsAccount,
                    'creditOutstanding' | 'status' | 'customerName' | 'transactionAccountNumber'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchTermPaymentAuditTrailsQueryVariables = Exact<{
  searchParams?: Maybe<TermPaymentAuditTrailSearchParams>;
  searchOptions?: Maybe<TermPaymentAuditTrailsSearchOptions>;
}>;

export type FetchTermPaymentAuditTrailsQuery = { __typename?: 'Query' } & {
  termPaymentAuditTrails: { __typename?: 'TermPaymentAuditTrailsConnection' } & Pick<
    TermPaymentAuditTrailsConnection,
    'totalCount'
  > & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'TermPaymentAuditTrail' } & Pick<
              TermPaymentAuditTrail,
              'id' | 'comments' | 'updatedBy' | 'createdAt' | 'revisionNumber' | 'revisionType'
            >
          >
        >
      >;
    };
};

export type FetchInvoiceGroupV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInvoiceGroupV2Query = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<
      InvoiceGroup,
      | 'id'
      | 'name'
      | 'currency'
      | 'updatePaymentMethodLink'
      | 'transactionAccountId'
      | 'transactionAccountNumber'
      | 'recipients'
    > & {
        termPaymentStatus?: Maybe<
          { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
        >;
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            | 'id'
            | 'name'
            | 'addressLine1'
            | 'addressLine2'
            | 'city'
            | 'state'
            | 'country'
            | 'postcode'
            | 'taxId'
            | 'shipToPriceEligibility'
            | 'taxExempt'
          > & {
              taxIds?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                        metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                      }
                  >
                >
              >;
              taxLabels?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                        taxIdLabels?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'TasstaxIdLabel' } & Pick<
                                TasstaxIdLabel,
                                'description' | 'displayName' | 'type'
                              > & {
                                  metadata?: Maybe<
                                    { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                        labels?: Maybe<
                                          Array<
                                            Maybe<
                                              { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                TassTaxIdLabelMetadataLabel,
                                                'default' | 'label' | 'vatStatus'
                                              >
                                            >
                                          >
                                        >;
                                      }
                                  >;
                                }
                            >
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                card?: Maybe<
                  { __typename?: 'CreditCardDetails' } & Pick<
                    CreditCardDetails,
                    'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                  >
                >;
              })
          | ({ __typename?: 'PaymentOnTerms' } & Pick<
              PaymentOnTerms,
              'totalCreditLimit' | 'paymentMethod' | 'id' | 'type' | 'default' | 'paymentIssue'
            >)
        >;
        transactionAccount?: Maybe<
          { __typename?: 'TransactionAccount' } & Pick<
            TransactionAccount,
            'id' | 'displayName' | 'updatePaymentMethodLink' | 'partnerAccountId'
          > & {
              billToParty?: Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  | 'name'
                  | 'addressLine1'
                  | 'addressLine2'
                  | 'city'
                  | 'state'
                  | 'country'
                  | 'postcode'
                  | 'taxId'
                  | 'taxExempt'
                > & {
                    taxIds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                              metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                            }
                        >
                      >
                    >;
                    taxLabels?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                              taxIdLabels?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'TasstaxIdLabel' } & Pick<
                                      TasstaxIdLabel,
                                      'description' | 'displayName' | 'type'
                                    > & {
                                        metadata?: Maybe<
                                          { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                            TassTaxIdLabelMetadata,
                                            'type'
                                          > & {
                                              labels?: Maybe<
                                                Array<
                                                  Maybe<
                                                    { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                      TassTaxIdLabelMetadataLabel,
                                                      'default' | 'label' | 'vatStatus'
                                                    >
                                                  >
                                                >
                                              >;
                                            }
                                        >;
                                      }
                                  >
                                >
                              >;
                            }
                        >
                      >
                    >;
                  }
              >;
              availablePaymentMethods?: Maybe<
                { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                    nodes?: Maybe<
                      Array<
                        Maybe<
                          | ({ __typename?: 'CreditCard' } & Pick<
                              CreditCard,
                              'id' | 'paymentIssue' | 'type' | 'default'
                            > & {
                                card?: Maybe<
                                  { __typename?: 'CreditCardDetails' } & Pick<
                                    CreditCardDetails,
                                    'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                                  >
                                >;
                              })
                          | ({ __typename?: 'PaymentOnTerms' } & Pick<
                              PaymentOnTerms,
                              'totalCreditLimit' | 'paymentMethod' | 'id' | 'paymentIssue' | 'type' | 'default'
                            > & {
                                terms?: Maybe<
                                  { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                    PaymentOnTermsDetails,
                                    'invoiceDueDays'
                                  >
                                >;
                              })
                        >
                      >
                    >;
                  }
              >;
            }
        >;
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

export type FetchInvoicesForInvoiceGroupPageV2QueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoicesForInvoiceGroupPageV2Query = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        invoices?: Maybe<
          { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Invoice' } & Pick<
                      Invoice,
                      | 'id'
                      | 'status'
                      | 'invoiceNumber'
                      | 'sourceSystem'
                      | 'paymentMethod'
                      | 'paymentMethodId'
                      | 'creditCardMaskedNumber'
                      | 'dueDate'
                      | 'paymentCurrency'
                      | 'purchaseOrderNumber'
                      | 'pdfLink'
                    > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                        refunds?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Refunds' } & Pick<
                                Refunds,
                                | 'id'
                                | 'type'
                                | 'creditNoteNumber'
                                | 'sourceSystem'
                                | 'total'
                                | 'currency'
                                | 'status'
                                | 'arn'
                              >
                            >
                          >
                        >;
                        dunningStatus?: Maybe<
                          Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                        >;
                      }
                  >
                >
              >;
              pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
            }
        >;
      }
  >;
};

export type FetchPaymentMethodsForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaymentMethodsForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        availablePaymentMethods?: Maybe<
          { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<
                        PaymentOnTerms,
                        'id' | 'type' | 'default' | 'paymentIssue'
                      > & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >
                >
              >;
            }
        >;
      }
  >;
};

export type FetchPendingInvoicesForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPendingInvoicesForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'transactionAccountId' | 'pendingInvoices'>
  >;
};

export type FetchProductsIdForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
  fetchEntitlementProductIDs?: Maybe<Scalars['Boolean']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchProductsIdForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        products?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<{ __typename?: 'InvoiceGroupProduct' } & Pick<InvoiceGroupProduct, 'productId' | 'productName'>>
                >
              >;
            }
        >;
      }
  >;
};

export type BlendedComputationDetailsFragment = { __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'blended'> & {
    blendedComputation?: Maybe<
      { __typename?: 'BlendedComputation' } & Pick<
        BlendedComputation,
        | 'newGlp'
        | 'previousGlp'
        | 'upsellPercentage'
        | 'renewPercentage'
        | 'upsellValue'
        | 'renewalValue'
        | 'upsellMargin'
        | 'renewalMargin'
        | 'blendedMargin'
      >
    >;
  };

export type LineItemDetailsForInvoiceFragment = { __typename?: 'InvoiceLineItems' } & Pick<
  InvoiceLineItems,
  | 'id'
  | 'edition'
  | 'entitlementId'
  | 'entitlementNumber'
  | 'cloudSiteHostname'
  | 'amount'
  | 'subtotal'
  | 'description'
  | 'cloudSiteId'
  | 'platform'
  | 'productKey'
  | 'productName'
  | 'startDate'
  | 'invoiceLineItemId'
  | 'endDate'
  | 'promotionIds'
  | 'quantity'
  | 'sen'
  | 'pricingPlanId'
  | 'taxRate'
  | 'taxAmountPaymentCurrency'
  | 'logoId'
> & {
    originalInvoiceReferral?: Maybe<
      { __typename?: 'OriginalInvoiceReferral' } & Pick<OriginalInvoiceReferral, 'invoiceNumber'>
    >;
    promotionItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
              purpose?: Maybe<{ __typename?: 'Purpose' } & Pick<Purpose, 'reasonCode' | 'name' | 'invoiceNote'>>;
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                    >
                  >
                >
              >;
              eligibilityRules?: Maybe<{ __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>>;
            }
        >
      >
    >;
    discounts?: Maybe<
      Array<
        Maybe<
          { __typename?: 'InvoiceDiscounts' } & Pick<
            InvoiceDiscounts,
            'amount' | 'type' | 'percent' | 'reason' | 'reasonCode' | 'promotionId'
          >
        >
      >
    >;
    margins?: Maybe<
      Array<
        Maybe<{ __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'type' | 'amount' | 'percent' | 'promotionId'>>
      >
    >;
    entitlement?: Maybe<
      { __typename?: 'InvoiceEntitlementItem' } & Pick<
        InvoiceEntitlementItem,
        | 'id'
        | 'entitlementNumber'
        | 'baseProduct'
        | 'cloudSiteId'
        | 'cloudSiteUrl'
        | 'platform'
        | 'productId'
        | 'productName'
        | 'parentSen'
        | 'sourceSystem'
        | 'billingCycle'
        | 'billingStatus'
        | 'pricingPlanId'
        | 'offeringId'
      > & { accountId: InvoiceEntitlementItem['orgId']; businessKey: InvoiceEntitlementItem['id'] } & {
          scheduledChanges?: Maybe<
            { __typename?: 'ScheduledChanges' } & {
              chargeQuantities?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'ChargeQuantity' } & Pick<
                      ChargeQuantity,
                      'chargeElement' | 'quantity' | 'lastUpdatedAt'
                    > & {
                        usersUpdate?: Maybe<
                          { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                            ChargeQuantityUsersUpdate,
                            'isAdded' | 'isRemoved' | 'isCreated' | 'changeBy'
                          >
                        >;
                      }
                  >
                >
              >;
            }
          >;
        }
    >;
    essotEntitlement?: Maybe<
      { __typename?: 'InvoiceEssotEntitlementItem' } & {
        relatesFromEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
        relatesToEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
      }
    >;
    orgInfo?: Maybe<{ __typename?: 'OrgDetails' } & Pick<OrgDetails, 'orgId' | 'orgName'>>;
    pricingPlan?: Maybe<
      { __typename?: 'PricingPlan' } & Pick<
        PricingPlan,
        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
      > & {
          tiers?: Maybe<
            Array<
              Maybe<
                { __typename?: 'PricingTiers' } & Pick<PricingTiers, 'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'>
              >
            >
          >;
        }
    >;
    taxItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaxItems' } & Pick<
            TaxItems,
            'id' | 'taxPercent' | 'tax' | 'taxId' | 'taxAmountLabel' | 'taxIdLabel'
          >
        >
      >
    >;
    latestInvoiceDetails?: Maybe<
      { __typename?: 'latestInvoiceDetails' } & Pick<LatestInvoiceDetails, 'id' | 'invoiceNumber'>
    >;
  };

export type ProductAppLineItemsFragment = { __typename?: 'ProductAppLineItem' } & {
  products: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceFragment>>;
  apps: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceFragment>>;
  addOns?: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceFragment>>;
};

export type CoupledLineItemsOnInvoiceFragment = { __typename?: 'ProductAppLineItemData' } & {
  jira: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment;
  confluence: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment;
  statuspage: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment;
  atlassianGuard?: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment;
  other?: Maybe<{ __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment>;
};

export type FetchtxaBalanceDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchtxaBalanceDetailsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber'
  > & {
      transactionAccountBalanceEntity?: Maybe<
        Array<
          Maybe<
            { __typename?: 'txaCustomerBalanceDetails' } & Pick<
              TxaCustomerBalanceDetails,
              'invoiceNumber' | 'endingAmount'
            >
          >
        >
      >;
    };
};

export type FetchInvoiceQueryV2QueryVariables = Exact<{
  id: Scalars['ID'];
  transactionAccountId?: Maybe<Scalars['String']>;
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInvoiceQueryV2Query = { __typename?: 'Query' } & {
  invoice: { __typename?: 'Invoice' } & Pick<
    Invoice,
    | 'id'
    | 'invoiceNumber'
    | 'sourceId'
    | 'selfServeBACInvoiceLink'
    | 'domain'
    | 'status'
    | 'createdTimestamp'
    | 'billingGroupId'
    | 'paymentMethodId'
    | 'sourceSystem'
    | 'upgradeCredits'
    | 'totalDiscount'
    | 'totalPartnerMargin'
    | 'memo'
    | 'total'
    | 'taxes'
    | 'subtotal'
    | 'taxesPaymentCurrency'
    | 'transactionAccountId'
    | 'itemsTotal'
    | 'partnerAccountId'
    | 'partnerName'
    | 'paypalAccountEmail'
    | 'paymentCurrency'
    | 'paymentMethod'
    | 'promotionCode'
    | 'invoiceDueDays'
    | 'dueDate'
    | 'purchaseOrderNumber'
    | 'pdfLink'
    | 'appliedBalance'
  > & {
      creditCard?: Maybe<
        { __typename?: 'CreditCardDetails' } & Pick<
          CreditCardDetails,
          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
        >
      >;
      dunningStatus?: Maybe<
        Array<
          Maybe<
            { __typename?: 'DunningStatus' } & Pick<
              DunningStatus,
              'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
            >
          >
        >
      >;
      billTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      shipTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'id' | 'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & Pick<InvoiceLineItems, 'orderLineId'> &
              LineItemDetailsForInvoiceFragment
          >
        >
      >;
      coupledLineItems?: Maybe<{ __typename?: 'ProductAppLineItemData' } & CoupledLineItemsOnInvoiceFragment>;
      dstLineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & {
              metadata?: Maybe<{ __typename?: 'LineItemMetaData' } & Pick<LineItemMetaData, 'parentItemId' | 'type'>>;
            } & LineItemDetailsForInvoiceFragment
          >
        >
      >;
      refunds?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Refunds' } & Pick<
              Refunds,
              | 'id'
              | 'creditNoteNumber'
              | 'currency'
              | 'createdDate'
              | 'transactionAccountId'
              | 'sourceSystem'
              | 'memo'
              | 'reason'
              | 'refundId'
              | 'status'
              | 'type'
              | 'total'
              | 'arn'
              | 'requestedBy'
            > & {
                refundItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RefundItems' } & Pick<
                        RefundItems,
                        | 'id'
                        | 'invoiceLineItemId'
                        | 'entitlementId'
                        | 'quantity'
                        | 'description'
                        | 'total'
                        | 'totalExTax'
                        | 'totalTax'
                        | 'taxRate'
                        | 'taxableAmount'
                        | 'taxExemptAmount'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      slaCredits?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SlaCreditApplications' } & Pick<
              SlaCreditApplications,
              | 'amountExTax'
              | 'amountIncTax'
              | 'createdAt'
              | 'creditExternalId'
              | 'currency'
              | 'currencyExchangeRate'
              | 'modifiedAt'
              | 'notes'
              | 'taxAmount'
              | 'taxRate'
            >
          >
        >
      >;
    };
};

export type LineItemForRefundFragment = { __typename?: 'RefundItems' } & Pick<
  RefundItems,
  | 'id'
  | 'invoiceLineItemId'
  | 'entitlementNumber'
  | 'entitlementId'
  | 'quantity'
  | 'description'
  | 'total'
  | 'totalExTax'
  | 'totalTax'
  | 'taxRate'
  | 'taxableAmount'
  | 'taxExemptAmount'
  | 'platform'
  | 'productId'
  | 'edition'
  | 'productName'
  | 'billingCycle'
  | 'pricingPlanId'
  | 'editionWhileRefund'
  | 'refundToCustomerBalance'
  | 'logoId'
  | 'isAddOn'
> & {
    adjustments?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Adjustments' } & Pick<Adjustments, 'amount' | 'reason' | 'type' | 'percent' | 'promotionId'>
        >
      >
    >;
    adjustmentDetails?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Adjustments' } & Pick<Adjustments, 'amount' | 'reason' | 'type' | 'percent' | 'promotionId'>
        >
      >
    >;
    pricingPlan?: Maybe<
      { __typename?: 'PricingPlan' } & Pick<
        PricingPlan,
        'status' | 'pricingPlanType' | 'type' | 'billingFrequency' | 'id' | 'currency' | 'description'
      > & {
          tiers?: Maybe<
            Array<
              Maybe<
                { __typename?: 'PricingTiers' } & Pick<PricingTiers, 'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'>
              >
            >
          >;
        }
    >;
    taxItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaxItems' } & Pick<
            TaxItems,
            'id' | 'taxPercent' | 'tax' | 'taxId' | 'taxAmountLabel' | 'taxIdLabel'
          >
        >
      >
    >;
    margins?: Maybe<
      Array<Maybe<{ __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'amount' | 'percent' | 'type'>>>
    >;
    promotions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'type' | 'status'> & {
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                    >
                  >
                >
              >;
            }
        >
      >
    >;
  };

export type ProductAppRefundItemFragment = { __typename?: 'ProductAppRefundItem' } & {
  products: Array<Maybe<{ __typename?: 'RefundItems' } & LineItemForRefundFragment>>;
  apps: Array<Maybe<{ __typename?: 'RefundItems' } & LineItemForRefundFragment>>;
  addOns?: Array<Maybe<{ __typename?: 'RefundItems' } & LineItemForRefundFragment>>;
};

export type CoupledRefundItemsForRefundFragment = { __typename?: 'ProductAppRefundItemData' } & {
  jira: { __typename?: 'ProductAppRefundItem' } & ProductAppRefundItemFragment;
  confluence: { __typename?: 'ProductAppRefundItem' } & ProductAppRefundItemFragment;
  statuspage: { __typename?: 'ProductAppRefundItem' } & ProductAppRefundItemFragment;
  atlassianGuard?: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsFragment;
  other?: Maybe<{ __typename?: 'ProductAppRefundItem' } & ProductAppRefundItemFragment>;
};

export type BillAndShipToFragment = { __typename?: 'InvoiceBillAndShipTo' } & Pick<
  InvoiceBillAndShipTo,
  'fullName' | 'organization' | 'email' | 'taxId'
> & {
    address?: Maybe<
      { __typename?: 'InvoiceAddress' } & Pick<
        InvoiceAddress,
        'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
      >
    >;
    taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
    taxLabels?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
              taxIdLabels?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TasstaxIdLabel' } & Pick<TasstaxIdLabel, 'description' | 'displayName' | 'type'>
                  >
                >
              >;
            }
        >
      >
    >;
  };

export type PartnerRefundFragment = { __typename?: 'Refunds' } & Pick<
  Refunds,
  | 'id'
  | 'arn'
  | 'creditNoteNumber'
  | 'transactionAccountId'
  | 'sourceSystem'
  | 'sourceSystemId'
  | 'memo'
  | 'reason'
  | 'refundId'
  | 'chargeId'
  | 'rechargeInvoiceId'
  | 'status'
  | 'type'
  | 'createdDate'
  | 'orderId'
  | 'currency'
  | 'total'
  | 'totalExTax'
  | 'totalTax'
  | 'purchaseOrderNumber'
  | 'creditNoteId'
> & {
    refundItems?: Maybe<Array<Maybe<{ __typename?: 'RefundItems' } & LineItemForRefundFragment>>>;
    dstRefundItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'RefundItems' } & {
            metadata?: Maybe<{ __typename?: 'LineItemMetaData' } & Pick<LineItemMetaData, 'type' | 'parentItemId'>>;
          } & LineItemForRefundFragment
        >
      >
    >;
    coupledRefundItems?: Maybe<{ __typename?: 'ProductAppRefundItemData' } & CoupledRefundItemsForRefundFragment>;
    billTo?: Maybe<{ __typename?: 'InvoiceBillAndShipTo' } & BillAndShipToFragment>;
    shipTo?: Maybe<{ __typename?: 'InvoiceBillAndShipTo' } & BillAndShipToFragment>;
  };

export type FetchRefundDetailQueryv2QueryVariables = Exact<{
  id: Scalars['ID'];
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
}>;

export type FetchRefundDetailQueryv2Query = { __typename?: 'Query' } & {
  refund?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Refunds' } & Pick<
          Refunds,
          'creationNotes' | 'isPartner' | 'creditCardLastFourDigits' | 'paymentMethod'
        > &
          PartnerRefundFragment
      >
    >
  >;
};

export type FetchPartnerRefundDetailQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  transactionAccountId: Scalars['String'];
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
  fetchPricingPlan?: Maybe<Scalars['Boolean']>;
}>;

export type FetchPartnerRefundDetailQueryQuery = { __typename?: 'Query' } & {
  refund?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Refunds' } & Pick<Refunds, 'isPartner' | 'creditCardLastFourDigits' | 'paymentMethod'> &
          PartnerRefundFragment
      >
    >
  >;
};

export type FetchBillingAdminsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchBillingAdminsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'BillingAdminEdge' } & {
                    node: { __typename?: 'BillingAdmin' } & Pick<
                      BillingAdmin,
                      'email' | 'atlassianAccountId' | 'fullName'
                    >;
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchBillingProfilesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchBillingProfilesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<
                  InvoiceGroup,
                  | 'id'
                  | 'name'
                  | 'currency'
                  | 'transactionAccountId'
                  | 'pendingInvoices'
                  | 'shipToPriceEligibility'
                  | 'createdAt'
                > & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'country'
                        | 'state'
                        | 'phone'
                        | 'postcode'
                        | 'taxId'
                      > & {
                          taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                          taxLabels?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                    taxIdLabels?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'TasstaxIdLabel' } & Pick<
                                            TasstaxIdLabel,
                                            'description' | 'displayName' | 'type'
                                          >
                                        >
                                      >
                                    >;
                                  }
                              >
                            >
                          >;
                        }
                    >;
                    availablePaymentMethods?: Maybe<
                      { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                          nodes?: Maybe<
                            Array<
                              Maybe<
                                | ({ __typename?: 'CreditCard' } & Pick<
                                    CreditCard,
                                    'id' | 'paymentIssue' | 'type' | 'default'
                                  > & {
                                      card?: Maybe<
                                        { __typename?: 'CreditCardDetails' } & Pick<
                                          CreditCardDetails,
                                          | 'expirationMonth'
                                          | 'expirationYear'
                                          | 'last4Numbers'
                                          | 'brand'
                                          | 'cardHolderName'
                                        >
                                      >;
                                    })
                                | ({ __typename?: 'PaymentOnTerms' } & Pick<
                                    PaymentOnTerms,
                                    'id' | 'paymentIssue' | 'type' | 'default'
                                  > & {
                                      terms?: Maybe<
                                        { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                          PaymentOnTermsDetails,
                                          'invoiceDueDays'
                                        >
                                      >;
                                    })
                              >
                            >
                          >;
                        }
                    >;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & Pick<
                          CreditCard,
                          'id' | 'type' | 'paymentIssue' | 'default'
                        > & {
                            card?: Maybe<
                              { __typename?: 'CreditCardDetails' } & Pick<
                                CreditCardDetails,
                                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                              >
                            >;
                          })
                      | ({ __typename?: 'PaymentOnTerms' } & Pick<
                          PaymentOnTerms,
                          'id' | 'type' | 'paymentIssue' | 'default'
                        > & {
                            terms?: Maybe<
                              { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                            >;
                          })
                    >;
                    purchaseOrder?: Maybe<
                      { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                        InvoiceGroupPurchaseOrder,
                        'number' | 'oneTimeUse'
                      >
                    >;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type BillingProfileDetailsforFetchBillingProfilesForQuotesInPpcFragment = {
  __typename?: 'InvoiceGroupConnection';
} & Pick<InvoiceGroupConnection, 'totalCount'> & {
    nodes: Array<
      Maybe<
        { __typename?: 'InvoiceGroup' } & Pick<
          InvoiceGroup,
          | 'id'
          | 'name'
          | 'currency'
          | 'transactionAccountId'
          | 'isActive'
          | 'pendingInvoices'
          | 'shipToPriceEligibility'
          | 'createdAt'
        > & {
            shipToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                | 'id'
                | 'name'
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'country'
                | 'state'
                | 'phone'
                | 'postcode'
                | 'taxId'
              > & {
                  taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    payPal?: Maybe<
                      { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'name' | 'email'>
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<
                  PaymentOnTerms,
                  'id' | 'type' | 'paymentIssue' | 'default'
                > & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<
                        PaymentOnTermsDetails,
                        'invoiceDueDays' | 'payOnStatement'
                      >
                    >;
                  })
            >;
            purchaseOrder?: Maybe<
              { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
            >;
          }
      >
    >;
    pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
  };

export type FetchBillingProfilesForQuotesInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  isFetchBillingProfilesViaCCPEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchBillingProfilesForQuotesInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & BillingProfileDetailsforFetchBillingProfilesForQuotesInPpcFragment
      >;
      billingProfilesFromCCP?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & BillingProfileDetailsforFetchBillingProfilesForQuotesInPpcFragment
      >;
    };
};

export type FetchInvoiceGroupsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInvoiceGroupsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name' | 'currency'> & {
                    purchaseOrder?: Maybe<
                      { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                        InvoiceGroupPurchaseOrder,
                        'number' | 'oneTimeUse'
                      >
                    >;
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'name'
                        | 'id'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'state'
                        | 'country'
                        | 'postcode'
                        | 'taxId'
                      > & { taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>> }
                    >;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & Pick<
                          CreditCard,
                          'id' | 'type' | 'paymentIssue' | 'default'
                        > & {
                            card?: Maybe<
                              { __typename?: 'CreditCardDetails' } & Pick<
                                CreditCardDetails,
                                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                              >
                            >;
                          })
                      | ({ __typename?: 'PaymentOnTerms' } & Pick<
                          PaymentOnTerms,
                          'id' | 'type' | 'paymentIssue' | 'default'
                        > & {
                            terms?: Maybe<
                              { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                            >;
                          })
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type FetchInvoicesForPaymentMethodQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoicesForPaymentMethodQuery = { __typename?: 'Query' } & {
  invoiceGroupsForPaymentMethod?: Maybe<
    { __typename?: 'InvoiceGroupsForPaymentMethod' } & Pick<
      InvoiceGroupsForPaymentMethod,
      'id' | 'paymentMethodBillingGroupIds'
    > & {
        invoices?: Maybe<
          { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Invoice' } & Pick<
                      Invoice,
                      | 'id'
                      | 'status'
                      | 'invoiceNumber'
                      | 'sourceSystem'
                      | 'paymentMethod'
                      | 'creditCardMaskedNumber'
                      | 'dueDate'
                      | 'paymentCurrency'
                      | 'purchaseOrderNumber'
                      | 'pdfLink'
                    > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                        refunds?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Refunds' } & Pick<
                                Refunds,
                                | 'id'
                                | 'type'
                                | 'creditNoteNumber'
                                | 'sourceSystem'
                                | 'total'
                                | 'currency'
                                | 'status'
                                | 'arn'
                              >
                            >
                          >
                        >;
                        dunningStatus?: Maybe<
                          Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                        >;
                        shipTo?: Maybe<
                          { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'fullName'> & {
                              address?: Maybe<
                                { __typename?: 'InvoiceAddress' } & Pick<
                                  InvoiceAddress,
                                  'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                                >
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
              pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
            }
        >;
      }
  >;
};

export type FetchInvoicesForShipToPartyQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoicesForShipToPartyQuery = { __typename?: 'Query' } & {
  invoiceGroupsForShipToPartyId?: Maybe<
    { __typename?: 'InvoiceGroupsForShipToPartyId' } & Pick<
      InvoiceGroupsForShipToPartyId,
      'id' | 'shipToPartyBillingGroupIds'
    > & {
        invoices?: Maybe<
          { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Invoice' } & Pick<
                      Invoice,
                      | 'id'
                      | 'status'
                      | 'invoiceNumber'
                      | 'sourceSystem'
                      | 'paymentMethod'
                      | 'paymentMethodId'
                      | 'creditCardMaskedNumber'
                      | 'dueDate'
                      | 'paymentCurrency'
                      | 'purchaseOrderNumber'
                      | 'pdfLink'
                    > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                        refunds?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Refunds' } & Pick<
                                Refunds,
                                | 'id'
                                | 'type'
                                | 'creditNoteNumber'
                                | 'sourceSystem'
                                | 'total'
                                | 'currency'
                                | 'status'
                                | 'arn'
                              >
                            >
                          >
                        >;
                        dunningStatus?: Maybe<
                          Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                        >;
                      }
                  >
                >
              >;
              pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
            }
        >;
      }
  >;
};

export type FetchInvoicesForTransactionAccountV2QueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
  includeItems?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInvoicesForTransactionAccountV2Query = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      hamsInvoices?: Maybe<
        { __typename?: 'HamsInvoice' } & Pick<HamsInvoice, 'lastEvaluatedKey'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'sourceSystem'
                    | 'invoiceNumber'
                    | 'invoiceDueDays'
                    | 'billingGroupId'
                    | 'domain'
                    | 'paidDate'
                    | 'transactionAccountId'
                    | 'dueDate'
                    | 'total'
                    | 'paymentCurrency'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'createdTimestamp'
                    | 'status'
                    | 'pdfLink'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      creditCard?: Maybe<
                        { __typename?: 'CreditCardDetails' } & Pick<
                          CreditCardDetails,
                          'cardHolderName' | 'last4Numbers' | 'expirationYear' | 'expirationMonth'
                        >
                      >;
                      billTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                          InvoiceBillAndShipTo,
                          'fullName' | 'domain' | 'organization'
                        > & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                          InvoiceBillAndShipTo,
                          'fullName' | 'email' | 'domain' | 'organization'
                        > & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
          }
      >;
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'paymentCurrency'
                    | 'pdfLink'
                    | 'transactionAccountId'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                      lineItems?: Maybe<
                        Array<Maybe<{ __typename?: 'InvoiceLineItems' } & Pick<InvoiceLineItems, 'orderLineId'>>>
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchPendingInvoicesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPendingInvoicesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id' | 'pendingInvoices'>;
};

export type FetchShipToPartiesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchShipToPartiesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & Pick<CommerceAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CommerceAddress' } & Pick<
                    CommerceAddress,
                    | 'name'
                    | 'id'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'city'
                    | 'state'
                    | 'country'
                    | 'postcode'
                    | 'taxId'
                    | 'shipToPriceEligibility'
                    | 'taxExempt'
                    | 'hasLinkedSubscriptions'
                  > & {
                      taxIds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                                metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                              }
                          >
                        >
                      >;
                      taxLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                taxIdLabels?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TasstaxIdLabel' } & Pick<
                                        TasstaxIdLabel,
                                        'description' | 'displayName' | 'type'
                                      > & {
                                          metadata?: Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                              TassTaxIdLabelMetadata,
                                              'type'
                                            > & {
                                                labels?: Maybe<
                                                  Array<
                                                    Maybe<
                                                      { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                        TassTaxIdLabelMetadataLabel,
                                                        'default' | 'label' | 'vatStatus'
                                                      >
                                                    >
                                                  >
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchSubscriptionsForPaymentMethodQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSubscriptionsForPaymentMethodQuery = { __typename?: 'Query' } & {
  invoiceGroupsForPaymentMethod?: Maybe<
    { __typename?: 'InvoiceGroupsForPaymentMethod' } & Pick<
      InvoiceGroupsForPaymentMethod,
      'id' | 'paymentMethodBillingGroupIds'
    > & {
        productSubscriptions?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'InvoiceGroupProduct' } & Pick<
                      InvoiceGroupProduct,
                      | 'billingGroupId'
                      | 'billingFrequency'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'id'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                      | 'edition'
                      | 'cloudSiteHostname'
                      | 'billedUsers'
                      | 'trial'
                      | 'isSandbox'
                      | 'isApp'
                    >
                  >
                >
              >;
            }
        >;
      }
  >;
};

export type FetchSubscriptionsForShipToPartyQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSubscriptionsForShipToPartyQuery = { __typename?: 'Query' } & {
  invoiceGroupsForShipToPartyId?: Maybe<
    { __typename?: 'InvoiceGroupsForShipToPartyId' } & Pick<
      InvoiceGroupsForShipToPartyId,
      'id' | 'shipToPartyBillingGroupIds'
    > & {
        productSubscriptions?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'InvoiceGroupProduct' } & Pick<
                      InvoiceGroupProduct,
                      | 'billingFrequency'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'id'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                      | 'edition'
                      | 'cloudSiteHostname'
                      | 'billedUsers'
                      | 'trial'
                      | 'isSandbox'
                      | 'isApp'
                    >
                  >
                >
              >;
            }
        >;
      }
  >;
};

export type FetchOrdersByTransactionAccountIdQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchOrdersByTransactionAccountIdQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'id' | 'email'>>>>;
        }
      >;
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<
                  Order,
                  'id' | 'orderNumber' | 'billingContactEmail' | 'created' | 'contextSubject' | 'contextSubjectId'
                > & {
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    metadataObj?: Maybe<
                      { __typename?: 'OrderMetadataObj' } & Pick<
                        OrderMetadataObj,
                        | 'supportTicketNumber'
                        | 'handNote'
                        | 'termsOfTransfer'
                        | 'reasonCode'
                        | 'newBillingAdmin'
                        | 'currentBillingAdmin'
                      >
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'quantity'
                              | 'type'
                              | 'skipTrial'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                              | 'edition'
                              | 'entitlementId'
                              | 'entitlementNumber'
                              | 'parentEntitlementId'
                              | 'productName'
                              | 'productId'
                            > & {
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        'id' | 'title' | 'status' | 'type' | 'promotionCode'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'>
                                >;
                                orderLineItemsPurchaseMetadata?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                        OrderLineItemsPurchaseMetadataType,
                                        'fieldName' | 'fieldValue'
                                      >
                                    >
                                  >
                                >;
                                orderLineItemsAccountModification?: Maybe<
                                  { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                    OrderLineItemsAccountModification,
                                    'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type FetchBillingProfilesByPaymentMethodIdQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchBillingProfilesByPaymentMethodIdQuery = { __typename?: 'Query' } & {
  billingProfilesByPaymentMethodId?: Maybe<
    { __typename?: 'BillingProfiles' } & Pick<BillingProfiles, 'totalCount'> & {
        billingProfiles?: Maybe<
          Array<
            Maybe<
              { __typename?: 'BillingProfile' } & Pick<
                BillingProfile,
                'id' | 'name' | 'numberOfSubscriptions' | 'numberOfCloudsites' | 'isActive'
              > & {
                  shipTo?: Maybe<
                    { __typename?: 'ShipTo' } & Pick<
                      ShipTo,
                      'address1' | 'city' | 'country' | 'state' | 'postalCode' | 'name'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchTxaPartnerAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTxaPartnerAccountQuery = { __typename?: 'Query' } & {
  txaPartnerAccount?: Maybe<
    { __typename?: 'TXAPartnerAccount' } & Pick<
      TxaPartnerAccount,
      | 'programLevelGlobal'
      | 'type'
      | 'territory'
      | 'sourceSystem'
      | 'sourceId'
      | 'verifiedExpertise'
      | 'payOnAccount'
      | 'specializations'
    > & {
        domains?: Maybe<
          { __typename?: 'TXAPartnerAccountDomains' } & Pick<TxaPartnerAccountDomains, 'main' | 'alternates'>
        >;
      }
  >;
};

export type FetchPaymentMethodsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaymentMethodsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue'>)
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue'>)
                  >;
                }
            >
          >;
        }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'paymentIssue' | 'type' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      customerBalances?: Maybe<{ __typename?: 'CustomerBalancesRecord' } & Pick<CustomerBalancesRecord, 'usd'>>;
    };
};

export type FetchTransactionAccountV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountV2Query = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    | 'id'
    | 'partnerAccountId'
    | 'transactionAccountNumber'
    | 'billToPartyPricingEligibilty'
    | 'displayName'
    | 'isPartner'
    | 'status'
    | 'updatePaymentMethodLink'
    | 'creditRequestAppLink'
  > & {
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TermDetailsAccount' } & Pick<
                    TermDetailsAccount,
                    'status' | 'transactionAccountNumber'
                  >
                >
              >
            >;
          }
      >;
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          | 'id'
          | 'name'
          | 'addressLine1'
          | 'addressLine2'
          | 'city'
          | 'state'
          | 'country'
          | 'postcode'
          | 'taxId'
          | 'taxExempt'
        > & {
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            > & {
                                metadata?: Maybe<
                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                      labels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                              TassTaxIdLabelMetadataLabel,
                                              'default' | 'label' | 'vatStatus'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      productSubscriptions?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TransactionAccountProduct' } & Pick<
                  TransactionAccountProduct,
                  | 'billingFrequency'
                  | 'billingStatus'
                  | 'entitlementNumber'
                  | 'pricingPlanId'
                  | 'transactionAccountNumber'
                  | 'latestPeriodEndDate'
                  | 'latestPeriodStartDate'
                  | 'productName'
                  | 'productId'
                  | 'edition'
                  | 'offeringId'
                  | 'cloudSiteHostname'
                  | 'billingGroupId'
                  | 'provisioningStatus'
                  | 'id'
                  | 'billedUsers'
                  | 'trial'
                  | 'isSandbox'
                  | 'isApp'
                  | 'trialEndDate'
                > & {
                    pricingPlan?: Maybe<
                      { __typename?: 'PricingPlan' } & Pick<
                        PricingPlan,
                        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
                      > & {
                          tiers?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'PricingTiers' } & Pick<
                                  PricingTiers,
                                  'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                                >
                              >
                            >
                          >;
                        }
                    >;
                  }
              >
            >
          >;
        }
      >;
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  | 'id'
                  | 'name'
                  | 'addressLine1'
                  | 'addressLine2'
                  | 'city'
                  | 'state'
                  | 'country'
                  | 'postcode'
                  | 'taxId'
                  | 'taxExempt'
                >
              >
            >
          >;
        }
      >;
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'BillingAdmin' } & Pick<
                    BillingAdmin,
                    'email' | 'atlassianAccountId' | 'fullName' | 'isEmailVerified'
                  >
                >
              >
            >;
          }
      >;
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<
                  InvoiceGroup,
                  'id' | 'name' | 'currency' | 'shipToPriceEligibility'
                > & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'state'
                        | 'country'
                        | 'postcode'
                        | 'taxId'
                      >
                    >;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue'> & {
                            card?: Maybe<
                              { __typename?: 'CreditCardDetails' } & Pick<
                                CreditCardDetails,
                                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                              >
                            >;
                          })
                      | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue'> & {
                            terms?: Maybe<
                              { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                            >;
                          })
                    >;
                  }
              >
            >;
          }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'paymentMethod' | 'id' | 'type' | 'default' | 'paymentIssue'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type FetchPaymentMethodUpdateLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaymentMethodUpdateLinkQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  >;
};

export type FetchInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<
      InvoiceGroup,
      | 'id'
      | 'name'
      | 'currency'
      | 'updatePaymentMethodLink'
      | 'transactionAccountId'
      | 'transactionAccountNumber'
      | 'recipients'
    > & {
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            | 'id'
            | 'name'
            | 'addressLine1'
            | 'addressLine2'
            | 'city'
            | 'state'
            | 'country'
            | 'postcode'
            | 'taxId'
            | 'shipToPriceEligibility'
            | 'taxExempt'
          > & {
              taxIds?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                        metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                      }
                  >
                >
              >;
              taxLabels?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                        taxIdLabels?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'TasstaxIdLabel' } & Pick<
                                TasstaxIdLabel,
                                'description' | 'displayName' | 'type'
                              > & {
                                  metadata?: Maybe<
                                    { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                        labels?: Maybe<
                                          Array<
                                            Maybe<
                                              { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                TassTaxIdLabelMetadataLabel,
                                                'default' | 'label' | 'vatStatus'
                                              >
                                            >
                                          >
                                        >;
                                      }
                                  >;
                                }
                            >
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                card?: Maybe<
                  { __typename?: 'CreditCardDetails' } & Pick<
                    CreditCardDetails,
                    'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                  >
                >;
              })
          | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'default' | 'paymentIssue'>)
        >;
        transactionAccount?: Maybe<
          { __typename?: 'TransactionAccount' } & Pick<
            TransactionAccount,
            'id' | 'displayName' | 'updatePaymentMethodLink'
          > & {
              availablePaymentMethods?: Maybe<
                { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                    nodes?: Maybe<
                      Array<
                        Maybe<
                          | ({ __typename?: 'CreditCard' } & Pick<
                              CreditCard,
                              'id' | 'paymentIssue' | 'type' | 'default'
                            > & {
                                card?: Maybe<
                                  { __typename?: 'CreditCardDetails' } & Pick<
                                    CreditCardDetails,
                                    'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                                  >
                                >;
                              })
                          | ({ __typename?: 'PaymentOnTerms' } & Pick<
                              PaymentOnTerms,
                              'id' | 'paymentIssue' | 'type' | 'default'
                            > & {
                                terms?: Maybe<
                                  { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                    PaymentOnTermsDetails,
                                    'invoiceDueDays'
                                  >
                                >;
                              })
                        >
                      >
                    >;
                  }
              >;
            }
        >;
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

export type FetchInvoicesForInvoiceGroupPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchInvoicesForInvoiceGroupPageQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        invoices?: Maybe<
          { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Invoice' } & Pick<
                      Invoice,
                      | 'status'
                      | 'invoiceNumber'
                      | 'sourceSystem'
                      | 'paymentMethod'
                      | 'creditCardMaskedNumber'
                      | 'dueDate'
                      | 'paymentCurrency'
                      | 'purchaseOrderNumber'
                    > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                        refunds?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Refunds' } & Pick<
                                Refunds,
                                | 'id'
                                | 'type'
                                | 'creditNoteNumber'
                                | 'sourceSystem'
                                | 'total'
                                | 'currency'
                                | 'status'
                                | 'arn'
                              >
                            >
                          >
                        >;
                        dunningStatus?: Maybe<
                          Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                        >;
                      }
                  >
                >
              >;
              pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
            }
        >;
      }
  >;
};

export type FetchInvoiceQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInvoiceQueryQuery = { __typename?: 'Query' } & {
  invoice: { __typename?: 'Invoice' } & Pick<
    Invoice,
    | 'id'
    | 'invoiceNumber'
    | 'sourceId'
    | 'domain'
    | 'status'
    | 'createdTimestamp'
    | 'billingGroupId'
    | 'sourceSystem'
    | 'upgradeCredits'
    | 'totalDiscount'
    | 'memo'
    | 'total'
    | 'taxes'
    | 'subtotal'
    | 'taxesPaymentCurrency'
    | 'transactionAccountId'
    | 'itemsTotal'
    | 'partnerAccountId'
    | 'partnerName'
    | 'paypalAccountEmail'
    | 'paymentCurrency'
    | 'paymentMethod'
    | 'promotionCode'
    | 'invoiceDueDays'
    | 'dueDate'
    | 'purchaseOrderNumber'
    | 'pdfLink'
    | 'appliedBalance'
  > & {
      creditCard?: Maybe<
        { __typename?: 'CreditCardDetails' } & Pick<
          CreditCardDetails,
          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
        >
      >;
      dunningStatus?: Maybe<
        Array<
          Maybe<
            { __typename?: 'DunningStatus' } & Pick<
              DunningStatus,
              'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
            >
          >
        >
      >;
      billTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
          }
      >;
      shipTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
          }
      >;
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & Pick<
              InvoiceLineItems,
              | 'id'
              | 'edition'
              | 'entitlementId'
              | 'unitCount'
              | 'entitlementNumber'
              | 'cloudSiteHostname'
              | 'amount'
              | 'subtotal'
              | 'description'
              | 'cloudSiteId'
              | 'platform'
              | 'productKey'
              | 'startDate'
              | 'invoiceLineItemId'
              | 'endDate'
              | 'promotionIds'
              | 'quantity'
              | 'sen'
            > & {
                promotionItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                          applicationReason?: Maybe<
                            { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                                customisable?: Maybe<
                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                    id?: Maybe<
                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                        PromotionReasonListObj,
                                        'type'
                                      > & {
                                          anyOf?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                  ReasonCustomisableObj,
                                                  'readableName' | 'id'
                                                >
                                              >
                                            >
                                          >;
                                        }
                                    >;
                                  }
                                >;
                              }
                          >;
                          purpose?: Maybe<
                            { __typename?: 'Purpose' } & Pick<Purpose, 'reasonCode' | 'name' | 'invoiceNote'>
                          >;
                          benefits?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'Benefit' } & Pick<
                                  Benefit,
                                  'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                                >
                              >
                            >
                          >;
                        }
                    >
                  >
                >;
                discounts?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'InvoiceDiscounts' } & Pick<
                        InvoiceDiscounts,
                        'amount' | 'type' | 'percent' | 'reason' | 'reasonCode'
                      >
                    >
                  >
                >;
                entitlement?: Maybe<
                  { __typename?: 'InvoiceEntitlementItem' } & Pick<
                    InvoiceEntitlementItem,
                    | 'id'
                    | 'entitlementNumber'
                    | 'baseProduct'
                    | 'cloudSiteId'
                    | 'cloudSiteUrl'
                    | 'platform'
                    | 'productId'
                    | 'productName'
                    | 'parentSen'
                    | 'sourceSystem'
                    | 'billingCycle'
                    | 'billingStatus'
                  > & { accountId: InvoiceEntitlementItem['orgId']; businessKey: InvoiceEntitlementItem['id'] }
                >;
              }
          >
        >
      >;
      refunds?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Refunds' } & Pick<
              Refunds,
              | 'id'
              | 'creditNoteNumber'
              | 'currency'
              | 'createdDate'
              | 'transactionAccountId'
              | 'sourceSystem'
              | 'memo'
              | 'reason'
              | 'refundId'
              | 'status'
              | 'type'
              | 'total'
              | 'arn'
              | 'requestedBy'
            > & {
                refundItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RefundItems' } & Pick<
                        RefundItems,
                        | 'id'
                        | 'invoiceLineItemId'
                        | 'entitlementId'
                        | 'quantity'
                        | 'description'
                        | 'total'
                        | 'totalExTax'
                        | 'totalTax'
                        | 'taxRate'
                        | 'taxableAmount'
                        | 'taxExemptAmount'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      slaCredits?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SlaCreditApplications' } & Pick<
              SlaCreditApplications,
              | 'amountExTax'
              | 'amountIncTax'
              | 'createdAt'
              | 'creditExternalId'
              | 'currency'
              | 'currencyExchangeRate'
              | 'modifiedAt'
              | 'notes'
              | 'taxAmount'
              | 'taxRate'
            >
          >
        >
      >;
    };
};

export type FetchRefundDetailQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchRefundDetailQueryQuery = { __typename?: 'Query' } & {
  refund?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Refunds' } & Pick<
          Refunds,
          | 'id'
          | 'arn'
          | 'creditNoteNumber'
          | 'transactionAccountId'
          | 'sourceSystem'
          | 'sourceSystemId'
          | 'memo'
          | 'reason'
          | 'reasonCode'
          | 'refundId'
          | 'chargeId'
          | 'rechargeInvoiceId'
          | 'status'
          | 'type'
          | 'createdDate'
          | 'refundedDate'
          | 'orderId'
          | 'creationNotes'
          | 'currency'
          | 'total'
          | 'totalExTax'
          | 'totalTax'
          | 'purchaseOrderNumber'
          | 'creditNoteId'
        > & {
            refundItems?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'RefundItems' } & Pick<
                    RefundItems,
                    | 'id'
                    | 'invoiceLineItemId'
                    | 'entitlementNumber'
                    | 'entitlementId'
                    | 'quantity'
                    | 'description'
                    | 'total'
                    | 'totalExTax'
                    | 'totalTax'
                    | 'taxRate'
                    | 'taxableAmount'
                    | 'taxExemptAmount'
                    | 'platform'
                    | 'productId'
                    | 'edition'
                  > & {
                      adjustments?: Maybe<
                        Array<Maybe<{ __typename?: 'Adjustments' } & Pick<Adjustments, 'amount' | 'reason' | 'type'>>>
                      >;
                    }
                >
              >
            >;
            billTo?: Maybe<
              { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                InvoiceBillAndShipTo,
                'fullName' | 'organization' | 'email' | 'taxId'
              > & {
                  address?: Maybe<
                    { __typename?: 'InvoiceAddress' } & Pick<
                      InvoiceAddress,
                      'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                    >
                  >;
                }
            >;
            shipTo?: Maybe<
              { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                InvoiceBillAndShipTo,
                'fullName' | 'organization' | 'email' | 'taxId'
              > & {
                  address?: Maybe<
                    { __typename?: 'InvoiceAddress' } & Pick<
                      InvoiceAddress,
                      'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                    >
                  >;
                }
            >;
          }
      >
    >
  >;
};

export type FetchInvoicesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchInvoicesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'paymentCurrency'
                    | 'pdfLink'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & {
                          address?: Maybe<
                            { __typename?: 'InvoiceAddress' } & Pick<
                              InvoiceAddress,
                              'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                            >
                          >;
                        }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    | 'id'
    | 'transactionAccountNumber'
    | 'billToPartyPricingEligibilty'
    | 'displayName'
    | 'isPartner'
    | 'status'
    | 'updatePaymentMethodLink'
  > & {
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
        >
      >;
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<{ __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'email' | 'atlassianAccountId' | 'fullName'>>
              >
            >;
          }
      >;
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'state'
                        | 'country'
                        | 'postcode'
                        | 'taxId'
                      > & { taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>> }
                    >;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                            card?: Maybe<
                              { __typename?: 'CreditCardDetails' } & Pick<
                                CreditCardDetails,
                                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                              >
                            >;
                          })
                      | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                            terms?: Maybe<
                              { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                            >;
                          })
                    >;
                  }
              >
            >;
          }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'type' | 'default' | 'paymentIssue'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type FetchCloudLicenseQueryVariables = Exact<{
  params: SearchCloudLicenseParams;
}>;

export type FetchCloudLicenseQuery = { __typename?: 'Query' } & {
  cloudLicense?: Maybe<
    { __typename?: 'CloudLicenseResults' } & Pick<
      CloudLicenseResults,
      | 'accountId'
      | 'accountName'
      | 'accountOwnerEmail'
      | 'aliases'
      | 'baseProduct'
      | 'billingContactEmail'
      | 'billingCycle'
      | 'billingStatus'
      | 'businessKey'
      | 'cloudSiteId'
      | 'cloudSiteUrl'
      | 'createdDate'
      | 'firstPeriodEndDate'
      | 'firstPeriodStartDate'
      | 'hoursFromSupendedDate'
      | 'isAddon'
      | 'isCloud'
      | 'latestPeriodEndDate'
      | 'latestPeriodStartDate'
      | 'licenseLevel'
      | 'migrated'
      | 'planType'
      | 'platform'
      | 'productId'
      | 'productName'
      | 'regions'
      | 'renewalAction'
      | 'sen'
      | 'sourceSystem'
      | 'sources'
      | 'unitCount'
      | 'unitLabel'
      | 'updatedDate'
    > & {
        jobStatuses?: Maybe<
          { __typename?: 'JobStatus' } & Pick<
            JobStatus,
            'renameInProgress' | 'deleteInProgress' | 'reactivateInProgress' | 'deactivateInProgress'
          >
        >;
      }
  >;
};

export type FetchBillEstimateQueryVariables = Exact<{
  cloudSiteId: Scalars['ID'];
}>;

export type FetchBillEstimateQuery = { __typename?: 'Query' } & {
  billEstimate?: Maybe<
    { __typename?: 'BillEstimate' } & Pick<BillEstimate, 'currency' | 'totalAmountWithTax'> & {
        lines?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Lines' } & Pick<Lines, 'entitlementId'> & {
                  usage?: Maybe<
                    Array<
                      Maybe<{ __typename?: 'Usage' } & Pick<Usage, 'units' | 'currentUnits' | 'unlimited' | 'unitCode'>>
                    >
                  >;
                }
            >
          >
        >;
        currentBillingPeriod?: Maybe<
          { __typename?: 'BillingPeriod' } & Pick<BillingPeriod, 'startDate' | 'endDate' | 'frequency'>
        >;
        upcomingCurrencyExtras?: Maybe<
          { __typename?: 'UpcomingCurrencyExtras' } & Pick<UpcomingCurrencyExtras, 'currency'> & {
              period?: Maybe<
                { __typename?: 'BillingPeriod' } & Pick<BillingPeriod, 'startDate' | 'endDate' | 'frequency'>
              >;
            }
        >;
      }
  >;
};

export type EntitlementDetailsFragment = { __typename?: 'CloudSiteProduct' } & Pick<
  CloudSiteProduct,
  | 'accountId'
  | 'id'
  | 'sen'
  | 'baseProduct'
  | 'isAddon'
  | 'edition'
  | 'editionKey'
  | 'firstPeriodStartDate'
  | 'latestPeriodStartDate'
  | 'latestPeriodEndDate'
  | 'isCloud'
  | 'productId'
  | 'productName'
  | 'billingStatus'
  | 'planType'
  | 'unitCount'
  | 'unitLabel'
  | 'cloudSiteUrl'
  | 'endTimestamp'
  | 'billingFrequency'
  | 'entitlementNumber'
  | 'sourceSystem'
  | 'futureEditionKey'
  | 'overriddenEdition'
  | 'trialStartDate'
  | 'trialEndDate'
  | 'region'
  | 'nextBillingTimestamp'
  | 'userTier'
  | 'transactionAccountId'
  | 'transactionAccountNumber'
  | 'transactionAccountName'
  | 'trial'
  | 'billedUsers'
  | 'billingCycle'
  | 'provisioningStatus'
  | 'isSandbox'
  | 'isApp'
  | 'activeUsers'
  | 'logoId'
> & {
    pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type'>>;
    extendedCloudTrial?: Maybe<
      { __typename?: 'ExtendedCloudTrial' } & Pick<
        ExtendedCloudTrial,
        'btfSourceAccountId' | 'usageLimit' | 'usageType'
      >
    >;
    billToParty?: Maybe<
      { __typename?: 'CommerceAddress' } & Pick<
        CommerceAddress,
        'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
      >
    >;
    defaultPaymentMethod?: Maybe<
      | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
            card?: Maybe<
              { __typename?: 'CreditCardDetails' } & Pick<
                CreditCardDetails,
                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
              >
            >;
          })
      | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue' | 'default'> & {
            terms?: Maybe<{ __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>>;
          })
    >;
    upgradeTrial?: Maybe<
      { __typename?: 'UpgradeTrialDetails' } & Pick<
        UpgradeTrialDetails,
        'offeringName' | 'offeringId' | 'baseOfferingName'
      >
    >;
    scheduledChanges?: Maybe<
      { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
    >;
  };

export type ProductAppSubscriptionFragment = { __typename?: 'ProductAppSubscriptionForCloudSite' } & {
  products: Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailsFragment>>;
  apps: Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailsFragment>>;
};

export type FetchCloudSiteProductAppAndSubscriptionsQueryVariables = Exact<{
  parentSen: Scalars['String'];
  cloudSiteId?: Maybe<Scalars['String']>;
  showCcpData?: Maybe<Scalars['Boolean']>;
}>;

export type FetchCloudSiteProductAppAndSubscriptionsQuery = { __typename?: 'Query' } & {
  cloudSiteProductsAppsAndSubscriptions: { __typename?: 'ProductAppSubscriptionForCloudSiteData' } & {
    jira: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionFragment;
    statuspage: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionFragment;
    confluence: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionFragment;
    other?: Maybe<{ __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionFragment>;
  };
};

export type FetchCloudSiteProductsV2QueryVariables = Exact<{
  parentSen: Scalars['String'];
  cloudSiteId?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<CloudSiteProductsSearchOptions>;
  showCcpData?: Maybe<Scalars['Boolean']>;
}>;

export type FetchCloudSiteProductsV2Query = { __typename?: 'Query' } & {
  cloudSiteProducts?: Maybe<
    { __typename?: 'CloudSiteProductsConnection' } & Pick<CloudSiteProductsConnection, 'totalCount'> & {
        pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
        nodes?: Maybe<Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailsFragment>>>;
      }
  >;
};

export type FetchCreditsDetailsQueryVariables = Exact<{
  cloudSiteId: Scalars['ID'];
}>;

export type FetchCreditsDetailsQuery = { __typename?: 'Query' } & {
  credits?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Credit' } & Pick<
          Credit,
          | 'amountExTax'
          | 'amountIncTax'
          | 'amountConsumedExTax'
          | 'createdAt'
          | 'externalId'
          | 'currencyExchangeRate'
          | 'creditEventDate'
          | 'creditAppliedOrderId'
          | 'creditRequesterEmail'
          | 'creditType'
          | 'currency'
          | 'entitlementExternalId'
          | 'entitlementId'
          | 'expiration'
          | 'id'
          | 'modifiedAt'
          | 'notes'
          | 'productKey'
          | 'status'
          | 'supportRequestId'
          | 'taxAmount'
          | 'taxRate'
        >
      >
    >
  >;
};

export type FetchCloudSiteOrdersQueryVariables = Exact<{
  cloudSiteId: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchCloudSiteOrdersQuery = { __typename?: 'Query' } & {
  cloudSiteOrders?: Maybe<
    { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
        pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
        nodes: Array<
          Maybe<
            { __typename?: 'Order' } & Pick<
              Order,
              'id' | 'orderNumber' | 'billingContactEmail' | 'created' | 'contextSubject' | 'contextSubjectId'
            > & {
                metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                metadataObj?: Maybe<
                  { __typename?: 'OrderMetadataObj' } & Pick<
                    OrderMetadataObj,
                    | 'supportTicketNumber'
                    | 'handNote'
                    | 'termsOfTransfer'
                    | 'reasonCode'
                    | 'newBillingAdmin'
                    | 'currentBillingAdmin'
                  >
                >;
                orderLineItems?: Maybe<
                  { __typename?: 'OrderLineItemConnection' } & {
                    nodes: Array<
                      Maybe<
                        { __typename?: 'OrderLineItem' } & Pick<
                          OrderLineItem,
                          | 'lineItemId'
                          | 'quantity'
                          | 'type'
                          | 'skipTrial'
                          | 'orderTransitionType'
                          | 'salesTransitionType'
                          | 'edition'
                          | 'entitlementId'
                          | 'entitlementNumber'
                          | 'parentEntitlementId'
                          | 'productName'
                          | 'productId'
                        > & {
                            promotions?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                                      benefits?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'Benefit' } & Pick<
                                              Benefit,
                                              'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                            >
                                          >
                                        >
                                      >;
                                      promotionWindow?: Maybe<
                                        { __typename?: 'PromotionWindow' } & Pick<
                                          PromotionWindow,
                                          'endTime' | 'startTime'
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                            offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                            pricingPlan?: Maybe<
                              { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'>
                            >;
                            orderLineItemsPurchaseMetadata?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                    OrderLineItemsPurchaseMetadataType,
                                    'fieldName' | 'fieldValue'
                                  >
                                >
                              >
                            >;
                            orderLineItemsAccountModification?: Maybe<
                              { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                OrderLineItemsAccountModification,
                                'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                              >
                            >;
                          }
                      >
                    >;
                  }
                >;
              }
          >
        >;
      }
  >;
};

export type FetchSearchSupportIssuesQueryVariables = Exact<{
  searchParam?: Maybe<SupportIssueSearchParams>;
  searchOptions?: Maybe<SearchOptions>;
}>;

export type FetchSearchSupportIssuesQuery = { __typename?: 'Query' } & {
  fetchSearchSupportIssues?: Maybe<
    { __typename?: 'SupportIssuesConnection' } & Pick<SupportIssuesConnection, 'totalCount'> & {
        edges?: Maybe<
          Array<
            Maybe<
              { __typename?: 'SupportIssueEdge' } & Pick<SupportIssueEdge, 'cursor'> & {
                  node?: Maybe<
                    { __typename?: 'SupportIssue' } & Pick<
                      SupportIssue,
                      'issueKey' | 'summary' | 'currentStatus' | 'updatedTimestamp' | 'reporterEmailAddress'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchCloudSiteProductsQueryVariables = Exact<{
  parentSen: Scalars['String'];
  cloudSiteId?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<CloudSiteProductsSearchOptions>;
  showCcpData?: Maybe<Scalars['Boolean']>;
  fromCassi?: Maybe<Scalars['Boolean']>;
  callFromACUI?: Maybe<Scalars['Boolean']>;
}>;

export type FetchCloudSiteProductsQuery = { __typename?: 'Query' } & {
  cloudSiteProducts?: Maybe<
    { __typename?: 'CloudSiteProductsConnection' } & Pick<CloudSiteProductsConnection, 'totalCount'> & {
        pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'CloudSiteProduct' } & Pick<
                CloudSiteProduct,
                | 'accountId'
                | 'id'
                | 'sen'
                | 'baseProduct'
                | 'isAddon'
                | 'edition'
                | 'editionKey'
                | 'firstPeriodStartDate'
                | 'latestPeriodStartDate'
                | 'latestPeriodEndDate'
                | 'isCloud'
                | 'productId'
                | 'productName'
                | 'billingStatus'
                | 'planType'
                | 'unitCount'
                | 'unitLabel'
                | 'cloudSiteUrl'
                | 'entitlementNumber'
                | 'ccpEntitlementId'
                | 'cloudSiteId'
                | 'sourceSystem'
                | 'futureEditionKey'
                | 'overriddenEdition'
                | 'region'
                | 'billingCycle'
              > & {
                  extendedCloudTrial?: Maybe<
                    { __typename?: 'ExtendedCloudTrial' } & Pick<
                      ExtendedCloudTrial,
                      'btfSourceAccountId' | 'usageLimit' | 'usageType'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchContactDetailsV2QueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type FetchContactDetailsV2Query = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & Pick<
      Contact,
      | 'fullName'
      | 'businessKey'
      | 'phone'
      | 'email'
      | 'dataSource'
      | 'domain'
      | 'hasMultipleBillingAddress'
      | 'companyName'
    > & {
        address?: Maybe<
          { __typename?: 'Address' } & Pick<
            Address,
            'address1' | 'address2' | 'address3' | 'city' | 'country' | 'postalCode' | 'state'
          >
        >;
        atlassianAccount?: Maybe<
          { __typename?: 'AtlassianAccountDetails' } & Pick<
            AtlassianAccountDetails,
            | 'id'
            | 'active'
            | 'created'
            | 'hasVerifiedEmail'
            | 'organizationId'
            | 'organizationName'
            | 'updated'
            | 'atlassianAccessStatus'
          >
        >;
        communityAccount?: Maybe<
          { __typename?: 'CommunityUser' } & Pick<CommunityUser, 'id' | 'aaid' | 'viewProfileUrl' | 'topicsQuery'>
        >;
        accountPrivacySettings?: Maybe<
          Array<
            Maybe<
              { __typename?: 'AccountPrivacySettings' } & Pick<AccountPrivacySettings, 'fieldName' | 'fieldVisibility'>
            >
          >
        >;
        cloudSiteAccess?: Maybe<
          { __typename?: 'CloudSiteAccess' } & Pick<CloudSiteAccess, 'totalHits'> & {
              results?: Maybe<
                Array<
                  Maybe<{ __typename?: 'SiteAccess' } & Pick<SiteAccess, 'cloudSiteId' | 'cloudSiteUrl' | 'migrated'>>
                >
              >;
            }
        >;
        organizations?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Organizations' } & Pick<Organizations, 'id' | 'name'> & {
                  domains?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'Domains' } & Pick<
                          Domains,
                          'domain' | 'verified' | 'status' | 'verificationType' | 'timestamp'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchInvoicesForContactV2QueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoicesForContactV2Query = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & Pick<Contact, 'email'> & {
        invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'dueDate'
                    | 'updatedDate'
                    | 'paymentCurrency'
                    | 'status'
                    | 'pdfLink'
                    | 'transactionAccountId'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      creditCard?: Maybe<
                        { __typename?: 'CreditCardDetails' } & Pick<
                          CreditCardDetails,
                          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                        >
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & {
                          address?: Maybe<
                            { __typename?: 'InvoiceAddress' } & Pick<
                              InvoiceAddress,
                              'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                            >
                          >;
                        }
                      >;
                      billTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & {
                          address?: Maybe<
                            { __typename?: 'InvoiceAddress' } & Pick<
                              InvoiceAddress,
                              'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                            >
                          >;
                        }
                      >;
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              'id' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          };
      }
  >;
};

export type FetchSupportIssuesByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<SupportIssueSearchOptions>;
  updatedTo?: Maybe<Scalars['String']>;
  updatedFrom?: Maybe<Scalars['String']>;
  currentStatusIsIn?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;

export type FetchSupportIssuesByEmailQuery = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & Pick<Contact, 'fullName' | 'phone' | 'domain'> & {
        supportIssues: { __typename?: 'SupportIssuesConnection' } & Pick<SupportIssuesConnection, 'totalCount'> & {
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SupportIssueEdge' } & Pick<SupportIssueEdge, 'cursor'> & {
                      node?: Maybe<
                        { __typename?: 'SupportIssue' } & Pick<
                          SupportIssue,
                          'issueKey' | 'summary' | 'currentStatus' | 'updatedTimestamp' | 'reporterEmailAddress'
                        >
                      >;
                    }
                >
              >
            >;
          };
      }
  >;
};

export type FetchContactEmailDetailsQueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchContactEmailDetailsQuery = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & {
      emails: { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          edges?: Maybe<
            Array<
              Maybe<
                { __typename?: 'EmailEdge' } & Pick<EmailEdge, 'cursor'> & {
                    node: { __typename?: 'Email' } & Pick<
                      Email,
                      'id' | 'date' | 'mailbox' | 'messageId' | 'raw' | 'self' | 'size' | 'subject' | 'text'
                    > & {
                        attachments?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Attachment' } & Pick<
                                Attachment,
                                'checksum' | 'contentType' | 'contentDisposition' | 'filename' | 'size' | 'id' | 'self'
                              >
                            >
                          >
                        >;
                        from?: Maybe<
                          Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                        >;
                        to?: Maybe<
                          Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                        >;
                        bcc?: Maybe<
                          Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                        >;
                        cc?: Maybe<
                          Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                        >;
                        replyTo?: Maybe<
                          Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                        >;
                      };
                  }
              >
            >
          >;
        };
    }
  >;
};

export type FetchTransactionAccountSearchByEmailV2QueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchTransactionAccountSearchByEmailV2Query = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        transactionAccounts: { __typename?: 'TransactionAccountConnection' } & Pick<
          TransactionAccountConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccount' } & Pick<
                    TransactionAccount,
                    'displayName' | 'id' | 'transactionAccountNumber'
                  > & {
                      availablePaymentMethods?: Maybe<
                        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                            nodes?: Maybe<
                              Array<
                                Maybe<
                                  | ({ __typename?: 'CreditCard' } & Pick<
                                      CreditCard,
                                      'id' | 'type' | 'default' | 'paymentIssue'
                                    > & {
                                        card?: Maybe<
                                          { __typename?: 'CreditCardDetails' } & Pick<
                                            CreditCardDetails,
                                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                          >
                                        >;
                                      })
                                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                                      PaymentOnTerms,
                                      'id' | 'type' | 'default' | 'paymentIssue'
                                    > & {
                                        terms?: Maybe<
                                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                            PaymentOnTermsDetails,
                                            'invoiceDueDays'
                                          >
                                        >;
                                      })
                                >
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
          };
      }
  >;
};

export type FetchEmailDetailsQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type FetchEmailDetailsQuery = { __typename?: 'Query' } & {
  fetchEmailDetails?: Maybe<
    { __typename?: 'Email' } & Pick<
      Email,
      'id' | 'date' | 'html' | 'mailbox' | 'messageId' | 'raw' | 'self' | 'size' | 'subject' | 'text'
    > & {
        attachments?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Attachment' } & Pick<
                Attachment,
                'checksum' | 'contentType' | 'contentDisposition' | 'filename' | 'size' | 'id' | 'self'
              >
            >
          >
        >;
        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        bcc?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        cc?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        replyTo?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
      }
  >;
};

export type FetchAvailableOfferingsForChangeSubscriptionQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchAvailableOfferingsForChangeSubscriptionQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      availableOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<
              Offering,
              'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType' | 'status'
            > & {
                derivedFromOffering?: Maybe<
                  { __typename?: 'DerivedFromOffering' } & Pick<
                    DerivedFromOffering,
                    'templateId' | 'templateVersion' | 'originalOfferingKey'
                  >
                >;
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
              }
          >
        >
      >;
    };
};

export type PromotionsQueryFragment = { __typename?: 'Promotion' } & Pick<
  Promotion,
  | 'id'
  | 'promotionCode'
  | 'title'
  | 'type'
  | 'promotionInstanceId'
  | 'status'
  | 'cycleInterval'
  | 'pricingType'
  | 'cycleIntervalWithEligibleConditions'
  | 'isPromotionCustomisable'
> & {
    benefits?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Benefit' } & Pick<
            Benefit,
            'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
          > & {
              customisable?: Maybe<
                { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                    value?: Maybe<
                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                        BenefitCustomisableValue,
                        'type' | 'lowerBound' | 'upperBound'
                      >
                    >;
                    iterations?: Maybe<
                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                        BenefitCustomisableValue,
                        'type' | 'lowerBound' | 'upperBound'
                      >
                    >;
                  }
              >;
            }
        >
      >
    >;
    promotionWindow?: Maybe<{ __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>>;
    eligibilityRules?: Maybe<
      { __typename?: 'EligibilityRule' } & Pick<
        EligibilityRule,
        'products' | 'cycleInterval' | 'pricingType' | 'partnerType' | 'partnerTier' | 'saleTransitionType' | 'currency'
      >
    >;
    applicationReason?: Maybe<
      { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
          customisable?: Maybe<
            { __typename?: 'PromotionReasonCustomisable' } & {
              id?: Maybe<
                { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                    anyOf?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>
                        >
                      >
                    >;
                  }
              >;
            }
          >;
        }
    >;
  };

export type FetchLinkedEntitlementsForChangeSubcsriptionQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  skipUpgradeTrialField: Scalars['Boolean'];
}>;

export type FetchLinkedEntitlementsForChangeSubcsriptionQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'productId'
              | 'activeUsers'
              | 'entitlementNumber'
              | 'endTimestamp'
              | 'productName'
              | 'billingCycle'
              | 'billingFrequency'
              | 'latestPeriodEndDate'
              | 'offeringId'
              | 'subscriptionId'
              | 'billingStatus'
              | 'isApp'
              | 'transactionAccountId'
              | 'billingGroupId'
              | 'edition'
              | 'isSandbox'
              | 'parentSen'
              | 'logoId'
              | 'userTier'
              | 'unitCount'
            > & {
                promotions?: Maybe<Array<Maybe<{ __typename?: 'Promotion' } & PromotionsQueryFragment>>>;
                scheduledChanges?: Maybe<
                  { __typename?: 'ScheduledChanges' } & {
                    promotions?: Maybe<Array<Maybe<{ __typename?: 'Promotion' } & PromotionsQueryFragment>>>;
                  }
                >;
                offering?: Maybe<
                  { __typename?: 'Offering' } & Pick<
                    Offering,
                    'id' | 'name' | 'productKey' | 'level' | 'type' | 'pricingType' | 'status'
                  >
                >;
                pricingPlan?: Maybe<
                  { __typename?: 'PricingPlan' } & Pick<
                    PricingPlan,
                    | 'type'
                    | 'billingFrequency'
                    | 'id'
                    | 'currency'
                    | 'pricingPlanType'
                    | 'status'
                    | 'description'
                    | 'chargeElement'
                    | 'chargeType'
                  > & {
                      tiers?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'PricingTiers' } & Pick<
                              PricingTiers,
                              'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                            >
                          >
                        >
                      >;
                    }
                >;
                subscriptionTimestamps?: Maybe<
                  { __typename?: 'SubscriptionTimeStamps' } & Pick<
                    SubscriptionTimeStamps,
                    'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
                  >
                >;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                upgradeTrial?: Maybe<
                  { __typename?: 'UpgradeTrialDetails' } & Pick<
                    UpgradeTrialDetails,
                    'startTimestamp' | 'endTimestamp'
                  > & {
                      pricingPlan?: Maybe<
                        { __typename?: 'PricingPlan' } & Pick<
                          PricingPlan,
                          | 'type'
                          | 'billingFrequency'
                          | 'id'
                          | 'currency'
                          | 'pricingPlanType'
                          | 'status'
                          | 'description'
                          | 'chargeElement'
                          | 'chargeType'
                        > & {
                            tiers?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'PricingTiers' } & Pick<
                                    PricingTiers,
                                    'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                                  >
                                >
                              >
                            >;
                          }
                      >;
                    }
                >;
              }
          >
        >
      >;
    };
};

export type FetchPushPaymentCreditDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPushPaymentCreditDetailsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber'
  > & {
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<
          TermDetailsAccountConnection,
          'totalCreditLimit' | 'availableCreditLimit'
        >
      >;
    };
};

export type FetchTransactionAccountSearchQueryVariables = Exact<{
  query: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchTransactionAccountSearchQuery = { __typename?: 'Query' } & {
  searchForTransactionAccount: { __typename?: 'TransactionAccountConnection' } & Pick<
    TransactionAccountConnection,
    'totalCount'
  > & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'TransactionAccount' } & Pick<
              TransactionAccount,
              | 'displayName'
              | 'id'
              | 'programLevelGlobal'
              | 'partnerDiscountTier'
              | 'transactionAccountNumber'
              | 'billToPartyPricingEligibilty'
            > & {
                defaultPaymentMethod?: Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<
                      CreditCard,
                      'id' | 'type' | 'default' | 'paymentIssue' | 'hasLinkedSubscriptions'
                    >)
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'type' | 'default' | 'paymentIssue' | 'hasLinkedSubscriptions'
                    >)
                >;
                billingAdmins?: Maybe<
                  { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
                      nodes?: Maybe<
                        Array<Maybe<{ __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'fullName' | 'email'>>>
                      >;
                    }
                >;
                billToParty?: Maybe<
                  { __typename?: 'CommerceAddress' } & Pick<
                    CommerceAddress,
                    'taxId' | 'addressLine1' | 'addressLine2' | 'state' | 'city' | 'country' | 'postcode'
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchSandboxParentQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchSandboxParentQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'productId' | 'entitlementNumber' | 'billingStatus' | 'provisioningStatus' | 'edition' | 'productName' | 'isSandbox'
  > & {
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
    };
};

export type FetchAvailableOfferingsForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchAvailableOfferingsForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'edition' | 'plan' | 'transactionAccountId'
  > & {
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<
          Offering,
          'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType'
        > & {
            availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name' | 'units'>>>>;
        }
      >;
      availableOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<
              Offering,
              'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType' | 'status'
            > & {
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
                availableSyntheticPricingPlans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'SyntheticPricingPlan' } & Pick<
                        SyntheticPricingPlan,
                        'type' | 'status' | 'discountPercentage'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      validOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ValidOfferings' } & Pick<ValidOfferings, 'key' | 'offeringKey' | 'offeringName' | 'status'>
          >
        >
      >;
    };
};

export type FetchAvailablePartnerPromotionsForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  discountTier?: Maybe<Scalars['String']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePartnerPromotionsForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'productId' | 'edition'
  > & { billingFrequency: EntitlementDetails['billingCycle'] } & {
      availablePartnerPromotions?: Maybe<Array<Maybe<{ __typename?: 'Promotion' } & PromotionDetailsFragment>>>;
    };
};

export type FetchAvailablePricingPlansQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchAvailablePricingPlansQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'billingCycle' | 'plan'
  > & {
      availablePricingPlans?: Maybe<
        Array<
          Maybe<
            { __typename?: 'PricingPlan' } & Pick<
              PricingPlan,
              | 'type'
              | 'billingFrequency'
              | 'id'
              | 'currency'
              | 'pricingPlanType'
              | 'status'
              | 'description'
              | 'offeringName'
              | 'chargeElement'
              | 'chargeType'
            > & {
                tiers?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'PricingTiers' } & Pick<
                        PricingTiers,
                        'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type PromotionDetailsFragment = { __typename?: 'Promotion' } & Pick<
  Promotion,
  'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType' | 'isPromotionCustomisable' | 'type'
> & {
    benefits?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Benefit' } & Pick<
            Benefit,
            'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
          > & {
              customisable?: Maybe<
                { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                    value?: Maybe<
                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                        BenefitCustomisableValue,
                        'type' | 'lowerBound' | 'upperBound'
                      >
                    >;
                    iterations?: Maybe<
                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                        BenefitCustomisableValue,
                        'type' | 'lowerBound' | 'upperBound'
                      >
                    >;
                  }
              >;
            }
        >
      >
    >;
    promotionWindow?: Maybe<{ __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>>;
    eligibilityRules?: Maybe<
      { __typename?: 'EligibilityRule' } & Pick<
        EligibilityRule,
        'products' | 'cycleInterval' | 'pricingType' | 'partnerType' | 'partnerTier' | 'saleTransitionType' | 'currency'
      >
    >;
    applicationReason?: Maybe<
      { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
          customisable?: Maybe<
            { __typename?: 'PromotionReasonCustomisable' } & {
              id?: Maybe<
                { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                    anyOf?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>
                        >
                      >
                    >;
                  }
              >;
            }
          >;
        }
    >;
    customisableReasons?: Maybe<
      Array<Maybe<{ __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>>>
    >;
  };

export type FetchAvailablePromotionsForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePromotionsForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'productId' | 'edition'
  > & { billingFrequency: EntitlementDetails['billingCycle'] } & {
      availablePromotions?: Maybe<Array<Maybe<{ __typename?: 'Promotion' } & PromotionDetailsFragment>>>;
    };
};

export type FetchAuditTrailForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  dateFilter?: Maybe<DateRange>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchAuditTrailForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      auditNotes?: Maybe<
        { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<{ __typename?: 'AuditNote' } & Pick<AuditNote, 'body' | 'author' | 'created' | 'contactKey'>>
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchContactsForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchContactsForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id' | 'baseProduct'> & {
      users?: Maybe<
        { __typename?: 'UserConnection' } & Pick<UserConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'User' } & Pick<User, 'displayName' | 'primaryEmail' | 'roles' | 'lastActive'> & {
                      atlassianAccount?: Maybe<
                        { __typename?: 'AtlassianAccountDetails' } & Pick<AtlassianAccountDetails, 'id'>
                      >;
                    }
                >
              >
            >;
          }
      >;
      siteAdmins?: Maybe<
        { __typename?: 'SiteAdminConnection' } & Pick<SiteAdminConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SiteAdmin' } & Pick<
                    SiteAdmin,
                    'displayName' | 'primaryEmail' | 'roles' | 'lastActive'
                  > & {
                      atlassianAccount?: Maybe<
                        { __typename?: 'AtlassianAccountDetails' } & Pick<AtlassianAccountDetails, 'id'>
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchEntitlementDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchEntitlementDetailsQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    | 'createdDate'
    | 'hasOpenInvoices'
    | 'billingStatus'
    | 'cloudSiteHostname'
    | 'cloudSiteCustomHostname'
    | 'cloudSiteId'
    | 'cloudSiteSen'
    | 'entitlementNumber'
    | 'updatePaymentMethodLink'
    | 'hasPendingInvoices'
    | 'nextInvoiceTimeAt'
    | 'id'
    | 'endTimestamp'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'licenseLevel'
    | 'offeringId'
    | 'isOptOutAllowed'
    | 'version'
    | 'edition'
    | 'parentSen'
    | 'parentCloudSiteName'
    | 'platform'
    | 'productId'
    | 'productName'
    | 'baseProduct'
    | 'renewalAction'
    | 'sourceSystem'
    | 'plan'
    | 'subscriptionId'
    | 'unitCount'
    | 'activeSubscriptionBillingGroupId'
    | 'activeUsers'
    | 'totalBilledUsers'
    | 'provisioningStatus'
    | 'nextBillingTimestamp'
    | 'isSandbox'
    | 'isApp'
    | 'productType'
    | 'showExtendTrial'
    | 'productStatus'
    | 'logoId'
    | 'migrated'
    | 'userTier'
  > & { billingFrequency: EntitlementDetails['billingCycle'] } & {
      addOns?: Maybe<{ __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'>>;
      invoices: { __typename?: 'InvoiceConnection' } & {
        nodes?: Maybe<Array<Maybe<{ __typename?: 'Invoice' } & Pick<Invoice, 'id'>>>>;
      };
      upgradeTrial?: Maybe<
        { __typename?: 'UpgradeTrialDetails' } & Pick<
          UpgradeTrialDetails,
          'baseOfferingName' | 'offeringId' | 'offeringName' | 'startTimestamp' | 'endTimestamp'
        > & {
            pricingPlan?: Maybe<
              { __typename?: 'PricingPlan' } & Pick<
                PricingPlan,
                | 'type'
                | 'billingFrequency'
                | 'id'
                | 'currency'
                | 'pricingPlanType'
                | 'status'
                | 'description'
                | 'chargeType'
              > & {
                  tiers?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'PricingTiers' } & Pick<
                          PricingTiers,
                          'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                        >
                      >
                    >
                  >;
                }
            >;
            offering?: Maybe<
              { __typename?: 'Offering' } & Pick<
                Offering,
                'id' | 'name' | 'productKey' | 'level' | 'type' | 'pricingType' | 'status' | 'expiryDate'
              > & { trial?: Maybe<{ __typename?: 'OfferingTrial' } & Pick<OfferingTrial, 'lengthDays'>> }
            >;
          }
      >;
      nextBillEstimate?: Maybe<{ __typename?: 'NextBillEstimate' } & Pick<NextBillEstimate, 'total' | 'currency'>>;
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<
          Offering,
          'id' | 'name' | 'productKey' | 'level' | 'type' | 'pricingType' | 'status' | 'expiryDate'
        > & {
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
            trial?: Maybe<{ __typename?: 'OfferingTrial' } & Pick<OfferingTrial, 'lengthDays'>>;
            defaultPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'DefaultPricingPlans' } & Pick<DefaultPricingPlans, 'currency' | 'key' | 'type'> & {
                      cycle?: Maybe<
                        { __typename?: 'DefaultPricingPlanCycle' } & Pick<
                          DefaultPricingPlanCycle,
                          'name' | 'interval' | 'count'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      promotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              | 'id'
              | 'promotionCode'
              | 'title'
              | 'type'
              | 'promotionInstanceId'
              | 'status'
              | 'cycleInterval'
              | 'pricingType'
              | 'cycleIntervalWithEligibleConditions'
              | 'isPromotionCustomisable'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
              }
          >
        >
      >;
      trialPromotionDetails?: Maybe<
        { __typename?: 'TrialPromotionDetails' } & Pick<TrialPromotionDetails, 'totalTrialDays' | 'totalTrialCount'>
      >;
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
      pricingPlan?: Maybe<
        { __typename?: 'PricingPlan' } & Pick<
          PricingPlan,
          | 'type'
          | 'billingFrequency'
          | 'id'
          | 'currency'
          | 'pricingPlanType'
          | 'status'
          | 'chargeType'
          | 'chargeElement'
          | 'description'
        > & {
            tiers?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'PricingTiers' } & Pick<
                    PricingTiers,
                    'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                  >
                >
              >
            >;
          }
      >;
      scheduledChanges?: Maybe<{ __typename?: 'ScheduledChanges' } & ScheduledChangesForEntitlementV2Fragment>;
      subscription?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SubscriptionDetails' } & {
              subscriptionPeriod?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'SubscriptionPeriodDetails' } & Pick<
                      SubscriptionPeriodDetails,
                      'offeringKey' | 'startTimestamp'
                    > & {
                        chargeQuantities?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'ChargeQuantity' } & Pick<
                                ChargeQuantity,
                                'chargeElement' | 'quantity' | 'lastUpdatedAt'
                              >
                            >
                          >
                        >;
                        trial?: Maybe<
                          { __typename?: 'TrialTimeStamps' } & Pick<
                            TrialTimeStamps,
                            'startTimestamp' | 'endTimestamp' | 'pricingPlanId' | 'offeringId'
                          >
                        >;
                      }
                  >
                >
              >;
            }
          >
        >
      >;
      deletedProductDetails?: Maybe<
        { __typename?: 'DeletedProductDetails' } & Pick<
          DeletedProductDetails,
          'status' | 'datePlaced' | 'deletedOn' | 'author' | 'supportTicket' | 'internalComment'
        >
      >;
      relatesToEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'RelatedEntitlementDetails' } & Pick<
              RelatedEntitlementDetails,
              'entitlementId' | 'relationshipType'
            >
          >
        >
      >;
      relatesFromEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'RelatedEntitlementDetails' } & Pick<
              RelatedEntitlementDetails,
              'entitlementId' | 'relationshipType'
            >
          >
        >
      >;
    } & SubscribeToAddOnsFormData_EntitlementDetails_Fragment;
};

export type FetchEmailsForEntitlementPageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchEmailsForEntitlementPageQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      emails?: Maybe<
        { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EmailEdge' } & {
                    node: { __typename?: 'Email' } & Pick<
                      Email,
                      'subject' | 'size' | 'id' | 'html' | 'text' | 'date'
                    > & {
                        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      };
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchSupportIssuesForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParam?: Maybe<SupportIssueEntitlementSearchParams>;
}>;

export type FetchSupportIssuesForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id' | 'entitlementNumber'> & {
      supportIssues?: Maybe<
        { __typename?: 'SupportIssues' } & Pick<SupportIssues, 'totalHits'> & {
            results: Array<
              Maybe<
                { __typename?: 'SupportIssue' } & Pick<
                  SupportIssue,
                  'id' | 'issueKey' | 'summary' | 'currentStatus' | 'reporterEmailAddress' | 'updatedTimestamp'
                >
              >
            >;
          }
      >;
    };
};

export type FetchInvoiceForOrderToCancelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInvoiceForOrderToCancelQuery = { __typename?: 'Query' } & {
  invoiceForOrderToCancel: { __typename?: 'Invoice' } & Pick<Invoice, 'invoiceNumber' | 'createdDate'>;
};

export type FetchInvoicesForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchInvoicesForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'status'
                  | 'invoiceNumber'
                  | 'sourceSystem'
                  | 'paymentMethod'
                  | 'paymentMethodId'
                  | 'transactionAccountId'
                  | 'pdfLink'
                  | 'dueDate'
                  | 'createdDate'
                  | 'itemsTotal'
                  | 'grandTotal'
                  | 'paymentCurrency'
                > & {
                    creditCard?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                    paymentOnTermsDetails?: Maybe<
                      { __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'default'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        }
                    >;
                    refunds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Refunds' } & Pick<
                            Refunds,
                            | 'id'
                            | 'type'
                            | 'creditNoteNumber'
                            | 'sourceSystem'
                            | 'total'
                            | 'currency'
                            | 'status'
                            | 'arn'
                          >
                        >
                      >
                    >;
                    dunningStatus?: Maybe<
                      Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                    >;
                    transactionAccount?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TransactionAccount' } & Pick<
                            TransactionAccount,
                            'transactionAccountNumber' | 'id'
                          >
                        >
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

export type FetchLinkedAppsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
}>;

export type FetchLinkedAppsQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & {
    linkedEntitlements?: Maybe<
      Array<
        Maybe<{ __typename?: 'LinkedDestinationEntitlement' } & Pick<LinkedDestinationEntitlement, 'entitlementId'>>
      >
    >;
  };
};

export type FetchLinkedEntitlementsQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
}>;

export type FetchLinkedEntitlementsQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'billingFrequency'
              | 'cloudSiteHostname'
              | 'cloudSiteId'
              | 'productId'
              | 'createdDate'
              | 'edition'
              | 'unitCount'
              | 'provisioningStatus'
              | 'baseProduct'
              | 'billingStatus'
              | 'billedUsers'
              | 'entitlementNumber'
              | 'productName'
              | 'transactionAccountId'
              | 'userTier'
              | 'trialEndDate'
              | 'endTimestamp'
              | 'trialStartDate'
              | 'latestPeriodEndDate'
              | 'latestPeriodStartDate'
              | 'isApp'
              | 'isSandbox'
              | 'activeUsers'
              | 'version'
              | 'trial'
              | 'logoId'
              | 'migrated'
            > & {
                relatesToEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType' | 'id' | 'name'>>;
                pricingPlan?: Maybe<
                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'> & {
                      tiers?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'PricingTiers' } & Pick<
                              PricingTiers,
                              'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                            >
                          >
                        >
                      >;
                    }
                >;
                scheduledChanges?: Maybe<
                  { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
                >;
                upgradeTrial?: Maybe<
                  { __typename?: 'UpgradeTrialDetails' } & Pick<
                    UpgradeTrialDetails,
                    'baseOfferingName' | 'offeringId' | 'offeringName'
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchOrdersForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchOrdersForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<
                  Order,
                  'id' | 'orderNumber' | 'created' | 'contextSubject' | 'hasPendingInvoice'
                > & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    invoiceGroup?: Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name' | 'currency'> & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode'
                            >
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                        }
                    >;
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    metadataObj?: Maybe<
                      { __typename?: 'OrderMetadataObj' } & Pick<
                        OrderMetadataObj,
                        | 'supportTicketNumber'
                        | 'handNote'
                        | 'termsOfTransfer'
                        | 'reasonCode'
                        | 'newBillingAdmin'
                        | 'currentBillingAdmin'
                        | 'consentTaken'
                      >
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'skipTrial'
                              | 'orderLineItemsAdditionalNotes'
                              | 'reasonCode'
                              | 'offeringId'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                              | 'nextBillingAnchorTimestamp'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<
                                    PricingPlan,
                                    'type' | 'billingFrequency' | 'pricingPlanType' | 'status' | 'description'
                                  >
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        'id' | 'title' | 'status' | 'type' | 'promotionCode' | 'isPromotionCustomisable'
                                      > & {
                                          applicationReason?: Maybe<
                                            { __typename?: 'PromotionReason' } & Pick<
                                              PromotionReason,
                                              'id' | 'readableName'
                                            > & {
                                                customisable?: Maybe<
                                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                                    id?: Maybe<
                                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                                        PromotionReasonListObj,
                                                        'type'
                                                      > & {
                                                          anyOf?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                                  ReasonCustomisableObj,
                                                                  'readableName' | 'id'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                                >;
                                              }
                                          >;
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                                removedPromotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        'id' | 'title' | 'status' | 'type' | 'promotionCode'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                                orderLineItemsPurchaseMetadata?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                        OrderLineItemsPurchaseMetadataType,
                                        'fieldName' | 'fieldValue'
                                      >
                                    >
                                  >
                                >;
                                orderLineItemsAccountModification?: Maybe<
                                  { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                    OrderLineItemsAccountModification,
                                    'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                    billTo?: Maybe<{ __typename?: 'OrderBillTo' } & Pick<OrderBillTo, 'billToAccountId'>>;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchOrdersForRewindOnEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchOrdersForRewindOnEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      ordersForRewind?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber' | 'created' | 'contextSubject'> & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'name' | 'id'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        | 'id'
                                        | 'title'
                                        | 'status'
                                        | 'cycleInterval'
                                        | 'pricingType'
                                        | 'isPromotionCustomisable'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  | 'benefitType'
                                                  | 'subBenefitType'
                                                  | 'iterations'
                                                  | 'value'
                                                  | 'scale'
                                                  | 'type'
                                                  | 'duration'
                                                > & {
                                                    customisable?: Maybe<
                                                      { __typename?: 'BenefitCustomisableObj' } & Pick<
                                                        BenefitCustomisableObj,
                                                        'duration'
                                                      > & {
                                                          value?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                          iterations?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                          eligibilityRules?: Maybe<
                                            { __typename?: 'EligibilityRule' } & Pick<
                                              EligibilityRule,
                                              | 'products'
                                              | 'cycleInterval'
                                              | 'pricingType'
                                              | 'partnerType'
                                              | 'partnerTier'
                                              | 'saleTransitionType'
                                              | 'currency'
                                            >
                                          >;
                                          applicationReason?: Maybe<
                                            { __typename?: 'PromotionReason' } & Pick<
                                              PromotionReason,
                                              'id' | 'readableName'
                                            > & {
                                                customisable?: Maybe<
                                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                                    id?: Maybe<
                                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                                        PromotionReasonListObj,
                                                        'type'
                                                      > & {
                                                          anyOf?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                                  ReasonCustomisableObj,
                                                                  'readableName' | 'id'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchTransactionAccountForEntitlementQueryVariables = Exact<{
  entitlementId?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchTransactionAccountForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      termDetails?: Maybe<
        { __typename?: 'EntitlementTermDetails' } & Pick<
          EntitlementTermDetails,
          'availableCreditLimit' | 'currency' | 'totalCreditLimit'
        >
      >;
      transactionAccount?: Maybe<
        { __typename?: 'TransactionAccount' } & Pick<
          TransactionAccount,
          | 'id'
          | 'displayName'
          | 'partnerLevel'
          | 'partnerDiscountTier'
          | 'programLevelGlobal'
          | 'transactionAccountNumber'
          | 'partnerAccountId'
          | 'billToPartyPricingEligibilty'
        > & {
            availablePaymentMethods?: Maybe<
              { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                  nodes?: Maybe<
                    Array<
                      Maybe<
                        | ({ __typename?: 'CreditCard' } & Pick<
                            CreditCard,
                            'id' | 'type' | 'default' | 'paymentIssue'
                          > & {
                              card?: Maybe<
                                { __typename?: 'CreditCardDetails' } & Pick<
                                  CreditCardDetails,
                                  'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                >
                              >;
                            })
                        | ({ __typename?: 'PaymentOnTerms' } & Pick<
                            PaymentOnTerms,
                            'id' | 'type' | 'default' | 'paymentIssue'
                          > & {
                              terms?: Maybe<
                                { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                              >;
                            })
                      >
                    >
                  >;
                }
            >;
            billToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
              > & {
                  taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  > & {
                                      metadata?: Maybe<
                                        { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                          TassTaxIdLabelMetadata,
                                          'type'
                                        > & {
                                            labels?: Maybe<
                                              Array<
                                                Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                    TassTaxIdLabelMetadataLabel,
                                                    'default' | 'label' | 'vatStatus'
                                                  >
                                                >
                                              >
                                            >;
                                          }
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                    >;
                  })
            >;
            billingAdmins?: Maybe<
              { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
                  nodes?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'BillingAdmin' } & Pick<
                          BillingAdmin,
                          'email' | 'atlassianAccountId' | 'fullName'
                        >
                      >
                    >
                  >;
                }
            >;
            availableInvoiceGroups?: Maybe<
              { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
                  nodes: Array<
                    Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<
                        InvoiceGroup,
                        'id' | 'name' | 'currency' | 'shipToPriceEligibility'
                      > & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              | 'id'
                              | 'name'
                              | 'addressLine1'
                              | 'addressLine2'
                              | 'city'
                              | 'state'
                              | 'country'
                              | 'postcode'
                              | 'taxId'
                            > & {
                                taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                                taxLabels?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                          taxIdLabels?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'TasstaxIdLabel' } & Pick<
                                                  TasstaxIdLabel,
                                                  'description' | 'displayName' | 'type'
                                                > & {
                                                    metadata?: Maybe<
                                                      { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                                        TassTaxIdLabelMetadata,
                                                        'type'
                                                      > & {
                                                          labels?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                                  TassTaxIdLabelMetadataLabel,
                                                                  'default' | 'label' | 'vatStatus'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                          purchaseOrder?: Maybe<
                            { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                              InvoiceGroupPurchaseOrder,
                              'number' | 'oneTimeUse'
                            >
                          >;
                        }
                    >
                  >;
                }
            >;
          }
      >;
    };
};

export type FetchTransactionAccountForSetInvoiceGroupPaneQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForSetInvoiceGroupPaneQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<
                InvoiceGroup,
                'id' | 'name' | 'currency' | 'shipToPriceEligibility'
              > & {
                  shipToParty?: Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'id' | 'name'>>;
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchUserHistoryForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchUserHistoryForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'edition'
  > & {
      userHistory?: Maybe<
        { __typename?: 'UserHistoryDetails' } & Pick<UserHistoryDetails, 'nextId'> & {
            results?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ChargeQuantity' } & Pick<
                    ChargeQuantity,
                    'chargeElement' | 'quantity' | 'lastUpdatedAt'
                  > & {
                      usersUpdate?: Maybe<
                        { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                          ChargeQuantityUsersUpdate,
                          'isCreated' | 'isAdded' | 'isRemoved' | 'changeBy'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type ScheduledChangesForEntitlementV2Fragment = { __typename?: 'ScheduledChanges' } & Pick<
  ScheduledChanges,
  | 'nextChangeTimestamp'
  | 'subscriptionScheduleAction'
  | 'transactionAccountId'
  | 'invoiceGroupId'
  | 'scheduledBillingInvoiceGroupId'
> & {
    offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
    pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
    promotions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<
            Promotion,
            | 'promotionInstanceId'
            | 'id'
            | 'promotionCode'
            | 'status'
            | 'rule'
            | 'title'
            | 'type'
            | 'pricingType'
            | 'cycleInterval'
            | 'isPromotionCustomisable'
          > & {
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'value' | 'benefitType' | 'subBenefitType' | 'duration' | 'iterations'
                    > & {
                        customisable?: Maybe<
                          { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                              value?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                              iterations?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
              promotionWindow?: Maybe<
                { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'startTime' | 'endTime'>
              >;
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
            }
        >
      >
    >;
    chargeQuantities?: Maybe<
      Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>>
    >;
  };

export type OfferingFieldsToCompareFragment = { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>;

export type PricingPlanFieldsToCompareFragment = { __typename?: 'PricingPlan' } & Pick<
  PricingPlan,
  'type' | 'billingFrequency'
>;

type SubscribeToAddOnsFormData_EntitlementDetails_Fragment = { __typename?: 'EntitlementDetails' } & {
  offering?: Maybe<
    { __typename?: 'Offering' } & {
      availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
    }
  >;
};

type SubscribeToAddOnsFormData_Statuspage_Fragment = { __typename?: 'Statuspage' } & {
  offering?: Maybe<
    { __typename?: 'Offering' } & {
      availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
    }
  >;
};

type SubscribeToAddOnsFormData_Trello_Fragment = { __typename?: 'Trello' } & {
  offering?: Maybe<
    { __typename?: 'Offering' } & {
      availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
    }
  >;
};

export type SubscribeToAddOnsFormDataFragment =
  | SubscribeToAddOnsFormData_EntitlementDetails_Fragment
  | SubscribeToAddOnsFormData_Statuspage_Fragment
  | SubscribeToAddOnsFormData_Trello_Fragment;

export type FetchAddOnsForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchAddOnsForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'> & {
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'AddOnEdge' } & {
                    node?: Maybe<
                      { __typename?: 'AddOn' } & Pick<
                        AddOn,
                        | 'id'
                        | 'entitlementNumber'
                        | 'dateAdded'
                        | 'units'
                        | 'name'
                        | 'nextBillDate'
                        | 'dateRemoved'
                        | 'dateLastBilled'
                        | 'billingStatus'
                        | 'provisioningStatus'
                      >
                    >;
                  }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchAddOnsParentEntitlementV2QueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchAddOnsParentEntitlementV2Query = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    | 'id'
    | 'billingCycle'
    | 'billingStatus'
    | 'entitlementNumber'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'offeringId'
    | 'productName'
    | 'sourceSystem'
    | 'plan'
    | 'edition'
    | 'cloudSiteHostname'
    | 'billingGroupId'
    | 'productId'
    | 'provisioningStatus'
    | 'isSandbox'
  > & {
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
    };
};

export type FetchCustomerContactForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchCustomerContactForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & {
    endCustomerContacts?: Maybe<
      Array<
        Maybe<
          { __typename?: 'EndCustomerContact' } & Pick<EndCustomerContact, 'accountId' | 'email' | 'name' | 'picture'>
        >
      >
    >;
  };
};

export type FetchSandboxForEntitlementQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
}>;

export type FetchSandboxForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      sandboxEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'billingFrequency'
              | 'productId'
              | 'baseProduct'
              | 'billingStatus'
              | 'entitlementNumber'
              | 'productName'
              | 'transactionAccountId'
              | 'billingGroupId'
              | 'billedUsers'
              | 'latestPeriodEndDate'
              | 'edition'
              | 'cloudSiteHostname'
              | 'trial'
              | 'isApp'
              | 'activeUsers'
            > & {
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type SearchCloudSiteQueryVariables = Exact<{
  query: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
}>;

export type SearchCloudSiteQuery = { __typename?: 'Query' } & {
  searchCloudSite?: Maybe<
    { __typename?: 'CloudSiteResult' } & Pick<CloudSiteResult, 'totalHits'> & {
        results?: Maybe<
          Array<Maybe<{ __typename?: 'SiteAccess' } & Pick<SiteAccess, 'cloudSiteUrl' | 'cloudSiteId' | 'migrated'>>>
        >;
      }
  >;
};

export type FetchSearchEmailDetailsQueryVariables = Exact<{
  query: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
}>;

export type FetchSearchEmailDetailsQuery = { __typename?: 'Query' } & {
  searchEmailDetails?: Maybe<
    { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
        pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
        edges?: Maybe<
          Array<
            Maybe<
              { __typename?: 'EmailEdge' } & Pick<EmailEdge, 'cursor'> & {
                  node: { __typename?: 'Email' } & Pick<
                    Email,
                    'id' | 'date' | 'mailbox' | 'messageId' | 'raw' | 'self' | 'size' | 'subject' | 'text'
                  > & {
                      attachments?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Attachment' } & Pick<
                              Attachment,
                              'checksum' | 'contentType' | 'contentDisposition' | 'filename' | 'size' | 'id' | 'self'
                            >
                          >
                        >
                      >;
                      from?: Maybe<
                        Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                      >;
                      to?: Maybe<
                        Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                      >;
                      bcc?: Maybe<
                        Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                      >;
                      cc?: Maybe<
                        Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                      >;
                      replyTo?: Maybe<
                        Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>
                      >;
                    };
                }
            >
          >
        >;
      }
  >;
};

export type InvoiceSearchQueryVariables = Exact<{
  searchOptions?: Maybe<InvoiceWhereFilter>;
}>;

export type InvoiceSearchQuery = { __typename?: 'Query' } & {
  invoiceSearch?: Maybe<
    { __typename?: 'InvoicesSearchResult' } & Pick<InvoicesSearchResult, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Invoice' } & Pick<
                Invoice,
                | 'id'
                | 'invoiceNumber'
                | 'sourceId'
                | 'domain'
                | 'status'
                | 'createdTimestamp'
                | 'billingGroupId'
                | 'sourceSystem'
                | 'upgradeCredits'
                | 'totalDiscount'
                | 'memo'
                | 'total'
                | 'taxes'
                | 'subtotal'
                | 'taxesPaymentCurrency'
                | 'transactionAccountId'
                | 'itemsTotal'
                | 'partnerAccountId'
                | 'partnerName'
                | 'paypalAccountEmail'
                | 'paymentCurrency'
                | 'paymentMethod'
                | 'promotionCode'
                | 'invoiceDueDays'
                | 'dueDate'
                | 'purchaseOrderNumber'
                | 'pdfLink'
              > & {
                  creditCard?: Maybe<
                    { __typename?: 'CreditCardDetails' } & Pick<
                      CreditCardDetails,
                      'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                    >
                  >;
                  dunningStatus?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'DunningStatus' } & Pick<
                          DunningStatus,
                          'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
                        >
                      >
                    >
                  >;
                  billTo?: Maybe<
                    { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                      InvoiceBillAndShipTo,
                      'domain' | 'fullName' | 'organization' | 'email' | 'taxId'
                    > & {
                        address?: Maybe<
                          { __typename?: 'InvoiceAddress' } & Pick<
                            InvoiceAddress,
                            'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                          >
                        >;
                      }
                  >;
                  shipTo?: Maybe<
                    { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                      InvoiceBillAndShipTo,
                      'domain' | 'fullName' | 'organization' | 'email' | 'taxId'
                    > & {
                        address?: Maybe<
                          { __typename?: 'InvoiceAddress' } & Pick<
                            InvoiceAddress,
                            'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                          >
                        >;
                      }
                  >;
                  lineItems?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'InvoiceLineItems' } & Pick<
                          InvoiceLineItems,
                          | 'id'
                          | 'edition'
                          | 'entitlementId'
                          | 'entitlementNumber'
                          | 'cloudSiteHostname'
                          | 'amount'
                          | 'subtotal'
                          | 'description'
                          | 'platform'
                          | 'productKey'
                          | 'startDate'
                          | 'invoiceLineItemId'
                          | 'endDate'
                          | 'promotionIds'
                          | 'quantity'
                        > & {
                            promotionItems?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                                      purpose?: Maybe<
                                        { __typename?: 'Purpose' } & Pick<
                                          Purpose,
                                          'reasonCode' | 'name' | 'invoiceNote'
                                        >
                                      >;
                                      benefits?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'Benefit' } & Pick<
                                              Benefit,
                                              'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                            discounts?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'InvoiceDiscounts' } & Pick<
                                    InvoiceDiscounts,
                                    'amount' | 'type' | 'percent' | 'reason' | 'reasonCode'
                                  >
                                >
                              >
                            >;
                            entitlement?: Maybe<
                              { __typename?: 'InvoiceEntitlementItem' } & Pick<
                                InvoiceEntitlementItem,
                                | 'id'
                                | 'entitlementNumber'
                                | 'baseProduct'
                                | 'cloudSiteId'
                                | 'platform'
                                | 'productId'
                                | 'productName'
                                | 'parentSen'
                                | 'sourceSystem'
                                | 'billingCycle'
                                | 'billingStatus'
                              > & {
                                  accountId: InvoiceEntitlementItem['orgId'];
                                  businessKey: InvoiceEntitlementItem['id'];
                                }
                            >;
                          }
                      >
                    >
                  >;
                  refunds?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'Refunds' } & Pick<
                          Refunds,
                          | 'id'
                          | 'creditNoteNumber'
                          | 'currency'
                          | 'createdDate'
                          | 'transactionAccountId'
                          | 'sourceSystem'
                          | 'memo'
                          | 'reason'
                          | 'refundId'
                          | 'status'
                          | 'type'
                          | 'total'
                          | 'arn'
                        > & {
                            refundItems?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'RefundItems' } & Pick<
                                    RefundItems,
                                    | 'id'
                                    | 'invoiceLineItemId'
                                    | 'entitlementId'
                                    | 'quantity'
                                    | 'description'
                                    | 'total'
                                    | 'totalExTax'
                                    | 'totalTax'
                                    | 'taxRate'
                                    | 'taxableAmount'
                                    | 'taxExemptAmount'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                  slaCredits?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'SlaCreditApplications' } & Pick<
                          SlaCreditApplications,
                          | 'amountExTax'
                          | 'amountIncTax'
                          | 'createdAt'
                          | 'creditExternalId'
                          | 'currency'
                          | 'currencyExchangeRate'
                          | 'modifiedAt'
                          | 'notes'
                          | 'taxAmount'
                          | 'taxRate'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchPartnerAccountsQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
}>;

export type FetchPartnerAccountsQuery = { __typename?: 'Query' } & {
  fetchPartnerAccounts?: Maybe<
    { __typename?: 'PartnerAccountResult' } & Pick<PartnerAccountResult, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'PartnerAccount' } & Pick<PartnerAccount, 'id' | 'name' | 'programLevelGlobal'> & {
                  contactAccountRole?: Maybe<{ __typename?: 'AccountRole' } & Pick<AccountRole, 'roles'>>;
                  domains?: Maybe<{ __typename?: 'PartnerDomain' } & Pick<PartnerDomain, 'main' | 'alternates'>>;
                }
            >
          >
        >;
      }
  >;
};

export type SearchContactDetailsQueryVariables = Exact<{
  query: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
}>;

export type SearchContactDetailsQuery = { __typename?: 'Query' } & {
  searchContact?: Maybe<
    { __typename?: 'ContactSearchResult' } & Pick<ContactSearchResult, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Contact' } & Pick<Contact, 'email' | 'fullName'> & {
                  address?: Maybe<
                    { __typename?: 'Address' } & Pick<
                      Address,
                      'address1' | 'address2' | 'state' | 'postalCode' | 'country'
                    >
                  >;
                  atlassianAccount?: Maybe<
                    { __typename?: 'AtlassianAccountDetails' } & Pick<AtlassianAccountDetails, 'id'>
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchQuoteForContactsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<QuoteSearchParameters>;
}>;

export type FetchQuoteForContactsQuery = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        quoteHeaders: { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Quote' } & Pick<
                    Quote,
                    | 'id'
                    | 'domain'
                    | 'createdDate'
                    | 'currency'
                    | 'expiryDate'
                    | 'grandTotal'
                    | 'status'
                    | 'quoteType'
                    | 'atNumber'
                    | 'sourceSystem'
                  > & {
                      billTo?: Maybe<
                        { __typename?: 'QuoteBillingContact' } & Pick<QuoteBillingContact, 'firstName' | 'lastName'>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'QuoteBillingContact' } & Pick<QuoteBillingContact, 'firstName' | 'lastName'>
                      >;
                    }
                >
              >
            >;
          };
      }
  >;
};

export type FetchDirectMatchForSearchQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;

export type FetchDirectMatchForSearchQuery = { __typename?: 'Query' } & {
  searchForDirectMatch?: Maybe<
    { __typename?: 'DirectMatch' } & Pick<
      DirectMatch,
      'id' | 'entity' | 'identifier' | 'parentEntity' | 'parentIdentifier' | 'sourceSystem'
    >
  >;
};

export type SearchInvoicesQueryQueryVariables = Exact<{
  searchOptions?: Maybe<InvoiceWhereFilter>;
}>;

export type SearchInvoicesQueryQuery = { __typename?: 'Query' } & {
  invoices?: Maybe<
    { __typename?: 'InvoicesSearchResult' } & Pick<InvoicesSearchResult, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Invoice' } & Pick<
                Invoice,
                | 'id'
                | 'invoiceNumber'
                | 'sourceId'
                | 'domain'
                | 'status'
                | 'createdTimestamp'
                | 'billingGroupId'
                | 'sourceSystem'
                | 'upgradeCredits'
                | 'totalDiscount'
                | 'memo'
                | 'total'
                | 'taxes'
                | 'subtotal'
                | 'taxesPaymentCurrency'
                | 'transactionAccountId'
                | 'itemsTotal'
                | 'partnerAccountId'
                | 'partnerName'
                | 'paypalAccountEmail'
                | 'paymentCurrency'
                | 'paymentMethod'
                | 'promotionCode'
                | 'invoiceDueDays'
                | 'dueDate'
                | 'purchaseOrderNumber'
                | 'pdfLink'
              > & {
                  creditCard?: Maybe<
                    { __typename?: 'CreditCardDetails' } & Pick<
                      CreditCardDetails,
                      'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                    >
                  >;
                  dunningStatus?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'DunningStatus' } & Pick<
                          DunningStatus,
                          'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
                        >
                      >
                    >
                  >;
                  billTo?: Maybe<
                    { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                      InvoiceBillAndShipTo,
                      'domain' | 'fullName' | 'organization' | 'email' | 'taxId'
                    > & {
                        address?: Maybe<
                          { __typename?: 'InvoiceAddress' } & Pick<
                            InvoiceAddress,
                            'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                          >
                        >;
                      }
                  >;
                  shipTo?: Maybe<
                    { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                      InvoiceBillAndShipTo,
                      'domain' | 'fullName' | 'organization' | 'email' | 'taxId'
                    > & {
                        address?: Maybe<
                          { __typename?: 'InvoiceAddress' } & Pick<
                            InvoiceAddress,
                            'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
                          >
                        >;
                      }
                  >;
                  lineItems?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'InvoiceLineItems' } & Pick<
                          InvoiceLineItems,
                          | 'id'
                          | 'edition'
                          | 'entitlementId'
                          | 'entitlementNumber'
                          | 'cloudSiteHostname'
                          | 'amount'
                          | 'subtotal'
                          | 'description'
                          | 'platform'
                          | 'productKey'
                          | 'startDate'
                          | 'invoiceLineItemId'
                          | 'endDate'
                          | 'promotionIds'
                          | 'quantity'
                        > & {
                            promotionItems?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                                      purpose?: Maybe<
                                        { __typename?: 'Purpose' } & Pick<
                                          Purpose,
                                          'reasonCode' | 'name' | 'invoiceNote'
                                        >
                                      >;
                                      benefits?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'Benefit' } & Pick<
                                              Benefit,
                                              'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                            discounts?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'InvoiceDiscounts' } & Pick<
                                    InvoiceDiscounts,
                                    'amount' | 'type' | 'percent' | 'reason' | 'reasonCode'
                                  >
                                >
                              >
                            >;
                            entitlement?: Maybe<
                              { __typename?: 'InvoiceEntitlementItem' } & Pick<
                                InvoiceEntitlementItem,
                                | 'id'
                                | 'entitlementNumber'
                                | 'baseProduct'
                                | 'cloudSiteId'
                                | 'platform'
                                | 'productId'
                                | 'productName'
                                | 'parentSen'
                                | 'sourceSystem'
                                | 'billingCycle'
                                | 'billingStatus'
                              > & {
                                  accountId: InvoiceEntitlementItem['orgId'];
                                  businessKey: InvoiceEntitlementItem['id'];
                                }
                            >;
                          }
                      >
                    >
                  >;
                  refunds?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'Refunds' } & Pick<
                          Refunds,
                          | 'id'
                          | 'creditNoteNumber'
                          | 'currency'
                          | 'createdDate'
                          | 'transactionAccountId'
                          | 'sourceSystem'
                          | 'memo'
                          | 'reason'
                          | 'refundId'
                          | 'status'
                          | 'type'
                          | 'total'
                          | 'arn'
                        > & {
                            refundItems?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'RefundItems' } & Pick<
                                    RefundItems,
                                    | 'id'
                                    | 'invoiceLineItemId'
                                    | 'entitlementId'
                                    | 'quantity'
                                    | 'description'
                                    | 'total'
                                    | 'totalExTax'
                                    | 'totalTax'
                                    | 'taxRate'
                                    | 'taxableAmount'
                                    | 'taxExemptAmount'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                  slaCredits?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'SlaCreditApplications' } & Pick<
                          SlaCreditApplications,
                          | 'amountExTax'
                          | 'amountIncTax'
                          | 'createdAt'
                          | 'creditExternalId'
                          | 'currency'
                          | 'currencyExchangeRate'
                          | 'modifiedAt'
                          | 'notes'
                          | 'taxAmount'
                          | 'taxRate'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchSupportIssueQueryVariables = Exact<{
  params: SupportIssueParams;
}>;

export type FetchSupportIssueQuery = { __typename?: 'Query' } & {
  supportIssue?: Maybe<
    { __typename?: 'SupportIssueResult' } & Pick<
      SupportIssueResult,
      | 'summary'
      | 'sourceSystem'
      | 'issueKey'
      | 'assigneeDisplayName'
      | 'assigneeEmailAddress'
      | 'reporterDisplayName'
      | 'reporterEmailAddress'
      | 'description'
      | 'platform'
      | 'createdTimestamp'
    > & {
        status?: Maybe<
          { __typename?: 'SupportIssueStatus' } & Pick<
            SupportIssueStatus,
            'id' | 'name' | 'categoryId' | 'categoryKey' | 'categoryName'
          >
        >;
        comments?: Maybe<
          Array<
            Maybe<
              { __typename?: 'SupportIssueComment' } & Pick<
                SupportIssueComment,
                'businessKey' | 'authorDisplayName' | 'authorEmail' | 'createdTimestamp' | 'body'
              >
            >
          >
        >;
      }
  >;
};

export type FetchAuditNoteAuthorsQueryVariables = Exact<{
  searchParams?: Maybe<CommerceNoteSearchParams>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchAuditNoteAuthorsQuery = { __typename?: 'Query' } & {
  auditNotes: { __typename?: 'AuditNoteConnection' } & {
    nodes: Array<Maybe<{ __typename?: 'AuditNote' } & Pick<AuditNote, 'id' | 'author' | 'contactKey'>>>;
  };
};

export type FetchAuditNotesForEntityQueryVariables = Exact<{
  searchParams?: Maybe<CommerceNoteSearchParams>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchAuditNotesForEntityQuery = { __typename?: 'Query' } & {
  auditNotes: { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
      nodes: Array<
        Maybe<
          { __typename?: 'AuditNote' } & Pick<
            AuditNote,
            'id' | 'body' | 'author' | 'created' | 'contactKey' | 'creditNoteStatus'
          > & {
              metadata?: Maybe<
                Array<Maybe<{ __typename?: 'AuditNoteMetadata' } & Pick<AuditNoteMetadata, 'fieldName' | 'fieldValue'>>>
              >;
            }
        >
      >;
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
    };
};

export type FetchCloudSubscriptionDetailsForContactQueryVariables = Exact<{
  searchParams: CloudSubscriptionSearchParams;
  searchOptions?: Maybe<CloudSubscriptionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchCloudSubscriptionDetailsForContactQuery = { __typename?: 'Query' } & {
  cloudSubscription?: Maybe<
    { __typename?: 'CloudSubscriptionConnection' } & Pick<CloudSubscriptionConnection, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'CloudSubscription' } & Pick<
                CloudSubscription,
                | 'accountId'
                | 'id'
                | 'sen'
                | 'businessKey'
                | 'accountOwnerEmail'
                | 'billingContactEmail'
                | 'baseProduct'
                | 'billingCycle'
                | 'billingStatus'
                | 'cloudSiteId'
                | 'cloudSiteUrl'
                | 'cloudSiteCustomHostname'
                | 'latestPeriodEndDate'
                | 'unitCount'
                | 'createdDate'
                | 'endTimestamp'
                | 'roles'
                | 'provisioningStatus'
                | 'entitlementNumber'
                | 'firstPeriodEndDate'
                | 'firstPeriodStartDate'
                | 'latestPeriodStartDate'
                | 'updatedDate'
                | 'licenseLevel'
                | 'platform'
                | 'planType'
                | 'pageName'
                | 'isCloud'
                | 'renewalAction'
                | 'productName'
                | 'productId'
                | 'isAddon'
                | 'subscriptionId'
                | 'sourceSystem'
                | 'sources'
                | 'userTier'
                | 'edition'
                | 'editionKey'
                | 'bitbucketAccountType'
                | 'nextBillingTimestamp'
                | 'billingFrequency'
                | 'trial'
                | 'trialEndDate'
                | 'isSandbox'
                | 'isApp'
                | 'logoId'
              > & {
                  upgradeTrial?: Maybe<
                    { __typename?: 'UpgradeTrialDetails' } & Pick<
                      UpgradeTrialDetails,
                      'offeringId' | 'offeringName' | 'baseOfferingName'
                    >
                  >;
                  transactionDetail?: Maybe<
                    { __typename?: 'TransactionDetailObj' } & Pick<
                      TransactionDetailObj,
                      'transactionAccountId' | 'billToCompany' | 'shipToCompany'
                    >
                  >;
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'country'
                      | 'state'
                      | 'phone'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<
                        PaymentOnTerms,
                        'id' | 'type' | 'paymentIssue' | 'default'
                      > & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                  scheduledChanges?: Maybe<
                    { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
                  >;
                  subscription?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'SubscriptionDetails' } & {
                          subscriptionPeriod?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'SubscriptionPeriodDetails' } & {
                                  chargeQuantities?: Maybe<
                                    Array<
                                      Maybe<
                                        { __typename?: 'ChargeQuantity' } & Pick<
                                          ChargeQuantity,
                                          'chargeElement' | 'quantity' | 'lastUpdatedAt'
                                        >
                                      >
                                    >
                                  >;
                                }
                              >
                            >
                          >;
                        }
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchEntitlementForInvoiceLineItemQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchEntitlementForInvoiceLineItemQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id' | 'activeUsers'> & {
      offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
      pricingPlan?: Maybe<
        { __typename?: 'PricingPlan' } & Pick<
          PricingPlan,
          'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
        > & {
            tiers?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'PricingTiers' } & Pick<
                    PricingTiers,
                    'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchEntitlementsByBillingDateQueryVariables = Exact<{
  id: Scalars['ID'];
  entitlementId?: Maybe<Scalars['String']>;
  isTermed?: Maybe<Scalars['Boolean']>;
  isBillingCycleChange?: Maybe<Scalars['Boolean']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchEntitlementsByBillingDateQuery = { __typename?: 'Query' } & {
  entitlementsGroupByBillingDate?: Maybe<
    { __typename?: 'EntitlementsGroupByBillingDate' } & Pick<EntitlementsGroupByBillingDate, 'id'> & {
        billingDateGroup?: Maybe<
          Array<
            Maybe<
              { __typename?: 'entitlementGroup' } & Pick<EntitlementGroup, 'billingDate'> & {
                  entitlements?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'EntitlementDetails' } & Pick<
                          EntitlementDetails,
                          | 'entitlementNumber'
                          | 'edition'
                          | 'billingFrequency'
                          | 'cloudSiteHostname'
                          | 'productName'
                          | 'productId'
                          | 'latestPeriodEndDate'
                          | 'endTimestamp'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchInvoiceForSidebarQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInvoiceForSidebarQueryQuery = { __typename?: 'Query' } & {
  invoice: { __typename?: 'Invoice' } & Pick<
    Invoice,
    | 'id'
    | 'invoiceNumber'
    | 'sourceId'
    | 'selfServeBACInvoiceLink'
    | 'domain'
    | 'status'
    | 'createdTimestamp'
    | 'billingGroupId'
    | 'sourceSystem'
    | 'upgradeCredits'
    | 'totalDiscount'
    | 'memo'
    | 'total'
    | 'taxes'
    | 'subtotal'
    | 'taxesPaymentCurrency'
    | 'transactionAccountId'
    | 'itemsTotal'
    | 'partnerAccountId'
    | 'partnerName'
    | 'paypalAccountEmail'
    | 'paymentCurrency'
    | 'paymentMethod'
    | 'promotionCode'
    | 'invoiceDueDays'
    | 'dueDate'
    | 'purchaseOrderNumber'
    | 'pdfLink'
    | 'appliedBalance'
  > & {
      creditCard?: Maybe<
        { __typename?: 'CreditCardDetails' } & Pick<
          CreditCardDetails,
          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
        >
      >;
      dunningStatus?: Maybe<
        Array<
          Maybe<
            { __typename?: 'DunningStatus' } & Pick<
              DunningStatus,
              'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
            >
          >
        >
      >;
      billTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      shipTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      lineItems?: Maybe<Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceFragment>>>;
      coupledLineItems?: Maybe<{ __typename?: 'ProductAppLineItemData' } & CoupledLineItemsOnInvoiceFragment>;
      dstLineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & {
              metadata?: Maybe<{ __typename?: 'LineItemMetaData' } & Pick<LineItemMetaData, 'parentItemId' | 'type'>>;
            } & LineItemDetailsForInvoiceFragment
          >
        >
      >;
      refunds?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Refunds' } & Pick<
              Refunds,
              | 'id'
              | 'creditNoteNumber'
              | 'currency'
              | 'createdDate'
              | 'transactionAccountId'
              | 'sourceSystem'
              | 'memo'
              | 'reason'
              | 'refundId'
              | 'status'
              | 'type'
              | 'total'
              | 'arn'
              | 'requestedBy'
            > & {
                refundItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RefundItems' } & Pick<
                        RefundItems,
                        | 'id'
                        | 'invoiceLineItemId'
                        | 'entitlementId'
                        | 'quantity'
                        | 'description'
                        | 'total'
                        | 'totalExTax'
                        | 'totalTax'
                        | 'taxRate'
                        | 'taxableAmount'
                        | 'taxExemptAmount'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      slaCredits?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SlaCreditApplications' } & Pick<
              SlaCreditApplications,
              | 'amountExTax'
              | 'amountIncTax'
              | 'createdAt'
              | 'creditExternalId'
              | 'currency'
              | 'currencyExchangeRate'
              | 'modifiedAt'
              | 'notes'
              | 'taxAmount'
              | 'taxRate'
            >
          >
        >
      >;
    };
};

export type FetchPaymentMethodsForTransactionAccountOnTabQueryVariables = Exact<{
  id: Scalars['ID'];
  viewSubscriptionsLink?: Maybe<Scalars['Boolean']>;
}>;

export type FetchPaymentMethodsForTransactionAccountOnTabQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue'>)
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue'>)
                  >;
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                }
            >
          >;
        }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<
                      CreditCard,
                      'id' | 'paymentIssue' | 'type' | 'default' | 'hasLinkedSubscriptions'
                    > & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      | 'totalCreditLimit'
                      | 'paymentMethod'
                      | 'id'
                      | 'paymentIssue'
                      | 'type'
                      | 'default'
                      | 'hasLinkedSubscriptions'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      customerBalances?: Maybe<{ __typename?: 'CustomerBalancesRecord' } & Pick<CustomerBalancesRecord, 'usd'>>;
    };
};

export type FetchPricingHistoryForEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  filters?: Maybe<EntitlementDetailsFilters>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchPricingHistoryForEntitlementQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      pricingPlanHistory: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'invoiceNumber'
                  | 'status'
                  | 'billingGroupId'
                  | 'sourceSystem'
                  | 'totalDiscount'
                  | 'total'
                  | 'taxes'
                  | 'subtotal'
                  | 'taxesPaymentCurrency'
                  | 'itemsTotal'
                  | 'paymentCurrency'
                  | 'paidDate'
                > & {
                    lineItems?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'InvoiceLineItems' } & Pick<
                            InvoiceLineItems,
                            | 'id'
                            | 'edition'
                            | 'entitlementId'
                            | 'pricingPlanId'
                            | 'entitlementNumber'
                            | 'cloudSiteHostname'
                            | 'amount'
                            | 'total'
                            | 'subtotal'
                            | 'description'
                            | 'platform'
                            | 'productKey'
                            | 'startDate'
                            | 'invoiceLineItemId'
                            | 'endDate'
                            | 'quantity'
                          > & {
                              discounts?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'InvoiceDiscounts' } & Pick<
                                      InvoiceDiscounts,
                                      'amount' | 'type' | 'percent' | 'reason' | 'reasonCode'
                                    >
                                  >
                                >
                              >;
                              pricingPlan?: Maybe<
                                { __typename?: 'PricingPlan' } & Pick<
                                  PricingPlan,
                                  | 'id'
                                  | 'pricingPlanType'
                                  | 'description'
                                  | 'type'
                                  | 'amount'
                                  | 'status'
                                  | 'billingFrequency'
                                  | 'currency'
                                >
                              >;
                            }
                        >
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

export type FetchProductsForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchProductsForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        products?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'InvoiceGroupProduct' } & Pick<
                      InvoiceGroupProduct,
                      | 'billingFrequency'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'id'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                    >
                  >
                >
              >;
            }
        >;
      }
  >;
};

export type FetchProductsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchProductsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      products?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'billingFrequency'
                    | 'billingStatus'
                    | 'entitlementNumber'
                    | 'transactionAccountNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchCloudSitesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchCloudSitesForTransactionAccountQuery = { __typename?: 'Query' } & {
  cloudSitesForTransactionAccount: Array<
    Maybe<{ __typename?: 'CloudSiteDetail' } & Pick<CloudSiteDetail, 'cloudSiteId' | 'cloudSiteHostname'>>
  >;
};

export type FetchCloudSitesForBillingpProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCloudSitesForBillingpProfileQuery = { __typename?: 'Query' } & {
  cloudSitesForBillingProfile: Array<
    Maybe<{ __typename?: 'CloudSiteDetail' } & Pick<CloudSiteDetail, 'cloudSiteId' | 'cloudSiteHostname'>>
  >;
};

export type FetchSubscriptionsForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSubscriptionsForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        productSubscriptions?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'InvoiceGroupProduct' } & Pick<
                      InvoiceGroupProduct,
                      | 'billingFrequency'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'id'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                      | 'edition'
                      | 'cloudSiteHostname'
                      | 'billedUsers'
                      | 'trial'
                      | 'isSandbox'
                      | 'isApp'
                      | 'nextBillingTimestamp'
                    >
                  >
                >
              >;
            }
        >;
      }
  >;
};

export type FetchSubscriptionsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSubscriptionsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptions?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'billingFrequency'
                    | 'billingStatus'
                    | 'entitlementNumber'
                    | 'transactionAccountNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                    | 'edition'
                    | 'cloudSiteHostname'
                    | 'billingGroupId'
                    | 'provisioningStatus'
                    | 'id'
                    | 'billedUsers'
                    | 'trial'
                    | 'isSandbox'
                    | 'isApp'
                    | 'nextBillingTimestamp'
                  > & {
                      upgradeTrial?: Maybe<
                        { __typename?: 'UpgradeTrialDetails' } & Pick<
                          UpgradeTrialDetails,
                          'offeringName' | 'offeringId'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchEntitlementsGroupByCloudSiteQueryVariables = Exact<{
  invoiceGroupId: Scalars['ID'];
}>;

export type FetchEntitlementsGroupByCloudSiteQuery = { __typename?: 'Query' } & {
  entitlementsGroupByCloudSite?: Maybe<
    Array<
      Maybe<
        { __typename?: 'EntitlementsGroupByCloudSiteConnection' } & Pick<
          EntitlementsGroupByCloudSiteConnection,
          'cloudSiteId'
        > & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EntitlementsGroupByCloudSite' } & Pick<
                    EntitlementsGroupByCloudSite,
                    'entitlementNumber' | 'productName' | 'logoId' | 'productId' | 'cloudSiteHostname'
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FetchLinkedEntitlementsForTableQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
}>;

export type FetchLinkedEntitlementsForTableQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'productId'
              | 'entitlementNumber'
              | 'productName'
              | 'billingCycle'
              | 'billingFrequency'
              | 'latestPeriodEndDate'
              | 'endTimestamp'
              | 'nextBillingTimestamp'
              | 'offeringId'
              | 'subscriptionId'
              | 'billingStatus'
              | 'isApp'
              | 'transactionAccountId'
              | 'billingGroupId'
              | 'edition'
              | 'isSandbox'
              | 'parentSen'
              | 'logoId'
              | 'userTier'
            > & {
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType'>>;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchParentEntitlementDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type FetchParentEntitlementDetailsQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      parentEntitlementDetails?: Maybe<
        { __typename?: 'LinkedDestinationEntitlement' } & Pick<
          LinkedDestinationEntitlement,
          | 'entitlementId'
          | 'productId'
          | 'entitlementNumber'
          | 'productName'
          | 'latestPeriodEndDate'
          | 'offeringId'
          | 'subscriptionId'
          | 'billingStatus'
          | 'isApp'
        > & {
            relatesToEntitlements?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'RelatedEntitlementDetails' } & Pick<
                    RelatedEntitlementDetails,
                    'relationshipType' | 'entitlementId' | 'relationshipId'
                  >
                >
              >
            >;
            scheduledChanges?: Maybe<
              { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
            >;
          }
      >;
    };
};

export type ValidateApplicablePromocodeQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  promoCodes?: Maybe<Array<Maybe<PromoCode>> | Maybe<PromoCode>>;
}>;

export type ValidateApplicablePromocodeQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & {
    promoCodesApplicable?: Maybe<
      { __typename?: 'PromoCodeResponseDTO' } & Pick<
        PromoCodeResponseDto,
        'promotionId' | 'redeemedCount' | 'maxRedemptions' | 'notApplicablePromotionCodesWithReason'
      > & {
          promotions?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Promotion' } & Pick<
                  Promotion,
                  | 'id'
                  | 'title'
                  | 'maxRedemptions'
                  | 'promotionCodeType'
                  | 'status'
                  | 'cycleInterval'
                  | 'pricingType'
                  | 'isPromotionCustomisable'
                  | 'type'
                > & {
                    benefits?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Benefit' } & Pick<
                            Benefit,
                            'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                          > & {
                              customisable?: Maybe<
                                { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                    value?: Maybe<
                                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                                        BenefitCustomisableValue,
                                        'type' | 'lowerBound' | 'upperBound'
                                      >
                                    >;
                                    iterations?: Maybe<
                                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                                        BenefitCustomisableValue,
                                        'type' | 'lowerBound' | 'upperBound'
                                      >
                                    >;
                                  }
                              >;
                            }
                        >
                      >
                    >;
                    promotionWindow?: Maybe<
                      { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                    >;
                    eligibilityRules?: Maybe<
                      { __typename?: 'EligibilityRule' } & Pick<
                        EligibilityRule,
                        | 'products'
                        | 'cycleInterval'
                        | 'pricingType'
                        | 'partnerType'
                        | 'partnerTier'
                        | 'saleTransitionType'
                        | 'currency'
                      >
                    >;
                    applicationReason?: Maybe<
                      { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                          customisable?: Maybe<
                            { __typename?: 'PromotionReasonCustomisable' } & {
                              id?: Maybe<
                                { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                    anyOf?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'ReasonCustomisableObj' } & Pick<
                                            ReasonCustomisableObj,
                                            'readableName' | 'id'
                                          >
                                        >
                                      >
                                    >;
                                  }
                              >;
                            }
                          >;
                        }
                    >;
                    customisableReasons?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>
                        >
                      >
                    >;
                  }
              >
            >
          >;
        }
    >;
  };
};

export type FetchAvailableCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type FetchAvailableCountriesQuery = { __typename?: 'Query' } & {
  availableCountries: { __typename?: 'BillingCountryConnection' } & Pick<BillingCountryConnection, 'totalCount'> & {
      nodes: Array<Maybe<{ __typename?: 'BillingCountry' } & Pick<BillingCountry, 'isoCode' | 'name'>>>;
    };
};

export type FetchAvailableStatesForCountriesQueryVariables = Exact<{
  isoCode?: Maybe<Scalars['String']>;
}>;

export type FetchAvailableStatesForCountriesQuery = { __typename?: 'Query' } & {
  availableStatesForCountry: { __typename?: 'BillingCountryStateConnection' } & Pick<
    BillingCountryStateConnection,
    'totalCount'
  > & { nodes: Array<Maybe<{ __typename?: 'BillingCountryState' } & Pick<BillingCountryState, 'isoCode' | 'name'>>> };
  availableTaxLabels: Array<
    Maybe<
      { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
          taxIdLabels?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TasstaxIdLabel' } & Pick<TasstaxIdLabel, 'description' | 'displayName' | 'type'> & {
                    metadata?: Maybe<
                      { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                          labels?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                  TassTaxIdLabelMetadataLabel,
                                  'default' | 'label' | 'vatStatus'
                                >
                              >
                            >
                          >;
                        }
                    >;
                  }
              >
            >
          >;
        }
    >
  >;
};

export type FetchInflightInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInflightInvoiceQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id' | 'pendingInvoices'>;
};

export type FetchInflightInvoiceForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchInflightInvoiceForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<{ __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'pendingInvoices'>>;
};

export type EntitlementDetailsForTxaFragment = { __typename?: 'TransactionAccountProduct' } & Pick<
  TransactionAccountProduct,
  | 'billingFrequency'
  | 'entitlementNumber'
  | 'transactionAccountNumber'
  | 'latestPeriodEndDate'
  | 'latestPeriodStartDate'
  | 'productId'
  | 'productName'
  | 'baseProduct'
  | 'billingStatus'
  | 'edition'
  | 'cloudSiteHostname'
  | 'provisioningStatus'
  | 'billingGroupId'
  | 'id'
  | 'billedUsers'
  | 'trial'
  | 'isSandbox'
  | 'activeUsers'
  | 'isApp'
  | 'nextBillingTimestamp'
  | 'logoId'
  | 'userTier'
  | 'trialEndDate'
  | 'endTimestamp'
  | 'offeringId'
  | 'pricingPlanId'
  | 'version'
> & {
    pricingPlan?: Maybe<
      { __typename?: 'PricingPlan' } & Pick<
        PricingPlan,
        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
      > & {
          tiers?: Maybe<
            Array<
              Maybe<
                { __typename?: 'PricingTiers' } & Pick<PricingTiers, 'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'>
              >
            >
          >;
        }
    >;
    upgradeTrial?: Maybe<
      { __typename?: 'UpgradeTrialDetails' } & Pick<
        UpgradeTrialDetails,
        'offeringName' | 'offeringId' | 'baseOfferingName'
      >
    >;
    scheduledChanges?: Maybe<
      { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
    >;
    relatesFromEntitlements?: Maybe<
      Array<
        Maybe<
          { __typename?: 'RelatedEntitlementDetails' } & Pick<
            RelatedEntitlementDetails,
            'entitlementId' | 'relationshipType'
          >
        >
      >
    >;
  };

export type ProductAppSubscriptionForTxaFragment = { __typename?: 'ProductAppSubscription' } & {
  products: Array<Maybe<{ __typename?: 'TransactionAccountProduct' } & EntitlementDetailsForTxaFragment>>;
  apps: Array<Maybe<{ __typename?: 'TransactionAccountProduct' } & EntitlementDetailsForTxaFragment>>;
};

export type FetchProductAppSubscriptionsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchProductAppSubscriptionsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    productAndAppSubscriptions?: Maybe<
      { __typename?: 'ProductAppSubscriptionData' } & {
        jira: { __typename?: 'ProductAppSubscription' } & ProductAppSubscriptionForTxaFragment;
        statuspage: { __typename?: 'ProductAppSubscription' } & ProductAppSubscriptionForTxaFragment;
        confluence: { __typename?: 'ProductAppSubscription' } & ProductAppSubscriptionForTxaFragment;
        other?: Maybe<{ __typename?: 'ProductAppSubscription' } & ProductAppSubscriptionForTxaFragment>;
      }
    >;
  };
};

export type EntitlementDetailsForBillingProfileFragment = { __typename?: 'InvoiceGroupProduct' } & Pick<
  InvoiceGroupProduct,
  | 'billingGroupId'
  | 'billingFrequency'
  | 'entitlementNumber'
  | 'id'
  | 'latestPeriodEndDate'
  | 'latestPeriodStartDate'
  | 'productId'
  | 'productName'
  | 'baseProduct'
  | 'billingStatus'
  | 'edition'
  | 'cloudSiteHostname'
  | 'provisioningStatus'
  | 'billedUsers'
  | 'trial'
  | 'isSandbox'
  | 'isApp'
  | 'activeUsers'
  | 'nextBillingTimestamp'
  | 'userTier'
  | 'logoId'
  | 'endTimestamp'
  | 'trialStartDate'
  | 'trialEndDate'
> & {
    upgradeTrial?: Maybe<
      { __typename?: 'UpgradeTrialDetails' } & Pick<
        UpgradeTrialDetails,
        'offeringName' | 'offeringId' | 'baseOfferingName'
      >
    >;
    scheduledChanges?: Maybe<
      { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
    >;
  };

export type ProductAppSubscriptionForBillingProfileFragment = {
  __typename?: 'ProductAppSubscriptionForInvoiceGroup';
} & {
  products: Array<Maybe<{ __typename?: 'InvoiceGroupProduct' } & EntitlementDetailsForBillingProfileFragment>>;
  apps: Array<Maybe<{ __typename?: 'InvoiceGroupProduct' } & EntitlementDetailsForBillingProfileFragment>>;
};

export type FetchProductAppSubscriptionsForBillingProfileQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchProductAppSubscriptionsForBillingProfileQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & {
      productAndAppSubscriptions?: Maybe<
        { __typename?: 'ProductAppSubscriptionForInvoiceGroupData' } & {
          jira: {
            __typename?: 'ProductAppSubscriptionForInvoiceGroup';
          } & ProductAppSubscriptionForBillingProfileFragment;
          statuspage: {
            __typename?: 'ProductAppSubscriptionForInvoiceGroup';
          } & ProductAppSubscriptionForBillingProfileFragment;
          confluence: {
            __typename?: 'ProductAppSubscriptionForInvoiceGroup';
          } & ProductAppSubscriptionForBillingProfileFragment;
          other?: Maybe<
            { __typename?: 'ProductAppSubscriptionForInvoiceGroup' } & ProductAppSubscriptionForBillingProfileFragment
          >;
        }
      >;
    }
  >;
};

export type FetchTransactionAccountBalanceDetailsQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountBalanceDetailsQueryQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    transactionAccountBalanceEntity?: Maybe<
      Array<
        Maybe<
          { __typename?: 'txaCustomerBalanceDetails' } & Pick<
            TxaCustomerBalanceDetails,
            'createdAt' | 'type' | 'amount' | 'invoiceNumber' | 'endingAmount'
          >
        >
      >
    >;
  };
};

export type FetchInvoicesForAccountBalanceQueryVariables = Exact<{
  where?: Maybe<InvoiceWhereFilter>;
  size?: Maybe<Scalars['Int']>;
}>;

export type FetchInvoicesForAccountBalanceQuery = { __typename?: 'Query' } & {
  accountInvoices?: Maybe<
    { __typename?: 'InvoicesSearchResult' } & Pick<InvoicesSearchResult, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Invoice' } & Pick<Invoice, 'id' | 'invoiceNumber' | 'billingGroupId'> & {
                  shipTo?: Maybe<
                    { __typename?: 'InvoiceBillAndShipTo' } & Pick<
                      InvoiceBillAndShipTo,
                      'id' | 'organization' | 'fullName'
                    > & {
                        address?: Maybe<
                          { __typename?: 'InvoiceAddress' } & Pick<
                            InvoiceAddress,
                            'address1' | 'address2' | 'city' | 'country' | 'postalCode' | 'state'
                          >
                        >;
                      }
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type ProvisionedResourceMetadataObject = {
  __typename?: 'ProvisionedResourceMetadataObject';
  organisationId: Maybe<Scalars['String']>;
  organisationName: Maybe<Scalars['String']>;
};

export type FetchOrgDetailsForPpcQueryVariables = Exact<{
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  transactionAccountId?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<SearchOptions>;
}>;

export type FetchOrgDetailsForPpcQuery = { __typename?: 'Query' } & {
  fetchOrganisations: { __typename?: 'SearchOrganisationsConnection' } & Pick<
    SearchOrganisationsConnection,
    'totalCount'
  > & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ProvisionedResourceMetadataObject' } & Pick<
              ProvisionedResourceMetadataObject,
              'organisationId' | 'organisationName'
            >
          >
        >
      >;
    };
};

export type FetchBillingProfilesForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  fetchNodes?: Maybe<Scalars['Boolean']>;
}>;

export type FetchBillingProfilesForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'InvoiceGroup' } & Pick<
                    InvoiceGroup,
                    | 'id'
                    | 'name'
                    | 'currency'
                    | 'transactionAccountId'
                    | 'isActive'
                    | 'invoiceGroupNumber'
                    | 'shipToPriceEligibility'
                    | 'createdAt'
                  > & {
                      shipToParty?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          | 'id'
                          | 'name'
                          | 'addressLine1'
                          | 'addressLine2'
                          | 'city'
                          | 'country'
                          | 'state'
                          | 'phone'
                          | 'postcode'
                          | 'taxId'
                        > & {
                            taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                            taxLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                      taxIdLabels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TasstaxIdLabel' } & Pick<
                                              TasstaxIdLabel,
                                              'description' | 'displayName' | 'type'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >;
                      defaultPaymentMethod?: Maybe<
                        | ({ __typename?: 'CreditCard' } & Pick<
                            CreditCard,
                            'id' | 'type' | 'paymentIssue' | 'default'
                          > & {
                              card?: Maybe<
                                { __typename?: 'CreditCardDetails' } & Pick<
                                  CreditCardDetails,
                                  'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                >
                              >;
                            })
                        | ({ __typename?: 'PaymentOnTerms' } & Pick<
                            PaymentOnTerms,
                            'id' | 'type' | 'paymentIssue' | 'default'
                          > & {
                              terms?: Maybe<
                                { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                  PaymentOnTermsDetails,
                                  'invoiceDueDays' | 'payOnStatement'
                                >
                              >;
                            })
                      >;
                      purchaseOrder?: Maybe<
                        { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                          InvoiceGroupPurchaseOrder,
                          'number' | 'oneTimeUse'
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchInternalBillingProfilesForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  fetchNodes?: Maybe<Scalars['Boolean']>;
  relatedDomains: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
}>;

export type FetchInternalBillingProfilesForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      internalUseBillingProfiles?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'InvoiceGroup' } & Pick<
                    InvoiceGroup,
                    | 'id'
                    | 'name'
                    | 'currency'
                    | 'transactionAccountId'
                    | 'isActive'
                    | 'invoiceGroupNumber'
                    | 'shipToPriceEligibility'
                    | 'numberOfCloudsites'
                    | 'numberOfSubscriptions'
                    | 'createdAt'
                  > & {
                      shipToParty?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          | 'id'
                          | 'name'
                          | 'addressLine1'
                          | 'addressLine2'
                          | 'city'
                          | 'country'
                          | 'state'
                          | 'phone'
                          | 'postcode'
                          | 'taxId'
                        > & {
                            taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                            taxLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                      taxIdLabels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TasstaxIdLabel' } & Pick<
                                              TasstaxIdLabel,
                                              'description' | 'displayName' | 'type'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >;
                      defaultPaymentMethod?: Maybe<
                        | ({ __typename?: 'CreditCard' } & Pick<
                            CreditCard,
                            'id' | 'type' | 'paymentIssue' | 'default'
                          > & {
                              card?: Maybe<
                                { __typename?: 'CreditCardDetails' } & Pick<
                                  CreditCardDetails,
                                  'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                >
                              >;
                            })
                        | ({ __typename?: 'PaidAchCard' } & Pick<
                            PaidAchCard,
                            'id' | 'type' | 'paymentIssue' | 'default'
                          >)
                        | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                              payPal?: Maybe<
                                { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'email' | 'name'>
                              >;
                            })
                        | ({ __typename?: 'PaymentOnTerms' } & Pick<
                            PaymentOnTerms,
                            'id' | 'type' | 'paymentIssue' | 'default'
                          > & {
                              terms?: Maybe<
                                { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                  PaymentOnTermsDetails,
                                  'invoiceDueDays' | 'payOnStatement'
                                >
                              >;
                            })
                      >;
                      purchaseOrder?: Maybe<
                        { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                          InvoiceGroupPurchaseOrder,
                          'number' | 'oneTimeUse'
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchTransactionAccountForCreateBillingProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForCreateBillingProfileQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'paymentMethod' | 'id' | 'type' | 'default' | 'paymentIssue'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                  | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        payPal?: Maybe<
                          { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'name' | 'email'>
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type FetchAvailableInvoiceGroupsForOrderReviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAvailableInvoiceGroupsForOrderReviewQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'shipToPriceEligibility'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<
                        PaymentOnTerms,
                        'id' | 'type' | 'paymentIssue' | 'default'
                      > & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchPaymentMethodsForOrderReviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaymentMethodsForOrderReviewQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  > & {
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'paymentIssue' | 'type' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      customerBalances?: Maybe<{ __typename?: 'CustomerBalancesRecord' } & Pick<CustomerBalancesRecord, 'usd'>>;
    };
};

export type FetchBillToAddressByTransactionAccountIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchBillToAddressByTransactionAccountIdQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    billToParty?: Maybe<
      { __typename?: 'CommerceAddress' } & Pick<
        CommerceAddress,
        'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
      > & {
          taxIds?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                    metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                  }
              >
            >
          >;
          taxLabels?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                    taxIdLabels?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TasstaxIdLabel' } & Pick<
                            TasstaxIdLabel,
                            'description' | 'displayName' | 'type'
                          > & {
                              metadata?: Maybe<
                                { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                    labels?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                            TassTaxIdLabelMetadataLabel,
                                            'default' | 'label' | 'vatStatus'
                                          >
                                        >
                                      >
                                    >;
                                  }
                              >;
                            }
                        >
                      >
                    >;
                  }
              >
            >
          >;
        }
    >;
  };
};

export type FetchEntitlementDetailsForAppLinksPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchEntitlementDetailsForAppLinksPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    | 'entitlementNumber'
    | 'id'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'transactionAccountId'
    | 'edition'
    | 'platform'
    | 'productId'
    | 'productName'
    | 'plan'
    | 'subscriptionId'
    | 'cloudSiteHostname'
    | 'unitCount'
    | 'activeUsers'
    | 'isApp'
    | 'billingGroupId'
    | 'nextBillingTimestamp'
  > & { billingFrequency: EntitlementDetails['billingCycle']; maxUnitCount: EntitlementDetails['unitCount'] } & {
      relatesFromEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'RelatedEntitlementDetails' } & Pick<
              RelatedEntitlementDetails,
              'entitlementId' | 'relationshipType'
            >
          >
        >
      >;
    };
};

export type FetchEntitlementsForFamilyContainerPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchEntitlementsForFamilyContainerPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      entitlements?: Maybe<
        { __typename?: 'EssotEntitlementConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'EssotEntitlement' } & Pick<EssotEntitlement, 'id' | 'entitlementNumber' | 'unitCount'>
              >
            >
          >;
        }
      >;
    };
};

export type FetchSoldToAddressesForOrderReviewQueryVariables = Exact<{
  searchParams?: Maybe<ShipToPartySearchParams>;
}>;

export type FetchSoldToAddressesForOrderReviewQuery = { __typename?: 'Query' } & {
  shipToParty?: Maybe<
    { __typename?: 'ShipToPartyConnection' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'CommerceAddress' } & Pick<
              CommerceAddress,
              | 'id'
              | 'name'
              | 'addressLine1'
              | 'addressLine2'
              | 'city'
              | 'state'
              | 'country'
              | 'postcode'
              | 'taxId'
              | 'priceEligibility'
            >
          >
        >
      >;
    }
  >;
};

type PaymentMethodFields_CreditCard_Fragment = { __typename?: 'CreditCard' } & Pick<
  CreditCard,
  'id' | 'paymentIssue' | 'type' | 'default'
> & {
    card?: Maybe<
      { __typename?: 'CreditCardDetails' } & Pick<
        CreditCardDetails,
        'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
      >
    >;
  };

type PaymentMethodFields_PaymentOnTerms_Fragment = { __typename?: 'PaymentOnTerms' } & Pick<
  PaymentOnTerms,
  'totalCreditLimit' | 'paymentMethod' | 'id' | 'paymentIssue' | 'type' | 'default'
> & {
    terms?: Maybe<
      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays' | 'payOnStatement'>
    >;
  };

export type PaymentMethodFieldsFragment =
  | PaymentMethodFields_CreditCard_Fragment
  | PaymentMethodFields_PaymentOnTerms_Fragment;

export type CommerceAddressFieldsFragment = { __typename?: 'CommerceAddress' } & Pick<
  CommerceAddress,
  'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
> & {
    taxIds?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
              metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
            }
        >
      >
    >;
    taxLabels?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
              taxIdLabels?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TasstaxIdLabel' } & Pick<TasstaxIdLabel, 'description' | 'displayName' | 'type'> & {
                        metadata?: Maybe<
                          { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                              labels?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                      TassTaxIdLabelMetadataLabel,
                                      'default' | 'label' | 'vatStatus'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
            }
        >
      >
    >;
  };

export type FetchBillingProfileNameByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchBillingProfileNameByIdQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<{ __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'name' | 'invoiceGroupNumber'>>;
};

export type FetchContactDetailsFromContactServiceQueryVariables = Exact<{
  resourceAri?: Maybe<Scalars['String']>;
  contactType?: Maybe<Array<Maybe<ContactType>> | Maybe<ContactType>>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchContactDetailsFromContactServiceQuery = { __typename?: 'Query' } & {
  contactsByResource?: Maybe<
    Array<
      Maybe<
        { __typename?: 'ContactInfo' } & Pick<
          ContactInfo,
          'accountId' | 'email' | 'name' | 'picture' | 'updatedAt' | 'isPrimary'
        >
      >
    >
  >;
};

export type FetchEmailsForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  partnerAccountId: Scalars['String'];
  searchParams?: Maybe<BillingAdminEmailSearchParams>;
}>;

export type FetchEmailsForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      emails?: Maybe<
        { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EmailEdge' } & {
                    node: { __typename?: 'Email' } & Pick<Email, 'subject' | 'id' | 'date'> & {
                        attachments?: Maybe<
                          Array<
                            Maybe<{ __typename?: 'Attachment' } & Pick<Attachment, 'contentType' | 'filename' | 'id'>>
                          >
                        >;
                      };
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchInvoicesForSoldToAddressesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoicesForSoldToAddressesQuery = { __typename?: 'Query' } & {
  invoiceGroupsForShipToPartyIds?: Maybe<
    { __typename?: 'InvoiceGroupsForShipToPartyIds' } & Pick<
      InvoiceGroupsForShipToPartyIds,
      'ids' | 'shipToPartiesBillingGroupIds'
    > & {
        invoices?: Maybe<
          { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Invoice' } & Pick<
                      Invoice,
                      | 'id'
                      | 'status'
                      | 'invoiceNumber'
                      | 'sourceSystem'
                      | 'paymentMethod'
                      | 'paymentMethodId'
                      | 'creditCardMaskedNumber'
                      | 'dueDate'
                      | 'paymentCurrency'
                      | 'purchaseOrderNumber'
                      | 'pdfLink'
                    > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                        refunds?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Refunds' } & Pick<
                                Refunds,
                                | 'id'
                                | 'type'
                                | 'createdDate'
                                | 'creditNoteNumber'
                                | 'sourceSystem'
                                | 'total'
                                | 'currency'
                                | 'status'
                                | 'arn'
                              >
                            >
                          >
                        >;
                        dunningStatus?: Maybe<
                          Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                        >;
                      }
                  >
                >
              >;
              pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
            }
        >;
      }
  >;
};

export type FetchCreditNoteWithInvoicesQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type FetchCreditNoteWithInvoicesQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      refundedInvoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceDueDays'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'prePaymentCreditNotesAmount'
                    | 'paymentCurrency'
                    | 'transactionAccountId'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                              | 'creditNoteId'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'DunningStatus' } & Pick<
                              DunningStatus,
                              'errorCode' | 'nextPaymentAttempDate'
                            >
                          >
                        >
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchOverdueInvoicesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchOverdueInvoicesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      overdueInvoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'invoiceDueDays'
                    | 'paymentMethod'
                    | 'dueDate'
                    | 'paymentCurrency'
                    | 'pdfLink'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      creditCard?: Maybe<
                        { __typename?: 'CreditCardDetails' } & Pick<CreditCardDetails, 'last4Numbers'>
                      >;
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & {
                          address?: Maybe<
                            { __typename?: 'InvoiceAddress' } & Pick<
                              InvoiceAddress,
                              'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                            >
                          >;
                        }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchCloudSitesForTxaQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchCloudSitesForTxaQuery = { __typename?: 'Query' } & {
  cloudSitesForTransactionAccount: Array<
    Maybe<{ __typename?: 'CloudSiteDetail' } & Pick<CloudSiteDetail, 'cloudSiteId' | 'cloudSiteHostname'>>
  >;
};

export type FetchEntitlementDetailsForOrderHistoryPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchEntitlementDetailsForOrderHistoryPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'cloudSiteHostname' | 'cloudSiteId'
  >;
};

export type FetchInvoiceGroupsForOrderHistoryTableSearchQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchInvoiceGroupsForOrderHistoryTableSearchQuery = { __typename?: 'Query' } & {
  invoiceGroups?: Maybe<
    { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
        nodes: Array<Maybe<{ __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'>>>;
      }
  >;
};

export type FetchIGPurchaseOrderInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchIGPurchaseOrderInPpcQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

export type FetchOrdersByTransactionAccountIdInPpcQueryVariables = Exact<{
  transactionAccountId: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  fetchIsExternallyBilled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchOrdersByTransactionAccountIdInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'shipToPriceEligibility'> & {
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                }
            >
          >;
        }
      >;
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<
                  Order,
                  | 'id'
                  | 'orderNumber'
                  | 'billingContactEmail'
                  | 'created'
                  | 'contextSubject'
                  | 'contextSubjectId'
                  | 'sourceSystem'
                  | 'purchaseOrderNumber'
                > & {
                    billTo?: Maybe<
                      { __typename?: 'OrderBillTo' } & Pick<
                        OrderBillTo,
                        | 'billToCompanyName'
                        | 'billToAccountId'
                        | 'billToCity'
                        | 'billToAddress1'
                        | 'billToAddress2'
                        | 'billToCountry'
                        | 'billToState'
                        | 'billToPostalCode'
                      >
                    >;
                    shipTo?: Maybe<
                      { __typename?: 'OrderShipTo' } & Pick<
                        OrderShipTo,
                        | 'shipToCompanyName'
                        | 'shipToAccountId'
                        | 'shipToCity'
                        | 'shipToAddress1'
                        | 'shipToAddress2'
                        | 'shipToCountry'
                        | 'shipToState'
                        | 'shipToPostalCode'
                      >
                    >;
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    metadataObj?: Maybe<
                      { __typename?: 'OrderMetadataObj' } & Pick<
                        OrderMetadataObj,
                        | 'supportTicketNumber'
                        | 'handNote'
                        | 'termsOfTransfer'
                        | 'reasonCode'
                        | 'newBillingAdmin'
                        | 'currentBillingAdmin'
                        | 'contractId'
                        | 'contractType'
                      >
                    >;
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'quantity'
                              | 'type'
                              | 'skipTrial'
                              | 'status'
                              | 'nextBillingAnchorTimestamp'
                              | 'familyContainerId'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                              | 'edition'
                              | 'entitlementId'
                              | 'entitlementNumber'
                              | 'parentEntitlementId'
                              | 'productName'
                              | 'productId'
                              | 'cloudSiteHostname'
                              | 'logoId'
                              | 'isSandbox'
                              | 'isAddOn'
                            > & {
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        'id' | 'title' | 'status' | 'type' | 'promotionCode'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                          eligibilityRules?: Maybe<
                                            { __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>
                                          >;
                                        }
                                    >
                                  >
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'>
                                >;
                                orderLineItemsPurchaseMetadata?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                        OrderLineItemsPurchaseMetadataType,
                                        'fieldName' | 'fieldValue'
                                      >
                                    >
                                  >
                                >;
                                orderLineItemsAccountModification?: Maybe<
                                  { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                    OrderLineItemsAccountModification,
                                    'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                                  >
                                >;
                                quoteLineItemDetailsReference?: Maybe<
                                  { __typename?: 'QuoteLineItemDetailsReference' } & Pick<
                                    QuoteLineItemDetailsReference,
                                    'quoteId' | 'quoteLineItemId'
                                  >
                                >;
                                metadata?: Maybe<
                                  { __typename?: 'OrderLineItemMetadata' } & Pick<
                                    OrderLineItemMetadata,
                                    'legacyInvoiceId'
                                  >
                                >;
                                orderLineBillingBehaviourObject?: Maybe<
                                  { __typename?: 'OrderLineBillingBehaviour' } & Pick<
                                    OrderLineBillingBehaviour,
                                    'startDate' | 'type'
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type FetchCompaniesInPpcQueryVariables = Exact<{
  searchParams?: Maybe<ShipToPartySearchParams>;
}>;

export type FetchCompaniesInPpcQuery = { __typename?: 'Query' } & {
  shipToParty?: Maybe<
    { __typename?: 'ShipToPartyConnection' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'CommerceAddress' } & Pick<
              CommerceAddress,
              | 'id'
              | 'name'
              | 'addressLine1'
              | 'addressLine2'
              | 'city'
              | 'state'
              | 'country'
              | 'postcode'
              | 'taxId'
              | 'priceEligibility'
            >
          >
        >
      >;
    }
  >;
};

export type FetchInvoiceGroupsInQuoteTableQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
  transactionAccountId: Scalars['ID'];
}>;

export type FetchInvoiceGroupsInQuoteTableQuery = { __typename?: 'Query' } & {
  invoiceGroups?: Maybe<
    { __typename?: 'InvoiceGroupConnection' } & {
      nodes: Array<Maybe<{ __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'>>>;
    }
  >;
};

export type FetchEntitlementsCountByInvoiceGroupIdsQueryVariables = Exact<{
  transactionAccountId: Scalars['String'];
  invoiceGroupIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type FetchEntitlementsCountByInvoiceGroupIdsQuery = { __typename?: 'Query' } & {
  entitlementCountsForInvoiceGroupIds?: Maybe<
    Array<
      Maybe<
        { __typename?: 'InvoiceGroupsForInvoiceGroupIds' } & Pick<
          InvoiceGroupsForInvoiceGroupIds,
          'invoiceGroupId' | 'totalEntitlementsCount'
        >
      >
    >
  >;
};

export type FetchInvoiceGroupsCountBySoldToAddressNamesQueryVariables = Exact<{
  transactionAccountId: Scalars['String'];
  shipToPartyNames: Array<Scalars['String']> | Scalars['String'];
}>;

export type FetchInvoiceGroupsCountBySoldToAddressNamesQuery = { __typename?: 'Query' } & {
  invoiceGroupsCountForShipToPartyNames?: Maybe<
    Array<
      Maybe<
        { __typename?: 'InvoiceGroupsForShipToPartyNames' } & Pick<
          InvoiceGroupsForShipToPartyNames,
          'shipToPartyIds' | 'shipToPartyName' | 'totalCount'
        >
      >
    >
  >;
};

export type FetchShipToGroupedQueryVariables = Exact<{
  searchParams?: Maybe<ShipToPartySearchParams>;
  pageParams?: Maybe<ShipToPartyPageParams>;
}>;

export type FetchShipToGroupedQuery = { __typename?: 'Query' } & {
  shipToPartyGrouped?: Maybe<
    { __typename?: 'ShipToPartyAggregatedConnection' } & Pick<ShipToPartyAggregatedConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'ShipToPartyAggregated' } & Pick<ShipToPartyAggregated, 'key'> & {
                  data?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          | 'name'
                          | 'id'
                          | 'addressLine1'
                          | 'addressLine2'
                          | 'city'
                          | 'state'
                          | 'country'
                          | 'postcode'
                          | 'priceEligibility'
                          | 'taxId'
                        > & {
                            taxIds?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                                    }
                                >
                              >
                            >;
                            taxLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                      taxIdLabels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TasstaxIdLabel' } & Pick<
                                              TasstaxIdLabel,
                                              'description' | 'displayName' | 'type'
                                            > & {
                                                metadata?: Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                                    TassTaxIdLabelMetadata,
                                                    'type'
                                                  > & {
                                                      labels?: Maybe<
                                                        Array<
                                                          Maybe<
                                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                              TassTaxIdLabelMetadataLabel,
                                                              'default' | 'label' | 'vatStatus'
                                                            >
                                                          >
                                                        >
                                                      >;
                                                    }
                                                >;
                                              }
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchShipToInPpcQueryVariables = Exact<{
  searchParams?: Maybe<ShipToPartySearchParams>;
  pageParams?: Maybe<ShipToPartyPageParams>;
}>;

export type FetchShipToInPpcQuery = { __typename?: 'Query' } & {
  shipToParty?: Maybe<
    { __typename?: 'ShipToPartyConnection' } & Pick<ShipToPartyConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                | 'name'
                | 'id'
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'state'
                | 'country'
                | 'postcode'
                | 'priceEligibility'
                | 'taxId'
                | 'taxExempt'
                | 'hasLinkedSubscriptions'
              > & {
                  taxIds?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                            metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                          }
                      >
                    >
                  >;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  > & {
                                      metadata?: Maybe<
                                        { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                          TassTaxIdLabelMetadata,
                                          'type'
                                        > & {
                                            labels?: Maybe<
                                              Array<
                                                Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                    TassTaxIdLabelMetadataLabel,
                                                    'default' | 'label' | 'vatStatus'
                                                  >
                                                >
                                              >
                                            >;
                                          }
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >
          >
        >;
        pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
      }
  >;
};

export type FetchInvoiceGroupsForSoldToAddressNamesQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchInvoiceGroupsForSoldToAddressNamesQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name' | 'invoiceGroupNumber'> & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'country'
                        | 'state'
                        | 'phone'
                        | 'postcode'
                      >
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type BillingProfileDetailsForFetchBillingProfilesForBulkTransferQueryFragment = {
  __typename?: 'InvoiceGroupConnection';
} & Pick<InvoiceGroupConnection, 'totalCount'> & {
    nodes: Array<
      Maybe<
        { __typename?: 'InvoiceGroup' } & Pick<
          InvoiceGroup,
          'id' | 'name' | 'currency' | 'transactionAccountId' | 'isActive' | 'shipToPriceEligibility' | 'createdAt'
        > & {
            shipToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                | 'id'
                | 'name'
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'country'
                | 'state'
                | 'phone'
                | 'postcode'
                | 'taxId'
              > & {
                  taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    payPal?: Maybe<
                      { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'name' | 'email'>
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<
                  PaymentOnTerms,
                  'id' | 'type' | 'paymentIssue' | 'default'
                > & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<
                        PaymentOnTermsDetails,
                        'invoiceDueDays' | 'payOnStatement'
                      >
                    >;
                  })
            >;
            purchaseOrder?: Maybe<
              { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
            >;
          }
      >
    >;
    pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
  };

export type FetchBillingProfilesForBulkTransferQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isFetchBillingProfilesViaCCPEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchBillingProfilesForBulkTransferQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        {
          __typename?: 'InvoiceGroupConnection';
        } & BillingProfileDetailsForFetchBillingProfilesForBulkTransferQueryFragment
      >;
      billingProfilesFromCCP?: Maybe<
        {
          __typename?: 'InvoiceGroupConnection';
        } & BillingProfileDetailsForFetchBillingProfilesForBulkTransferQueryFragment
      >;
    };
};

export type FetchEntitlementListForIncludedProductsQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchEntitlementListForIncludedProductsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TransactionAccountProduct' } & Pick<
                  TransactionAccountProduct,
                  'id' | 'entitlementNumber' | 'productId' | 'productName' | 'cloudSiteHostname' | 'logoId'
                >
              >
            >
          >;
        }
      >;
    };
};

export type FetchEntitlementListForDownloadCsvQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isRestricted?: Maybe<Scalars['Boolean']>;
}>;

export type FetchEntitlementListForDownloadCsvQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TransactionAccountProduct' } & Pick<
                  TransactionAccountProduct,
                  | 'id'
                  | 'activeUsers'
                  | 'baseProduct'
                  | 'createdDate'
                  | 'billingStatus'
                  | 'entitlementNumber'
                  | 'latestPeriodEndDate'
                  | 'productId'
                  | 'cloudSiteHostname'
                  | 'billingFrequency'
                  | 'edition'
                  | 'billingGroupId'
                  | 'linkedAppsId'
                  | 'orgName'
                > & {
                    endCustomerContacts?: Maybe<
                      Array<{ __typename?: 'EndCustomerContact' } & Pick<EndCustomerContact, 'name'>>
                    >;
                    subscriptionTimestamps?: Maybe<
                      { __typename?: 'SubscriptionTimeStamps' } & Pick<
                        SubscriptionTimeStamps,
                        'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
                      >
                    >;
                    upgradeTrial?: Maybe<
                      { __typename?: 'UpgradeTrialDetails' } & Pick<
                        UpgradeTrialDetails,
                        'startTimestamp' | 'endTimestamp'
                      >
                    >;
                  }
              >
            >
          >;
        }
      >;
    };
};

export type FetchPendingInvoicesForBillingProfileQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId?: Maybe<Scalars['ID']>;
}>;

export type FetchPendingInvoicesForBillingProfileQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'transactionAccountId' | 'pendingInvoices'>
  >;
};

export type FetchEntitlementsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchEntitlementsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      entitlements?: Maybe<
        { __typename?: 'EssotEntitlementConnection' } & Pick<EssotEntitlementConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EssotEntitlement' } & Pick<
                    EssotEntitlement,
                    | 'id'
                    | 'entitlementNumber'
                    | 'transactionAccountId'
                    | 'cloudSiteId'
                    | 'cloudSiteHostname'
                    | 'billingFrequency'
                    | 'edition'
                    | 'provisioningStatus'
                    | 'organisationId'
                    | 'productName'
                  > & {
                      billingStatus: EssotEntitlement['status'];
                      productId: EssotEntitlement['productCatalogId'];
                      latestPeriodEndDate: EssotEntitlement['lastPeriodEndDate'];
                      billingGroupId: EssotEntitlement['invoiceGroupId'];
                      billedUsers: EssotEntitlement['unitCount'];
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchInvoiceGroupDetailsForSubscriptionTablePpcQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchInvoiceGroupDetailsForSubscriptionTablePpcQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'state' | 'postcode'
          >
        >;
      }
  >;
};

export type FetchInvoicesByEntitlementIdPpcQueryVariables = Exact<{
  searchOptions?: Maybe<InvoiceWhereFilter>;
}>;

export type FetchInvoicesByEntitlementIdPpcQuery = { __typename?: 'Query' } & {
  invoices?: Maybe<
    { __typename?: 'InvoicesSearchResult' } & {
      results?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Invoice' } & Pick<Invoice, 'id' | 'paymentCurrency' | 'pricingCurrency'> & {
                lineItems?: Maybe<
                  Array<Maybe<{ __typename?: 'InvoiceLineItems' } & Pick<InvoiceLineItems, 'entitlementId' | 'amount'>>>
                >;
              }
          >
        >
      >;
    }
  >;
};

export type FetchProductFamiliesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<ProductSubscriptionsFilterOptions>;
}>;

export type FetchProductFamiliesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productFamilies?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    'id' | 'entitlementNumber' | 'transactionAccountNumber' | 'cloudSiteHostname'
                  > & {
                      relatesToEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'entitlementId' | 'relationshipType'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchProductsAndLinkedEntitlementsQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  searchLinkedEntitlementParams?: Maybe<SearchLinkedEntitlementParams>;
}>;

export type FetchProductsAndLinkedEntitlementsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    'id' | 'productId' | 'offeringId' | 'productName'
                  > & {
                      relatesFromEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      relatesToEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RelatedEntitlementDetails' } & Pick<
                              RelatedEntitlementDetails,
                              'relationshipType' | 'entitlementId'
                            >
                          >
                        >
                      >;
                      linkedEntitlements?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
                              LinkedDestinationEntitlement,
                              | 'entitlementId'
                              | 'productId'
                              | 'productName'
                              | 'offeringId'
                              | 'subscriptionId'
                              | 'isApp'
                              | 'transactionAccountId'
                              | 'billingGroupId'
                              | 'edition'
                              | 'isSandbox'
                              | 'billingStatus'
                            > & {
                                relatesFromEntitlements?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                                        RelatedEntitlementDetails,
                                        'entitlementId' | 'relationshipType'
                                      >
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchShipToIdsByCompanyNameQueryVariables = Exact<{
  searchParams?: Maybe<ShipToPartySearchParams>;
  pageParams?: Maybe<ShipToPartyPageParams>;
}>;

export type FetchShipToIdsByCompanyNameQuery = { __typename?: 'Query' } & {
  shipToParty?: Maybe<
    { __typename: 'ShipToPartyConnection' } & Pick<ShipToPartyConnection, 'totalCount'> & {
        nodes?: Maybe<Array<Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'name' | 'id'>>>>;
        pageInfo?: Maybe<{ __typename: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
      }
  >;
};

export type FetchTransactionAccountForDownloadCsvQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForDownloadCsvQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country'
                    >
                  >;
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                            >
                          >;
                        })
                    | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue'>)
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchInvoiceGroupPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchInvoiceGroupPpcQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<
      InvoiceGroup,
      | 'id'
      | 'name'
      | 'currency'
      | 'updatePaymentMethodLink'
      | 'transactionAccountId'
      | 'transactionAccountNumber'
      | 'invoiceGroupNumber'
      | 'isActive'
      | 'recipients'
    > & {
        termPaymentStatus?: Maybe<
          { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
        >;
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'shipToPriceEligibility' | 'isActive'> &
            CommerceAddressFieldsFragment
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & PaymentMethodFields_CreditCard_Fragment)
          | ({ __typename?: 'PaymentOnTerms' } & PaymentMethodFields_PaymentOnTerms_Fragment)
        >;
        transactionAccount?: Maybe<
          { __typename?: 'TransactionAccount' } & Pick<
            TransactionAccount,
            'id' | 'displayName' | 'updatePaymentMethodLink' | 'partnerAccountId'
          > & {
              billToParty?: Maybe<{ __typename?: 'CommerceAddress' } & CommerceAddressFieldsFragment>;
              availablePaymentMethods?: Maybe<
                { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                    nodes?: Maybe<
                      Array<
                        Maybe<
                          | ({ __typename?: 'CreditCard' } & PaymentMethodFields_CreditCard_Fragment)
                          | ({ __typename?: 'PaymentOnTerms' } & PaymentMethodFields_PaymentOnTerms_Fragment)
                        >
                      >
                    >;
                  }
              >;
            }
        >;
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

export type FetchTransactionAccountForEditBillingProfilePaneQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForEditBillingProfilePaneQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & Pick<CommerceAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CommerceAddress' } & Pick<
                    CommerceAddress,
                    | 'name'
                    | 'id'
                    | 'taxId'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'city'
                    | 'country'
                    | 'state'
                    | 'postcode'
                  > & { taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id'>>>> }
                >
              >
            >;
          }
      >;
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'id' | 'name' | 'taxId' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'state' | 'postcode'
        > & { taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id'>>>> }
      >;
    };
};

export type BillingProfileDetailsforFetchBillingProfilesForCustomerFragment = {
  __typename?: 'InvoiceGroupConnection';
} & {
  nodes: Array<
    Maybe<
      { __typename?: 'InvoiceGroup' } & Pick<
        InvoiceGroup,
        'id' | 'name' | 'isActive' | 'currency' | 'shipToPriceEligibility'
      > & {
          shipToParty?: Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'id' | 'name'>>;
          defaultPaymentMethod?: Maybe<
            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type'>)
            | ({ __typename?: 'PayPal' } & Pick<PayPal, 'type'>)
            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type'>)
          >;
        }
    >
  >;
};

export type FetchBillingProfilesForCustomerQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions: Array<Maybe<FilterOption>> | Maybe<FilterOption>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  isFetchBillingProfilesViaCCPEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchBillingProfilesForCustomerQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    billingProfiles?: Maybe<
      { __typename?: 'InvoiceGroupConnection' } & BillingProfileDetailsforFetchBillingProfilesForCustomerFragment
    >;
    billingProfilesFromCCP?: Maybe<
      { __typename?: 'InvoiceGroupConnection' } & BillingProfileDetailsforFetchBillingProfilesForCustomerFragment
    >;
  };
};

export type FetchCustomersForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  viewTaxRelatedInfo?: Maybe<Scalars['Boolean']>;
}>;

export type FetchCustomersForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & Pick<CommerceAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'name' | 'id' | 'isActive'>>>
            >;
          }
      >;
    };
};

export type FetchInvoiceGroupDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId?: Maybe<Scalars['ID']>;
}>;

export type FetchInvoiceGroupDetailsQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<
      InvoiceGroup,
      'id' | 'name' | 'currency' | 'transactionAccountId' | 'invoiceGroupNumber' | 'isActive'
    > & {
        termPaymentStatus?: Maybe<
          { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
        >;
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'shipToPriceEligibility'> &
            CommerceAddressFieldsFragment
        >;
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

export type ValidateApplicablePromocodePpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  promoCodes?: Maybe<Array<Maybe<PromoCode>> | Maybe<PromoCode>>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type ValidateApplicablePromocodePpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & {
    promoCodesApplicable?: Maybe<
      { __typename?: 'PromoCodeResponseDTO' } & Pick<
        PromoCodeResponseDto,
        'promotionId' | 'redeemedCount' | 'notApplicablePromotionCodesWithReason'
      > & {
          promotions?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Promotion' } & Pick<
                  Promotion,
                  | 'id'
                  | 'title'
                  | 'maxRedemptions'
                  | 'promotionCodeType'
                  | 'status'
                  | 'cycleInterval'
                  | 'pricingType'
                  | 'isPromotionCustomisable'
                  | 'type'
                > & {
                    benefits?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Benefit' } & Pick<
                            Benefit,
                            'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                          > & {
                              values?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'BenefitsValueObj' } & Pick<BenefitsValueObj, 'appliedOn' | 'value'>
                                  >
                                >
                              >;
                              customisable?: Maybe<
                                { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                    value?: Maybe<
                                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                                        BenefitCustomisableValue,
                                        'type' | 'lowerBound' | 'upperBound'
                                      >
                                    >;
                                    iterations?: Maybe<
                                      { __typename?: 'BenefitCustomisableValue' } & Pick<
                                        BenefitCustomisableValue,
                                        'type' | 'lowerBound' | 'upperBound'
                                      >
                                    >;
                                  }
                              >;
                            }
                        >
                      >
                    >;
                    promotionWindow?: Maybe<
                      { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                    >;
                    eligibilityRules?: Maybe<
                      { __typename?: 'EligibilityRule' } & Pick<
                        EligibilityRule,
                        | 'products'
                        | 'cycleInterval'
                        | 'pricingType'
                        | 'partnerType'
                        | 'partnerTier'
                        | 'saleTransitionType'
                        | 'currency'
                      >
                    >;
                    applicationReason?: Maybe<
                      { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                          customisable?: Maybe<
                            { __typename?: 'PromotionReasonCustomisable' } & {
                              id?: Maybe<
                                { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                    anyOf?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'ReasonCustomisableObj' } & Pick<
                                            ReasonCustomisableObj,
                                            'readableName' | 'id'
                                          >
                                        >
                                      >
                                    >;
                                  }
                              >;
                            }
                          >;
                        }
                    >;
                    customisableReasons?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>
                        >
                      >
                    >;
                  }
              >
            >
          >;
        }
    >;
  };
};

export type FetchAvailableInvoiceGroupsForOrderSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAvailableInvoiceGroupsForOrderSummaryQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name' | 'shipToPriceEligibility'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<
                        PaymentOnTerms,
                        'id' | 'type' | 'paymentIssue' | 'default'
                      > & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPpcFragment = {
  __typename?: 'InvoiceGroupConnection';
} & Pick<InvoiceGroupConnection, 'totalCount'> & {
    nodes: Array<
      Maybe<
        { __typename?: 'InvoiceGroup' } & Pick<
          InvoiceGroup,
          'id' | 'name' | 'currency' | 'transactionAccountId' | 'isActive' | 'shipToPriceEligibility' | 'createdAt'
        > & {
            shipToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                | 'id'
                | 'name'
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'country'
                | 'state'
                | 'phone'
                | 'postcode'
                | 'taxId'
              > & {
                  taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue' | 'default'> & {
                    payPal?: Maybe<
                      { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'name' | 'email'>
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<
                  PaymentOnTerms,
                  'id' | 'type' | 'paymentIssue' | 'default'
                > & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<
                        PaymentOnTermsDetails,
                        'invoiceDueDays' | 'payOnStatement'
                      >
                    >;
                  })
            >;
            purchaseOrder?: Maybe<
              { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
            >;
          }
      >
    >;
    pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
  };

export type FetchCustomerBillingProfilesForTxaInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  refetchDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  isFetchBillingProfilesViaCCPEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchCustomerBillingProfilesForTxaInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingProfiles?: Maybe<
        {
          __typename?: 'InvoiceGroupConnection';
        } & BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPpcFragment
      >;
      billingProfilesFromCCP?: Maybe<
        {
          __typename?: 'InvoiceGroupConnection';
        } & BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPpcFragment
      >;
    };
};

export type FetchAssociatedBillingAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
  currency?: Maybe<Scalars['String']>;
}>;

export type FetchAssociatedBillingAccountsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<
          TermDetailsAccountConnection,
          | 'totalCount'
          | 'totalCreditLimit'
          | 'creditOutstanding'
          | 'availableCreditLimit'
          | 'paymentMethod'
          | 'currency'
          | 'status'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TermDetailsAccount' } & Pick<
                    TermDetailsAccount,
                    | 'creditOutstanding'
                    | 'status'
                    | 'customerName'
                    | 'transactionAccountNumber'
                    | 'transactionAccountId'
                    | 'pendingInvoiceRequestsTotal'
                    | 'taxId'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchTermDetailsPpcQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTermDetailsPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber'
  > & {
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'>)
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'paymentMethod' | 'id' | 'type'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                >
              >
            >;
          }
      >;
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'taxId' | 'state' | 'taxExempt' | 'addressLine1' | 'addressLine2' | 'city' | 'country'
        > & {
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'displayName' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'type' | 'displayName' | 'description'
                            > & {
                                metadata?: Maybe<
                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                      labels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                              TassTaxIdLabelMetadataLabel,
                                              'label' | 'vatStatus' | 'default'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<
          TermDetailsAccountConnection,
          | 'totalCount'
          | 'totalCreditLimit'
          | 'creditOutstanding'
          | 'availableCreditLimit'
          | 'paymentMethod'
          | 'currency'
          | 'status'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TermDetailsAccount' } & Pick<
                    TermDetailsAccount,
                    | 'creditOutstanding'
                    | 'status'
                    | 'customerName'
                    | 'transactionAccountNumber'
                    | 'pendingInvoiceRequestsTotal'
                    | 'taxId'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchTermPaymentAuditTrailsPpcQueryVariables = Exact<{
  searchParams?: Maybe<TermPaymentAuditTrailSearchParams>;
  searchOptions?: Maybe<TermPaymentAuditTrailsSearchOptions>;
}>;

export type FetchTermPaymentAuditTrailsPpcQuery = { __typename?: 'Query' } & {
  termPaymentAuditTrails: { __typename?: 'TermPaymentAuditTrailsConnection' } & Pick<
    TermPaymentAuditTrailsConnection,
    'totalCount'
  > & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'TermPaymentAuditTrail' } & Pick<
              TermPaymentAuditTrail,
              'id' | 'comments' | 'updatedBy' | 'createdAt' | 'revisionNumber' | 'revisionType'
            >
          >
        >
      >;
    };
};

export type FetchCustomersForTransactionAccountV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchCustomersForTransactionAccountV2Query = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & Pick<CommerceAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CommerceAddress' } & Pick<
                    CommerceAddress,
                    | 'name'
                    | 'id'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'city'
                    | 'state'
                    | 'country'
                    | 'postcode'
                    | 'taxId'
                    | 'shipToPriceEligibility'
                    | 'taxExempt'
                    | 'hasLinkedSubscriptions'
                  > & {
                      taxIds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                                metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                              }
                          >
                        >
                      >;
                      taxLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                taxIdLabels?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TasstaxIdLabel' } & Pick<
                                        TasstaxIdLabel,
                                        'description' | 'displayName' | 'type'
                                      > & {
                                          metadata?: Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                              TassTaxIdLabelMetadata,
                                              'type'
                                            > & {
                                                labels?: Maybe<
                                                  Array<
                                                    Maybe<
                                                      { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                        TassTaxIdLabelMetadataLabel,
                                                        'default' | 'label' | 'vatStatus'
                                                      >
                                                    >
                                                  >
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchInvoiceGroupsBySoldToAddressIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type FetchInvoiceGroupsBySoldToAddressIdsQuery = { __typename?: 'Query' } & {
  invoiceGroupsForShipToPartyIds?: Maybe<
    { __typename?: 'InvoiceGroupsForShipToPartyIds' } & Pick<
      InvoiceGroupsForShipToPartyIds,
      'shipToPartiesBillingGroupIds'
    >
  >;
};

export type FetchPaymentMethodsForTxaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchPaymentMethodsForTxaQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'paymentIssue' | 'type' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type SoldToAddressForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  soldToAddressId: Scalars['ID'];
}>;

export type SoldToAddressForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      soldToAddress?: Maybe<
        { __typename?: 'SoldToAddressConnection' } & Pick<SoldToAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SoldToAddress' } & Pick<
                    SoldToAddress,
                    | 'id'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'type'
                    | 'version'
                    | 'name'
                    | 'taxId'
                    | 'city'
                    | 'country'
                    | 'phone'
                    | 'postcode'
                    | 'state'
                    | 'shipToPriceEligibility'
                  > & {
                      taxIds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'displayName' | 'taxExempt'> & {
                                metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                              }
                          >
                        >
                      >;
                      taxLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                taxIdLabels?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TasstaxIdLabel' } & Pick<
                                        TasstaxIdLabel,
                                        'type' | 'displayName' | 'description'
                                      > & {
                                          metadata?: Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                              TassTaxIdLabelMetadata,
                                              'type'
                                            > & {
                                                labels?: Maybe<
                                                  Array<
                                                    Maybe<
                                                      { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                        TassTaxIdLabelMetadataLabel,
                                                        'label' | 'vatStatus' | 'default'
                                                      >
                                                    >
                                                  >
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchPaymentMethodsOfTransactionAccountForDetailPageQueryVariables = Exact<{
  id: Scalars['ID'];
  fetchAch?: Maybe<Scalars['Boolean']>;
}>;

export type FetchPaymentMethodsOfTransactionAccountForDetailPageQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'updatePaymentMethodLink' | 'billToPartyPricingEligibilty'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'paymentIssue'>)
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'paymentIssue'>)
                    | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'type' | 'paymentIssue'>)
                  >;
                }
            >
          >;
        }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'paymentMethod' | 'id' | 'paymentIssue' | 'type' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                  | ({ __typename?: 'PayPal' } & Pick<PayPal, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        payPal?: Maybe<
                          { __typename?: 'PayPalAccountDetails' } & Pick<PayPalAccountDetails, 'name' | 'email'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      customerBalances?: Maybe<{ __typename?: 'CustomerBalancesRecord' } & Pick<CustomerBalancesRecord, 'usd' | 'jpy'>>;
      billToParty?: Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'country' | 'taxExempt'>>;
      billingAccountsList?: Maybe<
        { __typename?: 'TermDetailsAccountConnection' } & Pick<
          TermDetailsAccountConnection,
          'availableCreditLimit' | 'currency' | 'status'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TermDetailsAccount' } & Pick<
                    TermDetailsAccount,
                    'pendingInvoiceRequestsTotal' | 'transactionAccountId' | 'creditOutstanding'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchTransactionAccountDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountDetailsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    | 'id'
    | 'partnerAccountId'
    | 'transactionAccountNumber'
    | 'billToPartyPricingEligibilty'
    | 'displayName'
    | 'isPartner'
    | 'status'
    | 'updatePaymentMethodLink'
  > & {
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
        > & {
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            > & {
                                metadata?: Maybe<
                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                      labels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                              TassTaxIdLabelMetadataLabel,
                                              'default' | 'label' | 'vatStatus'
                                            >
                                          >
                                        >
                                      >;
                                    }
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      productSubscriptions?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'TransactionAccountProduct' } & Pick<
                  TransactionAccountProduct,
                  | 'billingFrequency'
                  | 'billingStatus'
                  | 'entitlementNumber'
                  | 'pricingPlanId'
                  | 'transactionAccountNumber'
                  | 'latestPeriodEndDate'
                  | 'latestPeriodStartDate'
                  | 'productName'
                  | 'productId'
                  | 'edition'
                  | 'offeringId'
                  | 'cloudSiteHostname'
                  | 'billingGroupId'
                  | 'provisioningStatus'
                  | 'id'
                  | 'billedUsers'
                  | 'trial'
                  | 'isSandbox'
                  | 'isApp'
                  | 'trialEndDate'
                > & {
                    pricingPlan?: Maybe<
                      { __typename?: 'PricingPlan' } & Pick<
                        PricingPlan,
                        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
                      > & {
                          tiers?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'PricingTiers' } & Pick<
                                  PricingTiers,
                                  'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                                >
                              >
                            >
                          >;
                        }
                    >;
                  }
              >
            >
          >;
        }
      >;
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'CommerceAddress' } & Pick<
                  CommerceAddress,
                  | 'id'
                  | 'name'
                  | 'addressLine1'
                  | 'addressLine2'
                  | 'city'
                  | 'state'
                  | 'country'
                  | 'postcode'
                  | 'taxId'
                  | 'taxExempt'
                >
              >
            >
          >;
        }
      >;
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'BillingAdmin' } & Pick<
                    BillingAdmin,
                    'email' | 'atlassianAccountId' | 'fullName' | 'isEmailVerified'
                  >
                >
              >
            >;
          }
      >;
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'shipToPriceEligibility'> & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'state'
                        | 'country'
                        | 'postcode'
                        | 'taxId'
                      >
                    >;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                            card?: Maybe<
                              { __typename?: 'CreditCardDetails' } & Pick<
                                CreditCardDetails,
                                'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                              >
                            >;
                          })
                      | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                            terms?: Maybe<
                              { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                            >;
                          })
                    >;
                  }
              >
            >;
          }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default' | 'paymentIssue'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'id' | 'type' | 'default' | 'paymentIssue'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                        >;
                      })
                >
              >
            >;
          }
      >;
      customerBalances?: Maybe<{ __typename?: 'CustomerBalancesRecord' } & Pick<CustomerBalancesRecord, 'usd'>>;
    };
};

export type FetchTransactionAccountForAccountDetailsScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForAccountDetailsScreenQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'billToPartyPricingEligibilty'
  > & {
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
        > & {
            taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'>>>>;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & {
                    taxIdLabels?: Maybe<
                      Array<Maybe<{ __typename?: 'TasstaxIdLabel' } & Pick<TasstaxIdLabel, 'displayName' | 'type'>>>
                    >;
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchEmailDetailsInPpcQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type FetchEmailDetailsInPpcQuery = { __typename?: 'Query' } & {
  fetchEmailDetails?: Maybe<
    { __typename?: 'Email' } & Pick<
      Email,
      'id' | 'date' | 'html' | 'mailbox' | 'messageId' | 'raw' | 'self' | 'size' | 'subject' | 'text'
    > & {
        attachments?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Attachment' } & Pick<
                Attachment,
                'checksum' | 'contentType' | 'contentDisposition' | 'filename' | 'size' | 'id' | 'self'
              >
            >
          >
        >;
        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        replyTo?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        cc?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address' | 'name'>>>>;
      }
  >;
};

export type FetchAddOnsQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchAddOnsQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'billingFrequency'
              | 'productId'
              | 'createdDate'
              | 'baseProduct'
              | 'billingStatus'
              | 'entitlementNumber'
              | 'productName'
              | 'billingCycle'
              | 'transactionAccountId'
              | 'latestPeriodEndDate'
              | 'lastPeriodStartDate'
              | 'activeUsers'
              | 'userTier'
              | 'chargeElement'
            > & {
                nextBillEstimate?: Maybe<
                  { __typename?: 'NextBillEstimate' } & Pick<NextBillEstimate, 'total' | 'currency'>
                >;
              }
          >
        >
      >;
    };
};

export type FetchAvailableInvoiceGroupsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAvailableInvoiceGroupsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'shipToPriceEligibility'> & {
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchAvailablePromotionsForEntitlementPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePromotionsForEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'productId' | 'edition'
  > & { billingFrequency: EntitlementDetails['billingCycle'] };
};

export type FetchEndCustomerContactsPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  isRestricted?: Maybe<Scalars['Boolean']>;
}>;

export type FetchEndCustomerContactsPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      endCustomerContacts?: Maybe<
        Array<
          Maybe<
            { __typename?: 'EndCustomerContact' } & Pick<EndCustomerContact, 'accountId' | 'email' | 'name' | 'picture'>
          >
        >
      >;
    };
};

export type FetchProductInstancesForEntitlementQueryPpcQueryVariables = Exact<{
  id: Scalars['String'];
  transactionAccountId: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
}>;

export type FetchProductInstancesForEntitlementQueryPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'createdDate'
              | 'billingFrequency'
              | 'edition'
              | 'logoId'
              | 'productId'
              | 'productName'
              | 'billingStatus'
              | 'provisioningStatus'
              | 'chargeElement'
              | 'cloudSiteId'
              | 'cloudSiteHostname'
              | 'activeUsers'
              | 'userTier'
              | 'optedQuantitySource'
              | 'entitlementNumber'
              | 'linkedAppsId'
              | 'trial'
              | 'isApp'
              | 'isSandbox'
              | 'isAddOn'
              | 'isFutureDatedSubscription'
            > & {
                scheduledChanges?: Maybe<
                  { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
                >;
                provisionedResourceDetails?: Maybe<
                  { __typename?: 'ProvisionedResourceDetails' } & Pick<
                    ProvisionedResourceDetails,
                    'organisationName' | 'organisationId'
                  >
                >;
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType' | 'id' | 'name'>>;
              }
          >
        >
      >;
    };
};

export type ScheduledChangesForScheduledChangesTabFragment = { __typename?: 'ScheduledChanges' } & Pick<
  ScheduledChanges,
  | 'nextChangeTimestamp'
  | 'subscriptionScheduleAction'
  | 'transactionAccountId'
  | 'invoiceGroupId'
  | 'scheduledBillingInvoiceGroupId'
> & {
    offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
    pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
    promotions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<
            Promotion,
            | 'promotionInstanceId'
            | 'id'
            | 'status'
            | 'rule'
            | 'title'
            | 'type'
            | 'pricingType'
            | 'cycleInterval'
            | 'isPromotionCustomisable'
          > & {
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'value' | 'benefitType' | 'subBenefitType' | 'duration' | 'iterations'
                    > & {
                        customisable?: Maybe<
                          { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                              value?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                              iterations?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
              promotionWindow?: Maybe<
                { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'startTime' | 'endTime'>
              >;
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
            }
        >
      >
    >;
    chargeQuantities?: Maybe<
      Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>>
    >;
  };

export type ScheduledChangesForScheduledChangesTabPpcFragment = { __typename?: 'ScheduledChanges' } & Pick<
  ScheduledChanges,
  | 'nextChangeTimestamp'
  | 'subscriptionScheduleAction'
  | 'transactionAccountId'
  | 'invoiceGroupId'
  | 'scheduledBillingInvoiceGroupId'
> & {
    offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
    pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
    promotions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<
            Promotion,
            | 'promotionInstanceId'
            | 'id'
            | 'status'
            | 'rule'
            | 'title'
            | 'type'
            | 'pricingType'
            | 'cycleInterval'
            | 'isPromotionCustomisable'
          > & {
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'value' | 'benefitType' | 'subBenefitType' | 'duration' | 'iterations'
                    > & {
                        values?: Maybe<
                          Array<
                            Maybe<{ __typename?: 'BenefitsValueObj' } & Pick<BenefitsValueObj, 'appliedOn' | 'value'>>
                          >
                        >;
                        customisable?: Maybe<
                          { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                              value?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                              iterations?: Maybe<
                                { __typename?: 'BenefitCustomisableValue' } & Pick<
                                  BenefitCustomisableValue,
                                  'type' | 'lowerBound' | 'upperBound'
                                >
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
              eligibilityRules?: Maybe<{ __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>>;
              promotionWindow?: Maybe<
                { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'startTime' | 'endTime'>
              >;
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
            }
        >
      >
    >;
    chargeQuantities?: Maybe<
      Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>>
    >;
  };

export type FetchEntitlementDetailsPpcPerfV2QueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  fetchIsExternallyBilled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchEntitlementDetailsPpcPerfV2Query = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    | 'logoId'
    | 'createdDate'
    | 'billingStatus'
    | 'cloudSiteHostname'
    | 'cloudSiteCustomHostname'
    | 'cloudSiteId'
    | 'cloudSiteSen'
    | 'endTimestamp'
    | 'entitlementNumber'
    | 'updatePaymentMethodLink'
    | 'hasPendingInvoices'
    | 'id'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'licenseLevel'
    | 'offeringId'
    | 'isOptOutAllowed'
    | 'edition'
    | 'parentSen'
    | 'parentCloudSiteName'
    | 'platform'
    | 'productId'
    | 'nextBillingTimestamp'
    | 'productName'
    | 'productType'
    | 'baseProduct'
    | 'renewalAction'
    | 'sourceSystem'
    | 'plan'
    | 'subscriptionId'
    | 'unitCount'
    | 'activeSubscriptionBillingGroupId'
    | 'activeUsers'
    | 'provisioningStatus'
    | 'isSandbox'
    | 'isApp'
    | 'isAddOn'
    | 'userTier'
    | 'chargeElement'
    | 'showExtendTrial'
    | 'productStatus'
    | 'isExternallyBilled'
    | 'isFutureDatedSubscription'
    | 'futureDatedStartTimestamp'
    | 'metadata'
  > & { billingFrequency: EntitlementDetails['billingCycle'] } & {
      termDetails?: Maybe<
        { __typename?: 'EntitlementTermDetails' } & Pick<EntitlementTermDetails, 'paymentMethod' | 'totalCreditLimit'>
      >;
      invoices: { __typename?: 'InvoiceConnection' } & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Invoice' } & Pick<
                Invoice,
                'id' | 'createdDate' | 'grandTotal' | 'paymentCurrency' | 'pricingCurrency'
              > & {
                  lineItems?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'InvoiceLineItems' } & Pick<InvoiceLineItems, 'entitlementId' | 'id'> & {
                            discounts?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'InvoiceDiscounts' } & Pick<
                                    InvoiceDiscounts,
                                    'amount' | 'type' | 'percent' | 'reasonCode'
                                  >
                                >
                              >
                            >;
                            margins?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'InvoiceMargins' } & Pick<
                                    InvoiceMargins,
                                    'amount' | 'type' | 'percent' | 'promoCode'
                                  >
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >
          >
        >;
      };
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<
          Offering,
          'id' | 'name' | 'productKey' | 'level' | 'type' | 'pricingType' | 'status' | 'expiryDate'
        > & {
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      promotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              | 'id'
              | 'title'
              | 'type'
              | 'promotionInstanceId'
              | 'status'
              | 'cycleInterval'
              | 'pricingType'
              | 'cycleIntervalWithEligibleConditions'
              | 'isPromotionCustomisable'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          values?: Maybe<
                            Array<
                              Maybe<{ __typename?: 'BenefitsValueObj' } & Pick<BenefitsValueObj, 'appliedOn' | 'value'>>
                            >
                          >;
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
              }
          >
        >
      >;
      trialPromotionDetails?: Maybe<
        { __typename?: 'TrialPromotionDetails' } & Pick<TrialPromotionDetails, 'totalTrialDays' | 'totalTrialCount'>
      >;
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
      pricingPlan?: Maybe<
        { __typename?: 'PricingPlan' } & Pick<
          PricingPlan,
          'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
        > & {
            tiers?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'PricingTiers' } & Pick<
                    PricingTiers,
                    'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                  >
                >
              >
            >;
          }
      >;
      scheduledChanges?: Maybe<{ __typename?: 'ScheduledChanges' } & ScheduledChangesForScheduledChangesTabPpcFragment>;
      nextBillEstimate?: Maybe<
        { __typename?: 'NextBillEstimate' } & Pick<
          NextBillEstimate,
          'total' | 'currency' | 'renewalCharge' | 'proratedCharge'
        > & {
            lastBillEstimateItem?: Maybe<
              { __typename?: 'LastBillEstimateItem' } & {
                adjustments?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'LastBillEstimateItemAdjustment' } & Pick<
                        LastBillEstimateItemAdjustment,
                        'type' | 'amount' | 'percent'
                      >
                    >
                  >
                >;
                margins?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'LastBillEstimateItemMargin' } & Pick<
                        LastBillEstimateItemMargin,
                        'type' | 'amount' | 'percent'
                      >
                    >
                  >
                >;
              }
            >;
            nextCyclePartnerDiscountOrMargin?: Maybe<
              { __typename?: 'NextCyclePartnerDiscountOrMargin' } & Pick<
                NextCyclePartnerDiscountOrMargin,
                'amount' | 'percent' | 'promotionId'
              >
            >;
          }
      >;
      subscription?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SubscriptionDetails' } & {
              subscriptionPeriod?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'SubscriptionPeriodDetails' } & Pick<
                      SubscriptionPeriodDetails,
                      'offeringKey' | 'startTimestamp'
                    > & {
                        trial?: Maybe<
                          { __typename?: 'TrialTimeStamps' } & Pick<TrialTimeStamps, 'startTimestamp' | 'endTimestamp'>
                        >;
                        chargeQuantities?: Maybe<
                          Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'quantity'>>>
                        >;
                      }
                  >
                >
              >;
            }
          >
        >
      >;
      deletedProductDetails?: Maybe<
        { __typename?: 'DeletedProductDetails' } & Pick<
          DeletedProductDetails,
          'status' | 'datePlaced' | 'deletedOn' | 'author' | 'supportTicket' | 'internalComment'
        >
      >;
      relatesToEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'RelatedEntitlementDetails' } & Pick<
              RelatedEntitlementDetails,
              'entitlementId' | 'relationshipType'
            >
          >
        >
      >;
      relatesFromEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'RelatedEntitlementDetails' } & Pick<
              RelatedEntitlementDetails,
              'entitlementId' | 'relationshipType'
            >
          >
        >
      >;
      metadata?: Maybe<
        { __typename?: 'EntitlementMetadata' } & Pick<
          EntitlementMetadata,
          'contractId' | 'contractType' | 'originalOrderItemId'
        >
      >;
      upgradeTrial?: Maybe<
        { __typename?: 'UpgradeTrialDetails' } & Pick<
          UpgradeTrialDetails,
          'offeringId' | 'offeringName' | 'startTimestamp' | 'endTimestamp'
        > & {
            pricingPlan?: Maybe<
              { __typename?: 'PricingPlan' } & Pick<
                PricingPlan,
                'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
              > & {
                  tiers?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'PricingTiers' } & Pick<
                          PricingTiers,
                          'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                        >
                      >
                    >
                  >;
                }
            >;
          }
      >;
      pauseBilling?: Maybe<{ __typename?: 'PauseBilling' } & Pick<PauseBilling, 'startTimestamp' | 'endTimestamp'>>;
      provisionedResourceDetails?: Maybe<
        { __typename?: 'ProvisionedResourceDetails' } & Pick<
          ProvisionedResourceDetails,
          'organisationId' | 'organisationName' | 'provisionedResourceType'
        >
      >;
    };
};

export type FetchInvoiceGroupDetailsPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchInvoiceGroupDetailsPpcQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name'> & {
        termPaymentStatus?: Maybe<
          { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
        >;
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            'id' | 'name' | 'addressLine1' | 'city' | 'country' | 'state' | 'postcode'
          > & {
              taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'>>>>;
              taxLabels?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                        taxIdLabels?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'TasstaxIdLabel' } & Pick<
                                TasstaxIdLabel,
                                'description' | 'displayName' | 'type'
                              > & {
                                  metadata?: Maybe<
                                    { __typename?: 'TassTaxIdLabelMetadata' } & Pick<TassTaxIdLabelMetadata, 'type'> & {
                                        labels?: Maybe<
                                          Array<
                                            Maybe<
                                              { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                TassTaxIdLabelMetadataLabel,
                                                'default' | 'label' | 'vatStatus'
                                              >
                                            >
                                          >
                                        >;
                                      }
                                  >;
                                }
                            >
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default'> & {
                card?: Maybe<
                  { __typename?: 'CreditCardDetails' } & Pick<
                    CreditCardDetails,
                    'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'cardHolderName' | 'brand'
                  >
                >;
              })
          | ({ __typename?: 'PaymentOnTerms' } & Pick<
              PaymentOnTerms,
              'totalCreditLimit' | 'paymentMethod' | 'id' | 'type' | 'default'
            > & {
                terms?: Maybe<
                  { __typename?: 'PaymentOnTermsDetails' } & Pick<
                    PaymentOnTermsDetails,
                    'invoiceDueDays' | 'payOnStatement'
                  >
                >;
              })
          | ({ __typename?: 'ACH' } & Pick<Ach, 'id' | 'type' | 'default'> & {
                ach?: Maybe<{ __typename?: 'AchDetails' } & Pick<AchDetails, 'bankName' | 'last4'>>;
              })
        >;
      }
  >;
};

export type FetchInvoicesForEntitlementPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchInvoicesForEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'status'
                  | 'invoiceNumber'
                  | 'sourceSystem'
                  | 'paymentMethod'
                  | 'paymentMethodId'
                  | 'transactionAccountId'
                  | 'purchaseOrderNumber'
                  | 'pdfLink'
                  | 'dueDate'
                  | 'createdDate'
                  | 'itemsTotal'
                  | 'grandTotal'
                  | 'paymentCurrency'
                > & {
                    creditCard?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                    shipTo?: Maybe<
                      { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'fullName'> & {
                          address?: Maybe<
                            { __typename?: 'InvoiceAddress' } & Pick<
                              InvoiceAddress,
                              'address1' | 'address2' | 'postalCode' | 'city' | 'state' | 'country'
                            >
                          >;
                        }
                    >;
                    paymentOnTermsDetails?: Maybe<
                      { __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'default'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        }
                    >;
                    refunds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Refunds' } & Pick<
                            Refunds,
                            | 'id'
                            | 'type'
                            | 'creditNoteNumber'
                            | 'sourceSystem'
                            | 'total'
                            | 'currency'
                            | 'status'
                            | 'arn'
                          >
                        >
                      >
                    >;
                    dunningStatus?: Maybe<
                      Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                    >;
                    transactionAccount?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TransactionAccount' } & Pick<
                            TransactionAccount,
                            'transactionAccountNumber' | 'id'
                          >
                        >
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

export type FetchLinkedEntitlementBillingProfileQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchLinkedEntitlementBillingProfileQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<{ __typename?: 'LinkedDestinationEntitlement' } & Pick<LinkedDestinationEntitlement, 'billingGroupId'>>
        >
      >;
    };
};

export type FetchLinkedEntitlementChangeSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchLinkedEntitlementChangeSubscriptionQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              'id' | 'entitlementNumber' | 'productId' | 'productName' | 'offeringId'
            >
          >
        >
      >;
    };
};

export type FetchLinkedEntitlementsPpcQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchLinkedEntitlementsPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId' | 'isAddOn'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'billingFrequency'
              | 'cloudSiteHostname'
              | 'cloudSiteId'
              | 'productId'
              | 'createdDate'
              | 'edition'
              | 'unitCount'
              | 'provisioningStatus'
              | 'baseProduct'
              | 'billingStatus'
              | 'billedUsers'
              | 'entitlementNumber'
              | 'productName'
              | 'billingCycle'
              | 'offeringId'
              | 'subscriptionId'
              | 'billingGroupId'
              | 'parentSen'
              | 'userTier'
              | 'transactionAccountId'
              | 'latestPeriodEndDate'
              | 'isFutureDatedSubscription'
              | 'futureDatedStartTimestamp'
              | 'lastPeriodStartDate'
              | 'isApp'
              | 'isAddOn'
              | 'isSandbox'
              | 'activeUsers'
              | 'trial'
              | 'logoId'
              | 'linkedAppsId'
              | 'chargeElement'
              | 'optedQuantitySource'
              | 'offering'
            > & {
                subscriptionTimestamps?: Maybe<
                  { __typename?: 'SubscriptionTimeStamps' } & Pick<
                    SubscriptionTimeStamps,
                    'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
                  >
                >;
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType' | 'id' | 'name'>>;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                relatesToEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                nextBillEstimate?: Maybe<
                  { __typename?: 'NextBillEstimate' } & Pick<NextBillEstimate, 'total' | 'currency'>
                >;
                provisionedResourceDetails?: Maybe<
                  { __typename?: 'ProvisionedResourceDetails' } & Pick<
                    ProvisionedResourceDetails,
                    'organisationName' | 'organisationId'
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchSandboxForEntitlementForPpcQueryVariables = Exact<{
  id: Scalars['String'];
  transactionAccountId: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
}>;

export type FetchSandboxForEntitlementForPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      sandboxEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'billingFrequency'
              | 'productId'
              | 'baseProduct'
              | 'billingStatus'
              | 'entitlementNumber'
              | 'productName'
              | 'transactionAccountId'
              | 'billingGroupId'
              | 'billedUsers'
              | 'latestPeriodEndDate'
              | 'edition'
              | 'cloudSiteHostname'
              | 'cloudSiteId'
              | 'trial'
              | 'isApp'
              | 'activeUsers'
              | 'provisioningStatus'
              | 'linkedAppsId'
              | 'isFutureDatedSubscription'
            > & {
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                scheduledChanges?: Maybe<
                  { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
                >;
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType'>>;
              }
          >
        >
      >;
    };
};

export type FetchSandboxParentPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  fetchDetails?: Maybe<Scalars['Boolean']>;
}>;

export type FetchSandboxParentPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'productId' | 'entitlementNumber' | 'id' | 'edition' | 'productName'
  >;
};

export type FetchTransactionAccountForEntitlementPpcQueryVariables = Exact<{
  entitlementId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchTransactionAccountForEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id'> & {
      transactionAccount?: Maybe<
        { __typename?: 'TransactionAccount' } & Pick<
          TransactionAccount,
          'id' | 'displayName' | 'partnerLevel' | 'transactionAccountNumber' | 'billToPartyPricingEligibilty'
        > & {
            billToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
              > & {
                  taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'>>>>;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  > & {
                                      metadata?: Maybe<
                                        { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                          TassTaxIdLabelMetadata,
                                          'type'
                                        > & {
                                            labels?: Maybe<
                                              Array<
                                                Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                    TassTaxIdLabelMetadataLabel,
                                                    'default' | 'label' | 'vatStatus'
                                                  >
                                                >
                                              >
                                            >;
                                          }
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                    >;
                  })
            >;
            availableInvoiceGroups?: Maybe<
              { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
                  nodes: Array<
                    Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<
                        InvoiceGroup,
                        'id' | 'name' | 'currency' | 'shipToPriceEligibility'
                      > & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              | 'id'
                              | 'name'
                              | 'addressLine1'
                              | 'addressLine2'
                              | 'city'
                              | 'state'
                              | 'country'
                              | 'postcode'
                              | 'taxId'
                            > & {
                                taxIds?: Maybe<Array<Maybe<{ __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label'>>>>;
                                taxLabels?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                          taxIdLabels?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'TasstaxIdLabel' } & Pick<
                                                  TasstaxIdLabel,
                                                  'description' | 'displayName' | 'type'
                                                > & {
                                                    metadata?: Maybe<
                                                      { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                                        TassTaxIdLabelMetadata,
                                                        'type'
                                                      > & {
                                                          labels?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                                  TassTaxIdLabelMetadataLabel,
                                                                  'default' | 'label' | 'vatStatus'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                          purchaseOrder?: Maybe<
                            { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                              InvoiceGroupPurchaseOrder,
                              'number' | 'oneTimeUse'
                            >
                          >;
                        }
                    >
                  >;
                }
            >;
          }
      >;
    };
};

export type FetchUsageAggregationHistoryQueryVariables = Exact<{
  entitlementId: Scalars['String'];
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchUsageAggregationHistoryQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & {
    usageAggregation?: Maybe<
      { __typename?: 'UsageAggregationDetails' } & {
        period?: Maybe<{ __typename?: 'UsageTimePeriod' } & Pick<UsageTimePeriod, 'startTime' | 'endTime'>>;
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'UsageAggregation' } & Pick<
                UsageAggregation,
                'latestUsage' | 'periodTimestamp' | 'usersAdded' | 'usersRemoved' | 'maxUsage' | 'highWaterMarkUsage'
              >
            >
          >
        >;
      }
    >;
  };
};

export type FetchUserHistoryForEntitlementPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchUserHistoryForEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'edition'
  > & {
      userHistory?: Maybe<
        { __typename?: 'UserHistoryDetails' } & Pick<UserHistoryDetails, 'nextId'> & {
            results?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ChargeQuantity' } & Pick<
                    ChargeQuantity,
                    'chargeElement' | 'quantity' | 'lastUpdatedAt'
                  > & {
                      usersUpdate?: Maybe<
                        { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                          ChargeQuantityUsersUpdate,
                          'isCreated' | 'isAdded' | 'isRemoved' | 'changeBy'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchAvailableOfferingsForEntitlementPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchAvailableOfferingsForEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'edition' | 'plan' | 'transactionAccountId'
  > & {
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<
          Offering,
          'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType' | 'status' | 'offeringGroup'
        > & {
            availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
            relationshipRequirements?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'RelationshipRequirement' } & Pick<RelationshipRequirement, 'level' | 'side' | 'type'>
                >
              >
            >;
            trial?: Maybe<{ __typename?: 'OfferingTrial' } & Pick<OfferingTrial, 'lengthDays'>>;
          }
      >;
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name' | 'units'>>>>;
        }
      >;
      availableOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<
              Offering,
              'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType' | 'status'
            > & {
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
                availableSyntheticPricingPlans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'SyntheticPricingPlan' } & Pick<
                        SyntheticPricingPlan,
                        'type' | 'status' | 'discountPercentage'
                      >
                    >
                  >
                >;
                trial?: Maybe<{ __typename?: 'OfferingTrial' } & Pick<OfferingTrial, 'lengthDays'>>;
              }
          >
        >
      >;
      validOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ValidOfferings' } & Pick<ValidOfferings, 'key' | 'offeringKey' | 'offeringName' | 'status'>
          >
        >
      >;
    };
};

export type FetchAvailablePricingPlansPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePricingPlansPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<EntitlementDetails, 'id' | 'billingCycle'> & {
      availablePricingPlans?: Maybe<
        Array<
          Maybe<
            { __typename?: 'PricingPlan' } & Pick<
              PricingPlan,
              | 'type'
              | 'billingFrequency'
              | 'id'
              | 'currency'
              | 'pricingPlanType'
              | 'status'
              | 'description'
              | 'offeringName'
              | 'chargeElement'
              | 'chargeType'
            > & {
                tiers?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'PricingTiers' } & Pick<
                        PricingTiers,
                        'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchAvailablePartnerPromotionsForChangeEntitlementPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  discountTier?: Maybe<Scalars['String']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePartnerPromotionsForChangeEntitlementPpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'subscriptionId' | 'productId' | 'edition'
  > & { billingFrequency: EntitlementDetails['billingCycle'] } & {
      availablePromotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType' | 'isPromotionCustomisable' | 'type'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
                customisableReasons?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>>
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchLinkedEntitlementsForTablePpcQueryVariables = Exact<{
  id: Scalars['String'];
  searchLinkedEntitlementParams: SearchLinkedEntitlementParams;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchLinkedEntitlementsForTablePpcQuery = { __typename?: 'Query' } & {
  entitlementDetails: { __typename?: 'EntitlementDetails' } & Pick<
    EntitlementDetails,
    'id' | 'transactionAccountId'
  > & {
      linkedEntitlements?: Maybe<
        Array<
          Maybe<
            { __typename?: 'LinkedDestinationEntitlement' } & Pick<
              LinkedDestinationEntitlement,
              | 'entitlementId'
              | 'productId'
              | 'entitlementNumber'
              | 'productName'
              | 'billingCycle'
              | 'billingFrequency'
              | 'latestPeriodEndDate'
              | 'offeringId'
              | 'subscriptionId'
              | 'billingStatus'
              | 'isApp'
              | 'transactionAccountId'
              | 'billingGroupId'
              | 'edition'
              | 'isSandbox'
              | 'parentSen'
              | 'logoId'
              | 'userTier'
            > & {
                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'pricingType'>>;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchTransactionAccountForChangeSubscriptionPaneQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchTransactionAccountForChangeSubscriptionPaneQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'billToPartyPricingEligibilty'
  > & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<
                InvoiceGroup,
                'id' | 'name' | 'currency' | 'shipToPriceEligibility'
              > & {
                  purchaseOrder?: Maybe<
                    { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                      InvoiceGroupPurchaseOrder,
                      'number' | 'oneTimeUse'
                    >
                  >;
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      | 'id'
                      | 'name'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'state'
                      | 'country'
                      | 'postcode'
                      | 'taxId'
                    >
                  >;
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                          card?: Maybe<
                            { __typename?: 'CreditCardDetails' } & Pick<
                              CreditCardDetails,
                              'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                            >
                          >;
                        })
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        })
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchOverdueInvoicesForHomePageInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchOverdueInvoicesForHomePageInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      overdueInvoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    'id' | 'transactionAccountId' | 'invoiceNumber' | 'dueDate'
                  > & {
                      shipTo?: Maybe<{ __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'fullName'>>;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchCloudSitesForWidgetPpcQueryVariables = Exact<{
  params: SearchCloudLicensesParams;
}>;

export type FetchCloudSitesForWidgetPpcQuery = { __typename?: 'Query' } & {
  cloudLicenses?: Maybe<
    { __typename?: 'CloudLicenseConnection' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'CloudLicenseResults' } & Pick<
              CloudLicenseResults,
              'cloudSiteUrl' | 'billingGroupId' | 'cloudSiteId'
            > & { shipToParty?: Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'name'>> }
          >
        >
      >;
    }
  >;
};

export type FetchRecentlyGeneratedInvoicesForHomePageInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type FetchRecentlyGeneratedInvoicesForHomePageInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    'id' | 'transactionAccountId' | 'invoiceNumber' | 'createdTimestamp'
                  > & {
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'>
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchSubscriptionsForTxaForWidgetQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSubscriptionsForTxaForWidgetQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'id'
                    | 'baseProduct'
                    | 'transactionAccountId'
                    | 'entitlementNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                    | 'cloudSiteId'
                    | 'cloudSiteHostname'
                    | 'logoId'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchCreatedSubscriptionsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchCreatedSubscriptionsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'id'
                    | 'transactionAccountId'
                    | 'entitlementNumber'
                    | 'createdDate'
                    | 'productName'
                    | 'productId'
                    | 'cloudSiteId'
                    | 'cloudSiteHostname'
                    | 'logoId'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchUpcomingRenewalsForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchUpcomingRenewalsForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'id'
                    | 'baseProduct'
                    | 'transactionAccountId'
                    | 'entitlementNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                    | 'cloudSiteId'
                    | 'cloudSiteHostname'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type CheckForSubscriptionForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CheckForSubscriptionForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      productSubscriptionsInPPC?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<TransactionAccountProductConnection, 'totalCount'>
      >;
    };
};

export type LineItemDetailsForInvoiceInPpcFragment = { __typename?: 'InvoiceLineItems' } & Pick<
  InvoiceLineItems,
  | 'id'
  | 'edition'
  | 'entitlementId'
  | 'entitlementNumber'
  | 'cloudSiteHostname'
  | 'amount'
  | 'subtotal'
  | 'description'
  | 'cloudSiteId'
  | 'platform'
  | 'productKey'
  | 'productName'
  | 'startDate'
  | 'invoiceLineItemId'
  | 'endDate'
  | 'promotionIds'
  | 'quantity'
  | 'sen'
  | 'pricingPlanId'
  | 'taxRate'
  | 'taxAmountPaymentCurrency'
  | 'logoId'
> & {
    originalInvoiceReferral?: Maybe<
      { __typename?: 'OriginalInvoiceReferral' } & Pick<OriginalInvoiceReferral, 'invoiceNumber'>
    >;
    promotionItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
              purpose?: Maybe<{ __typename?: 'Purpose' } & Pick<Purpose, 'reasonCode' | 'name' | 'invoiceNote'>>;
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                    >
                  >
                >
              >;
              eligibilityRules?: Maybe<{ __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>>;
            }
        >
      >
    >;
    discounts?: Maybe<
      Array<
        Maybe<
          { __typename?: 'InvoiceDiscounts' } & Pick<
            InvoiceDiscounts,
            'amount' | 'type' | 'percent' | 'reason' | 'reasonCode' | 'promotionId'
          >
        >
      >
    >;
    margins?: Maybe<
      Array<
        Maybe<
          { __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'type' | 'amount' | 'percent' | 'promotionId'> &
            BlendedComputationDetailsFragment
        >
      >
    >;
    entitlement?: Maybe<
      { __typename?: 'InvoiceEntitlementItem' } & Pick<
        InvoiceEntitlementItem,
        | 'id'
        | 'entitlementNumber'
        | 'baseProduct'
        | 'cloudSiteId'
        | 'cloudSiteUrl'
        | 'platform'
        | 'productId'
        | 'productName'
        | 'parentSen'
        | 'sourceSystem'
        | 'billingCycle'
        | 'billingStatus'
        | 'pricingPlanId'
        | 'offeringId'
      > & { accountId: InvoiceEntitlementItem['orgId']; businessKey: InvoiceEntitlementItem['id'] } & {
          scheduledChanges?: Maybe<
            { __typename?: 'ScheduledChanges' } & {
              chargeQuantities?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'ChargeQuantity' } & Pick<
                      ChargeQuantity,
                      'chargeElement' | 'quantity' | 'lastUpdatedAt'
                    > & {
                        usersUpdate?: Maybe<
                          { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                            ChargeQuantityUsersUpdate,
                            'isAdded' | 'isRemoved' | 'isCreated' | 'changeBy'
                          >
                        >;
                      }
                  >
                >
              >;
            }
          >;
        }
    >;
    essotEntitlement?: Maybe<
      { __typename?: 'InvoiceEssotEntitlementItem' } & {
        relatesFromEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
        relatesToEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
      }
    >;
    orgInfo?: Maybe<{ __typename?: 'OrgDetails' } & Pick<OrgDetails, 'orgId' | 'orgName'>>;
    pricingPlan?: Maybe<
      { __typename?: 'PricingPlan' } & Pick<
        PricingPlan,
        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
      > & {
          tiers?: Maybe<
            Array<
              Maybe<
                { __typename?: 'PricingTiers' } & Pick<PricingTiers, 'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'>
              >
            >
          >;
        }
    >;
    taxItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaxItems' } & Pick<
            TaxItems,
            'id' | 'taxPercent' | 'tax' | 'taxId' | 'taxAmountLabel' | 'taxIdLabel'
          >
        >
      >
    >;
    latestInvoiceDetails?: Maybe<
      { __typename?: 'latestInvoiceDetails' } & Pick<LatestInvoiceDetails, 'id' | 'invoiceNumber'>
    >;
  };

export type ProductAppLineItemsInPpcFragment = { __typename?: 'ProductAppLineItem' } & {
  products: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceInPpcFragment>>;
  apps: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceInPpcFragment>>;
  addOns?: Maybe<Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceInPpcFragment>>>;
};

export type CoupledLineItemsOnInvoiceInPpcFragment = { __typename?: 'ProductAppLineItemData' } & {
  jira: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment;
  confluence: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment;
  statuspage: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment;
  atlassianGuard?: Maybe<{ __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment>;
  other?: Maybe<{ __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment>;
};

export type LineItemDetailsForInvoiceWithOverageFragment = { __typename?: 'InvoiceLineItems' } & Pick<
  InvoiceLineItems,
  | 'id'
  | 'edition'
  | 'entitlementId'
  | 'entitlementNumber'
  | 'cloudSiteHostname'
  | 'amount'
  | 'subtotal'
  | 'description'
  | 'cloudSiteId'
  | 'platform'
  | 'productKey'
  | 'productName'
  | 'startDate'
  | 'invoiceLineItemId'
  | 'endDate'
  | 'promotionIds'
  | 'quantity'
  | 'sen'
  | 'pricingPlanId'
  | 'taxRate'
  | 'taxAmountPaymentCurrency'
  | 'logoId'
> & {
    originalInvoiceReferral?: Maybe<
      { __typename?: 'OriginalInvoiceReferral' } & Pick<OriginalInvoiceReferral, 'invoiceNumber'>
    >;
    promotionItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
              applicationReason?: Maybe<
                { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                    customisable?: Maybe<
                      { __typename?: 'PromotionReasonCustomisable' } & {
                        id?: Maybe<
                          { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                              anyOf?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: 'ReasonCustomisableObj' } & Pick<
                                      ReasonCustomisableObj,
                                      'readableName' | 'id'
                                    >
                                  >
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
              purpose?: Maybe<{ __typename?: 'Purpose' } & Pick<Purpose, 'reasonCode' | 'name' | 'invoiceNote'>>;
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'duration' | 'benefitType' | 'subBenefitType' | 'value' | 'iterations'
                    >
                  >
                >
              >;
              eligibilityRules?: Maybe<{ __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>>;
            }
        >
      >
    >;
    discounts?: Maybe<
      Array<
        Maybe<
          { __typename?: 'InvoiceDiscounts' } & Pick<
            InvoiceDiscounts,
            'amount' | 'type' | 'percent' | 'reason' | 'reasonCode' | 'promotionId'
          >
        >
      >
    >;
    margins?: Maybe<
      Array<
        Maybe<
          { __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'type' | 'amount' | 'percent' | 'promotionId'> &
            BlendedComputationDetailsFragment
        >
      >
    >;
    entitlement?: Maybe<
      { __typename?: 'InvoiceEntitlementItem' } & Pick<
        InvoiceEntitlementItem,
        | 'id'
        | 'entitlementNumber'
        | 'baseProduct'
        | 'cloudSiteId'
        | 'cloudSiteUrl'
        | 'platform'
        | 'productId'
        | 'productName'
        | 'parentSen'
        | 'sourceSystem'
        | 'billingCycle'
        | 'billingStatus'
        | 'pricingPlanId'
        | 'offeringId'
      > & { accountId: InvoiceEntitlementItem['orgId']; businessKey: InvoiceEntitlementItem['id'] } & {
          scheduledChanges?: Maybe<
            { __typename?: 'ScheduledChanges' } & {
              chargeQuantities?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'ChargeQuantity' } & Pick<
                      ChargeQuantity,
                      'chargeElement' | 'quantity' | 'lastUpdatedAt'
                    > & {
                        usersUpdate?: Maybe<
                          { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                            ChargeQuantityUsersUpdate,
                            'isAdded' | 'isRemoved' | 'isCreated' | 'changeBy'
                          >
                        >;
                      }
                  >
                >
              >;
            }
          >;
        }
    >;
    essotEntitlement?: Maybe<
      { __typename?: 'InvoiceEssotEntitlementItem' } & {
        relatesFromEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
        relatesToEntitlements?: Maybe<
          Array<
            Maybe<
              { __typename?: 'RelatedEntitlementDetails' } & Pick<
                RelatedEntitlementDetails,
                'entitlementId' | 'relationshipType'
              >
            >
          >
        >;
      }
    >;
    orgInfo?: Maybe<{ __typename?: 'OrgDetails' } & Pick<OrgDetails, 'orgId' | 'orgName'>>;
    pricingPlan?: Maybe<
      { __typename?: 'PricingPlan' } & Pick<
        PricingPlan,
        'type' | 'billingFrequency' | 'id' | 'currency' | 'pricingPlanType' | 'status' | 'description'
      > & {
          tiers?: Maybe<
            Array<
              Maybe<
                { __typename?: 'PricingTiers' } & Pick<PricingTiers, 'unitAmount' | 'flatAmount' | 'floor' | 'ceiling'>
              >
            >
          >;
        }
    >;
    taxItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TaxItems' } & Pick<
            TaxItems,
            'id' | 'taxPercent' | 'tax' | 'taxId' | 'taxAmountLabel' | 'taxIdLabel'
          >
        >
      >
    >;
    latestInvoiceDetails?: Maybe<
      { __typename?: 'latestInvoiceDetails' } & Pick<LatestInvoiceDetails, 'id' | 'invoiceNumber'>
    >;
  } & OverageFragment;

export type ProductAppLineItemsWithOverageFragment = { __typename?: 'ProductAppLineItem' } & {
  products: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceWithOverageFragment>>;
  apps: Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceWithOverageFragment>>;
  addOns?: Maybe<Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceWithOverageFragment>>>;
};

export type CoupledLineItemsOnInvoiceWithOverageFragment = { __typename?: 'ProductAppLineItemData' } & {
  jira: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsWithOverageFragment;
  confluence: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsWithOverageFragment;
  statuspage: { __typename?: 'ProductAppLineItem' } & ProductAppLineItemsWithOverageFragment;
  atlassianGuard?: Maybe<{ __typename?: 'ProductAppLineItem' } & ProductAppLineItemsInPpcFragment>;
  other?: Maybe<{ __typename?: 'ProductAppLineItem' } & ProductAppLineItemsWithOverageFragment>;
};

export type FetchtxaBalanceDetailsPpcQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchtxaBalanceDetailsPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber'
  > & {
      transactionAccountBalanceEntity?: Maybe<
        Array<
          Maybe<
            { __typename?: 'txaCustomerBalanceDetails' } & Pick<
              TxaCustomerBalanceDetails,
              'invoiceNumber' | 'endingAmount'
            >
          >
        >
      >;
    };
};

export type FetchInvoiceQueryInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  transactionAccountId?: Maybe<Scalars['String']>;
  includeOverage?: Maybe<Scalars['Boolean']>;
  fetchAddOns?: Maybe<Scalars['Boolean']>;
  fetchAGPAddon?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInvoiceQueryInPpcQuery = { __typename?: 'Query' } & {
  invoice: { __typename?: 'Invoice' } & Pick<
    Invoice,
    | 'id'
    | 'invoiceNumber'
    | 'sourceId'
    | 'selfServeBACInvoiceLink'
    | 'domain'
    | 'status'
    | 'createdTimestamp'
    | 'userDefinedNotes'
    | 'billingGroupId'
    | 'paymentMethodId'
    | 'sourceSystem'
    | 'upgradeCredits'
    | 'totalDiscount'
    | 'totalPartnerMargin'
    | 'memo'
    | 'total'
    | 'taxes'
    | 'subtotal'
    | 'taxesPaymentCurrency'
    | 'transactionAccountId'
    | 'itemsTotal'
    | 'partnerAccountId'
    | 'partnerName'
    | 'paypalAccountEmail'
    | 'paymentCurrency'
    | 'paymentMethod'
    | 'promotionCode'
    | 'invoiceDueDays'
    | 'dueDate'
    | 'purchaseOrderNumber'
    | 'pdfLink'
    | 'appliedBalance'
  > & {
      creditCard?: Maybe<
        { __typename?: 'CreditCardDetails' } & Pick<
          CreditCardDetails,
          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
        >
      >;
      dunningStatus?: Maybe<
        Array<
          Maybe<
            { __typename?: 'DunningStatus' } & Pick<
              DunningStatus,
              'attemptCount' | 'paymentRetryDate' | 'errorCode' | 'declineCode' | 'nextPaymentAttempDate'
            >
          >
        >
      >;
      billTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      shipTo?: Maybe<
        { __typename?: 'InvoiceBillAndShipTo' } & Pick<
          InvoiceBillAndShipTo,
          'id' | 'fullName' | 'organization' | 'email' | 'taxId'
        > & {
            address?: Maybe<
              { __typename?: 'InvoiceAddress' } & Pick<
                InvoiceAddress,
                'address1' | 'address2' | 'city' | 'country' | 'phone' | 'postalCode' | 'state'
              >
            >;
            taxIds?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                    }
                >
              >
            >;
            taxLabels?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                      taxIdLabels?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'TasstaxIdLabel' } & Pick<
                              TasstaxIdLabel,
                              'description' | 'displayName' | 'type'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & Pick<InvoiceLineItems, 'orderLineId'> &
              LineItemDetailsForInvoiceInPpcFragment &
              OverageFragment
          >
        >
      >;
      coupledLineItems?: Maybe<
        { __typename?: 'ProductAppLineItemData' } & CoupledLineItemsOnInvoiceInPpcFragment &
          CoupledLineItemsOnInvoiceWithOverageFragment
      >;
      dstLineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & {
              metadata?: Maybe<{ __typename?: 'LineItemMetaData' } & Pick<LineItemMetaData, 'parentItemId' | 'type'>>;
            } & LineItemDetailsForInvoiceInPpcFragment
          >
        >
      >;
      refunds?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Refunds' } & Pick<
              Refunds,
              | 'id'
              | 'creditNoteNumber'
              | 'currency'
              | 'createdDate'
              | 'transactionAccountId'
              | 'sourceSystem'
              | 'memo'
              | 'reason'
              | 'refundId'
              | 'status'
              | 'type'
              | 'total'
              | 'arn'
              | 'requestedBy'
            > & {
                refundItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RefundItems' } & Pick<
                        RefundItems,
                        | 'id'
                        | 'invoiceLineItemId'
                        | 'entitlementId'
                        | 'quantity'
                        | 'description'
                        | 'total'
                        | 'totalExTax'
                        | 'totalTax'
                        | 'taxRate'
                        | 'taxableAmount'
                        | 'taxExemptAmount'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      slaCredits?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SlaCreditApplications' } & Pick<
              SlaCreditApplications,
              | 'amountExTax'
              | 'amountIncTax'
              | 'createdAt'
              | 'creditExternalId'
              | 'currency'
              | 'currencyExchangeRate'
              | 'modifiedAt'
              | 'notes'
              | 'taxAmount'
              | 'taxRate'
            >
          >
        >
      >;
    };
};

export type FetchInvoicesTotalCountForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type FetchInvoicesTotalCountForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      hamsInvoices?: Maybe<
        { __typename?: 'HamsInvoice' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'Invoice' } & Pick<Invoice, 'id'>>>>;
        }
      >;
      invoices?: Maybe<{ __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'>>;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'paymentIssue' | 'type' | 'default'> & {
                        card?: Maybe<
                          { __typename?: 'CreditCardDetails' } & Pick<
                            CreditCardDetails,
                            'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                          >
                        >;
                      })
                  | ({ __typename?: 'PaymentOnTerms' } & Pick<
                      PaymentOnTerms,
                      'totalCreditLimit' | 'paymentMethod' | 'id' | 'paymentIssue' | 'type' | 'default'
                    > & {
                        terms?: Maybe<
                          { __typename?: 'PaymentOnTermsDetails' } & Pick<
                            PaymentOnTermsDetails,
                            'invoiceDueDays' | 'payOnStatement'
                          >
                        >;
                      })
                >
              >
            >;
          }
      >;
    };
};

export type FetchOrdersByOrderLineIdQueryVariables = Exact<{
  transactionAccountId: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchOrdersByOrderLineIdQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    orders?: Maybe<
      { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
          nodes: Array<Maybe<{ __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber'>>>;
        }
    >;
  };
};

export type OverageFragment = { __typename?: 'InvoiceLineItems' } & {
  overage?: Maybe<
    { __typename?: 'Overage' } & Pick<
      Overage,
      'totalAccruedSubtotal' | 'totalUsersAdded' | 'totalTaxApplied' | 'totalMarginsApplied' | 'totalDiscountsApplied'
    > & {
        lineItems?: Maybe<Array<Maybe<{ __typename?: 'InvoiceLineItems' } & LineItemDetailsForInvoiceInPpcFragment>>>;
      }
  >;
};

export type FetchOrderDetailForTransactionAccountQueryVariables = Exact<{
  transactionAccountId: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  fetchIsExternallyBilled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchOrderDetailForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<
                  Order,
                  | 'id'
                  | 'orderNumber'
                  | 'billingContactEmail'
                  | 'created'
                  | 'contextSubject'
                  | 'contextSubjectId'
                  | 'currency'
                  | 'sourceSystem'
                  | 'purchaseOrderNumber'
                > & {
                    billTo?: Maybe<
                      { __typename?: 'OrderBillTo' } & Pick<
                        OrderBillTo,
                        | 'billToCompanyName'
                        | 'billToAccountId'
                        | 'billToCity'
                        | 'billToAddress1'
                        | 'billToAddress2'
                        | 'billToCountry'
                        | 'billToState'
                        | 'billToPostalCode'
                      >
                    >;
                    shipTo?: Maybe<
                      { __typename?: 'OrderShipTo' } & Pick<
                        OrderShipTo,
                        | 'shipToCompanyName'
                        | 'shipToAccountId'
                        | 'shipToCity'
                        | 'shipToAddress1'
                        | 'shipToAddress2'
                        | 'shipToCountry'
                        | 'shipToState'
                        | 'shipToPostalCode'
                      >
                    >;
                    authorProfile?: Maybe<
                      { __typename?: 'AuthorProfile' } & Pick<AuthorProfile, 'name' | 'email' | 'picture'>
                    >;
                    invoiceGroup?: Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name'> & {
                          shipToParty?: Maybe<{ __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'name'>>;
                        }
                    >;
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    metadataObj?: Maybe<
                      { __typename?: 'OrderMetadataObj' } & Pick<
                        OrderMetadataObj,
                        | 'supportTicketNumber'
                        | 'handNote'
                        | 'termsOfTransfer'
                        | 'reasonCode'
                        | 'newBillingAdmin'
                        | 'currentBillingAdmin'
                        | 'contractId'
                        | 'contractType'
                      >
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'quantity'
                              | 'type'
                              | 'skipTrial'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                              | 'edition'
                              | 'entitlementId'
                              | 'entitlementNumber'
                              | 'parentEntitlementId'
                              | 'productName'
                              | 'productId'
                            > & {
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        'id' | 'title' | 'status' | 'type' | 'promotionCode'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                > & {
                                                    values?: Maybe<
                                                      Array<
                                                        Maybe<
                                                          { __typename?: 'BenefitsValueObj' } & Pick<
                                                            BenefitsValueObj,
                                                            'appliedOn' | 'value'
                                                          >
                                                        >
                                                      >
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'>
                                >;
                                orderLineItemsPurchaseMetadata?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                        OrderLineItemsPurchaseMetadataType,
                                        'fieldName' | 'fieldValue'
                                      >
                                    >
                                  >
                                >;
                                orderLineItemsAccountModification?: Maybe<
                                  { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                    OrderLineItemsAccountModification,
                                    'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type FetchOrderDetailsQueryVariables = Exact<{
  filterOptions?: Maybe<FilterOption>;
  transactionAccountId: Scalars['ID'];
}>;

export type FetchOrderDetailsQuery = { __typename?: 'Query' } & {
  orderDetailV2?: Maybe<
    { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
        nodes: Array<
          Maybe<
            { __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber' | 'created' | 'contextSubject'> & {
                billTo?: Maybe<
                  { __typename?: 'OrderBillTo' } & Pick<
                    OrderBillTo,
                    | 'billToCompanyName'
                    | 'billToAccountId'
                    | 'billToCity'
                    | 'billToAddress1'
                    | 'billToAddress2'
                    | 'billToCountry'
                    | 'billToState'
                    | 'billToPostalCode'
                  >
                >;
                orderLineItems?: Maybe<
                  { __typename?: 'OrderLineItemConnection' } & {
                    nodes: Array<
                      Maybe<
                        { __typename?: 'OrderLineItem' } & Pick<
                          OrderLineItem,
                          | 'lineItemId'
                          | 'entitlementId'
                          | 'entitlementNumber'
                          | 'type'
                          | 'skipTrial'
                          | 'status'
                          | 'quantity'
                          | 'orderTransitionType'
                          | 'salesTransitionType'
                          | 'parentEntitlementId'
                          | 'productName'
                          | 'productId'
                          | 'cloudSiteHostname'
                          | 'nextBillingAnchorTimestamp'
                          | 'logoId'
                        > & {
                            pricingPlan?: Maybe<
                              { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type' | 'billingFrequency'>
                            >;
                            offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                            orderLineItemsPurchaseMetadata?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                    OrderLineItemsPurchaseMetadataType,
                                    'fieldName' | 'fieldValue'
                                  >
                                >
                              >
                            >;
                            orderLineItemsAccountModification?: Maybe<
                              { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                OrderLineItemsAccountModification,
                                'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                              >
                            >;
                            promotions?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'Promotion' } & Pick<
                                    Promotion,
                                    'id' | 'title' | 'status' | 'type' | 'promotionCode'
                                  > & {
                                      benefits?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'Benefit' } & Pick<
                                              Benefit,
                                              'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                            >
                                          >
                                        >
                                      >;
                                      promotionWindow?: Maybe<
                                        { __typename?: 'PromotionWindow' } & Pick<
                                          PromotionWindow,
                                          'endTime' | 'startTime'
                                        >
                                      >;
                                      eligibilityRules?: Maybe<
                                        { __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >;
                  }
                >;
              }
          >
        >;
      }
  >;
};

export type FetchInvoiceGroupDetailsForQuoteDetailsPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  txaId: Scalars['ID'];
}>;

export type FetchInvoiceGroupDetailsForQuoteDetailsPpcQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name'> & {
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'state' | 'postcode' | 'taxId'
          >
        >;
        termPaymentStatus?: Maybe<
          { __typename?: 'TermDetailsAccountConnection' } & Pick<TermDetailsAccountConnection, 'status'>
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type' | 'default'> & {
                card?: Maybe<
                  { __typename?: 'CreditCardDetails' } & Pick<
                    CreditCardDetails,
                    'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand' | 'cardHolderName'
                  >
                >;
              })
          | ({ __typename?: 'PaymentOnTerms' } & Pick<
              PaymentOnTerms,
              'totalCreditLimit' | 'paymentMethod' | 'id' | 'type' | 'default'
            > & {
                terms?: Maybe<
                  { __typename?: 'PaymentOnTermsDetails' } & Pick<
                    PaymentOnTermsDetails,
                    'invoiceDueDays' | 'payOnStatement'
                  >
                >;
              })
        >;
      }
  >;
};

export type FetchCloudSitesInPpcQueryVariables = Exact<{
  searchParams?: Maybe<CloudSiteSearchParams>;
}>;

export type FetchCloudSitesInPpcQuery = { __typename?: 'Query' } & {
  partnerCloudSites?: Maybe<
    { __typename?: 'CloudSiteDataConnection' } & Pick<CloudSiteDataConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'CloudSiteData' } & Pick<CloudSiteData, 'cloudSiteId' | 'cloudSiteHostname'> & {
                  shipToParty?: Maybe<
                    { __typename?: 'CommerceAddress' } & Pick<
                      CommerceAddress,
                      'id' | 'name' | 'addressLine1' | 'addressLine2' | 'state' | 'postcode' | 'country' | 'city'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchDirectMatchesForSearchInPpcQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchDirectMatchesForSearchInPpcQuery = { __typename?: 'Query' } & {
  searchForDirectMatch?: Maybe<
    { __typename?: 'DirectMatch' } & Pick<
      DirectMatch,
      'id' | 'entity' | 'identifier' | 'parentEntity' | 'parentIdentifier' | 'sourceSystem'
    >
  >;
};

export type FetchEndCustomerContactsInPpcQueryVariables = Exact<{
  searchParams?: Maybe<EndCustomerContactSearchParams>;
}>;

export type FetchEndCustomerContactsInPpcQuery = { __typename?: 'Query' } & {
  endCustomerContacts?: Maybe<
    { __typename?: 'EndCustomerContactConnection' } & Pick<EndCustomerContactConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'EndCustomerContact' } & Pick<
                EndCustomerContact,
                'picture' | 'name' | 'accountId' | 'email'
              >
            >
          >
        >;
      }
  >;
};

export type FetchPromotionsByIdsInPpcQueryVariables = Exact<{
  params?: Maybe<PromotionsInputParams>;
}>;

export type FetchPromotionsByIdsInPpcQuery = { __typename?: 'Query' } & {
  promotions?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Promotion' } & Pick<
          Promotion,
          'id' | 'status' | 'title' | 'type' | 'pricingType' | 'promotionInstanceId' | 'promotionCode'
        > & {
            benefits?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Benefit' } & Pick<
                    Benefit,
                    'benefitType' | 'scale' | 'subBenefitType' | 'value' | 'duration' | 'iterations'
                  > & {
                      values?: Maybe<
                        Array<
                          Maybe<{ __typename?: 'BenefitsValueObj' } & Pick<BenefitsValueObj, 'appliedOn' | 'value'>>
                        >
                      >;
                    }
                >
              >
            >;
            eligibilityRules?: Maybe<{ __typename?: 'EligibilityRule' } & Pick<EligibilityRule, 'currency'>>;
            applicationReason?: Maybe<{ __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id'>>;
          }
      >
    >
  >;
};

export type FetchInvoiceForEntitlementIdQueryVariables = Exact<{
  entitlementId: Scalars['ID'];
  invoiceRequestItemIds?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  txaId: Scalars['ID'];
}>;

export type FetchInvoiceForEntitlementIdQuery = { __typename?: 'Query' } & {
  invoiceForEntitlementId: { __typename?: 'Invoice' } & Pick<Invoice, 'id' | 'invoiceNumber'> & {
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'InvoiceLineItems' } & Pick<
              InvoiceLineItems,
              'entitlementId' | 'amount' | 'subtotal' | 'startDate' | 'endDate' | 'taxRate'
            > & {
                taxItems?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'TaxItems' } & Pick<
                        TaxItems,
                        'id' | 'tax' | 'taxAmountLabel' | 'taxId' | 'taxIdLabel' | 'taxPercent'
                      >
                    >
                  >
                >;
                margins?: Maybe<Array<Maybe<{ __typename?: 'InvoiceMargins' } & Pick<InvoiceMargins, 'amount'>>>>;
              }
          >
        >
      >;
    };
};
export type FetchInvoicesForTransactionAccountInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<InvoicesFilterOptions>;
}>;

export type FetchInvoicesForTransactionAccountInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'paymentCurrency'
                    | 'transactionAccountId'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchInvoicesForTransactionAccountWithContextQueryVariables = Exact<{
  id: Scalars['ID'];
  queryString?: Maybe<Scalars['String']>;
  partnerSearchContext?: Maybe<PartnerSearchContext>;
  pageParams?: Maybe<InvoicePageParams>;
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchInvoicesForTransactionAccountWithContextQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      partnerInvoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'paymentMethodId'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'paymentCurrency'
                    | 'pricingCurrency'
                    | 'pdfLink'
                    | 'transactionAccountId'
                    | 'status'
                    | 'purchaseOrderNumber'
                  > & { createdDate: Invoice['createdTimestamp']; grandTotal: Invoice['total'] } & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              | 'id'
                              | 'type'
                              | 'createdDate'
                              | 'creditNoteNumber'
                              | 'sourceSystem'
                              | 'total'
                              | 'currency'
                              | 'status'
                              | 'arn'
                            >
                          >
                        >
                      >;
                      dunningStatus?: Maybe<
                        Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                            address?: Maybe<
                              { __typename?: 'InvoiceAddress' } & Pick<
                                InvoiceAddress,
                                'address1' | 'address2' | 'city' | 'state' | 'country' | 'postalCode'
                              >
                            >;
                          }
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

export type FetchRefundsInPpcQueryVariables = Exact<{
  searchParams: RefundSearchParams;
}>;

export type FetchRefundsInPpcQuery = { __typename?: 'Query' } & {
  partnerRefunds?: Maybe<
    { __typename?: 'RefundConnection' } & {
      results?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Refunds' } & Pick<
              Refunds,
              | 'id'
              | 'creditNoteNumber'
              | 'transactionAccountId'
              | 'status'
              | 'arn'
              | 'createdDate'
              | 'sourceSystem'
              | 'total'
              | 'requestedBy'
            > & {
                shipTo?: Maybe<
                  { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                      address?: Maybe<
                        { __typename?: 'InvoiceAddress' } & Pick<
                          InvoiceAddress,
                          'address1' | 'address2' | 'city' | 'state' | 'postalCode' | 'country'
                        >
                      >;
                    }
                >;
              }
          >
        >
      >;
    }
  >;
};

export type FetchEntitlementIdsForEndCustomerContactQueryVariables = Exact<{
  searchParams?: Maybe<EndCustomerContactSearchParams>;
}>;

export type FetchEntitlementIdsForEndCustomerContactQuery = { __typename?: 'Query' } & {
  endCustomerContacts?: Maybe<
    { __typename?: 'EndCustomerContactConnection' } & Pick<EndCustomerContactConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'EndCustomerContact' } & Pick<
                EndCustomerContact,
                'picture' | 'name' | 'accountId' | 'email'
              > & {
                  entitlements?: Maybe<
                    { __typename?: 'EndCustomerContactEntitlements' } & Pick<
                      EndCustomerContactEntitlements,
                      'entitlementIds'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchInvoiceGroupsForPpcSearchQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
  transactionAccountId: Scalars['ID'];
}>;

export type FetchInvoiceGroupsForPpcSearchQuery = { __typename?: 'Query' } & {
  invoiceGroups?: Maybe<
    { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
        nodes: Array<Maybe<{ __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'>>>;
      }
  >;
};

export type FetchPartnerProductEntitlementsQueryVariables = Exact<{
  searchParams?: Maybe<ProductEntitlementSearchParams>;
  pageParams?: Maybe<ProductEntitlementPageParams>;
  fetchIsExternallyEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchPartnerProductEntitlementsQuery = { __typename?: 'Query' } & {
  partnerProductEntitlements?: Maybe<
    { __typename?: 'TransactionAccountProductConnection' } & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'TransactionAccountProduct' } & MakeOptional<
              Pick<
                TransactionAccountProduct,
                | 'id'
                | 'logoId'
                | 'isApp'
                | 'orgId'
                | 'orgName'
                | 'billedUsers'
                | 'billingCycle'
                | 'billingStatus'
                | 'billingFrequency'
                | 'cloudSiteId'
                | 'cloudSiteHostname'
                | 'provisioningStatus'
                | 'latestPeriodEndDate'
                | 'productName'
                | 'productId'
                | 'edition'
                | 'entitlementNumber'
                | 'linkedAppsId'
                | 'isExternallyBilled'
                | 'billingGroupId'
              >,
              'isExternallyBilled'
            > & {
                relatesToEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'RelatedEntitlementDetails' } & Pick<
                        RelatedEntitlementDetails,
                        'entitlementId' | 'relationshipType'
                      >
                    >
                  >
                >;
                chargeQuantities?: Maybe<
                  Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'chargeElement' | 'quantity'>>>
                >;
                shipTo?: Maybe<
                  { __typename?: 'InvoiceBillAndShipTo' } & Pick<InvoiceBillAndShipTo, 'id' | 'fullName'> & {
                      address?: Maybe<
                        { __typename?: 'InvoiceAddress' } & Pick<
                          InvoiceAddress,
                          'address1' | 'address2' | 'city' | 'state' | 'postalCode' | 'country'
                        >
                      >;
                    }
                >;
                pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & Pick<PricingPlan, 'id' | 'type'>>;
              }
          >
        >
      >;
    }
  >;
};

export type FetchAuditTrailDetailsQueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
}>;

export type FetchAuditTrailDetailsQuery = { __typename?: 'Query' } & {
  fetchAuditTrails?: Maybe<
    { __typename?: 'AuditNoteResult' } & Pick<AuditNoteResult, 'totalHits'> & {
        results?: Maybe<Array<Maybe<{ __typename?: 'AuditNote' } & Pick<AuditNote, 'author' | 'body' | 'created'>>>>;
      }
  >;
};

export type FetchContactDetailsQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type FetchContactDetailsQuery = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & Pick<
      Contact,
      'fullName' | 'businessKey' | 'phone' | 'email' | 'dataSource' | 'domain'
    > & {
        address?: Maybe<
          { __typename?: 'Address' } & Pick<
            Address,
            'address1' | 'address2' | 'address3' | 'city' | 'country' | 'postalCode' | 'state'
          >
        >;
        atlassianAccount?: Maybe<
          { __typename?: 'AtlassianAccountDetails' } & Pick<
            AtlassianAccountDetails,
            | 'id'
            | 'active'
            | 'created'
            | 'hasVerifiedEmail'
            | 'organizationId'
            | 'organizationName'
            | 'updated'
            | 'atlassianAccessStatus'
          >
        >;
        communityAccount?: Maybe<
          { __typename?: 'CommunityUser' } & Pick<CommunityUser, 'id' | 'aaid' | 'viewProfileUrl' | 'topicsQuery'>
        >;
        accountPrivacySettings?: Maybe<
          Array<
            Maybe<
              { __typename?: 'AccountPrivacySettings' } & Pick<AccountPrivacySettings, 'fieldName' | 'fieldVisibility'>
            >
          >
        >;
        cloudSiteAccess?: Maybe<
          { __typename?: 'CloudSiteAccess' } & Pick<CloudSiteAccess, 'totalHits'> & {
              results?: Maybe<
                Array<
                  Maybe<{ __typename?: 'SiteAccess' } & Pick<SiteAccess, 'cloudSiteId' | 'cloudSiteUrl' | 'migrated'>>
                >
              >;
            }
        >;
        organizations?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Organizations' } & Pick<Organizations, 'id' | 'name'> & {
                  domains?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'Domains' } & Pick<
                          Domains,
                          'domain' | 'verified' | 'status' | 'verificationType' | 'timestamp'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchInvoicesForContactQueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchInvoicesForContactQuery = { __typename?: 'Query' } & {
  fetchContact?: Maybe<
    { __typename?: 'Contact' } & Pick<Contact, 'email'> & {
        invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'dueDate'
                    | 'updatedDate'
                    | 'total'
                    | 'paymentCurrency'
                  > & {
                      creditCard?: Maybe<
                        { __typename?: 'CreditCardDetails' } & Pick<
                          CreditCardDetails,
                          'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                        >
                      >;
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              'id' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          };
      }
  >;
};

export type FetchServerLicensesByEmailQueryVariables = Exact<{
  params: SearchServerLicenses;
}>;

export type FetchServerLicensesByEmailQuery = { __typename?: 'Query' } & {
  fetchServerLicensesByEmail?: Maybe<
    { __typename?: 'ServerLicenseResults' } & Pick<
      ServerLicenseResults,
      'activeMaintenance' | 'expiredMaintenance' | 'totalHits'
    > & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'ServerLicense' } & Pick<
                ServerLicense,
                | 'accountId'
                | 'baseProduct'
                | 'billingContactEmail'
                | 'billingCycle'
                | 'billingStatus'
                | 'businessKey'
                | 'createdDate'
                | 'entitlementGroupId'
                | 'firstPeriodEndDate'
                | 'firstPeriodStartDate'
                | 'id'
                | 'isAddon'
                | 'isCloud'
                | 'latestPeriodEndDate'
                | 'latestPeriodStartDate'
                | 'licenseLevel'
                | 'maintenancePeriod'
                | 'planType'
                | 'platform'
                | 'productId'
                | 'productName'
                | 'renewalAction'
                | 'sen'
                | 'sources'
                | 'unitCount'
                | 'unitLabel'
                | 'updatedDate'
              >
            >
          >
        >;
      }
  >;
};

export type FetchServiceLicensesByEmailQueryVariables = Exact<{
  params: SearchServiceLicenses;
}>;

export type FetchServiceLicensesByEmailQuery = { __typename?: 'Query' } & {
  fetchServiceLicensesByEmail?: Maybe<
    { __typename?: 'ServiceLicenseResults' } & Pick<ServiceLicenseResults, 'totalHits'> & {
        results?: Maybe<
          Array<
            Maybe<
              { __typename?: 'ServerLicense' } & Pick<
                ServerLicense,
                | 'accountId'
                | 'baseProduct'
                | 'billingContactEmail'
                | 'billingCycle'
                | 'billingStatus'
                | 'businessKey'
                | 'createdDate'
                | 'entitlementGroupId'
                | 'firstPeriodEndDate'
                | 'firstPeriodStartDate'
                | 'id'
                | 'isAddon'
                | 'isCloud'
                | 'latestPeriodEndDate'
                | 'latestPeriodStartDate'
                | 'licenseLevel'
                | 'maintenancePeriod'
                | 'planType'
                | 'platform'
                | 'productId'
                | 'productName'
                | 'renewalAction'
                | 'sen'
                | 'sources'
                | 'unitCount'
                | 'unitLabel'
                | 'updatedDate'
              >
            >
          >
        >;
      }
  >;
};

export type FetchOppsForContactsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchOppsForContactsQuery = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        opportunities: { __typename?: 'OpportunityConnection' } & Pick<OpportunityConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Opportunity' } & Pick<
                    Opportunity,
                    'id' | 'accountName' | 'saleType' | 'amount' | 'netOrderAmount' | 'stageName' | 'ownerName'
                  > & {
                      opportunityLineItems?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'OpportunityLineItem' } & Pick<OpportunityLineItem, 'inventoryProductName'>
                          >
                        >
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode'
                        >
                      >;
                      billTo?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode' | 'phone'
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          };
      }
  >;
};

export type FetchTransactionAccountSearchByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchTransactionAccountSearchByEmailQuery = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        transactionAccounts: { __typename?: 'TransactionAccountConnection' } & Pick<
          TransactionAccountConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccount' } & Pick<
                    TransactionAccount,
                    'displayName' | 'id' | 'transactionAccountNumber'
                  >
                >
              >
            >;
          };
      }
  >;
};

export type OpsgenieSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OpsgenieSummaryQuery = { __typename?: 'Query' } & {
  opsgenie?: Maybe<
    { __typename?: 'Opsgenie' } & Pick<
      Opsgenie,
      | 'baseProduct'
      | 'id'
      | 'plan'
      | 'renewalAction'
      | 'billingFrequency'
      | 'latestPeriodEndDate'
      | 'latestPeriodStartDate'
      | 'platform'
      | 'productId'
      | 'billingStatus'
      | 'productName'
    >
  >;
};

export type FetchAvailableOfferingsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchAvailableOfferingsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id' | 'edition' | 'plan' | 'transactionAccountId'> & {
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<
          Offering,
          'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType'
        > & {
            availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name' | 'units'>>>>;
        }
      >;
      availableOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<
              Offering,
              'id' | 'name' | 'level' | 'key' | 'sku' | 'productKey' | 'pricingType'
            > & {
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
                availableSyntheticPricingPlans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'SyntheticPricingPlan' } & Pick<
                        SyntheticPricingPlan,
                        'type' | 'status' | 'discountPercentage'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      validOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ValidOfferings' } & Pick<ValidOfferings, 'key' | 'offeringKey' | 'offeringName' | 'status'>
          >
        >
      >;
    };
};

export type FetchAvailablePromotionsForStatusPageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  intendedBillingPeriodState?: Maybe<Scalars['String']>;
}>;

export type FetchAvailablePromotionsForStatusPageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id' | 'subscriptionId' | 'productId' | 'edition'> & {
      billingFrequency: Statuspage['billingCycle'];
    } & {
      availablePromotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType' | 'isPromotionCustomisable' | 'type'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
                customisableReasons?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>>
                  >
                >;
              }
          >
        >
      >;
    };
};

export type EntitlementDetailFragment = { __typename?: 'CloudSiteProduct' } & Pick<
  CloudSiteProduct,
  | 'accountId'
  | 'id'
  | 'sen'
  | 'edition'
  | 'editionKey'
  | 'trial'
  | 'firstPeriodStartDate'
  | 'latestPeriodStartDate'
  | 'latestPeriodEndDate'
  | 'productId'
  | 'productName'
  | 'billingStatus'
  | 'endTimestamp'
  | 'isCloud'
  | 'cloudSiteUrl'
  | 'billingFrequency'
  | 'entitlementNumber'
  | 'trialStartDate'
  | 'trialEndDate'
  | 'nextBillingTimestamp'
  | 'userTier'
  | 'transactionAccountNumber'
  | 'transactionAccountId'
  | 'invoiceGroupId'
  | 'billedUsers'
  | 'billingCycle'
  | 'isSandbox'
  | 'isApp'
  | 'provisioningStatus'
  | 'activeUsers'
  | 'logoId'
  | 'planType'
  | 'isAddOn'
> & {
    upgradeTrial?: Maybe<
      { __typename?: 'UpgradeTrialDetails' } & Pick<
        UpgradeTrialDetails,
        'offeringName' | 'offeringId' | 'baseOfferingName'
      >
    >;
    scheduledChanges?: Maybe<
      { __typename?: 'ScheduledChanges' } & Pick<ScheduledChanges, 'subscriptionScheduleAction'>
    >;
    offering?: Maybe<
      { __typename?: 'Offering' } & Pick<Offering, 'name'> & {
          relationshipRequirements?: Maybe<
            Array<
              Maybe<
                { __typename?: 'RelationshipRequirement' } & Pick<RelationshipRequirement, 'side' | 'level' | 'type'>
              >
            >
          >;
        }
    >;
    relatesFromEntitlements?: Maybe<
      Array<Maybe<{ __typename?: 'Relationship' } & Pick<Relationship, 'relationshipType'>>>
    >;
  };

export type ProductAppSubscriptionForOrganizationFragment = { __typename?: 'ProductAppSubscriptionForCloudSite' } & {
  products: Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailFragment>>;
  apps: Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailFragment>>;
};

export type FetchCloudSiteProductAppAndSubscriptionsForOrganizationQueryVariables = Exact<{
  parentSen?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
}>;

export type FetchProductsForOrganizationPpcQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>>>;
}>;

export type FetchProductsForOrganizationPpcQuery = { __typename?: 'Query' } & {
  productsForOrganizationPPC: Array<Maybe<{ __typename?: 'CloudSiteProduct' } & EntitlementDetailFragment>>;
};

export type FetchCloudSiteProductAppAndSubscriptionsForOrganizationQuery = { __typename?: 'Query' } & {
  cloudSiteProductsAppsAndSubscriptionsForOrganization: { __typename?: 'ProductAppSubscriptionForCloudSiteData' } & {
    jira: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionForOrganizationFragment;
    statuspage: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionForOrganizationFragment;
    confluence: { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionForOrganizationFragment;
    other?: Maybe<
      { __typename?: 'ProductAppSubscriptionForCloudSite' } & ProductAppSubscriptionForOrganizationFragment
    >;
  };
};

export type FetchCloudSitesForOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
  editionFilter?: Maybe<Scalars['Boolean']>;
  transactionAccountId?: Maybe<Scalars['String']>;
}>;

export type FetchCloudSitesForOrganizationQuery = { __typename?: 'Query' } & {
  cloudSitesForOrganization: Array<
    Maybe<
      { __typename?: 'CloudSiteDetail' } & Pick<
        CloudSiteDetail,
        'cloudSiteId' | 'cloudSiteHostname' | 'parentEntitlementId'
      >
    >
  >;
};

export type FetchInvoicesForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchInvoicesForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id' | 'transactionAccountId'> & {
      invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'status'
                  | 'invoiceNumber'
                  | 'sourceSystem'
                  | 'paymentMethod'
                  | 'paymentMethodId'
                  | 'transactionAccountId'
                  | 'pdfLink'
                  | 'dueDate'
                  | 'createdDate'
                  | 'itemsTotal'
                  | 'grandTotal'
                  | 'paymentCurrency'
                > & {
                    creditCard?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'cardHolderName' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                    paymentOnTermsDetails?: Maybe<
                      { __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type' | 'default'> & {
                          terms?: Maybe<
                            { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                          >;
                        }
                    >;
                    refunds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Refunds' } & Pick<
                            Refunds,
                            | 'id'
                            | 'type'
                            | 'creditNoteNumber'
                            | 'sourceSystem'
                            | 'total'
                            | 'currency'
                            | 'status'
                            | 'arn'
                          >
                        >
                      >
                    >;
                    dunningStatus?: Maybe<
                      Array<Maybe<{ __typename?: 'DunningStatus' } & Pick<DunningStatus, 'errorCode'>>>
                    >;
                    transactionAccount?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'TransactionAccount' } & Pick<
                            TransactionAccount,
                            'transactionAccountNumber' | 'id'
                          >
                        >
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

export type FetchOrdersForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchOrdersForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<
                  Order,
                  'id' | 'orderNumber' | 'created' | 'contextSubject' | 'hasPendingInvoice'
                > & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    invoiceGroup?: Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name'> & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode'
                            >
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                        }
                    >;
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    metadataObj?: Maybe<
                      { __typename?: 'OrderMetadataObj' } & Pick<
                        OrderMetadataObj,
                        | 'supportTicketNumber'
                        | 'handNote'
                        | 'termsOfTransfer'
                        | 'reasonCode'
                        | 'newBillingAdmin'
                        | 'currentBillingAdmin'
                      >
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'skipTrial'
                              | 'orderLineItemsAdditionalNotes'
                              | 'offeringId'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                                orderLineItemsPurchaseMetadata?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'orderLineItemsPurchaseMetadataType' } & Pick<
                                        OrderLineItemsPurchaseMetadataType,
                                        'fieldName' | 'fieldValue'
                                      >
                                    >
                                  >
                                >;
                                orderLineItemsAccountModification?: Maybe<
                                  { __typename?: 'OrderLineItemsAccountModification' } & Pick<
                                    OrderLineItemsAccountModification,
                                    'accountModificationTransactionAccountId' | 'accountModificationInvoiceGroupId'
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                    billTo?: Maybe<{ __typename?: 'OrderBillTo' } & Pick<OrderBillTo, 'billToAccountId'>>;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchOrdersForRewindOnStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchOrdersForRewindOnStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      ordersForRewind?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber' | 'created' | 'contextSubject'> & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'name' | 'id'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        | 'id'
                                        | 'title'
                                        | 'status'
                                        | 'cycleInterval'
                                        | 'pricingType'
                                        | 'isPromotionCustomisable'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  | 'benefitType'
                                                  | 'subBenefitType'
                                                  | 'iterations'
                                                  | 'value'
                                                  | 'scale'
                                                  | 'type'
                                                  | 'duration'
                                                > & {
                                                    customisable?: Maybe<
                                                      { __typename?: 'BenefitCustomisableObj' } & Pick<
                                                        BenefitCustomisableObj,
                                                        'duration'
                                                      > & {
                                                          value?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                          iterations?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                          eligibilityRules?: Maybe<
                                            { __typename?: 'EligibilityRule' } & Pick<
                                              EligibilityRule,
                                              | 'products'
                                              | 'cycleInterval'
                                              | 'pricingType'
                                              | 'partnerType'
                                              | 'partnerTier'
                                              | 'saleTransitionType'
                                              | 'currency'
                                            >
                                          >;
                                          applicationReason?: Maybe<
                                            { __typename?: 'PromotionReason' } & Pick<
                                              PromotionReason,
                                              'id' | 'readableName'
                                            > & {
                                                customisable?: Maybe<
                                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                                    id?: Maybe<
                                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                                        PromotionReasonListObj,
                                                        'type'
                                                      > & {
                                                          anyOf?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                                  ReasonCustomisableObj,
                                                                  'readableName' | 'id'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type AuditTrailQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type AuditTrailQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      auditNotes?: Maybe<
        { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<{ __typename?: 'AuditNote' } & Pick<AuditNote, 'body' | 'author' | 'created' | 'contactKey'>>
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchEmailsForStatuspagePageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchEmailsForStatuspagePageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      emails?: Maybe<
        { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EmailEdge' } & {
                    node: { __typename?: 'Email' } & Pick<
                      Email,
                      'subject' | 'size' | 'id' | 'html' | 'text' | 'date'
                    > & {
                        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      };
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchStatuspageDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchStatuspageDetailsQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<
    Statuspage,
    | 'createdDate'
    | 'billingStatus'
    | 'cloudSiteHostname'
    | 'cloudSiteCustomHostname'
    | 'cloudSiteId'
    | 'cloudSiteSen'
    | 'entitlementNumber'
    | 'updatePaymentMethodLink'
    | 'hasPendingInvoices'
    | 'nextInvoiceTimeAt'
    | 'id'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'firstPeriodStartDate'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'licenseLevel'
    | 'offeringId'
    | 'version'
    | 'edition'
    | 'parentSen'
    | 'parentCloudSiteName'
    | 'platform'
    | 'productId'
    | 'productName'
    | 'baseProduct'
    | 'renewalAction'
    | 'sourceSystem'
    | 'plan'
    | 'subscriptionId'
    | 'unitCount'
    | 'activeSubscriptionBillingGroupId'
    | 'activeUsers'
    | 'totalBilledUsers'
    | 'provisioningStatus'
  > & { billingFrequency: Statuspage['billingCycle'] } & {
      addOns?: Maybe<{ __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'>>;
      availablePromotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title'> & {
                benefits?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'Benefit' } & Pick<Benefit, 'benefitType' | 'type' | 'duration' | 'value'>>
                  >
                >;
              }
          >
        >
      >;
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name' | 'pricingType'> & {
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      promotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              | 'id'
              | 'title'
              | 'status'
              | 'cycleInterval'
              | 'pricingType'
              | 'cycleIntervalWithEligibleConditions'
              | 'isPromotionCustomisable'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
              }
          >
        >
      >;
      trialPromotionDetails?: Maybe<
        { __typename?: 'TrialPromotionDetails' } & Pick<TrialPromotionDetails, 'totalTrialDays' | 'totalTrialCount'>
      >;
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
      pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>>;
      scheduledChanges?: Maybe<{ __typename?: 'ScheduledChanges' } & ScheduledChangesForScheduledChangesTabFragment>;
      subscription?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SubscriptionDetails' } & {
              subscriptionPeriod?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'SubscriptionPeriodDetails' } & Pick<SubscriptionPeriodDetails, 'startTimestamp'>
                  >
                >
              >;
            }
          >
        >
      >;
    } & SubscribeToAddOnsFormData_Statuspage_Fragment;
};

export type FetchSiteAdminsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchSiteAdminsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      siteAdmins?: Maybe<
        { __typename?: 'SiteAdminConnection' } & Pick<SiteAdminConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SiteAdmin' } & Pick<
                    SiteAdmin,
                    'displayName' | 'primaryEmail' | 'roles' | 'lastActive'
                  >
                >
              >
            >;
          }
      >;
    };
};

export type FetchSupportIssuesForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  searchParam?: Maybe<SupportIssueEntitlementSearchParams>;
}>;

export type FetchSupportIssuesForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id' | 'entitlementNumber'> & {
      supportIssues?: Maybe<
        { __typename?: 'SupportIssues' } & Pick<SupportIssues, 'totalHits'> & {
            results: Array<
              Maybe<
                { __typename?: 'SupportIssue' } & Pick<
                  SupportIssue,
                  'id' | 'issueKey' | 'summary' | 'currentStatus' | 'reporterEmailAddress' | 'updatedTimestamp'
                >
              >
            >;
          }
      >;
    };
};

export type FetchUsersForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchUsersForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      users?: Maybe<
        { __typename?: 'UserConnection' } & Pick<UserConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            nodes?: Maybe<
              Array<
                Maybe<{ __typename?: 'User' } & Pick<User, 'displayName' | 'primaryEmail' | 'roles' | 'lastActive'>>
              >
            >;
          }
      >;
    };
};

export type FetchTransactionAccountForStatuspageQueryVariables = Exact<{
  entitlementId?: Maybe<Scalars['String']>;
}>;

export type FetchTransactionAccountForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      transactionAccount?: Maybe<
        { __typename?: 'TransactionAccount' } & Pick<
          TransactionAccount,
          'id' | 'displayName' | 'partnerLevel' | 'transactionAccountNumber' | 'billToPartyPricingEligibilty'
        > & {
            availablePaymentMethods?: Maybe<
              { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
                  nodes?: Maybe<
                    Array<
                      Maybe<
                        | ({ __typename?: 'CreditCard' } & Pick<
                            CreditCard,
                            'id' | 'type' | 'default' | 'paymentIssue'
                          > & {
                              card?: Maybe<
                                { __typename?: 'CreditCardDetails' } & Pick<
                                  CreditCardDetails,
                                  'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                >
                              >;
                            })
                        | ({ __typename?: 'PaymentOnTerms' } & Pick<
                            PaymentOnTerms,
                            'id' | 'type' | 'default' | 'paymentIssue'
                          > & {
                              terms?: Maybe<
                                { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                              >;
                            })
                      >
                    >
                  >;
                }
            >;
            billToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
              >
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                    >;
                  })
            >;
            billingAdmins?: Maybe<
              { __typename?: 'BillingAdminConnection' } & {
                nodes?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'email' | 'atlassianAccountId' | 'fullName'>
                    >
                  >
                >;
              }
            >;
            availableInvoiceGroups?: Maybe<
              { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
                  nodes: Array<
                    Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<
                        InvoiceGroup,
                        'id' | 'name' | 'currency' | 'shipToPriceEligibility'
                      > & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              | 'id'
                              | 'name'
                              | 'addressLine1'
                              | 'addressLine2'
                              | 'city'
                              | 'state'
                              | 'country'
                              | 'postcode'
                              | 'taxId'
                            >
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'paymentIssue'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'paymentIssue'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                          purchaseOrder?: Maybe<
                            { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                              InvoiceGroupPurchaseOrder,
                              'number' | 'oneTimeUse'
                            >
                          >;
                        }
                    >
                  >;
                }
            >;
          }
      >;
    };
};

export type FetchUserHistoryForStatusPageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchUserHistoryForStatusPageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id' | 'subscriptionId' | 'edition'> & {
      userHistory?: Maybe<
        { __typename?: 'UserHistoryDetails' } & Pick<UserHistoryDetails, 'nextId'> & {
            results?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ChargeQuantity' } & Pick<
                    ChargeQuantity,
                    'chargeElement' | 'quantity' | 'lastUpdatedAt'
                  > & {
                      usersUpdate?: Maybe<
                        { __typename?: 'ChargeQuantityUsersUpdate' } & Pick<
                          ChargeQuantityUsersUpdate,
                          'isCreated' | 'isAdded' | 'isRemoved' | 'changeBy'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    };
};

export type FetchAddOnsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchAddOnsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'> & {
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'AddOnEdge' } & {
                    node?: Maybe<
                      { __typename?: 'AddOn' } & Pick<
                        AddOn,
                        | 'id'
                        | 'entitlementNumber'
                        | 'dateAdded'
                        | 'units'
                        | 'name'
                        | 'nextBillDate'
                        | 'dateRemoved'
                        | 'dateLastBilled'
                        | 'billingStatus'
                      >
                    >;
                  }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

export type FetchAddOnsParentEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchAddOnsParentEntitlementQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<
    Statuspage,
    | 'id'
    | 'billingCycle'
    | 'billingStatus'
    | 'entitlementNumber'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'offeringId'
    | 'productName'
    | 'sourceSystem'
    | 'plan'
  > & { offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>> };
};

export type FetchEmailsForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchEmailsForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      emails: { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
          edges?: Maybe<
            Array<
              Maybe<
                { __typename?: 'EmailEdge' } & {
                  node: { __typename?: 'Email' } & Pick<Email, 'subject' | 'size' | 'id' | 'html' | 'text' | 'date'> & {
                      to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                    };
                }
              >
            >
          >;
        };
    };
};

export type FetchPeopleForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchPeopleForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      contacts: { __typename?: 'ContactConnection' } & Pick<ContactConnection, 'totalCount'> & {
          pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
          edges?: Maybe<
            Array<
              Maybe<
                { __typename?: 'ContactEdge' } & {
                  node?: Maybe<
                    { __typename?: 'Contact' } & {
                      primaryEmail: Contact['email'];
                      displayName: Contact['fullName'];
                      atlassianAccountId: Contact['atlassianAccountId'];
                    }
                  >;
                }
              >
            >
          >;
        };
    };
};

export type FetchSupportIssuesForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type FetchSupportIssuesForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      supportIssues: { __typename?: 'SupportIssues' } & Pick<SupportIssues, 'totalHits'> & {
          results: Array<
            Maybe<
              { __typename?: 'SupportIssue' } & Pick<
                SupportIssue,
                'id' | 'issueKey' | 'summary' | 'currentStatus' | 'reporterEmailAddress' | 'updatedTimestamp'
              >
            >
          >;
        };
    };
};

export type TrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type TrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<
    Trello,
    | 'baseProduct'
    | 'id'
    | 'plan'
    | 'renewalAction'
    | 'billingFrequency'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'platform'
    | 'productId'
    | 'billingStatus'
    | 'productName'
  >;
};

export type FetchPartnerBillingAdminIdsQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'partnerBillingAdminIds'>;
};

export type FetchPartnerBillingAdminIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type LastBillEstimateItem = {
  __typename?: 'LastBillEstimateItem';
  adjustments?: Maybe<Array<Maybe<LastBillEstimateItemAdjustment>>>;
  margins?: Maybe<Array<Maybe<LastBillEstimateItemMargin>>>;
};

export type LastBillEstimateItemAdjustment = {
  __typename?: 'LastBillEstimateItemAdjustment';
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Int']>;
  promotionCode?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LastBillEstimateItemMargin = {
  __typename?: 'LastBillEstimateItemMargin';
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};
